export const TRAINERS_HGSS = [
  {
    "name": "CHLOE",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4",
      "RAIKOU 1",
      "RAIKOU 2",
      "RAIKOU 3",
      "RAIKOU 4",
      "ENTEI 1",
      "ENTEI 2",
      "ENTEI 3",
      "ENTEI 4",
      "SUICUNE 1",
      "SUICUNE 2",
      "SUICUNE 3",
      "SUICUNE 4",
      "REGIROCK 1",
      "REGIROCK 2",
      "REGIROCK 3",
      "REGIROCK 4",
      "REGICE 1",
      "REGICE 2",
      "REGICE 3",
      "REGICE 4",
      "REGISTEEL 1",
      "REGISTEEL 2",
      "REGISTEEL 3",
      "REGISTEEL 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4",
      "HEATRAN 1",
      "HEATRAN 2",
      "HEATRAN 3",
      "HEATRAN 4",
      "CRESSELIA 1",
      "CRESSELIA 2",
      "CRESSELIA 3",
      "CRESSELIA 4",
      "REGIGIGAS 1",
      "REGIGIGAS 2",
      "REGIGIGAS 3",
      "REGIGIGAS 4"
    ]
  },
  {
    "name": "SAWYER",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4",
      "RAIKOU 1",
      "RAIKOU 2",
      "RAIKOU 3",
      "RAIKOU 4",
      "ENTEI 1",
      "ENTEI 2",
      "ENTEI 3",
      "ENTEI 4",
      "SUICUNE 1",
      "SUICUNE 2",
      "SUICUNE 3",
      "SUICUNE 4",
      "REGIROCK 1",
      "REGIROCK 2",
      "REGIROCK 3",
      "REGIROCK 4",
      "REGICE 1",
      "REGICE 2",
      "REGICE 3",
      "REGICE 4",
      "REGISTEEL 1",
      "REGISTEEL 2",
      "REGISTEEL 3",
      "REGISTEEL 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4",
      "HEATRAN 1",
      "HEATRAN 2",
      "HEATRAN 3",
      "HEATRAN 4",
      "CRESSELIA 1",
      "CRESSELIA 2",
      "CRESSELIA 3",
      "CRESSELIA 4",
      "REGIGIGAS 1",
      "REGIGIGAS 2",
      "REGIGIGAS 3",
      "REGIGIGAS 4"
    ]
  },
  {
    "name": "JOACHIM",
    "trainerClass": "Gentleman",
    "pokemon": [
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4",
      "RAIKOU 1",
      "RAIKOU 2",
      "RAIKOU 3",
      "RAIKOU 4",
      "ENTEI 1",
      "ENTEI 2",
      "ENTEI 3",
      "ENTEI 4",
      "SUICUNE 1",
      "SUICUNE 2",
      "SUICUNE 3",
      "SUICUNE 4",
      "REGIROCK 1",
      "REGIROCK 2",
      "REGIROCK 3",
      "REGIROCK 4",
      "REGICE 1",
      "REGICE 2",
      "REGICE 3",
      "REGICE 4",
      "REGISTEEL 1",
      "REGISTEEL 2",
      "REGISTEEL 3",
      "REGISTEEL 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4",
      "HEATRAN 1",
      "HEATRAN 2",
      "HEATRAN 3",
      "HEATRAN 4",
      "CRESSELIA 1",
      "CRESSELIA 2",
      "CRESSELIA 3",
      "CRESSELIA 4",
      "REGIGIGAS 1",
      "REGIGIGAS 2",
      "REGIGIGAS 3",
      "REGIGIGAS 4"
    ]
  },
  {
    "name": "ALMA",
    "trainerClass": "PKMN Ranger",
    "pokemon": [
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4",
      "RAIKOU 1",
      "RAIKOU 2",
      "RAIKOU 3",
      "RAIKOU 4",
      "ENTEI 1",
      "ENTEI 2",
      "ENTEI 3",
      "ENTEI 4",
      "SUICUNE 1",
      "SUICUNE 2",
      "SUICUNE 3",
      "SUICUNE 4",
      "REGIROCK 1",
      "REGIROCK 2",
      "REGIROCK 3",
      "REGIROCK 4",
      "REGICE 1",
      "REGICE 2",
      "REGICE 3",
      "REGICE 4",
      "REGISTEEL 1",
      "REGISTEEL 2",
      "REGISTEEL 3",
      "REGISTEEL 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4",
      "HEATRAN 1",
      "HEATRAN 2",
      "HEATRAN 3",
      "HEATRAN 4",
      "CRESSELIA 1",
      "CRESSELIA 2",
      "CRESSELIA 3",
      "CRESSELIA 4",
      "REGIGIGAS 1",
      "REGIGIGAS 2",
      "REGIGIGAS 3",
      "REGIGIGAS 4"
    ]
  },
  {
    "name": "GEOFF",
    "trainerClass": "PKMN Ranger",
    "pokemon": [
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4",
      "RAIKOU 1",
      "RAIKOU 2",
      "RAIKOU 3",
      "RAIKOU 4",
      "ENTEI 1",
      "ENTEI 2",
      "ENTEI 3",
      "ENTEI 4",
      "SUICUNE 1",
      "SUICUNE 2",
      "SUICUNE 3",
      "SUICUNE 4",
      "REGIROCK 1",
      "REGIROCK 2",
      "REGIROCK 3",
      "REGIROCK 4",
      "REGICE 1",
      "REGICE 2",
      "REGICE 3",
      "REGICE 4",
      "REGISTEEL 1",
      "REGISTEEL 2",
      "REGISTEEL 3",
      "REGISTEEL 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4",
      "HEATRAN 1",
      "HEATRAN 2",
      "HEATRAN 3",
      "HEATRAN 4",
      "CRESSELIA 1",
      "CRESSELIA 2",
      "CRESSELIA 3",
      "CRESSELIA 4",
      "REGIGIGAS 1",
      "REGIGIGAS 2",
      "REGIGIGAS 3",
      "REGIGIGAS 4"
    ]
  },
  {
    "name": "RIOHA",
    "trainerClass": "Socialite",
    "pokemon": [
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4",
      "RAIKOU 1",
      "RAIKOU 2",
      "RAIKOU 3",
      "RAIKOU 4",
      "ENTEI 1",
      "ENTEI 2",
      "ENTEI 3",
      "ENTEI 4",
      "SUICUNE 1",
      "SUICUNE 2",
      "SUICUNE 3",
      "SUICUNE 4",
      "REGIROCK 1",
      "REGIROCK 2",
      "REGIROCK 3",
      "REGIROCK 4",
      "REGICE 1",
      "REGICE 2",
      "REGICE 3",
      "REGICE 4",
      "REGISTEEL 1",
      "REGISTEEL 2",
      "REGISTEEL 3",
      "REGISTEEL 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4",
      "HEATRAN 1",
      "HEATRAN 2",
      "HEATRAN 3",
      "HEATRAN 4",
      "CRESSELIA 1",
      "CRESSELIA 2",
      "CRESSELIA 3",
      "CRESSELIA 4",
      "REGIGIGAS 1",
      "REGIGIGAS 2",
      "REGIGIGAS 3",
      "REGIGIGAS 4"
    ]
  },
  {
    "name": "COSTIN",
    "trainerClass": "Veteran",
    "pokemon": [
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4",
      "RAIKOU 1",
      "RAIKOU 2",
      "RAIKOU 3",
      "RAIKOU 4",
      "ENTEI 1",
      "ENTEI 2",
      "ENTEI 3",
      "ENTEI 4",
      "SUICUNE 1",
      "SUICUNE 2",
      "SUICUNE 3",
      "SUICUNE 4",
      "REGIROCK 1",
      "REGIROCK 2",
      "REGIROCK 3",
      "REGIROCK 4",
      "REGICE 1",
      "REGICE 2",
      "REGICE 3",
      "REGICE 4",
      "REGISTEEL 1",
      "REGISTEEL 2",
      "REGISTEEL 3",
      "REGISTEEL 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4",
      "HEATRAN 1",
      "HEATRAN 2",
      "HEATRAN 3",
      "HEATRAN 4",
      "CRESSELIA 1",
      "CRESSELIA 2",
      "CRESSELIA 3",
      "CRESSELIA 4",
      "REGIGIGAS 1",
      "REGIGIGAS 2",
      "REGIGIGAS 3",
      "REGIGIGAS 4"
    ]
  },
  {
    "name": "LEDA",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "DEWGONG 1",
      "DEWGONG 2",
      "DEWGONG 3",
      "DEWGONG 4",
      "GLALIE 1",
      "GLALIE 2",
      "GLALIE 3",
      "GLALIE 4",
      "FROSLASS 1",
      "FROSLASS 2",
      "FROSLASS 3",
      "FROSLASS 4",
      "ABOMASNOW 1",
      "ABOMASNOW 2",
      "ABOMASNOW 3",
      "ABOMASNOW 4",
      "WEAVILE 1",
      "WEAVILE 2",
      "WEAVILE 3",
      "WEAVILE 4",
      "GLACEON 1",
      "GLACEON 2",
      "GLACEON 3",
      "GLACEON 4",
      "WALREIN 1",
      "WALREIN 2",
      "WALREIN 3",
      "WALREIN 4",
      "MAMOSWINE 1",
      "MAMOSWINE 2",
      "MAMOSWINE 3",
      "MAMOSWINE 4",
      "LAPRAS 1",
      "LAPRAS 2",
      "LAPRAS 3",
      "LAPRAS 4",
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "REGICE 1",
      "REGICE 2",
      "REGICE 3",
      "REGICE 4"
    ]
  },
  {
    "name": "OPAL",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "DEWGONG 1",
      "DEWGONG 2",
      "DEWGONG 3",
      "DEWGONG 4",
      "GLALIE 1",
      "GLALIE 2",
      "GLALIE 3",
      "GLALIE 4",
      "FROSLASS 1",
      "FROSLASS 2",
      "FROSLASS 3",
      "FROSLASS 4",
      "ABOMASNOW 1",
      "ABOMASNOW 2",
      "ABOMASNOW 3",
      "ABOMASNOW 4",
      "WEAVILE 1",
      "WEAVILE 2",
      "WEAVILE 3",
      "WEAVILE 4",
      "GLACEON 1",
      "GLACEON 2",
      "GLACEON 3",
      "GLACEON 4",
      "WALREIN 1",
      "WALREIN 2",
      "WALREIN 3",
      "WALREIN 4",
      "MAMOSWINE 1",
      "MAMOSWINE 2",
      "MAMOSWINE 3",
      "MAMOSWINE 4",
      "LAPRAS 1",
      "LAPRAS 2",
      "LAPRAS 3",
      "LAPRAS 4",
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "REGICE 1",
      "REGICE 2",
      "REGICE 3",
      "REGICE 4"
    ]
  },
  {
    "name": "LEW",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "DEWGONG 1",
      "DEWGONG 2",
      "DEWGONG 3",
      "DEWGONG 4",
      "GLALIE 1",
      "GLALIE 2",
      "GLALIE 3",
      "GLALIE 4",
      "FROSLASS 1",
      "FROSLASS 2",
      "FROSLASS 3",
      "FROSLASS 4",
      "ABOMASNOW 1",
      "ABOMASNOW 2",
      "ABOMASNOW 3",
      "ABOMASNOW 4",
      "WEAVILE 1",
      "WEAVILE 2",
      "WEAVILE 3",
      "WEAVILE 4",
      "GLACEON 1",
      "GLACEON 2",
      "GLACEON 3",
      "GLACEON 4",
      "WALREIN 1",
      "WALREIN 2",
      "WALREIN 3",
      "WALREIN 4",
      "MAMOSWINE 1",
      "MAMOSWINE 2",
      "MAMOSWINE 3",
      "MAMOSWINE 4",
      "LAPRAS 1",
      "LAPRAS 2",
      "LAPRAS 3",
      "LAPRAS 4",
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "REGICE 1",
      "REGICE 2",
      "REGICE 3",
      "REGICE 4"
    ]
  },
  {
    "name": "THAD",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "DEWGONG 1",
      "DEWGONG 2",
      "DEWGONG 3",
      "DEWGONG 4",
      "GLALIE 1",
      "GLALIE 2",
      "GLALIE 3",
      "GLALIE 4",
      "FROSLASS 1",
      "FROSLASS 2",
      "FROSLASS 3",
      "FROSLASS 4",
      "ABOMASNOW 1",
      "ABOMASNOW 2",
      "ABOMASNOW 3",
      "ABOMASNOW 4",
      "WEAVILE 1",
      "WEAVILE 2",
      "WEAVILE 3",
      "WEAVILE 4",
      "GLACEON 1",
      "GLACEON 2",
      "GLACEON 3",
      "GLACEON 4",
      "WALREIN 1",
      "WALREIN 2",
      "WALREIN 3",
      "WALREIN 4",
      "MAMOSWINE 1",
      "MAMOSWINE 2",
      "MAMOSWINE 3",
      "MAMOSWINE 4",
      "LAPRAS 1",
      "LAPRAS 2",
      "LAPRAS 3",
      "LAPRAS 4",
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "REGICE 1",
      "REGICE 2",
      "REGICE 3",
      "REGICE 4"
    ]
  },
  {
    "name": "CARLY",
    "trainerClass": "Cowgirl",
    "pokemon": [
      "VENUSAUR 4",
      "CHARIZARD 4",
      "BLASTOISE 4",
      "MEGANIUM 4",
      "TYPHLOSION 4",
      "FERALIGATR 4",
      "SCEPTILE 4",
      "BLAZIKEN 4",
      "SWAMPERT 4",
      "TORTERRA 4",
      "INFERNAPE 4",
      "EMPOLEON 4",
      "DUGTRIO 4",
      "MAROWAK 4",
      "MEDICHAM 4",
      "QUAGSIRE 4",
      "GRANBULL 4",
      "JYNX 4",
      "MRMIME 4",
      "LANTURN 4",
      "BRELOOM 4",
      "FORRETRESS 4",
      "SKARMORY 4",
      "ABSOL 4",
      "WHISCASH 4",
      "HARIYAMA 4",
      "VESPIQUEN 4",
      "RAICHU 4",
      "DEWGONG 4",
      "MANECTRIC 4",
      "STARAPTOR 4",
      "GASTRODON 4",
      "SKUNTANK 4",
      "VILEPLUME 4",
      "VICTREEBEL 4",
      "ELECTRODE 4",
      "LUDICOLO 4",
      "SHIFTRY 4",
      "EXPLOUD 4",
      "GLALIE 4",
      "LOPUNNY 4",
      "FROSLASS 4",
      "AMBIPOM 4",
      "HYPNO 4",
      "GOLEM 4",
      "RHYDON 4",
      "SLOWBRO 4",
      "WEEZING 4",
      "KANGASKHAN 4",
      "TAUROS 4",
      "ALAKAZAM 4",
      "SLOWKING 4",
      "MILTANK 4",
      "ALTARIA 4",
      "TOXICROAK 4",
      "ABOMASNOW 4",
      "NIDOQUEEN 4",
      "NIDOKING 4",
      "CRADILY 4",
      "ARMALDO 4",
      "BASTIODON 4",
      "FLOATZEL 4",
      "MISMAGIUS 4",
      "DRIFBLIM 4",
      "GOLDUCK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "MUK 4"
    ]
  },
  {
    "name": "GINGER",
    "trainerClass": "Cowgirl",
    "pokemon": [
      "VENUSAUR 4",
      "CHARIZARD 4",
      "BLASTOISE 4",
      "MEGANIUM 4",
      "TYPHLOSION 4",
      "FERALIGATR 4",
      "SCEPTILE 4",
      "BLAZIKEN 4",
      "SWAMPERT 4",
      "TORTERRA 4",
      "INFERNAPE 4",
      "EMPOLEON 4",
      "DUGTRIO 4",
      "MAROWAK 4",
      "MEDICHAM 4",
      "QUAGSIRE 4",
      "GRANBULL 4",
      "JYNX 4",
      "MRMIME 4",
      "LANTURN 4",
      "BRELOOM 4",
      "FORRETRESS 4",
      "SKARMORY 4",
      "ABSOL 4",
      "WHISCASH 4",
      "HARIYAMA 4",
      "VESPIQUEN 4",
      "RAICHU 4",
      "DEWGONG 4",
      "MANECTRIC 4",
      "STARAPTOR 4",
      "GASTRODON 4",
      "SKUNTANK 4",
      "VILEPLUME 4",
      "VICTREEBEL 4",
      "ELECTRODE 4",
      "LUDICOLO 4",
      "SHIFTRY 4",
      "EXPLOUD 4",
      "GLALIE 4",
      "LOPUNNY 4",
      "FROSLASS 4",
      "AMBIPOM 4",
      "HYPNO 4",
      "GOLEM 4",
      "RHYDON 4",
      "SLOWBRO 4",
      "WEEZING 4",
      "KANGASKHAN 4",
      "TAUROS 4",
      "ALAKAZAM 4",
      "SLOWKING 4",
      "MILTANK 4",
      "ALTARIA 4",
      "TOXICROAK 4",
      "ABOMASNOW 4",
      "NIDOQUEEN 4",
      "NIDOKING 4",
      "CRADILY 4",
      "ARMALDO 4",
      "BASTIODON 4",
      "FLOATZEL 4",
      "MISMAGIUS 4",
      "DRIFBLIM 4",
      "GOLDUCK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "MUK 4"
    ]
  },
  {
    "name": "EUROPA",
    "trainerClass": "Pokefan",
    "pokemon": [
      "VENUSAUR 4",
      "CHARIZARD 4",
      "BLASTOISE 4",
      "MEGANIUM 4",
      "TYPHLOSION 4",
      "FERALIGATR 4",
      "SCEPTILE 4",
      "BLAZIKEN 4",
      "SWAMPERT 4",
      "TORTERRA 4",
      "INFERNAPE 4",
      "EMPOLEON 4",
      "DUGTRIO 4",
      "MAROWAK 4",
      "MEDICHAM 4",
      "QUAGSIRE 4",
      "GRANBULL 4",
      "JYNX 4",
      "MRMIME 4",
      "LANTURN 4",
      "BRELOOM 4",
      "FORRETRESS 4",
      "SKARMORY 4",
      "ABSOL 4",
      "WHISCASH 4",
      "HARIYAMA 4",
      "VESPIQUEN 4",
      "RAICHU 4",
      "DEWGONG 4",
      "MANECTRIC 4",
      "STARAPTOR 4",
      "GASTRODON 4",
      "SKUNTANK 4",
      "VILEPLUME 4",
      "VICTREEBEL 4",
      "ELECTRODE 4",
      "LUDICOLO 4",
      "SHIFTRY 4",
      "EXPLOUD 4",
      "GLALIE 4",
      "LOPUNNY 4",
      "FROSLASS 4",
      "AMBIPOM 4",
      "HYPNO 4",
      "GOLEM 4",
      "RHYDON 4",
      "SLOWBRO 4",
      "WEEZING 4",
      "KANGASKHAN 4",
      "TAUROS 4",
      "ALAKAZAM 4",
      "SLOWKING 4",
      "MILTANK 4",
      "ALTARIA 4",
      "TOXICROAK 4",
      "ABOMASNOW 4",
      "NIDOQUEEN 4",
      "NIDOKING 4",
      "CRADILY 4",
      "ARMALDO 4",
      "BASTIODON 4",
      "FLOATZEL 4",
      "MISMAGIUS 4",
      "DRIFBLIM 4",
      "GOLDUCK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "MUK 4"
    ]
  },
  {
    "name": "PANDORA",
    "trainerClass": "Pokefan",
    "pokemon": [
      "VENUSAUR 4",
      "CHARIZARD 4",
      "BLASTOISE 4",
      "MEGANIUM 4",
      "TYPHLOSION 4",
      "FERALIGATR 4",
      "SCEPTILE 4",
      "BLAZIKEN 4",
      "SWAMPERT 4",
      "TORTERRA 4",
      "INFERNAPE 4",
      "EMPOLEON 4",
      "DUGTRIO 4",
      "MAROWAK 4",
      "MEDICHAM 4",
      "QUAGSIRE 4",
      "GRANBULL 4",
      "JYNX 4",
      "MRMIME 4",
      "LANTURN 4",
      "BRELOOM 4",
      "FORRETRESS 4",
      "SKARMORY 4",
      "ABSOL 4",
      "WHISCASH 4",
      "HARIYAMA 4",
      "VESPIQUEN 4",
      "RAICHU 4",
      "DEWGONG 4",
      "MANECTRIC 4",
      "STARAPTOR 4",
      "GASTRODON 4",
      "SKUNTANK 4",
      "VILEPLUME 4",
      "VICTREEBEL 4",
      "ELECTRODE 4",
      "LUDICOLO 4",
      "SHIFTRY 4",
      "EXPLOUD 4",
      "GLALIE 4",
      "LOPUNNY 4",
      "FROSLASS 4",
      "AMBIPOM 4",
      "HYPNO 4",
      "GOLEM 4",
      "RHYDON 4",
      "SLOWBRO 4",
      "WEEZING 4",
      "KANGASKHAN 4",
      "TAUROS 4",
      "ALAKAZAM 4",
      "SLOWKING 4",
      "MILTANK 4",
      "ALTARIA 4",
      "TOXICROAK 4",
      "ABOMASNOW 4",
      "NIDOQUEEN 4",
      "NIDOKING 4",
      "CRADILY 4",
      "ARMALDO 4",
      "BASTIODON 4",
      "FLOATZEL 4",
      "MISMAGIUS 4",
      "DRIFBLIM 4",
      "GOLDUCK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "MUK 4"
    ]
  },
  {
    "name": "SIMON",
    "trainerClass": "Pokefan",
    "pokemon": [
      "VENUSAUR 4",
      "CHARIZARD 4",
      "BLASTOISE 4",
      "MEGANIUM 4",
      "TYPHLOSION 4",
      "FERALIGATR 4",
      "SCEPTILE 4",
      "BLAZIKEN 4",
      "SWAMPERT 4",
      "TORTERRA 4",
      "INFERNAPE 4",
      "EMPOLEON 4",
      "DUGTRIO 4",
      "MAROWAK 4",
      "MEDICHAM 4",
      "QUAGSIRE 4",
      "GRANBULL 4",
      "JYNX 4",
      "MRMIME 4",
      "LANTURN 4",
      "BRELOOM 4",
      "FORRETRESS 4",
      "SKARMORY 4",
      "ABSOL 4",
      "WHISCASH 4",
      "HARIYAMA 4",
      "VESPIQUEN 4",
      "RAICHU 4",
      "DEWGONG 4",
      "MANECTRIC 4",
      "STARAPTOR 4",
      "GASTRODON 4",
      "SKUNTANK 4",
      "VILEPLUME 4",
      "VICTREEBEL 4",
      "ELECTRODE 4",
      "LUDICOLO 4",
      "SHIFTRY 4",
      "EXPLOUD 4",
      "GLALIE 4",
      "LOPUNNY 4",
      "FROSLASS 4",
      "AMBIPOM 4",
      "HYPNO 4",
      "GOLEM 4",
      "RHYDON 4",
      "SLOWBRO 4",
      "WEEZING 4",
      "KANGASKHAN 4",
      "TAUROS 4",
      "ALAKAZAM 4",
      "SLOWKING 4",
      "MILTANK 4",
      "ALTARIA 4",
      "TOXICROAK 4",
      "ABOMASNOW 4",
      "NIDOQUEEN 4",
      "NIDOKING 4",
      "CRADILY 4",
      "ARMALDO 4",
      "BASTIODON 4",
      "FLOATZEL 4",
      "MISMAGIUS 4",
      "DRIFBLIM 4",
      "GOLDUCK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "MUK 4"
    ]
  },
  {
    "name": "TURNER",
    "trainerClass": "Pokefan",
    "pokemon": [
      "VENUSAUR 4",
      "CHARIZARD 4",
      "BLASTOISE 4",
      "MEGANIUM 4",
      "TYPHLOSION 4",
      "FERALIGATR 4",
      "SCEPTILE 4",
      "BLAZIKEN 4",
      "SWAMPERT 4",
      "TORTERRA 4",
      "INFERNAPE 4",
      "EMPOLEON 4",
      "DUGTRIO 4",
      "MAROWAK 4",
      "MEDICHAM 4",
      "QUAGSIRE 4",
      "GRANBULL 4",
      "JYNX 4",
      "MRMIME 4",
      "LANTURN 4",
      "BRELOOM 4",
      "FORRETRESS 4",
      "SKARMORY 4",
      "ABSOL 4",
      "WHISCASH 4",
      "HARIYAMA 4",
      "VESPIQUEN 4",
      "RAICHU 4",
      "DEWGONG 4",
      "MANECTRIC 4",
      "STARAPTOR 4",
      "GASTRODON 4",
      "SKUNTANK 4",
      "VILEPLUME 4",
      "VICTREEBEL 4",
      "ELECTRODE 4",
      "LUDICOLO 4",
      "SHIFTRY 4",
      "EXPLOUD 4",
      "GLALIE 4",
      "LOPUNNY 4",
      "FROSLASS 4",
      "AMBIPOM 4",
      "HYPNO 4",
      "GOLEM 4",
      "RHYDON 4",
      "SLOWBRO 4",
      "WEEZING 4",
      "KANGASKHAN 4",
      "TAUROS 4",
      "ALAKAZAM 4",
      "SLOWKING 4",
      "MILTANK 4",
      "ALTARIA 4",
      "TOXICROAK 4",
      "ABOMASNOW 4",
      "NIDOQUEEN 4",
      "NIDOKING 4",
      "CRADILY 4",
      "ARMALDO 4",
      "BASTIODON 4",
      "FLOATZEL 4",
      "MISMAGIUS 4",
      "DRIFBLIM 4",
      "GOLDUCK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "MUK 4"
    ]
  },
  {
    "name": "BORIS",
    "trainerClass": "Rancher",
    "pokemon": [
      "VENUSAUR 4",
      "CHARIZARD 4",
      "BLASTOISE 4",
      "MEGANIUM 4",
      "TYPHLOSION 4",
      "FERALIGATR 4",
      "SCEPTILE 4",
      "BLAZIKEN 4",
      "SWAMPERT 4",
      "TORTERRA 4",
      "INFERNAPE 4",
      "EMPOLEON 4",
      "DUGTRIO 4",
      "MAROWAK 4",
      "MEDICHAM 4",
      "QUAGSIRE 4",
      "GRANBULL 4",
      "JYNX 4",
      "MRMIME 4",
      "LANTURN 4",
      "BRELOOM 4",
      "FORRETRESS 4",
      "SKARMORY 4",
      "ABSOL 4",
      "WHISCASH 4",
      "HARIYAMA 4",
      "VESPIQUEN 4",
      "RAICHU 4",
      "DEWGONG 4",
      "MANECTRIC 4",
      "STARAPTOR 4",
      "GASTRODON 4",
      "SKUNTANK 4",
      "VILEPLUME 4",
      "VICTREEBEL 4",
      "ELECTRODE 4",
      "LUDICOLO 4",
      "SHIFTRY 4",
      "EXPLOUD 4",
      "GLALIE 4",
      "LOPUNNY 4",
      "FROSLASS 4",
      "AMBIPOM 4",
      "HYPNO 4",
      "GOLEM 4",
      "RHYDON 4",
      "SLOWBRO 4",
      "WEEZING 4",
      "KANGASKHAN 4",
      "TAUROS 4",
      "ALAKAZAM 4",
      "SLOWKING 4",
      "MILTANK 4",
      "ALTARIA 4",
      "TOXICROAK 4",
      "ABOMASNOW 4",
      "NIDOQUEEN 4",
      "NIDOKING 4",
      "CRADILY 4",
      "ARMALDO 4",
      "BASTIODON 4",
      "FLOATZEL 4",
      "MISMAGIUS 4",
      "DRIFBLIM 4",
      "GOLDUCK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "MUK 4"
    ]
  },
  {
    "name": "VERN",
    "trainerClass": "Rancher",
    "pokemon": [
      "VENUSAUR 4",
      "CHARIZARD 4",
      "BLASTOISE 4",
      "MEGANIUM 4",
      "TYPHLOSION 4",
      "FERALIGATR 4",
      "SCEPTILE 4",
      "BLAZIKEN 4",
      "SWAMPERT 4",
      "TORTERRA 4",
      "INFERNAPE 4",
      "EMPOLEON 4",
      "DUGTRIO 4",
      "MAROWAK 4",
      "MEDICHAM 4",
      "QUAGSIRE 4",
      "GRANBULL 4",
      "JYNX 4",
      "MRMIME 4",
      "LANTURN 4",
      "BRELOOM 4",
      "FORRETRESS 4",
      "SKARMORY 4",
      "ABSOL 4",
      "WHISCASH 4",
      "HARIYAMA 4",
      "VESPIQUEN 4",
      "RAICHU 4",
      "DEWGONG 4",
      "MANECTRIC 4",
      "STARAPTOR 4",
      "GASTRODON 4",
      "SKUNTANK 4",
      "VILEPLUME 4",
      "VICTREEBEL 4",
      "ELECTRODE 4",
      "LUDICOLO 4",
      "SHIFTRY 4",
      "EXPLOUD 4",
      "GLALIE 4",
      "LOPUNNY 4",
      "FROSLASS 4",
      "AMBIPOM 4",
      "HYPNO 4",
      "GOLEM 4",
      "RHYDON 4",
      "SLOWBRO 4",
      "WEEZING 4",
      "KANGASKHAN 4",
      "TAUROS 4",
      "ALAKAZAM 4",
      "SLOWKING 4",
      "MILTANK 4",
      "ALTARIA 4",
      "TOXICROAK 4",
      "ABOMASNOW 4",
      "NIDOQUEEN 4",
      "NIDOKING 4",
      "CRADILY 4",
      "ARMALDO 4",
      "BASTIODON 4",
      "FLOATZEL 4",
      "MISMAGIUS 4",
      "DRIFBLIM 4",
      "GOLDUCK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "MUK 4"
    ]
  },
  {
    "name": "ELISE",
    "trainerClass": "PKMN Ranger",
    "pokemon": [
      "VENUSAUR 4",
      "CHARIZARD 4",
      "BLASTOISE 4",
      "MEGANIUM 4",
      "TYPHLOSION 4",
      "FERALIGATR 4",
      "SCEPTILE 4",
      "BLAZIKEN 4",
      "SWAMPERT 4",
      "TORTERRA 4",
      "INFERNAPE 4",
      "EMPOLEON 4",
      "DUGTRIO 4",
      "MAROWAK 4",
      "MEDICHAM 4",
      "QUAGSIRE 4",
      "GRANBULL 4",
      "JYNX 4",
      "MRMIME 4",
      "LANTURN 4",
      "BRELOOM 4",
      "FORRETRESS 4",
      "SKARMORY 4",
      "ABSOL 4",
      "WHISCASH 4",
      "HARIYAMA 4",
      "VESPIQUEN 4",
      "RAICHU 4",
      "DEWGONG 4",
      "MANECTRIC 4",
      "STARAPTOR 4",
      "GASTRODON 4",
      "SKUNTANK 4",
      "VILEPLUME 4",
      "VICTREEBEL 4",
      "ELECTRODE 4",
      "LUDICOLO 4",
      "SHIFTRY 4",
      "EXPLOUD 4",
      "GLALIE 4",
      "LOPUNNY 4",
      "FROSLASS 4",
      "AMBIPOM 4",
      "HYPNO 4",
      "GOLEM 4",
      "RHYDON 4",
      "SLOWBRO 4",
      "WEEZING 4",
      "KANGASKHAN 4",
      "TAUROS 4",
      "ALAKAZAM 4",
      "SLOWKING 4",
      "MILTANK 4",
      "ALTARIA 4",
      "TOXICROAK 4",
      "ABOMASNOW 4",
      "NIDOQUEEN 4",
      "NIDOKING 4",
      "CRADILY 4",
      "ARMALDO 4",
      "BASTIODON 4",
      "FLOATZEL 4",
      "MISMAGIUS 4",
      "DRIFBLIM 4",
      "GOLDUCK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "MUK 4"
    ]
  },
  {
    "name": "ANDRE",
    "trainerClass": "Camper",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "FREDDY",
    "trainerClass": "Camper",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "INGA",
    "trainerClass": "Picnicker",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "TONYA",
    "trainerClass": "Picnicker",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "ANTONIA",
    "trainerClass": "PKMN Breeder",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "ZORYA",
    "trainerClass": "PKMN Breeder",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "PETER",
    "trainerClass": "PKMN Breeder",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "TYRON",
    "trainerClass": "PKMN Breeder",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "CHARLIE",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "DAPHNE",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "GUNTHER",
    "trainerClass": "PKMN Ranger",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "KARSTON",
    "trainerClass": "Gentleman",
    "pokemon": [
      "GENGAR 4",
      "AMPHAROS 4",
      "POLITOED 4",
      "PINSIR 4",
      "SCIZOR 4",
      "HERACROSS 4",
      "URSARING 4",
      "HOUNDOOM 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "RAMPARDOS 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "NINETALES 4",
      "MACHAMP 4",
      "SHUCKLE 4",
      "ROSERADE 4",
      "HONCHKROW 4",
      "STEELIX 4",
      "WEAVILE 4",
      "GLISCOR 4",
      "TENTACRUEL 4",
      "AERODACTYL 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "YANMEGA 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "FLYGON 4",
      "VAPOREON 4",
      "JOLTEON 4",
      "FLAREON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LEAFEON 4",
      "GLACEON 4",
      "LUCARIO 4",
      "HIPPOWDON 4",
      "PROBOPASS 4",
      "DUSKNOIR 4",
      "AGGRON 4",
      "WALREIN 4",
      "MAMOSWINE 4",
      "LAPRAS 4",
      "CROBAT 4",
      "MAGNEZONE 4",
      "RHYPERIOR 4",
      "TANGROWTH 4",
      "PORYGON-Z 4",
      "GYARADOS 4",
      "SNORLAX 4",
      "KINGDRA 4",
      "BLISSEY 4",
      "MILOTIC 4",
      "ELECTIVIRE 4",
      "MAGMORTAR 4",
      "TOGEKISS 4",
      "ARCANINE 4",
      "DRAGONITE 4",
      "TYRANITAR 4",
      "SALAMENCE 4",
      "METAGROSS 4",
      "GARCHOMP 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "CECIL",
    "trainerClass": "Guitarist",
    "pokemon": [
      "BLAZIKEN 4",
      "INFERNAPE 4",
      "MEDICHAM 4",
      "JYNX 4",
      "MRMIME 4",
      "LANTURN 4",
      "BRELOOM 4",
      "ABSOL 4",
      "HARIYAMA 4",
      "RAICHU 4",
      "MANECTRIC 4",
      "SKUNTANK 4",
      "ELECTRODE 4",
      "SHIFTRY 4",
      "FROSLASS 4",
      "HYPNO 4",
      "SLOWBRO 4",
      "ALAKAZAM 4",
      "SLOWKING 4",
      "TOXICROAK 4",
      "MISMAGIUS 4",
      "DRIFBLIM 4",
      "POLIWRATH 4",
      "GENGAR 4",
      "AMPHAROS 4",
      "HERACROSS 4",
      "HOUNDOOM 4",
      "CLAYDOL 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "MACHAMP 4",
      "HONCHKROW 4",
      "WEAVILE 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "JOLTEON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LUCARIO 4",
      "DUSKNOIR 4",
      "MAGNEZONE 4",
      "ELECTIVIRE 4",
      "TYRANITAR 4",
      "METAGROSS 4"
    ]
  },
  {
    "name": "TOBIAS",
    "trainerClass": "Guitarist",
    "pokemon": [
      "BLAZIKEN 4",
      "INFERNAPE 4",
      "MEDICHAM 4",
      "JYNX 4",
      "MRMIME 4",
      "LANTURN 4",
      "BRELOOM 4",
      "ABSOL 4",
      "HARIYAMA 4",
      "RAICHU 4",
      "MANECTRIC 4",
      "SKUNTANK 4",
      "ELECTRODE 4",
      "SHIFTRY 4",
      "FROSLASS 4",
      "HYPNO 4",
      "SLOWBRO 4",
      "ALAKAZAM 4",
      "SLOWKING 4",
      "TOXICROAK 4",
      "MISMAGIUS 4",
      "DRIFBLIM 4",
      "POLIWRATH 4",
      "GENGAR 4",
      "AMPHAROS 4",
      "HERACROSS 4",
      "HOUNDOOM 4",
      "CLAYDOL 4",
      "BRONZONG 4",
      "DRAPION 4",
      "LUXRAY 4",
      "MACHAMP 4",
      "HONCHKROW 4",
      "WEAVILE 4",
      "GARDEVOIR 4",
      "GALLADE 4",
      "EXEGGUTOR 4",
      "STARMIE 4",
      "JOLTEON 4",
      "ESPEON 4",
      "UMBREON 4",
      "LUCARIO 4",
      "DUSKNOIR 4",
      "MAGNEZONE 4",
      "ELECTIVIRE 4",
      "TYRANITAR 4",
      "METAGROSS 4"
    ]
  },
  {
    "name": "HELENE",
    "trainerClass": "Idol",
    "pokemon": [
      "GRANBULL 4",
      "LANTURN 4",
      "RAICHU 4",
      "MANECTRIC 4",
      "STARAPTOR 4",
      "ELECTRODE 4",
      "EXPLOUD 4",
      "LOPUNNY 4",
      "AMBIPOM 4",
      "KANGASKHAN 4",
      "TAUROS 4",
      "MILTANK 4",
      "AMPHAROS 4",
      "URSARING 4",
      "LUXRAY 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "JOLTEON 4",
      "MAGNEZONE 4",
      "PORYGON-Z 4",
      "SNORLAX 4",
      "BLISSEY 4",
      "ELECTIVIRE 4",
      "TOGEKISS 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "MARANDA",
    "trainerClass": "Idol",
    "pokemon": [
      "GRANBULL 4",
      "LANTURN 4",
      "RAICHU 4",
      "MANECTRIC 4",
      "STARAPTOR 4",
      "ELECTRODE 4",
      "EXPLOUD 4",
      "LOPUNNY 4",
      "AMBIPOM 4",
      "KANGASKHAN 4",
      "TAUROS 4",
      "MILTANK 4",
      "AMPHAROS 4",
      "URSARING 4",
      "LUXRAY 4",
      "PORYGON2 4",
      "LICKILICKY 4",
      "JOLTEON 4",
      "MAGNEZONE 4",
      "PORYGON-Z 4",
      "SNORLAX 4",
      "BLISSEY 4",
      "ELECTIVIRE 4",
      "TOGEKISS 4",
      "SLAKING 4"
    ]
  },
  {
    "name": "BECKY",
    "trainerClass": "Beauty",
    "pokemon": [
      "VENUSAUR 3",
      "CHARIZARD 3",
      "BLASTOISE 3",
      "MEGANIUM 3",
      "TYPHLOSION 3",
      "FERALIGATR 3",
      "SCEPTILE 3",
      "BLAZIKEN 3",
      "SWAMPERT 3",
      "TORTERRA 3",
      "INFERNAPE 3",
      "EMPOLEON 3",
      "DUGTRIO 3",
      "MAROWAK 3",
      "MEDICHAM 3",
      "QUAGSIRE 3",
      "GRANBULL 3",
      "JYNX 3",
      "MRMIME 3",
      "LANTURN 3",
      "BRELOOM 3",
      "FORRETRESS 3",
      "SKARMORY 3",
      "ABSOL 3",
      "WHISCASH 3",
      "HARIYAMA 3",
      "VESPIQUEN 3",
      "RAICHU 3",
      "DEWGONG 3",
      "MANECTRIC 3",
      "STARAPTOR 3",
      "GASTRODON 3",
      "SKUNTANK 3",
      "VILEPLUME 3",
      "VICTREEBEL 3",
      "ELECTRODE 3",
      "LUDICOLO 3",
      "SHIFTRY 3",
      "EXPLOUD 3",
      "GLALIE 3",
      "LOPUNNY 3",
      "FROSLASS 3",
      "AMBIPOM 3",
      "HYPNO 3",
      "GOLEM 3",
      "RHYDON 3",
      "SLOWBRO 3",
      "WEEZING 3",
      "KANGASKHAN 3",
      "TAUROS 3",
      "ALAKAZAM 3",
      "SLOWKING 3",
      "MILTANK 3",
      "ALTARIA 3",
      "TOXICROAK 3",
      "ABOMASNOW 3",
      "NIDOQUEEN 3",
      "NIDOKING 3",
      "CRADILY 3",
      "ARMALDO 3",
      "BASTIODON 3",
      "FLOATZEL 3",
      "MISMAGIUS 3",
      "DRIFBLIM 3",
      "GOLDUCK 3",
      "POLIWRATH 3",
      "RAPIDASH 3",
      "MUK 3"
    ]
  },
  {
    "name": "AUSTIN",
    "trainerClass": "Jogger",
    "pokemon": [
      "VENUSAUR 3",
      "CHARIZARD 3",
      "BLASTOISE 3",
      "MEGANIUM 3",
      "TYPHLOSION 3",
      "FERALIGATR 3",
      "SCEPTILE 3",
      "BLAZIKEN 3",
      "SWAMPERT 3",
      "TORTERRA 3",
      "INFERNAPE 3",
      "EMPOLEON 3",
      "DUGTRIO 3",
      "MAROWAK 3",
      "MEDICHAM 3",
      "QUAGSIRE 3",
      "GRANBULL 3",
      "JYNX 3",
      "MRMIME 3",
      "LANTURN 3",
      "BRELOOM 3",
      "FORRETRESS 3",
      "SKARMORY 3",
      "ABSOL 3",
      "WHISCASH 3",
      "HARIYAMA 3",
      "VESPIQUEN 3",
      "RAICHU 3",
      "DEWGONG 3",
      "MANECTRIC 3",
      "STARAPTOR 3",
      "GASTRODON 3",
      "SKUNTANK 3",
      "VILEPLUME 3",
      "VICTREEBEL 3",
      "ELECTRODE 3",
      "LUDICOLO 3",
      "SHIFTRY 3",
      "EXPLOUD 3",
      "GLALIE 3",
      "LOPUNNY 3",
      "FROSLASS 3",
      "AMBIPOM 3",
      "HYPNO 3",
      "GOLEM 3",
      "RHYDON 3",
      "SLOWBRO 3",
      "WEEZING 3",
      "KANGASKHAN 3",
      "TAUROS 3",
      "ALAKAZAM 3",
      "SLOWKING 3",
      "MILTANK 3",
      "ALTARIA 3",
      "TOXICROAK 3",
      "ABOMASNOW 3",
      "NIDOQUEEN 3",
      "NIDOKING 3",
      "CRADILY 3",
      "ARMALDO 3",
      "BASTIODON 3",
      "FLOATZEL 3",
      "MISMAGIUS 3",
      "DRIFBLIM 3",
      "GOLDUCK 3",
      "POLIWRATH 3",
      "RAPIDASH 3",
      "MUK 3"
    ]
  },
  {
    "name": "JANICE",
    "trainerClass": "Socialite",
    "pokemon": [
      "VENUSAUR 3",
      "CHARIZARD 3",
      "BLASTOISE 3",
      "MEGANIUM 3",
      "TYPHLOSION 3",
      "FERALIGATR 3",
      "SCEPTILE 3",
      "BLAZIKEN 3",
      "SWAMPERT 3",
      "TORTERRA 3",
      "INFERNAPE 3",
      "EMPOLEON 3",
      "DUGTRIO 3",
      "MAROWAK 3",
      "MEDICHAM 3",
      "QUAGSIRE 3",
      "GRANBULL 3",
      "JYNX 3",
      "MRMIME 3",
      "LANTURN 3",
      "BRELOOM 3",
      "FORRETRESS 3",
      "SKARMORY 3",
      "ABSOL 3",
      "WHISCASH 3",
      "HARIYAMA 3",
      "VESPIQUEN 3",
      "RAICHU 3",
      "DEWGONG 3",
      "MANECTRIC 3",
      "STARAPTOR 3",
      "GASTRODON 3",
      "SKUNTANK 3",
      "VILEPLUME 3",
      "VICTREEBEL 3",
      "ELECTRODE 3",
      "LUDICOLO 3",
      "SHIFTRY 3",
      "EXPLOUD 3",
      "GLALIE 3",
      "LOPUNNY 3",
      "FROSLASS 3",
      "AMBIPOM 3",
      "HYPNO 3",
      "GOLEM 3",
      "RHYDON 3",
      "SLOWBRO 3",
      "WEEZING 3",
      "KANGASKHAN 3",
      "TAUROS 3",
      "ALAKAZAM 3",
      "SLOWKING 3",
      "MILTANK 3",
      "ALTARIA 3",
      "TOXICROAK 3",
      "ABOMASNOW 3",
      "NIDOQUEEN 3",
      "NIDOKING 3",
      "CRADILY 3",
      "ARMALDO 3",
      "BASTIODON 3",
      "FLOATZEL 3",
      "MISMAGIUS 3",
      "DRIFBLIM 3",
      "GOLDUCK 3",
      "POLIWRATH 3",
      "RAPIDASH 3",
      "MUK 3"
    ]
  },
  {
    "name": "DIMITRI",
    "trainerClass": "Jogger",
    "pokemon": [
      "GENGAR 3",
      "AMPHAROS 3",
      "POLITOED 3",
      "PINSIR 3",
      "SCIZOR 3",
      "HERACROSS 3",
      "URSARING 3",
      "HOUNDOOM 3",
      "DONPHAN 3",
      "WAILORD 3",
      "CLAYDOL 3",
      "RAMPARDOS 3",
      "BRONZONG 3",
      "DRAPION 3",
      "LUXRAY 3",
      "NINETALES 3",
      "MACHAMP 3",
      "SHUCKLE 3",
      "ROSERADE 3",
      "HONCHKROW 3",
      "STEELIX 3",
      "WEAVILE 3",
      "GLISCOR 3",
      "TENTACRUEL 3",
      "AERODACTYL 3",
      "PORYGON2 3",
      "LICKILICKY 3",
      "YANMEGA 3",
      "GARDEVOIR 3",
      "GALLADE 3",
      "EXEGGUTOR 3",
      "STARMIE 3",
      "FLYGON 3",
      "VAPOREON 3",
      "JOLTEON 3",
      "FLAREON 3",
      "ESPEON 3",
      "UMBREON 3",
      "LEAFEON 3",
      "GLACEON 3",
      "LUCARIO 3",
      "HIPPOWDON 3",
      "PROBOPASS 3",
      "DUSKNOIR 3",
      "AGGRON 3",
      "WALREIN 3",
      "MAMOSWINE 3",
      "LAPRAS 3",
      "CROBAT 3",
      "MAGNEZONE 3",
      "RHYPERIOR 3",
      "TANGROWTH 3",
      "PORYGON-Z 3",
      "GYARADOS 3",
      "SNORLAX 3",
      "KINGDRA 3",
      "BLISSEY 3",
      "MILOTIC 3",
      "ELECTIVIRE 3",
      "MAGMORTAR 3",
      "TOGEKISS 3",
      "ARCANINE 3",
      "DRAGONITE 3",
      "TYRANITAR 3",
      "SALAMENCE 3",
      "METAGROSS 3",
      "GARCHOMP 3",
      "SLAKING 3"
    ]
  },
  {
    "name": "SAMI",
    "trainerClass": "Parasol Lady",
    "pokemon": [
      "GENGAR 3",
      "AMPHAROS 3",
      "POLITOED 3",
      "PINSIR 3",
      "SCIZOR 3",
      "HERACROSS 3",
      "URSARING 3",
      "HOUNDOOM 3",
      "DONPHAN 3",
      "WAILORD 3",
      "CLAYDOL 3",
      "RAMPARDOS 3",
      "BRONZONG 3",
      "DRAPION 3",
      "LUXRAY 3",
      "NINETALES 3",
      "MACHAMP 3",
      "SHUCKLE 3",
      "ROSERADE 3",
      "HONCHKROW 3",
      "STEELIX 3",
      "WEAVILE 3",
      "GLISCOR 3",
      "TENTACRUEL 3",
      "AERODACTYL 3",
      "PORYGON2 3",
      "LICKILICKY 3",
      "YANMEGA 3",
      "GARDEVOIR 3",
      "GALLADE 3",
      "EXEGGUTOR 3",
      "STARMIE 3",
      "FLYGON 3",
      "VAPOREON 3",
      "JOLTEON 3",
      "FLAREON 3",
      "ESPEON 3",
      "UMBREON 3",
      "LEAFEON 3",
      "GLACEON 3",
      "LUCARIO 3",
      "HIPPOWDON 3",
      "PROBOPASS 3",
      "DUSKNOIR 3",
      "AGGRON 3",
      "WALREIN 3",
      "MAMOSWINE 3",
      "LAPRAS 3",
      "CROBAT 3",
      "MAGNEZONE 3",
      "RHYPERIOR 3",
      "TANGROWTH 3",
      "PORYGON-Z 3",
      "GYARADOS 3",
      "SNORLAX 3",
      "KINGDRA 3",
      "BLISSEY 3",
      "MILOTIC 3",
      "ELECTIVIRE 3",
      "MAGMORTAR 3",
      "TOGEKISS 3",
      "ARCANINE 3",
      "DRAGONITE 3",
      "TYRANITAR 3",
      "SALAMENCE 3",
      "METAGROSS 3",
      "GARCHOMP 3",
      "SLAKING 3"
    ]
  },
  {
    "name": "ALFRED",
    "trainerClass": "Veteran",
    "pokemon": [
      "GENGAR 3",
      "AMPHAROS 3",
      "POLITOED 3",
      "PINSIR 3",
      "SCIZOR 3",
      "HERACROSS 3",
      "URSARING 3",
      "HOUNDOOM 3",
      "DONPHAN 3",
      "WAILORD 3",
      "CLAYDOL 3",
      "RAMPARDOS 3",
      "BRONZONG 3",
      "DRAPION 3",
      "LUXRAY 3",
      "NINETALES 3",
      "MACHAMP 3",
      "SHUCKLE 3",
      "ROSERADE 3",
      "HONCHKROW 3",
      "STEELIX 3",
      "WEAVILE 3",
      "GLISCOR 3",
      "TENTACRUEL 3",
      "AERODACTYL 3",
      "PORYGON2 3",
      "LICKILICKY 3",
      "YANMEGA 3",
      "GARDEVOIR 3",
      "GALLADE 3",
      "EXEGGUTOR 3",
      "STARMIE 3",
      "FLYGON 3",
      "VAPOREON 3",
      "JOLTEON 3",
      "FLAREON 3",
      "ESPEON 3",
      "UMBREON 3",
      "LEAFEON 3",
      "GLACEON 3",
      "LUCARIO 3",
      "HIPPOWDON 3",
      "PROBOPASS 3",
      "DUSKNOIR 3",
      "AGGRON 3",
      "WALREIN 3",
      "MAMOSWINE 3",
      "LAPRAS 3",
      "CROBAT 3",
      "MAGNEZONE 3",
      "RHYPERIOR 3",
      "TANGROWTH 3",
      "PORYGON-Z 3",
      "GYARADOS 3",
      "SNORLAX 3",
      "KINGDRA 3",
      "BLISSEY 3",
      "MILOTIC 3",
      "ELECTIVIRE 3",
      "MAGMORTAR 3",
      "TOGEKISS 3",
      "ARCANINE 3",
      "DRAGONITE 3",
      "TYRANITAR 3",
      "SALAMENCE 3",
      "METAGROSS 3",
      "GARCHOMP 3",
      "SLAKING 3"
    ]
  },
  {
    "name": "HARVEY",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "CHARIZARD 1",
      "CHARIZARD 2",
      "CHARIZARD 3",
      "CHARIZARD 4",
      "FERALIGATR 1",
      "FERALIGATR 2",
      "FERALIGATR 3",
      "FERALIGATR 4",
      "SCEPTILE 1",
      "SCEPTILE 2",
      "SCEPTILE 3",
      "SCEPTILE 4",
      "RHYDON 1",
      "RHYDON 2",
      "RHYDON 3",
      "RHYDON 4",
      "KANGASKHAN 1",
      "KANGASKHAN 2",
      "KANGASKHAN 3",
      "KANGASKHAN 4",
      "ALTARIA 1",
      "ALTARIA 2",
      "ALTARIA 3",
      "ALTARIA 4",
      "BASTIODON 1",
      "BASTIODON 2",
      "BASTIODON 3",
      "BASTIODON 4",
      "RAMPARDOS 1",
      "RAMPARDOS 2",
      "RAMPARDOS 3",
      "RAMPARDOS 4",
      "STEELIX 1",
      "STEELIX 2",
      "STEELIX 3",
      "STEELIX 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "FLYGON 1",
      "FLYGON 2",
      "FLYGON 3",
      "FLYGON 4",
      "AGGRON 1",
      "AGGRON 2",
      "AGGRON 3",
      "AGGRON 4",
      "LAPRAS 1",
      "LAPRAS 2",
      "LAPRAS 3",
      "LAPRAS 4",
      "GYARADOS 1",
      "GYARADOS 2",
      "GYARADOS 3",
      "GYARADOS 4",
      "KINGDRA 1",
      "KINGDRA 2",
      "KINGDRA 3",
      "KINGDRA 4",
      "MILOTIC 1",
      "MILOTIC 2",
      "MILOTIC 3",
      "MILOTIC 4",
      "ARCANINE 1",
      "ARCANINE 2",
      "ARCANINE 3",
      "ARCANINE 4",
      "DRAGONITE 1",
      "DRAGONITE 2",
      "DRAGONITE 3",
      "DRAGONITE 4",
      "TYRANITAR 1",
      "TYRANITAR 2",
      "TYRANITAR 3",
      "TYRANITAR 4",
      "SALAMENCE 1",
      "SALAMENCE 2",
      "SALAMENCE 3",
      "SALAMENCE 4",
      "GARCHOMP 1",
      "GARCHOMP 2",
      "GARCHOMP 3",
      "GARCHOMP 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4"
    ]
  },
  {
    "name": "NICOLAS",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "CHARIZARD 1",
      "CHARIZARD 2",
      "CHARIZARD 3",
      "CHARIZARD 4",
      "FERALIGATR 1",
      "FERALIGATR 2",
      "FERALIGATR 3",
      "FERALIGATR 4",
      "SCEPTILE 1",
      "SCEPTILE 2",
      "SCEPTILE 3",
      "SCEPTILE 4",
      "RHYDON 1",
      "RHYDON 2",
      "RHYDON 3",
      "RHYDON 4",
      "KANGASKHAN 1",
      "KANGASKHAN 2",
      "KANGASKHAN 3",
      "KANGASKHAN 4",
      "ALTARIA 1",
      "ALTARIA 2",
      "ALTARIA 3",
      "ALTARIA 4",
      "BASTIODON 1",
      "BASTIODON 2",
      "BASTIODON 3",
      "BASTIODON 4",
      "RAMPARDOS 1",
      "RAMPARDOS 2",
      "RAMPARDOS 3",
      "RAMPARDOS 4",
      "STEELIX 1",
      "STEELIX 2",
      "STEELIX 3",
      "STEELIX 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "FLYGON 1",
      "FLYGON 2",
      "FLYGON 3",
      "FLYGON 4",
      "AGGRON 1",
      "AGGRON 2",
      "AGGRON 3",
      "AGGRON 4",
      "LAPRAS 1",
      "LAPRAS 2",
      "LAPRAS 3",
      "LAPRAS 4",
      "GYARADOS 1",
      "GYARADOS 2",
      "GYARADOS 3",
      "GYARADOS 4",
      "KINGDRA 1",
      "KINGDRA 2",
      "KINGDRA 3",
      "KINGDRA 4",
      "MILOTIC 1",
      "MILOTIC 2",
      "MILOTIC 3",
      "MILOTIC 4",
      "ARCANINE 1",
      "ARCANINE 2",
      "ARCANINE 3",
      "ARCANINE 4",
      "DRAGONITE 1",
      "DRAGONITE 2",
      "DRAGONITE 3",
      "DRAGONITE 4",
      "TYRANITAR 1",
      "TYRANITAR 2",
      "TYRANITAR 3",
      "TYRANITAR 4",
      "SALAMENCE 1",
      "SALAMENCE 2",
      "SALAMENCE 3",
      "SALAMENCE 4",
      "GARCHOMP 1",
      "GARCHOMP 2",
      "GARCHOMP 3",
      "GARCHOMP 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4"
    ]
  },
  {
    "name": "AMBRE",
    "trainerClass": "Aroma Lady",
    "pokemon": [
      "VENUSAUR 2",
      "MEGANIUM 2",
      "SCEPTILE 2",
      "TORTERRA 2",
      "BRELOOM 2",
      "VILEPLUME 2",
      "VICTREEBEL 2",
      "LUDICOLO 2",
      "SHIFTRY 2",
      "ABOMASNOW 2",
      "CRADILY 2",
      "ROSERADE 2",
      "EXEGGUTOR 2",
      "LEAFEON 2",
      "TANGROWTH 2",
      "VENUSAUR 3",
      "MEGANIUM 3",
      "SCEPTILE 3",
      "TORTERRA 3",
      "BRELOOM 3",
      "VILEPLUME 3",
      "VICTREEBEL 3",
      "LUDICOLO 3",
      "SHIFTRY 3",
      "ABOMASNOW 3",
      "CRADILY 3",
      "ROSERADE 3",
      "EXEGGUTOR 3",
      "LEAFEON 3",
      "TANGROWTH 3",
      "VENUSAUR 4",
      "MEGANIUM 4",
      "SCEPTILE 4",
      "TORTERRA 4",
      "BRELOOM 4",
      "VILEPLUME 4",
      "VICTREEBEL 4",
      "LUDICOLO 4",
      "SHIFTRY 4",
      "ABOMASNOW 4",
      "CRADILY 4",
      "ROSERADE 4",
      "EXEGGUTOR 4",
      "LEAFEON 4",
      "TANGROWTH 4",
      "VENUSAUR 1",
      "MEGANIUM 1",
      "SCEPTILE 1",
      "TORTERRA 1",
      "BRELOOM 1",
      "VILEPLUME 1",
      "VICTREEBEL 1",
      "LUDICOLO 1",
      "SHIFTRY 1",
      "ABOMASNOW 1",
      "CRADILY 1",
      "ROSERADE 1",
      "EXEGGUTOR 1",
      "LEAFEON 1",
      "TANGROWTH 1"
    ]
  },
  {
    "name": "ELISHA",
    "trainerClass": "Aroma Lady",
    "pokemon": [
      "VENUSAUR 2",
      "MEGANIUM 2",
      "SCEPTILE 2",
      "TORTERRA 2",
      "BRELOOM 2",
      "VILEPLUME 2",
      "VICTREEBEL 2",
      "LUDICOLO 2",
      "SHIFTRY 2",
      "ABOMASNOW 2",
      "CRADILY 2",
      "ROSERADE 2",
      "EXEGGUTOR 2",
      "LEAFEON 2",
      "TANGROWTH 2",
      "VENUSAUR 3",
      "MEGANIUM 3",
      "SCEPTILE 3",
      "TORTERRA 3",
      "BRELOOM 3",
      "VILEPLUME 3",
      "VICTREEBEL 3",
      "LUDICOLO 3",
      "SHIFTRY 3",
      "ABOMASNOW 3",
      "CRADILY 3",
      "ROSERADE 3",
      "EXEGGUTOR 3",
      "LEAFEON 3",
      "TANGROWTH 3",
      "VENUSAUR 4",
      "MEGANIUM 4",
      "SCEPTILE 4",
      "TORTERRA 4",
      "BRELOOM 4",
      "VILEPLUME 4",
      "VICTREEBEL 4",
      "LUDICOLO 4",
      "SHIFTRY 4",
      "ABOMASNOW 4",
      "CRADILY 4",
      "ROSERADE 4",
      "EXEGGUTOR 4",
      "LEAFEON 4",
      "TANGROWTH 4",
      "VENUSAUR 1",
      "MEGANIUM 1",
      "SCEPTILE 1",
      "TORTERRA 1",
      "BRELOOM 1",
      "VILEPLUME 1",
      "VICTREEBEL 1",
      "LUDICOLO 1",
      "SHIFTRY 1",
      "ABOMASNOW 1",
      "CRADILY 1",
      "ROSERADE 1",
      "EXEGGUTOR 1",
      "LEAFEON 1",
      "TANGROWTH 1"
    ]
  },
  {
    "name": "MARIANE",
    "trainerClass": "Battle Girl",
    "pokemon": [
      "MOLTRES 1",
      "ENTEI 1",
      "HEATRAN 1",
      "CHARIZARD 2",
      "TYPHLOSION 2",
      "BLAZIKEN 2",
      "INFERNAPE 2",
      "MEDICHAM 2",
      "BRELOOM 2",
      "HARIYAMA 2",
      "TOXICROAK 2",
      "POLIWRATH 2",
      "RAPIDASH 2",
      "HERACROSS 2",
      "NINETALES 2",
      "HOUNDOOM 2",
      "MACHAMP 2",
      "GALLADE 2",
      "FLAREON 2",
      "LUCARIO 2",
      "MAGMORTAR 2",
      "ARCANINE 2",
      "MOLTRES 2",
      "ENTEI 2",
      "HEATRAN 2",
      "PRIMEAPE 2",
      "HITMONCHAN 2",
      "HITMONLEE 2",
      "HITMONTOP 2",
      "CHARIZARD 3",
      "TYPHLOSION 3",
      "BLAZIKEN 3",
      "INFERNAPE 3",
      "MEDICHAM 3",
      "BRELOOM 3",
      "HARIYAMA 3",
      "TOXICROAK 3",
      "POLIWRATH 3",
      "RAPIDASH 3",
      "HERACROSS 3",
      "NINETALES 3",
      "HOUNDOOM 3",
      "MACHAMP 3",
      "GALLADE 3",
      "FLAREON 3",
      "LUCARIO 3",
      "MAGMORTAR 3",
      "ARCANINE 3",
      "MOLTRES 3",
      "ENTEI 3",
      "HEATRAN 3",
      "CHARIZARD 4",
      "TYPHLOSION 4",
      "BLAZIKEN 4",
      "INFERNAPE 4",
      "MEDICHAM 4",
      "BRELOOM 4",
      "HARIYAMA 4",
      "TOXICROAK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "HERACROSS 4",
      "NINETALES 4",
      "HOUNDOOM 4",
      "MACHAMP 4",
      "GALLADE 4",
      "FLAREON 4",
      "LUCARIO 4",
      "MAGMORTAR 4",
      "ARCANINE 4",
      "MOLTRES 4",
      "ENTEI 4",
      "HEATRAN 4"
    ]
  },
  {
    "name": "EVE",
    "trainerClass": "Battle Girl",
    "pokemon": [
      "MOLTRES 1",
      "ENTEI 1",
      "HEATRAN 1",
      "CHARIZARD 2",
      "TYPHLOSION 2",
      "BLAZIKEN 2",
      "INFERNAPE 2",
      "MEDICHAM 2",
      "BRELOOM 2",
      "HARIYAMA 2",
      "TOXICROAK 2",
      "POLIWRATH 2",
      "RAPIDASH 2",
      "HERACROSS 2",
      "NINETALES 2",
      "HOUNDOOM 2",
      "MACHAMP 2",
      "GALLADE 2",
      "FLAREON 2",
      "LUCARIO 2",
      "MAGMORTAR 2",
      "ARCANINE 2",
      "MOLTRES 2",
      "ENTEI 2",
      "HEATRAN 2",
      "PRIMEAPE 2",
      "HITMONCHAN 2",
      "HITMONLEE 2",
      "HITMONTOP 2",
      "CHARIZARD 3",
      "TYPHLOSION 3",
      "BLAZIKEN 3",
      "INFERNAPE 3",
      "MEDICHAM 3",
      "BRELOOM 3",
      "HARIYAMA 3",
      "TOXICROAK 3",
      "POLIWRATH 3",
      "RAPIDASH 3",
      "HERACROSS 3",
      "NINETALES 3",
      "HOUNDOOM 3",
      "MACHAMP 3",
      "GALLADE 3",
      "FLAREON 3",
      "LUCARIO 3",
      "MAGMORTAR 3",
      "ARCANINE 3",
      "MOLTRES 3",
      "ENTEI 3",
      "HEATRAN 3",
      "CHARIZARD 4",
      "TYPHLOSION 4",
      "BLAZIKEN 4",
      "INFERNAPE 4",
      "MEDICHAM 4",
      "BRELOOM 4",
      "HARIYAMA 4",
      "TOXICROAK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "HERACROSS 4",
      "NINETALES 4",
      "HOUNDOOM 4",
      "MACHAMP 4",
      "GALLADE 4",
      "FLAREON 4",
      "LUCARIO 4",
      "MAGMORTAR 4",
      "ARCANINE 4",
      "MOLTRES 4",
      "ENTEI 4",
      "HEATRAN 4"
    ]
  },
  {
    "name": "FERGUS",
    "trainerClass": "Black Belt",
    "pokemon": [
      "MOLTRES 1",
      "ENTEI 1",
      "HEATRAN 1",
      "CHARIZARD 2",
      "TYPHLOSION 2",
      "BLAZIKEN 2",
      "INFERNAPE 2",
      "MEDICHAM 2",
      "BRELOOM 2",
      "HARIYAMA 2",
      "TOXICROAK 2",
      "POLIWRATH 2",
      "RAPIDASH 2",
      "HERACROSS 2",
      "NINETALES 2",
      "HOUNDOOM 2",
      "MACHAMP 2",
      "GALLADE 2",
      "FLAREON 2",
      "LUCARIO 2",
      "MAGMORTAR 2",
      "ARCANINE 2",
      "MOLTRES 2",
      "ENTEI 2",
      "HEATRAN 2",
      "PRIMEAPE 2",
      "HITMONCHAN 2",
      "HITMONLEE 2",
      "HITMONTOP 2",
      "CHARIZARD 3",
      "TYPHLOSION 3",
      "BLAZIKEN 3",
      "INFERNAPE 3",
      "MEDICHAM 3",
      "BRELOOM 3",
      "HARIYAMA 3",
      "TOXICROAK 3",
      "POLIWRATH 3",
      "RAPIDASH 3",
      "HERACROSS 3",
      "NINETALES 3",
      "HOUNDOOM 3",
      "MACHAMP 3",
      "GALLADE 3",
      "FLAREON 3",
      "LUCARIO 3",
      "MAGMORTAR 3",
      "ARCANINE 3",
      "MOLTRES 3",
      "ENTEI 3",
      "HEATRAN 3",
      "CHARIZARD 4",
      "TYPHLOSION 4",
      "BLAZIKEN 4",
      "INFERNAPE 4",
      "MEDICHAM 4",
      "BRELOOM 4",
      "HARIYAMA 4",
      "TOXICROAK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "HERACROSS 4",
      "NINETALES 4",
      "HOUNDOOM 4",
      "MACHAMP 4",
      "GALLADE 4",
      "FLAREON 4",
      "LUCARIO 4",
      "MAGMORTAR 4",
      "ARCANINE 4",
      "MOLTRES 4",
      "ENTEI 4",
      "HEATRAN 4"
    ]
  },
  {
    "name": "RONNI",
    "trainerClass": "Black Belt",
    "pokemon": [
      "MOLTRES 1",
      "ENTEI 1",
      "HEATRAN 1",
      "CHARIZARD 2",
      "TYPHLOSION 2",
      "BLAZIKEN 2",
      "INFERNAPE 2",
      "MEDICHAM 2",
      "BRELOOM 2",
      "HARIYAMA 2",
      "TOXICROAK 2",
      "POLIWRATH 2",
      "RAPIDASH 2",
      "HERACROSS 2",
      "NINETALES 2",
      "HOUNDOOM 2",
      "MACHAMP 2",
      "GALLADE 2",
      "FLAREON 2",
      "LUCARIO 2",
      "MAGMORTAR 2",
      "ARCANINE 2",
      "MOLTRES 2",
      "ENTEI 2",
      "HEATRAN 2",
      "PRIMEAPE 2",
      "HITMONCHAN 2",
      "HITMONLEE 2",
      "HITMONTOP 2",
      "CHARIZARD 3",
      "TYPHLOSION 3",
      "BLAZIKEN 3",
      "INFERNAPE 3",
      "MEDICHAM 3",
      "BRELOOM 3",
      "HARIYAMA 3",
      "TOXICROAK 3",
      "POLIWRATH 3",
      "RAPIDASH 3",
      "HERACROSS 3",
      "NINETALES 3",
      "HOUNDOOM 3",
      "MACHAMP 3",
      "GALLADE 3",
      "FLAREON 3",
      "LUCARIO 3",
      "MAGMORTAR 3",
      "ARCANINE 3",
      "MOLTRES 3",
      "ENTEI 3",
      "HEATRAN 3",
      "CHARIZARD 4",
      "TYPHLOSION 4",
      "BLAZIKEN 4",
      "INFERNAPE 4",
      "MEDICHAM 4",
      "BRELOOM 4",
      "HARIYAMA 4",
      "TOXICROAK 4",
      "POLIWRATH 4",
      "RAPIDASH 4",
      "HERACROSS 4",
      "NINETALES 4",
      "HOUNDOOM 4",
      "MACHAMP 4",
      "GALLADE 4",
      "FLAREON 4",
      "LUCARIO 4",
      "MAGMORTAR 4",
      "ARCANINE 4",
      "MOLTRES 4",
      "ENTEI 4",
      "HEATRAN 4"
    ]
  },
  {
    "name": "ELIZA",
    "trainerClass": "Bird Keeper",
    "pokemon": [
      "CHARIZARD 1",
      "CHARIZARD 2",
      "CHARIZARD 3",
      "CHARIZARD 4",
      "SKARMORY 1",
      "SKARMORY 2",
      "SKARMORY 3",
      "SKARMORY 4",
      "VESPIQUEN 1",
      "VESPIQUEN 2",
      "VESPIQUEN 3",
      "VESPIQUEN 4",
      "STARAPTOR 1",
      "STARAPTOR 2",
      "STARAPTOR 3",
      "STARAPTOR 4",
      "ALTARIA 1",
      "ALTARIA 2",
      "ALTARIA 3",
      "ALTARIA 4",
      "DRIFBLIM 1",
      "DRIFBLIM 2",
      "DRIFBLIM 3",
      "DRIFBLIM 4",
      "HONCHKROW 1",
      "HONCHKROW 2",
      "HONCHKROW 3",
      "HONCHKROW 4",
      "GLISCOR 1",
      "GLISCOR 2",
      "GLISCOR 3",
      "GLISCOR 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "YANMEGA 1",
      "YANMEGA 2",
      "YANMEGA 3",
      "YANMEGA 4",
      "CROBAT 1",
      "CROBAT 2",
      "CROBAT 3",
      "CROBAT 4",
      "GYARADOS 1",
      "GYARADOS 2",
      "GYARADOS 3",
      "GYARADOS 4",
      "TOGEKISS 1",
      "TOGEKISS 2",
      "TOGEKISS 3",
      "TOGEKISS 4",
      "DRAGONITE 1",
      "DRAGONITE 2",
      "DRAGONITE 3",
      "DRAGONITE 4",
      "SALAMENCE 1",
      "SALAMENCE 2",
      "SALAMENCE 3",
      "SALAMENCE 4",
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4",
      "XATU 2"
    ]
  },
  {
    "name": "KIRA",
    "trainerClass": "Bird Keeper",
    "pokemon": [
      "CHARIZARD 1",
      "CHARIZARD 2",
      "CHARIZARD 3",
      "CHARIZARD 4",
      "SKARMORY 1",
      "SKARMORY 2",
      "SKARMORY 3",
      "SKARMORY 4",
      "VESPIQUEN 1",
      "VESPIQUEN 2",
      "VESPIQUEN 3",
      "VESPIQUEN 4",
      "STARAPTOR 1",
      "STARAPTOR 2",
      "STARAPTOR 3",
      "STARAPTOR 4",
      "ALTARIA 1",
      "ALTARIA 2",
      "ALTARIA 3",
      "ALTARIA 4",
      "DRIFBLIM 1",
      "DRIFBLIM 2",
      "DRIFBLIM 3",
      "DRIFBLIM 4",
      "HONCHKROW 1",
      "HONCHKROW 2",
      "HONCHKROW 3",
      "HONCHKROW 4",
      "GLISCOR 1",
      "GLISCOR 2",
      "GLISCOR 3",
      "GLISCOR 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "YANMEGA 1",
      "YANMEGA 2",
      "YANMEGA 3",
      "YANMEGA 4",
      "CROBAT 1",
      "CROBAT 2",
      "CROBAT 3",
      "CROBAT 4",
      "GYARADOS 1",
      "GYARADOS 2",
      "GYARADOS 3",
      "GYARADOS 4",
      "TOGEKISS 1",
      "TOGEKISS 2",
      "TOGEKISS 3",
      "TOGEKISS 4",
      "DRAGONITE 1",
      "DRAGONITE 2",
      "DRAGONITE 3",
      "DRAGONITE 4",
      "SALAMENCE 1",
      "SALAMENCE 2",
      "SALAMENCE 3",
      "SALAMENCE 4",
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4",
      "XATU 2"
    ]
  },
  {
    "name": "DARREN",
    "trainerClass": "Cameraman",
    "pokemon": [
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "MRMIME 1",
      "MRMIME 2",
      "MRMIME 3",
      "MRMIME 4",
      "LANTURN 1",
      "LANTURN 2",
      "LANTURN 3",
      "LANTURN 4",
      "RAICHU 1",
      "RAICHU 2",
      "RAICHU 3",
      "RAICHU 4",
      "MANECTRIC 1",
      "MANECTRIC 2",
      "MANECTRIC 3",
      "MANECTRIC 4",
      "ELECTRODE 1",
      "ELECTRODE 2",
      "ELECTRODE 3",
      "ELECTRODE 4",
      "HYPNO 1",
      "HYPNO 2",
      "HYPNO 3",
      "HYPNO 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "ALAKAZAM 1",
      "ALAKAZAM 2",
      "ALAKAZAM 3",
      "ALAKAZAM 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "AMPHAROS 1",
      "AMPHAROS 2",
      "AMPHAROS 3",
      "AMPHAROS 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "LUXRAY 1",
      "LUXRAY 2",
      "LUXRAY 3",
      "LUXRAY 4",
      "GARDEVOIR 1",
      "GARDEVOIR 2",
      "GARDEVOIR 3",
      "GARDEVOIR 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "EXEGGUTOR 1",
      "EXEGGUTOR 2",
      "EXEGGUTOR 3",
      "EXEGGUTOR 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "JOLTEON 1",
      "JOLTEON 2",
      "JOLTEON 3",
      "JOLTEON 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "MAGNEZONE 1",
      "MAGNEZONE 2",
      "MAGNEZONE 3",
      "MAGNEZONE 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4",
      "ELECTIVIRE 1",
      "ELECTIVIRE 2",
      "ELECTIVIRE 3",
      "ELECTIVIRE 4"
    ]
  },
  {
    "name": "SKIP",
    "trainerClass": "Cameraman",
    "pokemon": [
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "MRMIME 1",
      "MRMIME 2",
      "MRMIME 3",
      "MRMIME 4",
      "LANTURN 1",
      "LANTURN 2",
      "LANTURN 3",
      "LANTURN 4",
      "RAICHU 1",
      "RAICHU 2",
      "RAICHU 3",
      "RAICHU 4",
      "MANECTRIC 1",
      "MANECTRIC 2",
      "MANECTRIC 3",
      "MANECTRIC 4",
      "ELECTRODE 1",
      "ELECTRODE 2",
      "ELECTRODE 3",
      "ELECTRODE 4",
      "HYPNO 1",
      "HYPNO 2",
      "HYPNO 3",
      "HYPNO 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "ALAKAZAM 1",
      "ALAKAZAM 2",
      "ALAKAZAM 3",
      "ALAKAZAM 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "AMPHAROS 1",
      "AMPHAROS 2",
      "AMPHAROS 3",
      "AMPHAROS 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "LUXRAY 1",
      "LUXRAY 2",
      "LUXRAY 3",
      "LUXRAY 4",
      "GARDEVOIR 1",
      "GARDEVOIR 2",
      "GARDEVOIR 3",
      "GARDEVOIR 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "EXEGGUTOR 1",
      "EXEGGUTOR 2",
      "EXEGGUTOR 3",
      "EXEGGUTOR 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "JOLTEON 1",
      "JOLTEON 2",
      "JOLTEON 3",
      "JOLTEON 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "MAGNEZONE 1",
      "MAGNEZONE 2",
      "MAGNEZONE 3",
      "MAGNEZONE 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4",
      "ELECTIVIRE 1",
      "ELECTIVIRE 2",
      "ELECTIVIRE 3",
      "ELECTIVIRE 4"
    ]
  },
  {
    "name": "ELAINE",
    "trainerClass": "Reporter",
    "pokemon": [
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "MRMIME 1",
      "MRMIME 2",
      "MRMIME 3",
      "MRMIME 4",
      "LANTURN 1",
      "LANTURN 2",
      "LANTURN 3",
      "LANTURN 4",
      "RAICHU 1",
      "RAICHU 2",
      "RAICHU 3",
      "RAICHU 4",
      "MANECTRIC 1",
      "MANECTRIC 2",
      "MANECTRIC 3",
      "MANECTRIC 4",
      "ELECTRODE 1",
      "ELECTRODE 2",
      "ELECTRODE 3",
      "ELECTRODE 4",
      "HYPNO 1",
      "HYPNO 2",
      "HYPNO 3",
      "HYPNO 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "ALAKAZAM 1",
      "ALAKAZAM 2",
      "ALAKAZAM 3",
      "ALAKAZAM 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "AMPHAROS 1",
      "AMPHAROS 2",
      "AMPHAROS 3",
      "AMPHAROS 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "LUXRAY 1",
      "LUXRAY 2",
      "LUXRAY 3",
      "LUXRAY 4",
      "GARDEVOIR 1",
      "GARDEVOIR 2",
      "GARDEVOIR 3",
      "GARDEVOIR 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "EXEGGUTOR 1",
      "EXEGGUTOR 2",
      "EXEGGUTOR 3",
      "EXEGGUTOR 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "JOLTEON 1",
      "JOLTEON 2",
      "JOLTEON 3",
      "JOLTEON 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "MAGNEZONE 1",
      "MAGNEZONE 2",
      "MAGNEZONE 3",
      "MAGNEZONE 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4",
      "ELECTIVIRE 1",
      "ELECTIVIRE 2",
      "ELECTIVIRE 3",
      "ELECTIVIRE 4"
    ]
  },
  {
    "name": "KATIE",
    "trainerClass": "Reporter",
    "pokemon": [
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "MRMIME 1",
      "MRMIME 2",
      "MRMIME 3",
      "MRMIME 4",
      "LANTURN 1",
      "LANTURN 2",
      "LANTURN 3",
      "LANTURN 4",
      "RAICHU 1",
      "RAICHU 2",
      "RAICHU 3",
      "RAICHU 4",
      "MANECTRIC 1",
      "MANECTRIC 2",
      "MANECTRIC 3",
      "MANECTRIC 4",
      "ELECTRODE 1",
      "ELECTRODE 2",
      "ELECTRODE 3",
      "ELECTRODE 4",
      "HYPNO 1",
      "HYPNO 2",
      "HYPNO 3",
      "HYPNO 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "ALAKAZAM 1",
      "ALAKAZAM 2",
      "ALAKAZAM 3",
      "ALAKAZAM 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "AMPHAROS 1",
      "AMPHAROS 2",
      "AMPHAROS 3",
      "AMPHAROS 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "LUXRAY 1",
      "LUXRAY 2",
      "LUXRAY 3",
      "LUXRAY 4",
      "GARDEVOIR 1",
      "GARDEVOIR 2",
      "GARDEVOIR 3",
      "GARDEVOIR 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "EXEGGUTOR 1",
      "EXEGGUTOR 2",
      "EXEGGUTOR 3",
      "EXEGGUTOR 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "JOLTEON 1",
      "JOLTEON 2",
      "JOLTEON 3",
      "JOLTEON 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "MAGNEZONE 1",
      "MAGNEZONE 2",
      "MAGNEZONE 3",
      "MAGNEZONE 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4",
      "ELECTIVIRE 1",
      "ELECTIVIRE 2",
      "ELECTIVIRE 3",
      "ELECTIVIRE 4"
    ]
  },
  {
    "name": "ENZO",
    "trainerClass": "Clown",
    "pokemon": [
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "MRMIME 1",
      "MRMIME 2",
      "MRMIME 3",
      "MRMIME 4",
      "FROSLASS 1",
      "FROSLASS 2",
      "FROSLASS 3",
      "FROSLASS 4",
      "HYPNO 1",
      "HYPNO 2",
      "HYPNO 3",
      "HYPNO 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "ALAKAZAM 1",
      "ALAKAZAM 2",
      "ALAKAZAM 3",
      "ALAKAZAM 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "MISMAGIUS 1",
      "MISMAGIUS 2",
      "MISMAGIUS 3",
      "MISMAGIUS 4",
      "DRIFBLIM 1",
      "DRIFBLIM 2",
      "DRIFBLIM 3",
      "DRIFBLIM 4",
      "GENGAR 1",
      "GENGAR 2",
      "GENGAR 3",
      "GENGAR 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "GARDEVOIR 1",
      "GARDEVOIR 2",
      "GARDEVOIR 3",
      "GARDEVOIR 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "EXEGGUTOR 1",
      "EXEGGUTOR 2",
      "EXEGGUTOR 3",
      "EXEGGUTOR 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "DUSKNOIR 1",
      "DUSKNOIR 2",
      "DUSKNOIR 3",
      "DUSKNOIR 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4"
    ]
  },
  {
    "name": "FRANK",
    "trainerClass": "Clown",
    "pokemon": [
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "MRMIME 1",
      "MRMIME 2",
      "MRMIME 3",
      "MRMIME 4",
      "FROSLASS 1",
      "FROSLASS 2",
      "FROSLASS 3",
      "FROSLASS 4",
      "HYPNO 1",
      "HYPNO 2",
      "HYPNO 3",
      "HYPNO 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "ALAKAZAM 1",
      "ALAKAZAM 2",
      "ALAKAZAM 3",
      "ALAKAZAM 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "MISMAGIUS 1",
      "MISMAGIUS 2",
      "MISMAGIUS 3",
      "MISMAGIUS 4",
      "DRIFBLIM 1",
      "DRIFBLIM 2",
      "DRIFBLIM 3",
      "DRIFBLIM 4",
      "GENGAR 1",
      "GENGAR 2",
      "GENGAR 3",
      "GENGAR 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "GARDEVOIR 1",
      "GARDEVOIR 2",
      "GARDEVOIR 3",
      "GARDEVOIR 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "EXEGGUTOR 1",
      "EXEGGUTOR 2",
      "EXEGGUTOR 3",
      "EXEGGUTOR 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "DUSKNOIR 1",
      "DUSKNOIR 2",
      "DUSKNOIR 3",
      "DUSKNOIR 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4"
    ]
  },
  {
    "name": "LEROY",
    "trainerClass": "Collector",
    "pokemon": [
      "VENUSAUR 1",
      "CHARIZARD 1",
      "BLASTOISE 1",
      "MEGANIUM 1",
      "TYPHLOSION 1",
      "FERALIGATR 1",
      "SCEPTILE 1",
      "BLAZIKEN 1",
      "SWAMPERT 1",
      "TORTERRA 1",
      "INFERNAPE 1",
      "EMPOLEON 1",
      "DUGTRIO 1",
      "MAROWAK 1",
      "MEDICHAM 1",
      "QUAGSIRE 1",
      "GRANBULL 1",
      "JYNX 1",
      "MRMIME 1",
      "LANTURN 1",
      "BRELOOM 1",
      "FORRETRESS 1",
      "SKARMORY 1",
      "ABSOL 1",
      "WHISCASH 1",
      "HARIYAMA 1",
      "VESPIQUEN 1",
      "RAICHU 1",
      "DEWGONG 1",
      "MANECTRIC 1",
      "STARAPTOR 1",
      "GASTRODON 1",
      "SKUNTANK 1",
      "VILEPLUME 1",
      "VICTREEBEL 1",
      "ELECTRODE 1",
      "LUDICOLO 1",
      "SHIFTRY 1",
      "EXPLOUD 1",
      "GLALIE 1",
      "LOPUNNY 1",
      "FROSLASS 1",
      "AMBIPOM 1",
      "HYPNO 1",
      "GOLEM 1",
      "RHYDON 1",
      "SLOWBRO 1",
      "WEEZING 1",
      "KANGASKHAN 1",
      "TAUROS 1",
      "ALAKAZAM 1",
      "SLOWKING 1",
      "MILTANK 1",
      "ALTARIA 1",
      "TOXICROAK 1",
      "ABOMASNOW 1",
      "NIDOQUEEN 1",
      "NIDOKING 1",
      "CRADILY 1",
      "ARMALDO 1",
      "BASTIODON 1",
      "FLOATZEL 1",
      "MISMAGIUS 1",
      "DRIFBLIM 1",
      "GOLDUCK 1",
      "POLIWRATH 1",
      "RAPIDASH 1",
      "MUK 1"
    ]
  },
  {
    "name": "NEWMAN",
    "trainerClass": "Collector",
    "pokemon": [
      "GENGAR 1",
      "AMPHAROS 1",
      "POLITOED 1",
      "PINSIR 1",
      "SCIZOR 1",
      "HERACROSS 1",
      "URSARING 1",
      "HOUNDOOM 1",
      "DONPHAN 1",
      "WAILORD 1",
      "CLAYDOL 1",
      "RAMPARDOS 1",
      "BRONZONG 1",
      "DRAPION 1",
      "LUXRAY 1",
      "NINETALES 1",
      "MACHAMP 1",
      "SHUCKLE 1",
      "ROSERADE 1",
      "HONCHKROW 1",
      "STEELIX 1",
      "WEAVILE 1",
      "GLISCOR 1",
      "TENTACRUEL 1",
      "AERODACTYL 1",
      "PORYGON2 1",
      "LICKILICKY 1",
      "YANMEGA 1",
      "GARDEVOIR 1",
      "GALLADE 1",
      "EXEGGUTOR 1",
      "STARMIE 1",
      "FLYGON 1",
      "VAPOREON 1",
      "JOLTEON 1",
      "FLAREON 1",
      "ESPEON 1",
      "UMBREON 1",
      "LEAFEON 1",
      "GLACEON 1",
      "LUCARIO 1",
      "HIPPOWDON 1",
      "PROBOPASS 1",
      "DUSKNOIR 1",
      "AGGRON 1",
      "WALREIN 1",
      "MAMOSWINE 1",
      "LAPRAS 1",
      "CROBAT 1",
      "MAGNEZONE 1",
      "RHYPERIOR 1",
      "TANGROWTH 1",
      "PORYGON-Z 1",
      "GYARADOS 1",
      "SNORLAX 1",
      "KINGDRA 1",
      "BLISSEY 1",
      "MILOTIC 1",
      "ELECTIVIRE 1",
      "MAGMORTAR 1",
      "TOGEKISS 1",
      "ARCANINE 1",
      "DRAGONITE 1",
      "TYRANITAR 1",
      "SALAMENCE 1",
      "METAGROSS 1",
      "GARCHOMP 1",
      "SLAKING 1"
    ]
  },
  {
    "name": "HILDA",
    "trainerClass": "Cyclist",
    "pokemon": [
      "CHARIZARD 1",
      "CHARIZARD 2",
      "CHARIZARD 3",
      "CHARIZARD 4",
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "BRELOOM 1",
      "BRELOOM 2",
      "BRELOOM 3",
      "BRELOOM 4",
      "SKARMORY 1",
      "SKARMORY 2",
      "SKARMORY 3",
      "SKARMORY 4",
      "STARAPTOR 1",
      "STARAPTOR 2",
      "STARAPTOR 3",
      "STARAPTOR 4",
      "ALTARIA 1",
      "ALTARIA 2",
      "ALTARIA 3",
      "ALTARIA 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "HERACROSS 1",
      "HERACROSS 2",
      "HERACROSS 3",
      "HERACROSS 4",
      "MACHAMP 1",
      "MACHAMP 2",
      "MACHAMP 3",
      "MACHAMP 4",
      "HONCHKROW 1",
      "HONCHKROW 2",
      "HONCHKROW 3",
      "HONCHKROW 4",
      "GLISCOR 1",
      "GLISCOR 2",
      "GLISCOR 3",
      "GLISCOR 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "YANMEGA 1",
      "YANMEGA 2",
      "YANMEGA 3",
      "YANMEGA 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "LUCARIO 1",
      "LUCARIO 2",
      "LUCARIO 3",
      "LUCARIO 4",
      "CROBAT 1",
      "CROBAT 2",
      "CROBAT 3",
      "CROBAT 4",
      "TOGEKISS 1",
      "TOGEKISS 2",
      "TOGEKISS 3",
      "TOGEKISS 4",
      "SALAMENCE 1",
      "SALAMENCE 2",
      "SALAMENCE 3",
      "SALAMENCE 4",
      "DRAGONITE 1",
      "DRAGONITE 2",
      "DRAGONITE 3",
      "DRAGONITE 4",
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4"
    ]
  },
  {
    "name": "VANITA",
    "trainerClass": "Cyclist",
    "pokemon": [
      "CHARIZARD 1",
      "CHARIZARD 2",
      "CHARIZARD 3",
      "CHARIZARD 4",
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "BRELOOM 1",
      "BRELOOM 2",
      "BRELOOM 3",
      "BRELOOM 4",
      "SKARMORY 1",
      "SKARMORY 2",
      "SKARMORY 3",
      "SKARMORY 4",
      "STARAPTOR 1",
      "STARAPTOR 2",
      "STARAPTOR 3",
      "STARAPTOR 4",
      "ALTARIA 1",
      "ALTARIA 2",
      "ALTARIA 3",
      "ALTARIA 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "HERACROSS 1",
      "HERACROSS 2",
      "HERACROSS 3",
      "HERACROSS 4",
      "MACHAMP 1",
      "MACHAMP 2",
      "MACHAMP 3",
      "MACHAMP 4",
      "HONCHKROW 1",
      "HONCHKROW 2",
      "HONCHKROW 3",
      "HONCHKROW 4",
      "GLISCOR 1",
      "GLISCOR 2",
      "GLISCOR 3",
      "GLISCOR 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "YANMEGA 1",
      "YANMEGA 2",
      "YANMEGA 3",
      "YANMEGA 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "LUCARIO 1",
      "LUCARIO 2",
      "LUCARIO 3",
      "LUCARIO 4",
      "CROBAT 1",
      "CROBAT 2",
      "CROBAT 3",
      "CROBAT 4",
      "TOGEKISS 1",
      "TOGEKISS 2",
      "TOGEKISS 3",
      "TOGEKISS 4",
      "SALAMENCE 1",
      "SALAMENCE 2",
      "SALAMENCE 3",
      "SALAMENCE 4",
      "DRAGONITE 1",
      "DRAGONITE 2",
      "DRAGONITE 3",
      "DRAGONITE 4",
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4"
    ]
  },
  {
    "name": "CLIVE",
    "trainerClass": "Cyclist",
    "pokemon": [
      "CHARIZARD 1",
      "CHARIZARD 2",
      "CHARIZARD 3",
      "CHARIZARD 4",
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "BRELOOM 1",
      "BRELOOM 2",
      "BRELOOM 3",
      "BRELOOM 4",
      "SKARMORY 1",
      "SKARMORY 2",
      "SKARMORY 3",
      "SKARMORY 4",
      "STARAPTOR 1",
      "STARAPTOR 2",
      "STARAPTOR 3",
      "STARAPTOR 4",
      "ALTARIA 1",
      "ALTARIA 2",
      "ALTARIA 3",
      "ALTARIA 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "HERACROSS 1",
      "HERACROSS 2",
      "HERACROSS 3",
      "HERACROSS 4",
      "MACHAMP 1",
      "MACHAMP 2",
      "MACHAMP 3",
      "MACHAMP 4",
      "HONCHKROW 1",
      "HONCHKROW 2",
      "HONCHKROW 3",
      "HONCHKROW 4",
      "GLISCOR 1",
      "GLISCOR 2",
      "GLISCOR 3",
      "GLISCOR 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "YANMEGA 1",
      "YANMEGA 2",
      "YANMEGA 3",
      "YANMEGA 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "LUCARIO 1",
      "LUCARIO 2",
      "LUCARIO 3",
      "LUCARIO 4",
      "CROBAT 1",
      "CROBAT 2",
      "CROBAT 3",
      "CROBAT 4",
      "TOGEKISS 1",
      "TOGEKISS 2",
      "TOGEKISS 3",
      "TOGEKISS 4",
      "SALAMENCE 1",
      "SALAMENCE 2",
      "SALAMENCE 3",
      "SALAMENCE 4",
      "DRAGONITE 1",
      "DRAGONITE 2",
      "DRAGONITE 3",
      "DRAGONITE 4",
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4"
    ]
  },
  {
    "name": "WARD",
    "trainerClass": "Cyclist",
    "pokemon": [
      "CHARIZARD 1",
      "CHARIZARD 2",
      "CHARIZARD 3",
      "CHARIZARD 4",
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "BRELOOM 1",
      "BRELOOM 2",
      "BRELOOM 3",
      "BRELOOM 4",
      "SKARMORY 1",
      "SKARMORY 2",
      "SKARMORY 3",
      "SKARMORY 4",
      "STARAPTOR 1",
      "STARAPTOR 2",
      "STARAPTOR 3",
      "STARAPTOR 4",
      "ALTARIA 1",
      "ALTARIA 2",
      "ALTARIA 3",
      "ALTARIA 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "HERACROSS 1",
      "HERACROSS 2",
      "HERACROSS 3",
      "HERACROSS 4",
      "MACHAMP 1",
      "MACHAMP 2",
      "MACHAMP 3",
      "MACHAMP 4",
      "HONCHKROW 1",
      "HONCHKROW 2",
      "HONCHKROW 3",
      "HONCHKROW 4",
      "GLISCOR 1",
      "GLISCOR 2",
      "GLISCOR 3",
      "GLISCOR 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "YANMEGA 1",
      "YANMEGA 2",
      "YANMEGA 3",
      "YANMEGA 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "LUCARIO 1",
      "LUCARIO 2",
      "LUCARIO 3",
      "LUCARIO 4",
      "CROBAT 1",
      "CROBAT 2",
      "CROBAT 3",
      "CROBAT 4",
      "TOGEKISS 1",
      "TOGEKISS 2",
      "TOGEKISS 3",
      "TOGEKISS 4",
      "SALAMENCE 1",
      "SALAMENCE 2",
      "SALAMENCE 3",
      "SALAMENCE 4",
      "DRAGONITE 1",
      "DRAGONITE 2",
      "DRAGONITE 3",
      "DRAGONITE 4",
      "ARTICUNO 1",
      "ARTICUNO 2",
      "ARTICUNO 3",
      "ARTICUNO 4",
      "ZAPDOS 1",
      "ZAPDOS 2",
      "ZAPDOS 3",
      "ZAPDOS 4",
      "MOLTRES 1",
      "MOLTRES 2",
      "MOLTRES 3",
      "MOLTRES 4"
    ]
  },
  {
    "name": "DELANEY",
    "trainerClass": "Fisherman",
    "pokemon": [
      "QUAGSIRE 1",
      "QUAGSIRE 2",
      "QUAGSIRE 3",
      "QUAGSIRE 4",
      "LANTURN 1",
      "LANTURN 2",
      "LANTURN 3",
      "LANTURN 4",
      "DEWGONG 1",
      "DEWGONG 2",
      "DEWGONG 3",
      "DEWGONG 4",
      "GASTRODON 1",
      "GASTRODON 2",
      "GASTRODON 3",
      "GASTRODON 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "FLOATZEL 1",
      "FLOATZEL 2",
      "FLOATZEL 3",
      "FLOATZEL 4",
      "GOLDUCK 1",
      "GOLDUCK 2",
      "GOLDUCK 3",
      "GOLDUCK 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "POLITOED 1",
      "POLITOED 2",
      "POLITOED 3",
      "POLITOED 4",
      "WAILORD 1",
      "WAILORD 2",
      "WAILORD 3",
      "WAILORD 4",
      "TENTACRUEL 1",
      "TENTACRUEL 2",
      "TENTACRUEL 3",
      "TENTACRUEL 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "WALREIN 1",
      "WALREIN 2",
      "WALREIN 3",
      "WALREIN 4",
      "LAPRAS 1",
      "LAPRAS 2",
      "LAPRAS 3",
      "LAPRAS 4",
      "GYARADOS 1",
      "GYARADOS 2",
      "GYARADOS 3",
      "GYARADOS 4",
      "KINGDRA 1",
      "KINGDRA 2",
      "KINGDRA 3",
      "KINGDRA 4",
      "MILOTIC 1",
      "MILOTIC 2",
      "MILOTIC 3",
      "MILOTIC 4",
      "SHARPEDO 2",
      "WHISCASH 1",
      "WHISCASH 2",
      "WHISCASH 3",
      "WHISCASH 4"
    ]
  },
  {
    "name": "KEATON",
    "trainerClass": "Fisherman",
    "pokemon": [
      "QUAGSIRE 1",
      "QUAGSIRE 2",
      "QUAGSIRE 3",
      "QUAGSIRE 4",
      "LANTURN 1",
      "LANTURN 2",
      "LANTURN 3",
      "LANTURN 4",
      "DEWGONG 1",
      "DEWGONG 2",
      "DEWGONG 3",
      "DEWGONG 4",
      "GASTRODON 1",
      "GASTRODON 2",
      "GASTRODON 3",
      "GASTRODON 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "FLOATZEL 1",
      "FLOATZEL 2",
      "FLOATZEL 3",
      "FLOATZEL 4",
      "GOLDUCK 1",
      "GOLDUCK 2",
      "GOLDUCK 3",
      "GOLDUCK 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "POLITOED 1",
      "POLITOED 2",
      "POLITOED 3",
      "POLITOED 4",
      "WAILORD 1",
      "WAILORD 2",
      "WAILORD 3",
      "WAILORD 4",
      "TENTACRUEL 1",
      "TENTACRUEL 2",
      "TENTACRUEL 3",
      "TENTACRUEL 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "WALREIN 1",
      "WALREIN 2",
      "WALREIN 3",
      "WALREIN 4",
      "LAPRAS 1",
      "LAPRAS 2",
      "LAPRAS 3",
      "LAPRAS 4",
      "GYARADOS 1",
      "GYARADOS 2",
      "GYARADOS 3",
      "GYARADOS 4",
      "KINGDRA 1",
      "KINGDRA 2",
      "KINGDRA 3",
      "KINGDRA 4",
      "MILOTIC 1",
      "MILOTIC 2",
      "MILOTIC 3",
      "MILOTIC 4",
      "SHARPEDO 2",
      "WHISCASH 1",
      "WHISCASH 2",
      "WHISCASH 3",
      "WHISCASH 4"
    ]
  },
  {
    "name": "IGGY",
    "trainerClass": "Guitarist",
    "pokemon": [
      "LANTURN 1",
      "LANTURN 2",
      "LANTURN 3",
      "LANTURN 4",
      "RAICHU 1",
      "RAICHU 2",
      "RAICHU 3",
      "RAICHU 4",
      "MANECTRIC 1",
      "MANECTRIC 2",
      "MANECTRIC 3",
      "MANECTRIC 4",
      "ELECTRODE 1",
      "ELECTRODE 2",
      "ELECTRODE 3",
      "ELECTRODE 4",
      "FROSLASS 1",
      "FROSLASS 2",
      "FROSLASS 3",
      "FROSLASS 4",
      "MISMAGIUS 1",
      "MISMAGIUS 2",
      "MISMAGIUS 3",
      "MISMAGIUS 4",
      "DRIFBLIM 1",
      "DRIFBLIM 2",
      "DRIFBLIM 3",
      "DRIFBLIM 4",
      "GENGAR 1",
      "GENGAR 2",
      "GENGAR 3",
      "GENGAR 4",
      "AMPHAROS 1",
      "AMPHAROS 2",
      "AMPHAROS 3",
      "AMPHAROS 4",
      "LUXRAY 1",
      "LUXRAY 2",
      "LUXRAY 3",
      "LUXRAY 4",
      "JOLTEON 1",
      "JOLTEON 2",
      "JOLTEON 3",
      "JOLTEON 4",
      "DUSKNOIR 1",
      "DUSKNOIR 2",
      "DUSKNOIR 3",
      "DUSKNOIR 4",
      "MAGNEZONE 1",
      "MAGNEZONE 2",
      "MAGNEZONE 3",
      "MAGNEZONE 4",
      "ELECTIVIRE 1",
      "ELECTIVIRE 2",
      "ELECTIVIRE 3",
      "ELECTIVIRE 4"
    ]
  },
  {
    "name": "ROGET",
    "trainerClass": "Guitarist",
    "pokemon": [
      "LANTURN 1",
      "LANTURN 2",
      "LANTURN 3",
      "LANTURN 4",
      "RAICHU 1",
      "RAICHU 2",
      "RAICHU 3",
      "RAICHU 4",
      "MANECTRIC 1",
      "MANECTRIC 2",
      "MANECTRIC 3",
      "MANECTRIC 4",
      "ELECTRODE 1",
      "ELECTRODE 2",
      "ELECTRODE 3",
      "ELECTRODE 4",
      "FROSLASS 1",
      "FROSLASS 2",
      "FROSLASS 3",
      "FROSLASS 4",
      "MISMAGIUS 1",
      "MISMAGIUS 2",
      "MISMAGIUS 3",
      "MISMAGIUS 4",
      "DRIFBLIM 1",
      "DRIFBLIM 2",
      "DRIFBLIM 3",
      "DRIFBLIM 4",
      "GENGAR 1",
      "GENGAR 2",
      "GENGAR 3",
      "GENGAR 4",
      "AMPHAROS 1",
      "AMPHAROS 2",
      "AMPHAROS 3",
      "AMPHAROS 4",
      "LUXRAY 1",
      "LUXRAY 2",
      "LUXRAY 3",
      "LUXRAY 4",
      "JOLTEON 1",
      "JOLTEON 2",
      "JOLTEON 3",
      "JOLTEON 4",
      "DUSKNOIR 1",
      "DUSKNOIR 2",
      "DUSKNOIR 3",
      "DUSKNOIR 4",
      "MAGNEZONE 1",
      "MAGNEZONE 2",
      "MAGNEZONE 3",
      "MAGNEZONE 4",
      "ELECTIVIRE 1",
      "ELECTIVIRE 2",
      "ELECTIVIRE 3",
      "ELECTIVIRE 4"
    ]
  },
  {
    "name": "GLEN",
    "trainerClass": "Hiker",
    "pokemon": [
      "TORTERRA 1",
      "TORTERRA 2",
      "TORTERRA 3",
      "TORTERRA 4",
      "DUGTRIO 1",
      "DUGTRIO 2",
      "DUGTRIO 3",
      "DUGTRIO 4",
      "MAROWAK 1",
      "MAROWAK 2",
      "MAROWAK 3",
      "MAROWAK 4",
      "GOLEM 1",
      "GOLEM 2",
      "GOLEM 3",
      "GOLEM 4",
      "RHYDON 1",
      "RHYDON 2",
      "RHYDON 3",
      "RHYDON 4",
      "NIDOQUEEN 1",
      "NIDOQUEEN 2",
      "NIDOQUEEN 3",
      "NIDOQUEEN 4",
      "NIDOKING 1",
      "NIDOKING 2",
      "NIDOKING 3",
      "NIDOKING 4",
      "CRADILY 1",
      "CRADILY 2",
      "CRADILY 3",
      "CRADILY 4",
      "ARMALDO 1",
      "ARMALDO 2",
      "ARMALDO 3",
      "ARMALDO 4",
      "BASTIODON 1",
      "BASTIODON 2",
      "BASTIODON 3",
      "BASTIODON 4",
      "DONPHAN 1",
      "DONPHAN 2",
      "DONPHAN 3",
      "DONPHAN 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "RAMPARDOS 1",
      "RAMPARDOS 2",
      "RAMPARDOS 3",
      "RAMPARDOS 4",
      "SHUCKLE 1",
      "SHUCKLE 2",
      "SHUCKLE 3",
      "SHUCKLE 4",
      "STEELIX 1",
      "STEELIX 2",
      "STEELIX 3",
      "STEELIX 4",
      "GLISCOR 1",
      "GLISCOR 2",
      "GLISCOR 3",
      "GLISCOR 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "FLYGON 1",
      "FLYGON 2",
      "FLYGON 3",
      "FLYGON 4",
      "HIPPOWDON 1",
      "HIPPOWDON 2",
      "HIPPOWDON 3",
      "HIPPOWDON 4",
      "PROBOPASS 1",
      "PROBOPASS 2",
      "PROBOPASS 3",
      "PROBOPASS 4",
      "AGGRON 1",
      "AGGRON 2",
      "AGGRON 3",
      "AGGRON 4",
      "MAMOSWINE 1",
      "MAMOSWINE 2",
      "MAMOSWINE 3",
      "MAMOSWINE 4",
      "RHYPERIOR 1",
      "RHYPERIOR 2",
      "RHYPERIOR 3",
      "RHYPERIOR 4",
      "TYRANITAR 1",
      "TYRANITAR 2",
      "TYRANITAR 3",
      "TYRANITAR 4"
    ]
  },
  {
    "name": "LYLE",
    "trainerClass": "Hiker",
    "pokemon": [
      "TORTERRA 1",
      "TORTERRA 2",
      "TORTERRA 3",
      "TORTERRA 4",
      "DUGTRIO 1",
      "DUGTRIO 2",
      "DUGTRIO 3",
      "DUGTRIO 4",
      "MAROWAK 1",
      "MAROWAK 2",
      "MAROWAK 3",
      "MAROWAK 4",
      "GOLEM 1",
      "GOLEM 2",
      "GOLEM 3",
      "GOLEM 4",
      "RHYDON 1",
      "RHYDON 2",
      "RHYDON 3",
      "RHYDON 4",
      "NIDOQUEEN 1",
      "NIDOQUEEN 2",
      "NIDOQUEEN 3",
      "NIDOQUEEN 4",
      "NIDOKING 1",
      "NIDOKING 2",
      "NIDOKING 3",
      "NIDOKING 4",
      "CRADILY 1",
      "CRADILY 2",
      "CRADILY 3",
      "CRADILY 4",
      "ARMALDO 1",
      "ARMALDO 2",
      "ARMALDO 3",
      "ARMALDO 4",
      "BASTIODON 1",
      "BASTIODON 2",
      "BASTIODON 3",
      "BASTIODON 4",
      "DONPHAN 1",
      "DONPHAN 2",
      "DONPHAN 3",
      "DONPHAN 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "RAMPARDOS 1",
      "RAMPARDOS 2",
      "RAMPARDOS 3",
      "RAMPARDOS 4",
      "SHUCKLE 1",
      "SHUCKLE 2",
      "SHUCKLE 3",
      "SHUCKLE 4",
      "STEELIX 1",
      "STEELIX 2",
      "STEELIX 3",
      "STEELIX 4",
      "GLISCOR 1",
      "GLISCOR 2",
      "GLISCOR 3",
      "GLISCOR 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "FLYGON 1",
      "FLYGON 2",
      "FLYGON 3",
      "FLYGON 4",
      "HIPPOWDON 1",
      "HIPPOWDON 2",
      "HIPPOWDON 3",
      "HIPPOWDON 4",
      "PROBOPASS 1",
      "PROBOPASS 2",
      "PROBOPASS 3",
      "PROBOPASS 4",
      "AGGRON 1",
      "AGGRON 2",
      "AGGRON 3",
      "AGGRON 4",
      "MAMOSWINE 1",
      "MAMOSWINE 2",
      "MAMOSWINE 3",
      "MAMOSWINE 4",
      "RHYPERIOR 1",
      "RHYPERIOR 2",
      "RHYPERIOR 3",
      "RHYPERIOR 4",
      "TYRANITAR 1",
      "TYRANITAR 2",
      "TYRANITAR 3",
      "TYRANITAR 4"
    ]
  },
  {
    "name": "COCOA",
    "trainerClass": "Idol",
    "pokemon": [
      "VAPOREON 1",
      "VAPOREON 2",
      "VAPOREON 3",
      "VAPOREON 4",
      "JOLTEON 1",
      "JOLTEON 2",
      "JOLTEON 3",
      "JOLTEON 4",
      "FLAREON 1",
      "FLAREON 2",
      "FLAREON 3",
      "FLAREON 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "UMBREON 1",
      "UMBREON 2",
      "UMBREON 3",
      "UMBREON 4",
      "LEAFEON 1",
      "LEAFEON 2",
      "LEAFEON 3",
      "LEAFEON 4",
      "GLACEON 1",
      "GLACEON 2",
      "GLACEON 3",
      "GLACEON 4"
    ]
  },
  {
    "name": "NISSA",
    "trainerClass": "Idol",
    "pokemon": [
      "VAPOREON 1",
      "VAPOREON 2",
      "VAPOREON 3",
      "VAPOREON 4",
      "JOLTEON 1",
      "JOLTEON 2",
      "JOLTEON 3",
      "JOLTEON 4",
      "FLAREON 1",
      "FLAREON 2",
      "FLAREON 3",
      "FLAREON 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "UMBREON 1",
      "UMBREON 2",
      "UMBREON 3",
      "UMBREON 4",
      "LEAFEON 1",
      "LEAFEON 2",
      "LEAFEON 3",
      "LEAFEON 4",
      "GLACEON 1",
      "GLACEON 2",
      "GLACEON 3",
      "GLACEON 4"
    ]
  },
  {
    "name": "KRISTI",
    "trainerClass": "Idol",
    "pokemon": [
      "VENUSAUR 1",
      "VENUSAUR 2",
      "VENUSAUR 3",
      "VENUSAUR 4",
      "CHARIZARD 1",
      "CHARIZARD 2",
      "CHARIZARD 3",
      "CHARIZARD 4",
      "BLASTOISE 1",
      "BLASTOISE 2",
      "BLASTOISE 3",
      "BLASTOISE 4",
      "MEGANIUM 1",
      "MEGANIUM 2",
      "MEGANIUM 3",
      "MEGANIUM 4",
      "TYPHLOSION 1",
      "TYPHLOSION 2",
      "TYPHLOSION 3",
      "TYPHLOSION 4",
      "FERALIGATR 1",
      "FERALIGATR 2",
      "FERALIGATR 3",
      "FERALIGATR 4",
      "SCEPTILE 1",
      "SCEPTILE 2",
      "SCEPTILE 3",
      "SCEPTILE 4",
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "SWAMPERT 1",
      "SWAMPERT 2",
      "SWAMPERT 3",
      "SWAMPERT 4",
      "TORTERRA 1",
      "TORTERRA 2",
      "TORTERRA 3",
      "TORTERRA 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "EMPOLEON 1",
      "EMPOLEON 2",
      "EMPOLEON 3",
      "EMPOLEON 4"
    ]
  },
  {
    "name": "TRISTA",
    "trainerClass": "Idol",
    "pokemon": [
      "VENUSAUR 1",
      "VENUSAUR 2",
      "VENUSAUR 3",
      "VENUSAUR 4",
      "CHARIZARD 1",
      "CHARIZARD 2",
      "CHARIZARD 3",
      "CHARIZARD 4",
      "BLASTOISE 1",
      "BLASTOISE 2",
      "BLASTOISE 3",
      "BLASTOISE 4",
      "MEGANIUM 1",
      "MEGANIUM 2",
      "MEGANIUM 3",
      "MEGANIUM 4",
      "TYPHLOSION 1",
      "TYPHLOSION 2",
      "TYPHLOSION 3",
      "TYPHLOSION 4",
      "FERALIGATR 1",
      "FERALIGATR 2",
      "FERALIGATR 3",
      "FERALIGATR 4",
      "SCEPTILE 1",
      "SCEPTILE 2",
      "SCEPTILE 3",
      "SCEPTILE 4",
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "SWAMPERT 1",
      "SWAMPERT 2",
      "SWAMPERT 3",
      "SWAMPERT 4",
      "TORTERRA 1",
      "TORTERRA 2",
      "TORTERRA 3",
      "TORTERRA 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "EMPOLEON 1",
      "EMPOLEON 2",
      "EMPOLEON 3",
      "EMPOLEON 4"
    ]
  },
  {
    "name": "HUGH",
    "trainerClass": "Policeman",
    "pokemon": [
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "EMPOLEON 1",
      "EMPOLEON 2",
      "EMPOLEON 3",
      "EMPOLEON 4",
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "BRELOOM 1",
      "BRELOOM 2",
      "BRELOOM 3",
      "BRELOOM 4",
      "FORRETRESS 1",
      "FORRETRESS 2",
      "FORRETRESS 3",
      "FORRETRESS 4",
      "SKARMORY 1",
      "SKARMORY 2",
      "SKARMORY 3",
      "SKARMORY 4",
      "HARIYAMA 1",
      "HARIYAMA 2",
      "HARIYAMA 3",
      "HARIYAMA 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "BASTIODON 1",
      "BASTIODON 2",
      "BASTIODON 3",
      "BASTIODON 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "SCIZOR 1",
      "SCIZOR 2",
      "SCIZOR 3",
      "SCIZOR 4",
      "HERACROSS 1",
      "HERACROSS 2",
      "HERACROSS 3",
      "HERACROSS 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "MACHAMP 1",
      "MACHAMP 2",
      "MACHAMP 3",
      "MACHAMP 4",
      "STEELIX 1",
      "STEELIX 2",
      "STEELIX 3",
      "STEELIX 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "LUCARIO 1",
      "LUCARIO 2",
      "LUCARIO 3",
      "LUCARIO 4",
      "PROBOPASS 1",
      "PROBOPASS 2",
      "PROBOPASS 3",
      "PROBOPASS 4",
      "AGGRON 1",
      "AGGRON 2",
      "AGGRON 3",
      "AGGRON 4",
      "MAGNEZONE 1",
      "MAGNEZONE 2",
      "MAGNEZONE 3",
      "MAGNEZONE 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4"
    ]
  },
  {
    "name": "KEGAN",
    "trainerClass": "Policeman",
    "pokemon": [
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "EMPOLEON 1",
      "EMPOLEON 2",
      "EMPOLEON 3",
      "EMPOLEON 4",
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "BRELOOM 1",
      "BRELOOM 2",
      "BRELOOM 3",
      "BRELOOM 4",
      "FORRETRESS 1",
      "FORRETRESS 2",
      "FORRETRESS 3",
      "FORRETRESS 4",
      "SKARMORY 1",
      "SKARMORY 2",
      "SKARMORY 3",
      "SKARMORY 4",
      "HARIYAMA 1",
      "HARIYAMA 2",
      "HARIYAMA 3",
      "HARIYAMA 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "BASTIODON 1",
      "BASTIODON 2",
      "BASTIODON 3",
      "BASTIODON 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "SCIZOR 1",
      "SCIZOR 2",
      "SCIZOR 3",
      "SCIZOR 4",
      "HERACROSS 1",
      "HERACROSS 2",
      "HERACROSS 3",
      "HERACROSS 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "MACHAMP 1",
      "MACHAMP 2",
      "MACHAMP 3",
      "MACHAMP 4",
      "STEELIX 1",
      "STEELIX 2",
      "STEELIX 3",
      "STEELIX 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "LUCARIO 1",
      "LUCARIO 2",
      "LUCARIO 3",
      "LUCARIO 4",
      "PROBOPASS 1",
      "PROBOPASS 2",
      "PROBOPASS 3",
      "PROBOPASS 4",
      "AGGRON 1",
      "AGGRON 2",
      "AGGRON 3",
      "AGGRON 4",
      "MAGNEZONE 1",
      "MAGNEZONE 2",
      "MAGNEZONE 3",
      "MAGNEZONE 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4"
    ]
  },
  {
    "name": "CHESTER",
    "trainerClass": "PI",
    "pokemon": [
      "KINGLER 2",
      "GLALIE 2",
      "ABOMASNOW 2",
      "NIDOKING 2",
      "FLYGON 2",
      "LAPRAS 2",
      "MAGNEZONE 2",
      "DUGTRIO 3",
      "WHISCASH 3",
      "DEWGONG 3",
      "GASTRODON 3",
      "WEEZING 3",
      "BASTIODON 3",
      "RAPIDASH 3",
      "GLISCOR 3",
      "EXEGGUTOR 3",
      "HIPPOWDON 3",
      "PROBOPASS 3",
      "WALREIN 3",
      "MAMOSWINE 3",
      "RHYPERIOR 3",
      "FORRETRESS 4",
      "SKUNTANK 4",
      "ELECTRODE 4",
      "SHIFTRY 4",
      "GLALIE 4",
      "GOLEM 4",
      "RHYDON 4",
      "DRIFBLIM 4",
      "MUK 4",
      "PINSIR 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "BRONZONG 4",
      "STEELIX 4",
      "LICKILICKY 4",
      "METAGROSS 4",
      "ARTICUNO 4",
      "REGIROCK 4",
      "HEATRAN 4"
    ]
  },
  {
    "name": "CONWAY",
    "trainerClass": "PI",
    "pokemon": [
      "KINGLER 2",
      "GLALIE 2",
      "ABOMASNOW 2",
      "NIDOKING 2",
      "FLYGON 2",
      "LAPRAS 2",
      "MAGNEZONE 2",
      "DUGTRIO 3",
      "WHISCASH 3",
      "DEWGONG 3",
      "GASTRODON 3",
      "WEEZING 3",
      "BASTIODON 3",
      "RAPIDASH 3",
      "GLISCOR 3",
      "EXEGGUTOR 3",
      "HIPPOWDON 3",
      "PROBOPASS 3",
      "WALREIN 3",
      "MAMOSWINE 3",
      "RHYPERIOR 3",
      "FORRETRESS 4",
      "SKUNTANK 4",
      "ELECTRODE 4",
      "SHIFTRY 4",
      "GLALIE 4",
      "GOLEM 4",
      "RHYDON 4",
      "DRIFBLIM 4",
      "MUK 4",
      "PINSIR 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "BRONZONG 4",
      "STEELIX 4",
      "LICKILICKY 4",
      "METAGROSS 4",
      "ARTICUNO 4",
      "REGIROCK 4",
      "HEATRAN 4"
    ]
  },
  {
    "name": "RALPH",
    "trainerClass": "PI",
    "pokemon": [
      "KINGLER 2",
      "GLALIE 2",
      "ABOMASNOW 2",
      "NIDOKING 2",
      "FLYGON 2",
      "LAPRAS 2",
      "MAGNEZONE 2",
      "DUGTRIO 3",
      "WHISCASH 3",
      "DEWGONG 3",
      "GASTRODON 3",
      "WEEZING 3",
      "BASTIODON 3",
      "RAPIDASH 3",
      "GLISCOR 3",
      "EXEGGUTOR 3",
      "HIPPOWDON 3",
      "PROBOPASS 3",
      "WALREIN 3",
      "MAMOSWINE 3",
      "RHYPERIOR 3",
      "FORRETRESS 4",
      "SKUNTANK 4",
      "ELECTRODE 4",
      "SHIFTRY 4",
      "GLALIE 4",
      "GOLEM 4",
      "RHYDON 4",
      "DRIFBLIM 4",
      "MUK 4",
      "PINSIR 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "BRONZONG 4",
      "STEELIX 4",
      "LICKILICKY 4",
      "METAGROSS 4",
      "ARTICUNO 4",
      "REGIROCK 4",
      "HEATRAN 4"
    ]
  },
  {
    "name": "RIVER",
    "trainerClass": "PI",
    "pokemon": [
      "KINGLER 2",
      "GLALIE 2",
      "ABOMASNOW 2",
      "NIDOKING 2",
      "FLYGON 2",
      "LAPRAS 2",
      "MAGNEZONE 2",
      "DUGTRIO 3",
      "WHISCASH 3",
      "DEWGONG 3",
      "GASTRODON 3",
      "WEEZING 3",
      "BASTIODON 3",
      "RAPIDASH 3",
      "GLISCOR 3",
      "EXEGGUTOR 3",
      "HIPPOWDON 3",
      "PROBOPASS 3",
      "WALREIN 3",
      "MAMOSWINE 3",
      "RHYPERIOR 3",
      "FORRETRESS 4",
      "SKUNTANK 4",
      "ELECTRODE 4",
      "SHIFTRY 4",
      "GLALIE 4",
      "GOLEM 4",
      "RHYDON 4",
      "DRIFBLIM 4",
      "MUK 4",
      "PINSIR 4",
      "DONPHAN 4",
      "WAILORD 4",
      "CLAYDOL 4",
      "BRONZONG 4",
      "STEELIX 4",
      "LICKILICKY 4",
      "METAGROSS 4",
      "ARTICUNO 4",
      "REGIROCK 4",
      "HEATRAN 4"
    ]
  },
  {
    "name": "IRENE",
    "trainerClass": "Psychic",
    "pokemon": [
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "MRMIME 1",
      "MRMIME 2",
      "MRMIME 3",
      "MRMIME 4",
      "HYPNO 1",
      "HYPNO 2",
      "HYPNO 3",
      "HYPNO 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "ALAKAZAM 1",
      "ALAKAZAM 2",
      "ALAKAZAM 3",
      "ALAKAZAM 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "GARDEVOIR 1",
      "GARDEVOIR 2",
      "GARDEVOIR 3",
      "GARDEVOIR 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "EXEGGUTOR 1",
      "EXEGGUTOR 2",
      "EXEGGUTOR 3",
      "EXEGGUTOR 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4",
      "CRESSELIA 1",
      "CRESSELIA 2",
      "CRESSELIA 3",
      "CRESSELIA 4",
      "GIRAFARIG 2"
    ]
  },
  {
    "name": "SYLVIE",
    "trainerClass": "Psychic",
    "pokemon": [
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "MRMIME 1",
      "MRMIME 2",
      "MRMIME 3",
      "MRMIME 4",
      "HYPNO 1",
      "HYPNO 2",
      "HYPNO 3",
      "HYPNO 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "ALAKAZAM 1",
      "ALAKAZAM 2",
      "ALAKAZAM 3",
      "ALAKAZAM 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "GARDEVOIR 1",
      "GARDEVOIR 2",
      "GARDEVOIR 3",
      "GARDEVOIR 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "EXEGGUTOR 1",
      "EXEGGUTOR 2",
      "EXEGGUTOR 3",
      "EXEGGUTOR 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4",
      "CRESSELIA 1",
      "CRESSELIA 2",
      "CRESSELIA 3",
      "CRESSELIA 4",
      "GIRAFARIG 2"
    ]
  },
  {
    "name": "BERKLEY",
    "trainerClass": "Psychic",
    "pokemon": [
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "MRMIME 1",
      "MRMIME 2",
      "MRMIME 3",
      "MRMIME 4",
      "HYPNO 1",
      "HYPNO 2",
      "HYPNO 3",
      "HYPNO 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "ALAKAZAM 1",
      "ALAKAZAM 2",
      "ALAKAZAM 3",
      "ALAKAZAM 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "GARDEVOIR 1",
      "GARDEVOIR 2",
      "GARDEVOIR 3",
      "GARDEVOIR 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "EXEGGUTOR 1",
      "EXEGGUTOR 2",
      "EXEGGUTOR 3",
      "EXEGGUTOR 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4",
      "CRESSELIA 1",
      "CRESSELIA 2",
      "CRESSELIA 3",
      "CRESSELIA 4",
      "GIRAFARIG 2"
    ]
  },
  {
    "name": "DENVER",
    "trainerClass": "Psychic",
    "pokemon": [
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "JYNX 1",
      "JYNX 2",
      "JYNX 3",
      "JYNX 4",
      "MRMIME 1",
      "MRMIME 2",
      "MRMIME 3",
      "MRMIME 4",
      "HYPNO 1",
      "HYPNO 2",
      "HYPNO 3",
      "HYPNO 4",
      "SLOWBRO 1",
      "SLOWBRO 2",
      "SLOWBRO 3",
      "SLOWBRO 4",
      "ALAKAZAM 1",
      "ALAKAZAM 2",
      "ALAKAZAM 3",
      "ALAKAZAM 4",
      "SLOWKING 1",
      "SLOWKING 2",
      "SLOWKING 3",
      "SLOWKING 4",
      "CLAYDOL 1",
      "CLAYDOL 2",
      "CLAYDOL 3",
      "CLAYDOL 4",
      "BRONZONG 1",
      "BRONZONG 2",
      "BRONZONG 3",
      "BRONZONG 4",
      "GARDEVOIR 1",
      "GARDEVOIR 2",
      "GARDEVOIR 3",
      "GARDEVOIR 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "EXEGGUTOR 1",
      "EXEGGUTOR 2",
      "EXEGGUTOR 3",
      "EXEGGUTOR 4",
      "STARMIE 1",
      "STARMIE 2",
      "STARMIE 3",
      "STARMIE 4",
      "ESPEON 1",
      "ESPEON 2",
      "ESPEON 3",
      "ESPEON 4",
      "METAGROSS 1",
      "METAGROSS 2",
      "METAGROSS 3",
      "METAGROSS 4",
      "LATIAS 1",
      "LATIAS 2",
      "LATIAS 3",
      "LATIAS 4",
      "LATIOS 1",
      "LATIOS 2",
      "LATIOS 3",
      "LATIOS 4",
      "CRESSELIA 1",
      "CRESSELIA 2",
      "CRESSELIA 3",
      "CRESSELIA 4",
      "GIRAFARIG 2"
    ]
  },
  {
    "name": "RON",
    "trainerClass": "Roughneck",
    "pokemon": [
      "ABSOL 1",
      "ABSOL 2",
      "ABSOL 3",
      "ABSOL 4",
      "SKUNTANK 1",
      "SKUNTANK 2",
      "SKUNTANK 3",
      "SKUNTANK 4",
      "SHIFTRY 1",
      "SHIFTRY 2",
      "SHIFTRY 3",
      "SHIFTRY 4",
      "FROSLASS 1",
      "FROSLASS 2",
      "FROSLASS 3",
      "FROSLASS 4",
      "WEEZING 1",
      "WEEZING 2",
      "WEEZING 3",
      "WEEZING 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "NIDOQUEEN 1",
      "NIDOQUEEN 2",
      "NIDOQUEEN 3",
      "NIDOQUEEN 4",
      "NIDOKING 1",
      "NIDOKING 2",
      "NIDOKING 3",
      "NIDOKING 4",
      "MISMAGIUS 1",
      "MISMAGIUS 2",
      "MISMAGIUS 3",
      "MISMAGIUS 4",
      "DRIFBLIM 1",
      "DRIFBLIM 2",
      "DRIFBLIM 3",
      "DRIFBLIM 4",
      "MUK 1",
      "MUK 2",
      "MUK 3",
      "MUK 4",
      "GENGAR 1",
      "GENGAR 2",
      "GENGAR 3",
      "GENGAR 4",
      "HOUNDOOM 1",
      "HOUNDOOM 2",
      "HOUNDOOM 3",
      "HOUNDOOM 4",
      "DRAPION 1",
      "DRAPION 2",
      "DRAPION 3",
      "DRAPION 4",
      "HONCHKROW 1",
      "HONCHKROW 2",
      "HONCHKROW 3",
      "HONCHKROW 4",
      "WEAVILE 1",
      "WEAVILE 2",
      "WEAVILE 3",
      "WEAVILE 4",
      "TENTACRUEL 1",
      "TENTACRUEL 2",
      "TENTACRUEL 3",
      "TENTACRUEL 4",
      "UMBREON 1",
      "UMBREON 2",
      "UMBREON 3",
      "UMBREON 4",
      "DUSKNOIR 1",
      "DUSKNOIR 2",
      "DUSKNOIR 3",
      "DUSKNOIR 4",
      "CROBAT 1",
      "CROBAT 2",
      "CROBAT 3",
      "CROBAT 4",
      "TYRANITAR 1",
      "TYRANITAR 2",
      "TYRANITAR 3",
      "TYRANITAR 4",
      "MIGHTYENA 2",
      "SHARPEDO 2",
      "CRAWDAUNT 2",
      "CACTURNE 2"
    ]
  },
  {
    "name": "ROSS",
    "trainerClass": "Roughneck",
    "pokemon": [
      "ABSOL 1",
      "ABSOL 2",
      "ABSOL 3",
      "ABSOL 4",
      "SKUNTANK 1",
      "SKUNTANK 2",
      "SKUNTANK 3",
      "SKUNTANK 4",
      "SHIFTRY 1",
      "SHIFTRY 2",
      "SHIFTRY 3",
      "SHIFTRY 4",
      "FROSLASS 1",
      "FROSLASS 2",
      "FROSLASS 3",
      "FROSLASS 4",
      "WEEZING 1",
      "WEEZING 2",
      "WEEZING 3",
      "WEEZING 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "NIDOQUEEN 1",
      "NIDOQUEEN 2",
      "NIDOQUEEN 3",
      "NIDOQUEEN 4",
      "NIDOKING 1",
      "NIDOKING 2",
      "NIDOKING 3",
      "NIDOKING 4",
      "MISMAGIUS 1",
      "MISMAGIUS 2",
      "MISMAGIUS 3",
      "MISMAGIUS 4",
      "DRIFBLIM 1",
      "DRIFBLIM 2",
      "DRIFBLIM 3",
      "DRIFBLIM 4",
      "MUK 1",
      "MUK 2",
      "MUK 3",
      "MUK 4",
      "GENGAR 1",
      "GENGAR 2",
      "GENGAR 3",
      "GENGAR 4",
      "HOUNDOOM 1",
      "HOUNDOOM 2",
      "HOUNDOOM 3",
      "HOUNDOOM 4",
      "DRAPION 1",
      "DRAPION 2",
      "DRAPION 3",
      "DRAPION 4",
      "HONCHKROW 1",
      "HONCHKROW 2",
      "HONCHKROW 3",
      "HONCHKROW 4",
      "WEAVILE 1",
      "WEAVILE 2",
      "WEAVILE 3",
      "WEAVILE 4",
      "TENTACRUEL 1",
      "TENTACRUEL 2",
      "TENTACRUEL 3",
      "TENTACRUEL 4",
      "UMBREON 1",
      "UMBREON 2",
      "UMBREON 3",
      "UMBREON 4",
      "DUSKNOIR 1",
      "DUSKNOIR 2",
      "DUSKNOIR 3",
      "DUSKNOIR 4",
      "CROBAT 1",
      "CROBAT 2",
      "CROBAT 3",
      "CROBAT 4",
      "TYRANITAR 1",
      "TYRANITAR 2",
      "TYRANITAR 3",
      "TYRANITAR 4",
      "MIGHTYENA 2",
      "SHARPEDO 2",
      "CRAWDAUNT 2",
      "CACTURNE 2"
    ]
  },
  {
    "name": "ISADORE",
    "trainerClass": "Rune Maniac",
    "pokemon": [
      "EMPOLEON 1",
      "FORRETRESS 1",
      "SKARMORY 1",
      "BASTIODON 1",
      "SCIZOR 1",
      "BRONZONG 1",
      "STEELIX 1",
      "LUCARIO 1",
      "PROBOPASS 1",
      "AGGRON 1",
      "MAGNEZONE 1",
      "METAGROSS 1",
      "EMPOLEON 2",
      "FORRETRESS 2",
      "SKARMORY 2",
      "BASTIODON 2",
      "SCIZOR 2",
      "BRONZONG 2",
      "STEELIX 2",
      "LUCARIO 2",
      "PROBOPASS 2",
      "AGGRON 2",
      "MAGNEZONE 2",
      "METAGROSS 2",
      "GOLEM 2",
      "RHYDON 2",
      "CRADILY 2",
      "ARMALDO 2",
      "RAMPARDOS 2",
      "SHUCKLE 2",
      "AERODACTYL 2",
      "RHYPERIOR 2",
      "TYRANITAR 2",
      "SUDOWOODO 2",
      "MAGCARGO 2",
      "PUPITAR 2",
      "METANG 2",
      "LAIRON 2",
      "LUNATONE 2",
      "SOLROCK 2",
      "MAGNETON 2",
      "RELICANTH 2",
      "OMASTAR 2",
      "KABUTOPS 2",
      "EMPOLEON 3",
      "FORRETRESS 3",
      "SKARMORY 3",
      "BASTIODON 3",
      "SCIZOR 3",
      "BRONZONG 3",
      "STEELIX 3",
      "LUCARIO 3",
      "PROBOPASS 3",
      "AGGRON 3",
      "MAGNEZONE 3",
      "METAGROSS 3",
      "GOLEM 3",
      "RHYDON 3",
      "CRADILY 3",
      "ARMALDO 3",
      "RAMPARDOS 3",
      "SHUCKLE 3",
      "AERODACTYL 3",
      "RHYPERIOR 3",
      "TYRANITAR 3",
      "EMPOLEON 4",
      "FORRETRESS 4",
      "SKARMORY 4",
      "BASTIODON 4",
      "SCIZOR 4",
      "BRONZONG 4",
      "STEELIX 4",
      "LUCARIO 4",
      "PROBOPASS 4",
      "AGGRON 4",
      "MAGNEZONE 4",
      "METAGROSS 4",
      "GOLEM 4",
      "RHYDON 4",
      "CRADILY 4",
      "ARMALDO 4",
      "RAMPARDOS 4",
      "SHUCKLE 4",
      "AERODACTYL 4",
      "RHYPERIOR 4",
      "TYRANITAR 4"
    ]
  },
  {
    "name": "WALTON",
    "trainerClass": "Rune Maniac",
    "pokemon": [
      "EMPOLEON 1",
      "FORRETRESS 1",
      "SKARMORY 1",
      "BASTIODON 1",
      "SCIZOR 1",
      "BRONZONG 1",
      "STEELIX 1",
      "LUCARIO 1",
      "PROBOPASS 1",
      "AGGRON 1",
      "MAGNEZONE 1",
      "METAGROSS 1",
      "EMPOLEON 2",
      "FORRETRESS 2",
      "SKARMORY 2",
      "BASTIODON 2",
      "SCIZOR 2",
      "BRONZONG 2",
      "STEELIX 2",
      "LUCARIO 2",
      "PROBOPASS 2",
      "AGGRON 2",
      "MAGNEZONE 2",
      "METAGROSS 2",
      "GOLEM 2",
      "RHYDON 2",
      "CRADILY 2",
      "ARMALDO 2",
      "RAMPARDOS 2",
      "SHUCKLE 2",
      "AERODACTYL 2",
      "RHYPERIOR 2",
      "TYRANITAR 2",
      "SUDOWOODO 2",
      "MAGCARGO 2",
      "PUPITAR 2",
      "METANG 2",
      "LAIRON 2",
      "LUNATONE 2",
      "SOLROCK 2",
      "MAGNETON 2",
      "RELICANTH 2",
      "OMASTAR 2",
      "KABUTOPS 2",
      "EMPOLEON 3",
      "FORRETRESS 3",
      "SKARMORY 3",
      "BASTIODON 3",
      "SCIZOR 3",
      "BRONZONG 3",
      "STEELIX 3",
      "LUCARIO 3",
      "PROBOPASS 3",
      "AGGRON 3",
      "MAGNEZONE 3",
      "METAGROSS 3",
      "GOLEM 3",
      "RHYDON 3",
      "CRADILY 3",
      "ARMALDO 3",
      "RAMPARDOS 3",
      "SHUCKLE 3",
      "AERODACTYL 3",
      "RHYPERIOR 3",
      "TYRANITAR 3",
      "EMPOLEON 4",
      "FORRETRESS 4",
      "SKARMORY 4",
      "BASTIODON 4",
      "SCIZOR 4",
      "BRONZONG 4",
      "STEELIX 4",
      "LUCARIO 4",
      "PROBOPASS 4",
      "AGGRON 4",
      "MAGNEZONE 4",
      "METAGROSS 4",
      "GOLEM 4",
      "RHYDON 4",
      "CRADILY 4",
      "ARMALDO 4",
      "RAMPARDOS 4",
      "SHUCKLE 4",
      "AERODACTYL 4",
      "RHYPERIOR 4",
      "TYRANITAR 4"
    ]
  },
  {
    "name": "CARLO",
    "trainerClass": "Sailor",
    "pokemon": [
      "BLASTOISE 4",
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "BRELOOM 1",
      "BRELOOM 2",
      "BRELOOM 3",
      "BRELOOM 4",
      "DEWGONG 4",
      "EMPOLEON 4",
      "FERALIGATR 4",
      "FLOATZEL 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "GASTRODON 4",
      "GOLDUCK 4",
      "GYARADOS 4",
      "HARIYAMA 1",
      "HARIYAMA 2",
      "HARIYAMA 3",
      "HARIYAMA 4",
      "HERACROSS 1",
      "HERACROSS 2",
      "HERACROSS 3",
      "HERACROSS 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "KINGDRA 4",
      "LANTURN 4",
      "LAPRAS 4",
      "LUCARIO 1",
      "LUCARIO 2",
      "LUCARIO 3",
      "LUCARIO 4",
      "LUDICOLO 4",
      "MACHAMP 1",
      "MACHAMP 2",
      "MACHAMP 3",
      "MACHAMP 4",
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "MILOTIC 4",
      "POLITOED 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "QUAGSIRE 4",
      "SLOWBRO 4",
      "SLOWKING 4",
      "STARMIE 4",
      "SWAMPERT 4",
      "TENTACRUEL 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "VAPOREON 4",
      "WAILORD 4",
      "WALREIN 4",
      "WHISCASH 4"
    ]
  },
  {
    "name": "HORATIO",
    "trainerClass": "Sailor",
    "pokemon": [
      "BLASTOISE 4",
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "BRELOOM 1",
      "BRELOOM 2",
      "BRELOOM 3",
      "BRELOOM 4",
      "DEWGONG 4",
      "EMPOLEON 4",
      "FERALIGATR 4",
      "FLOATZEL 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "GASTRODON 4",
      "GOLDUCK 4",
      "GYARADOS 4",
      "HARIYAMA 1",
      "HARIYAMA 2",
      "HARIYAMA 3",
      "HARIYAMA 4",
      "HERACROSS 1",
      "HERACROSS 2",
      "HERACROSS 3",
      "HERACROSS 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "KINGDRA 4",
      "LANTURN 4",
      "LAPRAS 4",
      "LUCARIO 1",
      "LUCARIO 2",
      "LUCARIO 3",
      "LUCARIO 4",
      "LUDICOLO 4",
      "MACHAMP 1",
      "MACHAMP 2",
      "MACHAMP 3",
      "MACHAMP 4",
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "MILOTIC 4",
      "POLITOED 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "QUAGSIRE 4",
      "SLOWBRO 4",
      "SLOWKING 4",
      "STARMIE 4",
      "SWAMPERT 4",
      "TENTACRUEL 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "VAPOREON 4",
      "WAILORD 4",
      "WALREIN 4",
      "WHISCASH 4"
    ]
  },
  {
    "name": "IRWIN",
    "trainerClass": "Scientist",
    "pokemon": [
      "VENUSAUR 2",
      "CHARIZARD 2",
      "BLASTOISE 2",
      "MEGANIUM 2",
      "TYPHLOSION 2",
      "FERALIGATR 2",
      "SCEPTILE 2",
      "BLAZIKEN 2",
      "SWAMPERT 2",
      "TORTERRA 2",
      "INFERNAPE 2",
      "EMPOLEON 2",
      "DUGTRIO 2",
      "MAROWAK 2",
      "MEDICHAM 2",
      "QUAGSIRE 2",
      "GRANBULL 2",
      "JYNX 2",
      "MRMIME 2",
      "LANTURN 2",
      "BRELOOM 2",
      "FORRETRESS 2",
      "SKARMORY 2",
      "ABSOL 2",
      "WHISCASH 2",
      "HARIYAMA 2",
      "VESPIQUEN 2",
      "RAICHU 2",
      "DEWGONG 2",
      "MANECTRIC 2",
      "STARAPTOR 2",
      "GASTRODON 2",
      "SKUNTANK 2",
      "VILEPLUME 2",
      "VICTREEBEL 2",
      "ELECTRODE 2",
      "LUDICOLO 2",
      "SHIFTRY 2",
      "EXPLOUD 2",
      "GLALIE 2",
      "LOPUNNY 2",
      "FROSLASS 2",
      "AMBIPOM 2",
      "HYPNO 2",
      "GOLEM 2",
      "RHYDON 2",
      "SLOWBRO 2",
      "WEEZING 2",
      "KANGASKHAN 2",
      "TAUROS 2",
      "ALAKAZAM 2",
      "SLOWKING 2",
      "MILTANK 2",
      "ALTARIA 2",
      "TOXICROAK 2",
      "ABOMASNOW 2",
      "NIDOQUEEN 2",
      "NIDOKING 2",
      "CRADILY 2",
      "ARMALDO 2",
      "BASTIODON 2",
      "FLOATZEL 2",
      "MISMAGIUS 2",
      "DRIFBLIM 2",
      "GOLDUCK 2",
      "POLIWRATH 2",
      "RAPIDASH 2",
      "MUK 2"
    ]
  },
  {
    "name": "FLYNN",
    "trainerClass": "Scientist",
    "pokemon": [
      "GENGAR 2",
      "AMPHAROS 2",
      "POLITOED 2",
      "PINSIR 2",
      "SCIZOR 2",
      "HERACROSS 2",
      "URSARING 2",
      "HOUNDOOM 2",
      "DONPHAN 2",
      "WAILORD 2",
      "CLAYDOL 2",
      "RAMPARDOS 2",
      "BRONZONG 2",
      "DRAPION 2",
      "LUXRAY 2",
      "NINETALES 2",
      "MACHAMP 2",
      "SHUCKLE 2",
      "ROSERADE 2",
      "HONCHKROW 2",
      "STEELIX 2",
      "WEAVILE 2",
      "GLISCOR 2",
      "TENTACRUEL 2",
      "AERODACTYL 2",
      "PORYGON2 2",
      "LICKILICKY 2",
      "YANMEGA 2",
      "GARDEVOIR 2",
      "GALLADE 2",
      "EXEGGUTOR 2",
      "STARMIE 2",
      "FLYGON 2",
      "VAPOREON 2",
      "JOLTEON 2",
      "FLAREON 2",
      "ESPEON 2",
      "UMBREON 2",
      "LEAFEON 2",
      "GLACEON 2",
      "LUCARIO 2",
      "HIPPOWDON 2",
      "PROBOPASS 2",
      "DUSKNOIR 2",
      "AGGRON 2",
      "WALREIN 2",
      "MAMOSWINE 2",
      "LAPRAS 2",
      "CROBAT 2",
      "MAGNEZONE 2",
      "RHYPERIOR 2",
      "TANGROWTH 2",
      "PORYGON-Z 2",
      "GYARADOS 2",
      "SNORLAX 2",
      "KINGDRA 2",
      "BLISSEY 2",
      "MILOTIC 2",
      "ELECTIVIRE 2",
      "MAGMORTAR 2",
      "TOGEKISS 2",
      "ARCANINE 2",
      "DRAGONITE 2",
      "TYRANITAR 2",
      "SALAMENCE 2",
      "METAGROSS 2",
      "GARCHOMP 2",
      "SLAKING 2"
    ]
  },
  {
    "name": "XANDER",
    "trainerClass": "Waiter",
    "pokemon": [
      "GENGAR 2",
      "AMPHAROS 2",
      "POLITOED 2",
      "PINSIR 2",
      "SCIZOR 2",
      "HERACROSS 2",
      "URSARING 2",
      "HOUNDOOM 2",
      "DONPHAN 2",
      "WAILORD 2",
      "CLAYDOL 2",
      "RAMPARDOS 2",
      "BRONZONG 2",
      "DRAPION 2",
      "LUXRAY 2",
      "NINETALES 2",
      "MACHAMP 2",
      "SHUCKLE 2",
      "ROSERADE 2",
      "HONCHKROW 2",
      "STEELIX 2",
      "WEAVILE 2",
      "GLISCOR 2",
      "TENTACRUEL 2",
      "AERODACTYL 2",
      "PORYGON2 2",
      "LICKILICKY 2",
      "YANMEGA 2",
      "GARDEVOIR 2",
      "GALLADE 2",
      "EXEGGUTOR 2",
      "STARMIE 2",
      "FLYGON 2",
      "VAPOREON 2",
      "JOLTEON 2",
      "FLAREON 2",
      "ESPEON 2",
      "UMBREON 2",
      "LEAFEON 2",
      "GLACEON 2",
      "LUCARIO 2",
      "HIPPOWDON 2",
      "PROBOPASS 2",
      "DUSKNOIR 2",
      "AGGRON 2",
      "WALREIN 2",
      "MAMOSWINE 2",
      "LAPRAS 2",
      "CROBAT 2",
      "MAGNEZONE 2",
      "RHYPERIOR 2",
      "TANGROWTH 2",
      "PORYGON-Z 2",
      "GYARADOS 2",
      "SNORLAX 2",
      "KINGDRA 2",
      "BLISSEY 2",
      "MILOTIC 2",
      "ELECTIVIRE 2",
      "MAGMORTAR 2",
      "TOGEKISS 2",
      "ARCANINE 2",
      "DRAGONITE 2",
      "TYRANITAR 2",
      "SALAMENCE 2",
      "METAGROSS 2",
      "GARCHOMP 2",
      "SLAKING 2"
    ]
  },
  {
    "name": "LESLIE",
    "trainerClass": "Waitress",
    "pokemon": [
      "GENGAR 2",
      "AMPHAROS 2",
      "POLITOED 2",
      "PINSIR 2",
      "SCIZOR 2",
      "HERACROSS 2",
      "URSARING 2",
      "HOUNDOOM 2",
      "DONPHAN 2",
      "WAILORD 2",
      "CLAYDOL 2",
      "RAMPARDOS 2",
      "BRONZONG 2",
      "DRAPION 2",
      "LUXRAY 2",
      "NINETALES 2",
      "MACHAMP 2",
      "SHUCKLE 2",
      "ROSERADE 2",
      "HONCHKROW 2",
      "STEELIX 2",
      "WEAVILE 2",
      "GLISCOR 2",
      "TENTACRUEL 2",
      "AERODACTYL 2",
      "PORYGON2 2",
      "LICKILICKY 2",
      "YANMEGA 2",
      "GARDEVOIR 2",
      "GALLADE 2",
      "EXEGGUTOR 2",
      "STARMIE 2",
      "FLYGON 2",
      "VAPOREON 2",
      "JOLTEON 2",
      "FLAREON 2",
      "ESPEON 2",
      "UMBREON 2",
      "LEAFEON 2",
      "GLACEON 2",
      "LUCARIO 2",
      "HIPPOWDON 2",
      "PROBOPASS 2",
      "DUSKNOIR 2",
      "AGGRON 2",
      "WALREIN 2",
      "MAMOSWINE 2",
      "LAPRAS 2",
      "CROBAT 2",
      "MAGNEZONE 2",
      "RHYPERIOR 2",
      "TANGROWTH 2",
      "PORYGON-Z 2",
      "GYARADOS 2",
      "SNORLAX 2",
      "KINGDRA 2",
      "BLISSEY 2",
      "MILOTIC 2",
      "ELECTIVIRE 2",
      "MAGMORTAR 2",
      "TOGEKISS 2",
      "ARCANINE 2",
      "DRAGONITE 2",
      "TYRANITAR 2",
      "SALAMENCE 2",
      "METAGROSS 2",
      "GARCHOMP 2",
      "SLAKING 2"
    ]
  },
  {
    "name": "WARREN",
    "trainerClass": "Waiter",
    "pokemon": [
      "VENUSAUR 2",
      "CHARIZARD 2",
      "BLASTOISE 2",
      "MEGANIUM 2",
      "TYPHLOSION 2",
      "FERALIGATR 2",
      "SCEPTILE 2",
      "BLAZIKEN 2",
      "SWAMPERT 2",
      "TORTERRA 2",
      "INFERNAPE 2",
      "EMPOLEON 2",
      "DUGTRIO 2",
      "MAROWAK 2",
      "MEDICHAM 2",
      "QUAGSIRE 2",
      "GRANBULL 2",
      "JYNX 2",
      "MRMIME 2",
      "LANTURN 2",
      "BRELOOM 2",
      "FORRETRESS 2",
      "SKARMORY 2",
      "ABSOL 2",
      "WHISCASH 2",
      "HARIYAMA 2",
      "VESPIQUEN 2",
      "RAICHU 2",
      "DEWGONG 2",
      "MANECTRIC 2",
      "STARAPTOR 2",
      "GASTRODON 2",
      "SKUNTANK 2",
      "VILEPLUME 2",
      "VICTREEBEL 2",
      "ELECTRODE 2",
      "LUDICOLO 2",
      "SHIFTRY 2",
      "EXPLOUD 2",
      "GLALIE 2",
      "LOPUNNY 2",
      "FROSLASS 2",
      "AMBIPOM 2",
      "HYPNO 2",
      "GOLEM 2",
      "RHYDON 2",
      "SLOWBRO 2",
      "WEEZING 2",
      "KANGASKHAN 2",
      "TAUROS 2",
      "ALAKAZAM 2",
      "SLOWKING 2",
      "MILTANK 2",
      "ALTARIA 2",
      "TOXICROAK 2",
      "ABOMASNOW 2",
      "NIDOQUEEN 2",
      "NIDOKING 2",
      "CRADILY 2",
      "ARMALDO 2",
      "BASTIODON 2",
      "FLOATZEL 2",
      "MISMAGIUS 2",
      "DRIFBLIM 2",
      "GOLDUCK 2",
      "POLIWRATH 2",
      "RAPIDASH 2",
      "MUK 2"
    ]
  },
  {
    "name": "KATHY",
    "trainerClass": "Waitress",
    "pokemon": [
      "VENUSAUR 2",
      "CHARIZARD 2",
      "BLASTOISE 2",
      "MEGANIUM 2",
      "TYPHLOSION 2",
      "FERALIGATR 2",
      "SCEPTILE 2",
      "BLAZIKEN 2",
      "SWAMPERT 2",
      "TORTERRA 2",
      "INFERNAPE 2",
      "EMPOLEON 2",
      "DUGTRIO 2",
      "MAROWAK 2",
      "MEDICHAM 2",
      "QUAGSIRE 2",
      "GRANBULL 2",
      "JYNX 2",
      "MRMIME 2",
      "LANTURN 2",
      "BRELOOM 2",
      "FORRETRESS 2",
      "SKARMORY 2",
      "ABSOL 2",
      "WHISCASH 2",
      "HARIYAMA 2",
      "VESPIQUEN 2",
      "RAICHU 2",
      "DEWGONG 2",
      "MANECTRIC 2",
      "STARAPTOR 2",
      "GASTRODON 2",
      "SKUNTANK 2",
      "VILEPLUME 2",
      "VICTREEBEL 2",
      "ELECTRODE 2",
      "LUDICOLO 2",
      "SHIFTRY 2",
      "EXPLOUD 2",
      "GLALIE 2",
      "LOPUNNY 2",
      "FROSLASS 2",
      "AMBIPOM 2",
      "HYPNO 2",
      "GOLEM 2",
      "RHYDON 2",
      "SLOWBRO 2",
      "WEEZING 2",
      "KANGASKHAN 2",
      "TAUROS 2",
      "ALAKAZAM 2",
      "SLOWKING 2",
      "MILTANK 2",
      "ALTARIA 2",
      "TOXICROAK 2",
      "ABOMASNOW 2",
      "NIDOQUEEN 2",
      "NIDOKING 2",
      "CRADILY 2",
      "ARMALDO 2",
      "BASTIODON 2",
      "FLOATZEL 2",
      "MISMAGIUS 2",
      "DRIFBLIM 2",
      "GOLDUCK 2",
      "POLIWRATH 2",
      "RAPIDASH 2",
      "MUK 2"
    ]
  },
  {
    "name": "BOYCE",
    "trainerClass": "Worker",
    "pokemon": [
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "HARIYAMA 1",
      "HARIYAMA 2",
      "HARIYAMA 3",
      "HARIYAMA 4",
      "GOLEM 1",
      "GOLEM 2",
      "GOLEM 3",
      "GOLEM 4",
      "RHYDON 1",
      "RHYDON 2",
      "RHYDON 3",
      "RHYDON 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "CRADILY 1",
      "CRADILY 2",
      "CRADILY 3",
      "CRADILY 4",
      "ARMALDO 1",
      "ARMALDO 2",
      "ARMALDO 3",
      "ARMALDO 4",
      "BASTIODON 1",
      "BASTIODON 2",
      "BASTIODON 3",
      "BASTIODON 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "HERACROSS 1",
      "HERACROSS 2",
      "HERACROSS 3",
      "HERACROSS 4",
      "RAMPARDOS 1",
      "RAMPARDOS 2",
      "RAMPARDOS 3",
      "RAMPARDOS 4",
      "MACHAMP 1",
      "MACHAMP 2",
      "MACHAMP 3",
      "MACHAMP 4",
      "SHUCKLE 1",
      "SHUCKLE 2",
      "SHUCKLE 3",
      "SHUCKLE 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "LUCARIO 1",
      "LUCARIO 2",
      "LUCARIO 3",
      "LUCARIO 4",
      "PROBOPASS 1",
      "PROBOPASS 2",
      "PROBOPASS 3",
      "PROBOPASS 4",
      "AGGRON 1",
      "AGGRON 2",
      "AGGRON 3",
      "AGGRON 4",
      "RHYPERIOR 1",
      "RHYPERIOR 2",
      "RHYPERIOR 3",
      "RHYPERIOR 4",
      "TYRANITAR 1",
      "TYRANITAR 2",
      "TYRANITAR 3",
      "TYRANITAR 4",
      "BRELOOM 1",
      "BRELOOM 2",
      "BRELOOM 3",
      "BRELOOM 4"
    ]
  },
  {
    "name": "TYRELL",
    "trainerClass": "Worker",
    "pokemon": [
      "BLAZIKEN 1",
      "BLAZIKEN 2",
      "BLAZIKEN 3",
      "BLAZIKEN 4",
      "INFERNAPE 1",
      "INFERNAPE 2",
      "INFERNAPE 3",
      "INFERNAPE 4",
      "MEDICHAM 1",
      "MEDICHAM 2",
      "MEDICHAM 3",
      "MEDICHAM 4",
      "HARIYAMA 1",
      "HARIYAMA 2",
      "HARIYAMA 3",
      "HARIYAMA 4",
      "GOLEM 1",
      "GOLEM 2",
      "GOLEM 3",
      "GOLEM 4",
      "RHYDON 1",
      "RHYDON 2",
      "RHYDON 3",
      "RHYDON 4",
      "TOXICROAK 1",
      "TOXICROAK 2",
      "TOXICROAK 3",
      "TOXICROAK 4",
      "CRADILY 1",
      "CRADILY 2",
      "CRADILY 3",
      "CRADILY 4",
      "ARMALDO 1",
      "ARMALDO 2",
      "ARMALDO 3",
      "ARMALDO 4",
      "BASTIODON 1",
      "BASTIODON 2",
      "BASTIODON 3",
      "BASTIODON 4",
      "POLIWRATH 1",
      "POLIWRATH 2",
      "POLIWRATH 3",
      "POLIWRATH 4",
      "HERACROSS 1",
      "HERACROSS 2",
      "HERACROSS 3",
      "HERACROSS 4",
      "RAMPARDOS 1",
      "RAMPARDOS 2",
      "RAMPARDOS 3",
      "RAMPARDOS 4",
      "MACHAMP 1",
      "MACHAMP 2",
      "MACHAMP 3",
      "MACHAMP 4",
      "SHUCKLE 1",
      "SHUCKLE 2",
      "SHUCKLE 3",
      "SHUCKLE 4",
      "AERODACTYL 1",
      "AERODACTYL 2",
      "AERODACTYL 3",
      "AERODACTYL 4",
      "GALLADE 1",
      "GALLADE 2",
      "GALLADE 3",
      "GALLADE 4",
      "LUCARIO 1",
      "LUCARIO 2",
      "LUCARIO 3",
      "LUCARIO 4",
      "PROBOPASS 1",
      "PROBOPASS 2",
      "PROBOPASS 3",
      "PROBOPASS 4",
      "AGGRON 1",
      "AGGRON 2",
      "AGGRON 3",
      "AGGRON 4",
      "RHYPERIOR 1",
      "RHYPERIOR 2",
      "RHYPERIOR 3",
      "RHYPERIOR 4",
      "TYRANITAR 1",
      "TYRANITAR 2",
      "TYRANITAR 3",
      "TYRANITAR 4",
      "BRELOOM 1",
      "BRELOOM 2",
      "BRELOOM 3",
      "BRELOOM 4"
    ]
  },
  {
    "name": "YARDLEY",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "GENGAR 1",
      "AMPHAROS 1",
      "POLITOED 1",
      "PINSIR 1",
      "SCIZOR 1",
      "HERACROSS 1",
      "URSARING 1",
      "HOUNDOOM 1",
      "DONPHAN 1",
      "WAILORD 1",
      "CLAYDOL 1",
      "RAMPARDOS 1",
      "BRONZONG 1",
      "DRAPION 1",
      "LUXRAY 1",
      "NINETALES 1",
      "MACHAMP 1",
      "SHUCKLE 1",
      "ROSERADE 1",
      "HONCHKROW 1",
      "STEELIX 1",
      "WEAVILE 1",
      "GLISCOR 1",
      "TENTACRUEL 1",
      "AERODACTYL 1",
      "PORYGON2 1",
      "LICKILICKY 1",
      "YANMEGA 1",
      "GARDEVOIR 1",
      "GALLADE 1",
      "EXEGGUTOR 1",
      "STARMIE 1",
      "FLYGON 1",
      "VAPOREON 1",
      "JOLTEON 1",
      "FLAREON 1",
      "ESPEON 1",
      "UMBREON 1",
      "LEAFEON 1",
      "GLACEON 1",
      "LUCARIO 1",
      "HIPPOWDON 1",
      "PROBOPASS 1",
      "DUSKNOIR 1",
      "AGGRON 1",
      "WALREIN 1",
      "MAMOSWINE 1",
      "LAPRAS 1",
      "CROBAT 1",
      "MAGNEZONE 1",
      "RHYPERIOR 1",
      "TANGROWTH 1",
      "PORYGON-Z 1",
      "GYARADOS 1",
      "SNORLAX 1",
      "KINGDRA 1",
      "BLISSEY 1",
      "MILOTIC 1",
      "ELECTIVIRE 1",
      "MAGMORTAR 1",
      "TOGEKISS 1",
      "ARCANINE 1",
      "DRAGONITE 1",
      "TYRANITAR 1",
      "SALAMENCE 1",
      "METAGROSS 1",
      "GARCHOMP 1",
      "SLAKING 1"
    ]
  },
  {
    "name": "STAVROS",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "GENGAR 1",
      "AMPHAROS 1",
      "POLITOED 1",
      "PINSIR 1",
      "SCIZOR 1",
      "HERACROSS 1",
      "URSARING 1",
      "HOUNDOOM 1",
      "DONPHAN 1",
      "WAILORD 1",
      "CLAYDOL 1",
      "RAMPARDOS 1",
      "BRONZONG 1",
      "DRAPION 1",
      "LUXRAY 1",
      "NINETALES 1",
      "MACHAMP 1",
      "SHUCKLE 1",
      "ROSERADE 1",
      "HONCHKROW 1",
      "STEELIX 1",
      "WEAVILE 1",
      "GLISCOR 1",
      "TENTACRUEL 1",
      "AERODACTYL 1",
      "PORYGON2 1",
      "LICKILICKY 1",
      "YANMEGA 1",
      "GARDEVOIR 1",
      "GALLADE 1",
      "EXEGGUTOR 1",
      "STARMIE 1",
      "FLYGON 1",
      "VAPOREON 1",
      "JOLTEON 1",
      "FLAREON 1",
      "ESPEON 1",
      "UMBREON 1",
      "LEAFEON 1",
      "GLACEON 1",
      "LUCARIO 1",
      "HIPPOWDON 1",
      "PROBOPASS 1",
      "DUSKNOIR 1",
      "AGGRON 1",
      "WALREIN 1",
      "MAMOSWINE 1",
      "LAPRAS 1",
      "CROBAT 1",
      "MAGNEZONE 1",
      "RHYPERIOR 1",
      "TANGROWTH 1",
      "PORYGON-Z 1",
      "GYARADOS 1",
      "SNORLAX 1",
      "KINGDRA 1",
      "BLISSEY 1",
      "MILOTIC 1",
      "ELECTIVIRE 1",
      "MAGMORTAR 1",
      "TOGEKISS 1",
      "ARCANINE 1",
      "DRAGONITE 1",
      "TYRANITAR 1",
      "SALAMENCE 1",
      "METAGROSS 1",
      "GARCHOMP 1",
      "SLAKING 1"
    ]
  },
  {
    "name": "ZANE",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "GENGAR 1",
      "AMPHAROS 1",
      "POLITOED 1",
      "PINSIR 1",
      "SCIZOR 1",
      "HERACROSS 1",
      "URSARING 1",
      "HOUNDOOM 1",
      "DONPHAN 1",
      "WAILORD 1",
      "CLAYDOL 1",
      "RAMPARDOS 1",
      "BRONZONG 1",
      "DRAPION 1",
      "LUXRAY 1",
      "NINETALES 1",
      "MACHAMP 1",
      "SHUCKLE 1",
      "ROSERADE 1",
      "HONCHKROW 1",
      "STEELIX 1",
      "WEAVILE 1",
      "GLISCOR 1",
      "TENTACRUEL 1",
      "AERODACTYL 1",
      "PORYGON2 1",
      "LICKILICKY 1",
      "YANMEGA 1",
      "GARDEVOIR 1",
      "GALLADE 1",
      "EXEGGUTOR 1",
      "STARMIE 1",
      "FLYGON 1",
      "VAPOREON 1",
      "JOLTEON 1",
      "FLAREON 1",
      "ESPEON 1",
      "UMBREON 1",
      "LEAFEON 1",
      "GLACEON 1",
      "LUCARIO 1",
      "HIPPOWDON 1",
      "PROBOPASS 1",
      "DUSKNOIR 1",
      "AGGRON 1",
      "WALREIN 1",
      "MAMOSWINE 1",
      "LAPRAS 1",
      "CROBAT 1",
      "MAGNEZONE 1",
      "RHYPERIOR 1",
      "TANGROWTH 1",
      "PORYGON-Z 1",
      "GYARADOS 1",
      "SNORLAX 1",
      "KINGDRA 1",
      "BLISSEY 1",
      "MILOTIC 1",
      "ELECTIVIRE 1",
      "MAGMORTAR 1",
      "TOGEKISS 1",
      "ARCANINE 1",
      "DRAGONITE 1",
      "TYRANITAR 1",
      "SALAMENCE 1",
      "METAGROSS 1",
      "GARCHOMP 1",
      "SLAKING 1"
    ]
  },
  {
    "name": "KIM",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "GENGAR 1",
      "AMPHAROS 1",
      "POLITOED 1",
      "PINSIR 1",
      "SCIZOR 1",
      "HERACROSS 1",
      "URSARING 1",
      "HOUNDOOM 1",
      "DONPHAN 1",
      "WAILORD 1",
      "CLAYDOL 1",
      "RAMPARDOS 1",
      "BRONZONG 1",
      "DRAPION 1",
      "LUXRAY 1",
      "NINETALES 1",
      "MACHAMP 1",
      "SHUCKLE 1",
      "ROSERADE 1",
      "HONCHKROW 1",
      "STEELIX 1",
      "WEAVILE 1",
      "GLISCOR 1",
      "TENTACRUEL 1",
      "AERODACTYL 1",
      "PORYGON2 1",
      "LICKILICKY 1",
      "YANMEGA 1",
      "GARDEVOIR 1",
      "GALLADE 1",
      "EXEGGUTOR 1",
      "STARMIE 1",
      "FLYGON 1",
      "VAPOREON 1",
      "JOLTEON 1",
      "FLAREON 1",
      "ESPEON 1",
      "UMBREON 1",
      "LEAFEON 1",
      "GLACEON 1",
      "LUCARIO 1",
      "HIPPOWDON 1",
      "PROBOPASS 1",
      "DUSKNOIR 1",
      "AGGRON 1",
      "WALREIN 1",
      "MAMOSWINE 1",
      "LAPRAS 1",
      "CROBAT 1",
      "MAGNEZONE 1",
      "RHYPERIOR 1",
      "TANGROWTH 1",
      "PORYGON-Z 1",
      "GYARADOS 1",
      "SNORLAX 1",
      "KINGDRA 1",
      "BLISSEY 1",
      "MILOTIC 1",
      "ELECTIVIRE 1",
      "MAGMORTAR 1",
      "TOGEKISS 1",
      "ARCANINE 1",
      "DRAGONITE 1",
      "TYRANITAR 1",
      "SALAMENCE 1",
      "METAGROSS 1",
      "GARCHOMP 1",
      "SLAKING 1"
    ]
  },
  {
    "name": "MACY",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "GENGAR 1",
      "AMPHAROS 1",
      "POLITOED 1",
      "PINSIR 1",
      "SCIZOR 1",
      "HERACROSS 1",
      "URSARING 1",
      "HOUNDOOM 1",
      "DONPHAN 1",
      "WAILORD 1",
      "CLAYDOL 1",
      "RAMPARDOS 1",
      "BRONZONG 1",
      "DRAPION 1",
      "LUXRAY 1",
      "NINETALES 1",
      "MACHAMP 1",
      "SHUCKLE 1",
      "ROSERADE 1",
      "HONCHKROW 1",
      "STEELIX 1",
      "WEAVILE 1",
      "GLISCOR 1",
      "TENTACRUEL 1",
      "AERODACTYL 1",
      "PORYGON2 1",
      "LICKILICKY 1",
      "YANMEGA 1",
      "GARDEVOIR 1",
      "GALLADE 1",
      "EXEGGUTOR 1",
      "STARMIE 1",
      "FLYGON 1",
      "VAPOREON 1",
      "JOLTEON 1",
      "FLAREON 1",
      "ESPEON 1",
      "UMBREON 1",
      "LEAFEON 1",
      "GLACEON 1",
      "LUCARIO 1",
      "HIPPOWDON 1",
      "PROBOPASS 1",
      "DUSKNOIR 1",
      "AGGRON 1",
      "WALREIN 1",
      "MAMOSWINE 1",
      "LAPRAS 1",
      "CROBAT 1",
      "MAGNEZONE 1",
      "RHYPERIOR 1",
      "TANGROWTH 1",
      "PORYGON-Z 1",
      "GYARADOS 1",
      "SNORLAX 1",
      "KINGDRA 1",
      "BLISSEY 1",
      "MILOTIC 1",
      "ELECTIVIRE 1",
      "MAGMORTAR 1",
      "TOGEKISS 1",
      "ARCANINE 1",
      "DRAGONITE 1",
      "TYRANITAR 1",
      "SALAMENCE 1",
      "METAGROSS 1",
      "GARCHOMP 1",
      "SLAKING 1"
    ]
  },
  {
    "name": "FAUN",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "GENGAR 1",
      "AMPHAROS 1",
      "POLITOED 1",
      "PINSIR 1",
      "SCIZOR 1",
      "HERACROSS 1",
      "URSARING 1",
      "HOUNDOOM 1",
      "DONPHAN 1",
      "WAILORD 1",
      "CLAYDOL 1",
      "RAMPARDOS 1",
      "BRONZONG 1",
      "DRAPION 1",
      "LUXRAY 1",
      "NINETALES 1",
      "MACHAMP 1",
      "SHUCKLE 1",
      "ROSERADE 1",
      "HONCHKROW 1",
      "STEELIX 1",
      "WEAVILE 1",
      "GLISCOR 1",
      "TENTACRUEL 1",
      "AERODACTYL 1",
      "PORYGON2 1",
      "LICKILICKY 1",
      "YANMEGA 1",
      "GARDEVOIR 1",
      "GALLADE 1",
      "EXEGGUTOR 1",
      "STARMIE 1",
      "FLYGON 1",
      "VAPOREON 1",
      "JOLTEON 1",
      "FLAREON 1",
      "ESPEON 1",
      "UMBREON 1",
      "LEAFEON 1",
      "GLACEON 1",
      "LUCARIO 1",
      "HIPPOWDON 1",
      "PROBOPASS 1",
      "DUSKNOIR 1",
      "AGGRON 1",
      "WALREIN 1",
      "MAMOSWINE 1",
      "LAPRAS 1",
      "CROBAT 1",
      "MAGNEZONE 1",
      "RHYPERIOR 1",
      "TANGROWTH 1",
      "PORYGON-Z 1",
      "GYARADOS 1",
      "SNORLAX 1",
      "KINGDRA 1",
      "BLISSEY 1",
      "MILOTIC 1",
      "ELECTIVIRE 1",
      "MAGMORTAR 1",
      "TOGEKISS 1",
      "ARCANINE 1",
      "DRAGONITE 1",
      "TYRANITAR 1",
      "SALAMENCE 1",
      "METAGROSS 1",
      "GARCHOMP 1",
      "SLAKING 1"
    ]
  },
  {
    "name": "DOYLE",
    "trainerClass": "Pokemon Ranger",
    "pokemon": [
      "VENUSAUR 1",
      "CHARIZARD 1",
      "BLASTOISE 1",
      "MEGANIUM 1",
      "TYPHLOSION 1",
      "FERALIGATR 1",
      "SCEPTILE 1",
      "BLAZIKEN 1",
      "SWAMPERT 1",
      "TORTERRA 1",
      "INFERNAPE 1",
      "EMPOLEON 1",
      "DUGTRIO 1",
      "MAROWAK 1",
      "MEDICHAM 1",
      "QUAGSIRE 1",
      "GRANBULL 1",
      "JYNX 1",
      "MRMIME 1",
      "LANTURN 1",
      "BRELOOM 1",
      "FORRETRESS 1",
      "SKARMORY 1",
      "ABSOL 1",
      "WHISCASH 1",
      "HARIYAMA 1",
      "VESPIQUEN 1",
      "RAICHU 1",
      "DEWGONG 1",
      "MANECTRIC 1",
      "STARAPTOR 1",
      "GASTRODON 1",
      "SKUNTANK 1",
      "VILEPLUME 1",
      "VICTREEBEL 1",
      "ELECTRODE 1",
      "LUDICOLO 1",
      "SHIFTRY 1",
      "EXPLOUD 1",
      "GLALIE 1",
      "LOPUNNY 1",
      "FROSLASS 1",
      "AMBIPOM 1",
      "HYPNO 1",
      "GOLEM 1",
      "RHYDON 1",
      "SLOWBRO 1",
      "WEEZING 1",
      "KANGASKHAN 1",
      "TAUROS 1",
      "ALAKAZAM 1",
      "SLOWKING 1",
      "MILTANK 1",
      "ALTARIA 1",
      "TOXICROAK 1",
      "ABOMASNOW 1",
      "NIDOQUEEN 1",
      "NIDOKING 1",
      "CRADILY 1",
      "ARMALDO 1",
      "BASTIODON 1",
      "FLOATZEL 1",
      "MISMAGIUS 1",
      "DRIFBLIM 1",
      "GOLDUCK 1",
      "POLIWRATH 1",
      "RAPIDASH 1",
      "MUK 1"
    ]
  },
  {
    "name": "DUKE",
    "trainerClass": "Pokemon Ranger",
    "pokemon": [
      "VENUSAUR 1",
      "CHARIZARD 1",
      "BLASTOISE 1",
      "MEGANIUM 1",
      "TYPHLOSION 1",
      "FERALIGATR 1",
      "SCEPTILE 1",
      "BLAZIKEN 1",
      "SWAMPERT 1",
      "TORTERRA 1",
      "INFERNAPE 1",
      "EMPOLEON 1",
      "DUGTRIO 1",
      "MAROWAK 1",
      "MEDICHAM 1",
      "QUAGSIRE 1",
      "GRANBULL 1",
      "JYNX 1",
      "MRMIME 1",
      "LANTURN 1",
      "BRELOOM 1",
      "FORRETRESS 1",
      "SKARMORY 1",
      "ABSOL 1",
      "WHISCASH 1",
      "HARIYAMA 1",
      "VESPIQUEN 1",
      "RAICHU 1",
      "DEWGONG 1",
      "MANECTRIC 1",
      "STARAPTOR 1",
      "GASTRODON 1",
      "SKUNTANK 1",
      "VILEPLUME 1",
      "VICTREEBEL 1",
      "ELECTRODE 1",
      "LUDICOLO 1",
      "SHIFTRY 1",
      "EXPLOUD 1",
      "GLALIE 1",
      "LOPUNNY 1",
      "FROSLASS 1",
      "AMBIPOM 1",
      "HYPNO 1",
      "GOLEM 1",
      "RHYDON 1",
      "SLOWBRO 1",
      "WEEZING 1",
      "KANGASKHAN 1",
      "TAUROS 1",
      "ALAKAZAM 1",
      "SLOWKING 1",
      "MILTANK 1",
      "ALTARIA 1",
      "TOXICROAK 1",
      "ABOMASNOW 1",
      "NIDOQUEEN 1",
      "NIDOKING 1",
      "CRADILY 1",
      "ARMALDO 1",
      "BASTIODON 1",
      "FLOATZEL 1",
      "MISMAGIUS 1",
      "DRIFBLIM 1",
      "GOLDUCK 1",
      "POLIWRATH 1",
      "RAPIDASH 1",
      "MUK 1"
    ]
  },
  {
    "name": "DEACON",
    "trainerClass": "Pokemon Ranger",
    "pokemon": [
      "VENUSAUR 1",
      "CHARIZARD 1",
      "BLASTOISE 1",
      "MEGANIUM 1",
      "TYPHLOSION 1",
      "FERALIGATR 1",
      "SCEPTILE 1",
      "BLAZIKEN 1",
      "SWAMPERT 1",
      "TORTERRA 1",
      "INFERNAPE 1",
      "EMPOLEON 1",
      "DUGTRIO 1",
      "MAROWAK 1",
      "MEDICHAM 1",
      "QUAGSIRE 1",
      "GRANBULL 1",
      "JYNX 1",
      "MRMIME 1",
      "LANTURN 1",
      "BRELOOM 1",
      "FORRETRESS 1",
      "SKARMORY 1",
      "ABSOL 1",
      "WHISCASH 1",
      "HARIYAMA 1",
      "VESPIQUEN 1",
      "RAICHU 1",
      "DEWGONG 1",
      "MANECTRIC 1",
      "STARAPTOR 1",
      "GASTRODON 1",
      "SKUNTANK 1",
      "VILEPLUME 1",
      "VICTREEBEL 1",
      "ELECTRODE 1",
      "LUDICOLO 1",
      "SHIFTRY 1",
      "EXPLOUD 1",
      "GLALIE 1",
      "LOPUNNY 1",
      "FROSLASS 1",
      "AMBIPOM 1",
      "HYPNO 1",
      "GOLEM 1",
      "RHYDON 1",
      "SLOWBRO 1",
      "WEEZING 1",
      "KANGASKHAN 1",
      "TAUROS 1",
      "ALAKAZAM 1",
      "SLOWKING 1",
      "MILTANK 1",
      "ALTARIA 1",
      "TOXICROAK 1",
      "ABOMASNOW 1",
      "NIDOQUEEN 1",
      "NIDOKING 1",
      "CRADILY 1",
      "ARMALDO 1",
      "BASTIODON 1",
      "FLOATZEL 1",
      "MISMAGIUS 1",
      "DRIFBLIM 1",
      "GOLDUCK 1",
      "POLIWRATH 1",
      "RAPIDASH 1",
      "MUK 1"
    ]
  },
  {
    "name": "MENA",
    "trainerClass": "Pokemon Ranger",
    "pokemon": [
      "VENUSAUR 1",
      "CHARIZARD 1",
      "BLASTOISE 1",
      "MEGANIUM 1",
      "TYPHLOSION 1",
      "FERALIGATR 1",
      "SCEPTILE 1",
      "BLAZIKEN 1",
      "SWAMPERT 1",
      "TORTERRA 1",
      "INFERNAPE 1",
      "EMPOLEON 1",
      "DUGTRIO 1",
      "MAROWAK 1",
      "MEDICHAM 1",
      "QUAGSIRE 1",
      "GRANBULL 1",
      "JYNX 1",
      "MRMIME 1",
      "LANTURN 1",
      "BRELOOM 1",
      "FORRETRESS 1",
      "SKARMORY 1",
      "ABSOL 1",
      "WHISCASH 1",
      "HARIYAMA 1",
      "VESPIQUEN 1",
      "RAICHU 1",
      "DEWGONG 1",
      "MANECTRIC 1",
      "STARAPTOR 1",
      "GASTRODON 1",
      "SKUNTANK 1",
      "VILEPLUME 1",
      "VICTREEBEL 1",
      "ELECTRODE 1",
      "LUDICOLO 1",
      "SHIFTRY 1",
      "EXPLOUD 1",
      "GLALIE 1",
      "LOPUNNY 1",
      "FROSLASS 1",
      "AMBIPOM 1",
      "HYPNO 1",
      "GOLEM 1",
      "RHYDON 1",
      "SLOWBRO 1",
      "WEEZING 1",
      "KANGASKHAN 1",
      "TAUROS 1",
      "ALAKAZAM 1",
      "SLOWKING 1",
      "MILTANK 1",
      "ALTARIA 1",
      "TOXICROAK 1",
      "ABOMASNOW 1",
      "NIDOQUEEN 1",
      "NIDOKING 1",
      "CRADILY 1",
      "ARMALDO 1",
      "BASTIODON 1",
      "FLOATZEL 1",
      "MISMAGIUS 1",
      "DRIFBLIM 1",
      "GOLDUCK 1",
      "POLIWRATH 1",
      "RAPIDASH 1",
      "MUK 1"
    ]
  },
  {
    "name": "MERCY",
    "trainerClass": "Pokemon Ranger",
    "pokemon": [
      "VENUSAUR 1",
      "CHARIZARD 1",
      "BLASTOISE 1",
      "MEGANIUM 1",
      "TYPHLOSION 1",
      "FERALIGATR 1",
      "SCEPTILE 1",
      "BLAZIKEN 1",
      "SWAMPERT 1",
      "TORTERRA 1",
      "INFERNAPE 1",
      "EMPOLEON 1",
      "DUGTRIO 1",
      "MAROWAK 1",
      "MEDICHAM 1",
      "QUAGSIRE 1",
      "GRANBULL 1",
      "JYNX 1",
      "MRMIME 1",
      "LANTURN 1",
      "BRELOOM 1",
      "FORRETRESS 1",
      "SKARMORY 1",
      "ABSOL 1",
      "WHISCASH 1",
      "HARIYAMA 1",
      "VESPIQUEN 1",
      "RAICHU 1",
      "DEWGONG 1",
      "MANECTRIC 1",
      "STARAPTOR 1",
      "GASTRODON 1",
      "SKUNTANK 1",
      "VILEPLUME 1",
      "VICTREEBEL 1",
      "ELECTRODE 1",
      "LUDICOLO 1",
      "SHIFTRY 1",
      "EXPLOUD 1",
      "GLALIE 1",
      "LOPUNNY 1",
      "FROSLASS 1",
      "AMBIPOM 1",
      "HYPNO 1",
      "GOLEM 1",
      "RHYDON 1",
      "SLOWBRO 1",
      "WEEZING 1",
      "KANGASKHAN 1",
      "TAUROS 1",
      "ALAKAZAM 1",
      "SLOWKING 1",
      "MILTANK 1",
      "ALTARIA 1",
      "TOXICROAK 1",
      "ABOMASNOW 1",
      "NIDOQUEEN 1",
      "NIDOKING 1",
      "CRADILY 1",
      "ARMALDO 1",
      "BASTIODON 1",
      "FLOATZEL 1",
      "MISMAGIUS 1",
      "DRIFBLIM 1",
      "GOLDUCK 1",
      "POLIWRATH 1",
      "RAPIDASH 1",
      "MUK 1"
    ]
  },
  {
    "name": "EVITA",
    "trainerClass": "Pokemon Ranger",
    "pokemon": [
      "VENUSAUR 1",
      "CHARIZARD 1",
      "BLASTOISE 1",
      "MEGANIUM 1",
      "TYPHLOSION 1",
      "FERALIGATR 1",
      "SCEPTILE 1",
      "BLAZIKEN 1",
      "SWAMPERT 1",
      "TORTERRA 1",
      "INFERNAPE 1",
      "EMPOLEON 1",
      "DUGTRIO 1",
      "MAROWAK 1",
      "MEDICHAM 1",
      "QUAGSIRE 1",
      "GRANBULL 1",
      "JYNX 1",
      "MRMIME 1",
      "LANTURN 1",
      "BRELOOM 1",
      "FORRETRESS 1",
      "SKARMORY 1",
      "ABSOL 1",
      "WHISCASH 1",
      "HARIYAMA 1",
      "VESPIQUEN 1",
      "RAICHU 1",
      "DEWGONG 1",
      "MANECTRIC 1",
      "STARAPTOR 1",
      "GASTRODON 1",
      "SKUNTANK 1",
      "VILEPLUME 1",
      "VICTREEBEL 1",
      "ELECTRODE 1",
      "LUDICOLO 1",
      "SHIFTRY 1",
      "EXPLOUD 1",
      "GLALIE 1",
      "LOPUNNY 1",
      "FROSLASS 1",
      "AMBIPOM 1",
      "HYPNO 1",
      "GOLEM 1",
      "RHYDON 1",
      "SLOWBRO 1",
      "WEEZING 1",
      "KANGASKHAN 1",
      "TAUROS 1",
      "ALAKAZAM 1",
      "SLOWKING 1",
      "MILTANK 1",
      "ALTARIA 1",
      "TOXICROAK 1",
      "ABOMASNOW 1",
      "NIDOQUEEN 1",
      "NIDOKING 1",
      "CRADILY 1",
      "ARMALDO 1",
      "BASTIODON 1",
      "FLOATZEL 1",
      "MISMAGIUS 1",
      "DRIFBLIM 1",
      "GOLDUCK 1",
      "POLIWRATH 1",
      "RAPIDASH 1",
      "MUK 1"
    ]
  },
  {
    "name": "HAROLD",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "AERODACTYL 1",
      "AGGRON 1",
      "ALTARIA 1",
      "ARCANINE 1",
      "CHARIZARD 1",
      "DRAGONITE 1",
      "DRAPION 1",
      "FERALIGATR 1",
      "FLYGON 1",
      "GARCHOMP 1",
      "GYARADOS 1",
      "KANGASKHAN 1",
      "KINGDRA 1",
      "LAPRAS 1",
      "MEGANIUM 1",
      "MILOTIC 1",
      "NIDOKING 1",
      "NIDOQUEEN 1",
      "RHYDON 1",
      "RHYPERIOR 1",
      "SALAMENCE 1",
      "SCEPTILE 1",
      "SKARMORY 1",
      "STEELIX 1",
      "TYPHLOSION 1",
      "TYRANITAR 1"
    ]
  },
  {
    "name": "HERMAN",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "AERODACTYL 1",
      "AGGRON 1",
      "ALTARIA 1",
      "ARCANINE 1",
      "CHARIZARD 1",
      "DRAGONITE 1",
      "DRAPION 1",
      "FERALIGATR 1",
      "FLYGON 1",
      "GARCHOMP 1",
      "GYARADOS 1",
      "KANGASKHAN 1",
      "KINGDRA 1",
      "LAPRAS 1",
      "MEGANIUM 1",
      "MILOTIC 1",
      "NIDOKING 1",
      "NIDOQUEEN 1",
      "RHYDON 1",
      "RHYPERIOR 1",
      "SALAMENCE 1",
      "SCEPTILE 1",
      "SKARMORY 1",
      "STEELIX 1",
      "TYPHLOSION 1",
      "TYRANITAR 1"
    ]
  },
  {
    "name": "EMMETT",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "AERODACTYL 1",
      "AGGRON 1",
      "ALTARIA 1",
      "ARCANINE 1",
      "CHARIZARD 1",
      "DRAGONITE 1",
      "DRAPION 1",
      "FERALIGATR 1",
      "FLYGON 1",
      "GARCHOMP 1",
      "GYARADOS 1",
      "KANGASKHAN 1",
      "KINGDRA 1",
      "LAPRAS 1",
      "MEGANIUM 1",
      "MILOTIC 1",
      "NIDOKING 1",
      "NIDOQUEEN 1",
      "RHYDON 1",
      "RHYPERIOR 1",
      "SALAMENCE 1",
      "SCEPTILE 1",
      "SKARMORY 1",
      "STEELIX 1",
      "TYPHLOSION 1",
      "TYRANITAR 1"
    ]
  },
  {
    "name": "ERICH",
    "trainerClass": "Dragon Tamer",
    "pokemon": [
      "AERODACTYL 1",
      "AGGRON 1",
      "ALTARIA 1",
      "ARCANINE 1",
      "CHARIZARD 1",
      "DRAGONITE 1",
      "DRAPION 1",
      "FERALIGATR 1",
      "FLYGON 1",
      "GARCHOMP 1",
      "GYARADOS 1",
      "KANGASKHAN 1",
      "KINGDRA 1",
      "LAPRAS 1",
      "MEGANIUM 1",
      "MILOTIC 1",
      "NIDOKING 1",
      "NIDOQUEEN 1",
      "RHYDON 1",
      "RHYPERIOR 1",
      "SALAMENCE 1",
      "SCEPTILE 1",
      "SKARMORY 1",
      "STEELIX 1",
      "TYPHLOSION 1",
      "TYRANITAR 1"
    ]
  },
  {
    "name": "GARVEY",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "ABOMASNOW 1",
      "AMBIPOM 1",
      "BLASTOISE 1",
      "BLISSEY 1",
      "DEWGONG 1",
      "EMPOLEON 1",
      "EXPLOUD 1",
      "FERALIGATR 1",
      "FLOATZEL 1",
      "FROSLASS 1",
      "GASTRODON 1",
      "GLACEON 1",
      "GLALIE 1",
      "GOLDUCK 1",
      "GRANBULL 1",
      "GYARADOS 1",
      "JYNX 1",
      "KANGASKHAN 1",
      "KINGDRA 1",
      "LAPRAS 1",
      "LICKILICKY 1",
      "LOPUNNY 1",
      "LUDICOLO 1",
      "MAMOSWINE 1",
      "MILOTIC 1",
      "MILTANK 1",
      "POLITOED 1",
      "POLIWRATH 1",
      "PORYGON-Z 1",
      "PORYGON2 1",
      "QUAGSIRE 1",
      "SLAKING 1",
      "SLOWBRO 1",
      "SLOWKING 1",
      "SNORLAX 1",
      "STARAPTOR 1",
      "STARMIE 1",
      "SWAMPERT 1",
      "TAUROS 1",
      "TENTACRUEL 1",
      "TOGEKISS 1",
      "URSARING 1",
      "VAPOREON 1",
      "WALREIN 1",
      "WEAVILE 1"
    ]
  },
  {
    "name": "CRUZ",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "ABOMASNOW 1",
      "AMBIPOM 1",
      "BLASTOISE 1",
      "BLISSEY 1",
      "DEWGONG 1",
      "EMPOLEON 1",
      "EXPLOUD 1",
      "FERALIGATR 1",
      "FLOATZEL 1",
      "FROSLASS 1",
      "GASTRODON 1",
      "GLACEON 1",
      "GLALIE 1",
      "GOLDUCK 1",
      "GRANBULL 1",
      "GYARADOS 1",
      "JYNX 1",
      "KANGASKHAN 1",
      "KINGDRA 1",
      "LAPRAS 1",
      "LICKILICKY 1",
      "LOPUNNY 1",
      "LUDICOLO 1",
      "MAMOSWINE 1",
      "MILOTIC 1",
      "MILTANK 1",
      "POLITOED 1",
      "POLIWRATH 1",
      "PORYGON-Z 1",
      "PORYGON2 1",
      "QUAGSIRE 1",
      "SLAKING 1",
      "SLOWBRO 1",
      "SLOWKING 1",
      "SNORLAX 1",
      "STARAPTOR 1",
      "STARMIE 1",
      "SWAMPERT 1",
      "TAUROS 1",
      "TENTACRUEL 1",
      "TOGEKISS 1",
      "URSARING 1",
      "VAPOREON 1",
      "WALREIN 1",
      "WEAVILE 1"
    ]
  },
  {
    "name": "PAMELA",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "ABOMASNOW 1",
      "AMBIPOM 1",
      "BLASTOISE 1",
      "BLISSEY 1",
      "DEWGONG 1",
      "EMPOLEON 1",
      "EXPLOUD 1",
      "FERALIGATR 1",
      "FLOATZEL 1",
      "FROSLASS 1",
      "GASTRODON 1",
      "GLACEON 1",
      "GLALIE 1",
      "GOLDUCK 1",
      "GRANBULL 1",
      "GYARADOS 1",
      "JYNX 1",
      "KANGASKHAN 1",
      "KINGDRA 1",
      "LAPRAS 1",
      "LICKILICKY 1",
      "LOPUNNY 1",
      "LUDICOLO 1",
      "MAMOSWINE 1",
      "MILOTIC 1",
      "MILTANK 1",
      "POLITOED 1",
      "POLIWRATH 1",
      "PORYGON-Z 1",
      "PORYGON2 1",
      "QUAGSIRE 1",
      "SLAKING 1",
      "SLOWBRO 1",
      "SLOWKING 1",
      "SNORLAX 1",
      "STARAPTOR 1",
      "STARMIE 1",
      "SWAMPERT 1",
      "TAUROS 1",
      "TENTACRUEL 1",
      "TOGEKISS 1",
      "URSARING 1",
      "VAPOREON 1",
      "WALREIN 1",
      "WEAVILE 1"
    ]
  },
  {
    "name": "DANIELA",
    "trainerClass": "Ace Trainer",
    "pokemon": [
      "ABOMASNOW 1",
      "AMBIPOM 1",
      "BLASTOISE 1",
      "BLISSEY 1",
      "DEWGONG 1",
      "EMPOLEON 1",
      "EXPLOUD 1",
      "FERALIGATR 1",
      "FLOATZEL 1",
      "FROSLASS 1",
      "GASTRODON 1",
      "GLACEON 1",
      "GLALIE 1",
      "GOLDUCK 1",
      "GRANBULL 1",
      "GYARADOS 1",
      "JYNX 1",
      "KANGASKHAN 1",
      "KINGDRA 1",
      "LAPRAS 1",
      "LICKILICKY 1",
      "LOPUNNY 1",
      "LUDICOLO 1",
      "MAMOSWINE 1",
      "MILOTIC 1",
      "MILTANK 1",
      "POLITOED 1",
      "POLIWRATH 1",
      "PORYGON-Z 1",
      "PORYGON2 1",
      "QUAGSIRE 1",
      "SLAKING 1",
      "SLOWBRO 1",
      "SLOWKING 1",
      "SNORLAX 1",
      "STARAPTOR 1",
      "STARMIE 1",
      "SWAMPERT 1",
      "TAUROS 1",
      "TENTACRUEL 1",
      "TOGEKISS 1",
      "URSARING 1",
      "VAPOREON 1",
      "WALREIN 1",
      "WEAVILE 1"
    ]
  },
  {
    "name": "KADEN",
    "trainerClass": "Youngster",
    "pokemon": [
      "ABSOL 2",
      "AMBIPOM 2",
      "BLASTOISE 2",
      "BLAZIKEN 2",
      "BRELOOM 2",
      "CHARIZARD 2",
      "DEWGONG 2",
      "DUGTRIO 2",
      "ELECTRODE 2",
      "EMPOLEON 2",
      "EXPLOUD 2",
      "FERALIGATR 2",
      "FORRETRESS 2",
      "FROSLASS 2",
      "GASTRODON 2",
      "GLALIE 2",
      "GOLEM 2",
      "GRANBULL 2",
      "HARIYAMA 2",
      "HYPNO 2",
      "INFERNAPE 2",
      "JYNX 2",
      "KANGASKHAN 2",
      "LANTURN 2",
      "LOPUNNY 2",
      "LUDICOLO 2",
      "MANECTRIC 2",
      "MAROWAK 2",
      "MEDICHAM 2",
      "MEGANIUM 2",
      "MRMIME 2",
      "QUAGSIRE 2",
      "RAICHU 2",
      "RHYDON 2",
      "SCEPTILE 2",
      "SHIFTRY 2",
      "SKARMORY 2",
      "SKUNTANK 2",
      "SLOWBRO 2",
      "STARAPTOR 2",
      "SWAMPERT 2",
      "TAUROS 2",
      "TORTERRA 2",
      "TYPHLOSION 2",
      "VENUSAUR 2",
      "VESPIQUEN 2",
      "VICTREEBEL 2",
      "VILEPLUME 2",
      "WEEZING 2",
      "WHISCASH 2"
    ]
  },
  {
    "name": "KOLBY",
    "trainerClass": "Youngster",
    "pokemon": [
      "ABSOL 2",
      "AMBIPOM 2",
      "BLASTOISE 2",
      "BLAZIKEN 2",
      "BRELOOM 2",
      "CHARIZARD 2",
      "DEWGONG 2",
      "DUGTRIO 2",
      "ELECTRODE 2",
      "EMPOLEON 2",
      "EXPLOUD 2",
      "FERALIGATR 2",
      "FORRETRESS 2",
      "FROSLASS 2",
      "GASTRODON 2",
      "GLALIE 2",
      "GOLEM 2",
      "GRANBULL 2",
      "HARIYAMA 2",
      "HYPNO 2",
      "INFERNAPE 2",
      "JYNX 2",
      "KANGASKHAN 2",
      "LANTURN 2",
      "LOPUNNY 2",
      "LUDICOLO 2",
      "MANECTRIC 2",
      "MAROWAK 2",
      "MEDICHAM 2",
      "MEGANIUM 2",
      "MRMIME 2",
      "QUAGSIRE 2",
      "RAICHU 2",
      "RHYDON 2",
      "SCEPTILE 2",
      "SHIFTRY 2",
      "SKARMORY 2",
      "SKUNTANK 2",
      "SLOWBRO 2",
      "STARAPTOR 2",
      "SWAMPERT 2",
      "TAUROS 2",
      "TORTERRA 2",
      "TYPHLOSION 2",
      "VENUSAUR 2",
      "VESPIQUEN 2",
      "VICTREEBEL 2",
      "VILEPLUME 2",
      "WEEZING 2",
      "WHISCASH 2"
    ]
  },
  {
    "name": "KARISSA",
    "trainerClass": "Lass",
    "pokemon": [
      "ABSOL 2",
      "AMBIPOM 2",
      "BLASTOISE 2",
      "BLAZIKEN 2",
      "BRELOOM 2",
      "CHARIZARD 2",
      "DEWGONG 2",
      "DUGTRIO 2",
      "ELECTRODE 2",
      "EMPOLEON 2",
      "EXPLOUD 2",
      "FERALIGATR 2",
      "FORRETRESS 2",
      "FROSLASS 2",
      "GASTRODON 2",
      "GLALIE 2",
      "GOLEM 2",
      "GRANBULL 2",
      "HARIYAMA 2",
      "HYPNO 2",
      "INFERNAPE 2",
      "JYNX 2",
      "KANGASKHAN 2",
      "LANTURN 2",
      "LOPUNNY 2",
      "LUDICOLO 2",
      "MANECTRIC 2",
      "MAROWAK 2",
      "MEDICHAM 2",
      "MEGANIUM 2",
      "MRMIME 2",
      "QUAGSIRE 2",
      "RAICHU 2",
      "RHYDON 2",
      "SCEPTILE 2",
      "SHIFTRY 2",
      "SKARMORY 2",
      "SKUNTANK 2",
      "SLOWBRO 2",
      "STARAPTOR 2",
      "SWAMPERT 2",
      "TAUROS 2",
      "TORTERRA 2",
      "TYPHLOSION 2",
      "VENUSAUR 2",
      "VESPIQUEN 2",
      "VICTREEBEL 2",
      "VILEPLUME 2",
      "WEEZING 2",
      "WHISCASH 2"
    ]
  },
  {
    "name": "LILIANA",
    "trainerClass": "Lass",
    "pokemon": [
      "ABSOL 2",
      "AMBIPOM 2",
      "BLASTOISE 2",
      "BLAZIKEN 2",
      "BRELOOM 2",
      "CHARIZARD 2",
      "DEWGONG 2",
      "DUGTRIO 2",
      "ELECTRODE 2",
      "EMPOLEON 2",
      "EXPLOUD 2",
      "FERALIGATR 2",
      "FORRETRESS 2",
      "FROSLASS 2",
      "GASTRODON 2",
      "GLALIE 2",
      "GOLEM 2",
      "GRANBULL 2",
      "HARIYAMA 2",
      "HYPNO 2",
      "INFERNAPE 2",
      "JYNX 2",
      "KANGASKHAN 2",
      "LANTURN 2",
      "LOPUNNY 2",
      "LUDICOLO 2",
      "MANECTRIC 2",
      "MAROWAK 2",
      "MEDICHAM 2",
      "MEGANIUM 2",
      "MRMIME 2",
      "QUAGSIRE 2",
      "RAICHU 2",
      "RHYDON 2",
      "SCEPTILE 2",
      "SHIFTRY 2",
      "SKARMORY 2",
      "SKUNTANK 2",
      "SLOWBRO 2",
      "STARAPTOR 2",
      "SWAMPERT 2",
      "TAUROS 2",
      "TORTERRA 2",
      "TYPHLOSION 2",
      "VENUSAUR 2",
      "VESPIQUEN 2",
      "VICTREEBEL 2",
      "VILEPLUME 2",
      "WEEZING 2",
      "WHISCASH 2"
    ]
  },
  {
    "name": "JONAS",
    "trainerClass": "School Kid",
    "pokemon": [
      "ABOMASNOW 2",
      "AERODACTYL 2",
      "ALAKAZAM 2",
      "ALTARIA 2",
      "AMPHAROS 2",
      "ARMALDO 2",
      "BASTIODON 2",
      "BRONZONG 2",
      "CLAYDOL 2",
      "CRADILY 2",
      "DONPHAN 2",
      "DRAPION 2",
      "DRIFBLIM 2",
      "EXEGGUTOR 2",
      "FLOATZEL 2",
      "GALLADE 2",
      "GARDEVOIR 2",
      "GENGAR 2",
      "GLISCOR 2",
      "GOLDUCK 2",
      "HERACROSS 2",
      "HONCHKROW 2",
      "HOUNDOOM 2",
      "LICKILICKY 2",
      "LUXRAY 2",
      "MACHAMP 2",
      "MILTANK 2",
      "MISMAGIUS 2",
      "MUK 2",
      "NIDOKING 2",
      "NIDOQUEEN 2",
      "NINETALES 2",
      "PINSIR 2",
      "POLITOED 2",
      "POLIWRATH 2",
      "PORYGON2 2",
      "RAMPARDOS 2",
      "RAPIDASH 2",
      "ROSERADE 2",
      "SCIZOR 2",
      "SHUCKLE 2",
      "SLOWKING 2",
      "STARMIE 2",
      "STEELIX 2",
      "TENTACRUEL 2",
      "TOXICROAK 2",
      "URSARING 2",
      "WAILORD 2",
      "WEAVILE 2",
      "YANMEGA 2"
    ]
  },
  {
    "name": "KEON",
    "trainerClass": "School Kid",
    "pokemon": [
      "ABOMASNOW 2",
      "AERODACTYL 2",
      "ALAKAZAM 2",
      "ALTARIA 2",
      "AMPHAROS 2",
      "ARMALDO 2",
      "BASTIODON 2",
      "BRONZONG 2",
      "CLAYDOL 2",
      "CRADILY 2",
      "DONPHAN 2",
      "DRAPION 2",
      "DRIFBLIM 2",
      "EXEGGUTOR 2",
      "FLOATZEL 2",
      "GALLADE 2",
      "GARDEVOIR 2",
      "GENGAR 2",
      "GLISCOR 2",
      "GOLDUCK 2",
      "HERACROSS 2",
      "HONCHKROW 2",
      "HOUNDOOM 2",
      "LICKILICKY 2",
      "LUXRAY 2",
      "MACHAMP 2",
      "MILTANK 2",
      "MISMAGIUS 2",
      "MUK 2",
      "NIDOKING 2",
      "NIDOQUEEN 2",
      "NINETALES 2",
      "PINSIR 2",
      "POLITOED 2",
      "POLIWRATH 2",
      "PORYGON2 2",
      "RAMPARDOS 2",
      "RAPIDASH 2",
      "ROSERADE 2",
      "SCIZOR 2",
      "SHUCKLE 2",
      "SLOWKING 2",
      "STARMIE 2",
      "STEELIX 2",
      "TENTACRUEL 2",
      "TOXICROAK 2",
      "URSARING 2",
      "WAILORD 2",
      "WEAVILE 2",
      "YANMEGA 2"
    ]
  },
  {
    "name": "CHELSIE",
    "trainerClass": "School Kid",
    "pokemon": [
      "ABOMASNOW 2",
      "AERODACTYL 2",
      "ALAKAZAM 2",
      "ALTARIA 2",
      "AMPHAROS 2",
      "ARMALDO 2",
      "BASTIODON 2",
      "BRONZONG 2",
      "CLAYDOL 2",
      "CRADILY 2",
      "DONPHAN 2",
      "DRAPION 2",
      "DRIFBLIM 2",
      "EXEGGUTOR 2",
      "FLOATZEL 2",
      "GALLADE 2",
      "GARDEVOIR 2",
      "GENGAR 2",
      "GLISCOR 2",
      "GOLDUCK 2",
      "HERACROSS 2",
      "HONCHKROW 2",
      "HOUNDOOM 2",
      "LICKILICKY 2",
      "LUXRAY 2",
      "MACHAMP 2",
      "MILTANK 2",
      "MISMAGIUS 2",
      "MUK 2",
      "NIDOKING 2",
      "NIDOQUEEN 2",
      "NINETALES 2",
      "PINSIR 2",
      "POLITOED 2",
      "POLIWRATH 2",
      "PORYGON2 2",
      "RAMPARDOS 2",
      "RAPIDASH 2",
      "ROSERADE 2",
      "SCIZOR 2",
      "SHUCKLE 2",
      "SLOWKING 2",
      "STARMIE 2",
      "STEELIX 2",
      "TENTACRUEL 2",
      "TOXICROAK 2",
      "URSARING 2",
      "WAILORD 2",
      "WEAVILE 2",
      "YANMEGA 2"
    ]
  },
  {
    "name": "REGINA",
    "trainerClass": "School Kid",
    "pokemon": [
      "ABOMASNOW 2",
      "AERODACTYL 2",
      "ALAKAZAM 2",
      "ALTARIA 2",
      "AMPHAROS 2",
      "ARMALDO 2",
      "BASTIODON 2",
      "BRONZONG 2",
      "CLAYDOL 2",
      "CRADILY 2",
      "DONPHAN 2",
      "DRAPION 2",
      "DRIFBLIM 2",
      "EXEGGUTOR 2",
      "FLOATZEL 2",
      "GALLADE 2",
      "GARDEVOIR 2",
      "GENGAR 2",
      "GLISCOR 2",
      "GOLDUCK 2",
      "HERACROSS 2",
      "HONCHKROW 2",
      "HOUNDOOM 2",
      "LICKILICKY 2",
      "LUXRAY 2",
      "MACHAMP 2",
      "MILTANK 2",
      "MISMAGIUS 2",
      "MUK 2",
      "NIDOKING 2",
      "NIDOQUEEN 2",
      "NINETALES 2",
      "PINSIR 2",
      "POLITOED 2",
      "POLIWRATH 2",
      "PORYGON2 2",
      "RAMPARDOS 2",
      "RAPIDASH 2",
      "ROSERADE 2",
      "SCIZOR 2",
      "SHUCKLE 2",
      "SLOWKING 2",
      "STARMIE 2",
      "STEELIX 2",
      "TENTACRUEL 2",
      "TOXICROAK 2",
      "URSARING 2",
      "WAILORD 2",
      "WEAVILE 2",
      "YANMEGA 2"
    ]
  },
  {
    "name": "DAULTON",
    "trainerClass": "Rich Boy",
    "pokemon": [
      "ABOMASNOW 2",
      "AERODACTYL 2",
      "ALAKAZAM 2",
      "ALTARIA 2",
      "AMPHAROS 2",
      "ARMALDO 2",
      "BASTIODON 2",
      "BRONZONG 2",
      "CLAYDOL 2",
      "CRADILY 2",
      "DONPHAN 2",
      "DRAPION 2",
      "DRIFBLIM 2",
      "EXEGGUTOR 2",
      "FLOATZEL 2",
      "GALLADE 2",
      "GARDEVOIR 2",
      "GENGAR 2",
      "GLISCOR 2",
      "GOLDUCK 2",
      "HERACROSS 2",
      "HONCHKROW 2",
      "HOUNDOOM 2",
      "LICKILICKY 2",
      "LUXRAY 2",
      "MACHAMP 2",
      "MILTANK 2",
      "MISMAGIUS 2",
      "MUK 2",
      "NIDOKING 2",
      "NIDOQUEEN 2",
      "NINETALES 2",
      "PINSIR 2",
      "POLITOED 2",
      "POLIWRATH 2",
      "PORYGON2 2",
      "RAMPARDOS 2",
      "RAPIDASH 2",
      "ROSERADE 2",
      "SCIZOR 2",
      "SHUCKLE 2",
      "SLOWKING 2",
      "STARMIE 2",
      "STEELIX 2",
      "TENTACRUEL 2",
      "TOXICROAK 2",
      "URSARING 2",
      "WAILORD 2",
      "WEAVILE 2",
      "YANMEGA 2"
    ]
  },
  {
    "name": "HANSON",
    "trainerClass": "Rich Boy",
    "pokemon": [
      "ABOMASNOW 2",
      "AERODACTYL 2",
      "ALAKAZAM 2",
      "ALTARIA 2",
      "AMPHAROS 2",
      "ARMALDO 2",
      "BASTIODON 2",
      "BRONZONG 2",
      "CLAYDOL 2",
      "CRADILY 2",
      "DONPHAN 2",
      "DRAPION 2",
      "DRIFBLIM 2",
      "EXEGGUTOR 2",
      "FLOATZEL 2",
      "GALLADE 2",
      "GARDEVOIR 2",
      "GENGAR 2",
      "GLISCOR 2",
      "GOLDUCK 2",
      "HERACROSS 2",
      "HONCHKROW 2",
      "HOUNDOOM 2",
      "LICKILICKY 2",
      "LUXRAY 2",
      "MACHAMP 2",
      "MILTANK 2",
      "MISMAGIUS 2",
      "MUK 2",
      "NIDOKING 2",
      "NIDOQUEEN 2",
      "NINETALES 2",
      "PINSIR 2",
      "POLITOED 2",
      "POLIWRATH 2",
      "PORYGON2 2",
      "RAMPARDOS 2",
      "RAPIDASH 2",
      "ROSERADE 2",
      "SCIZOR 2",
      "SHUCKLE 2",
      "SLOWKING 2",
      "STARMIE 2",
      "STEELIX 2",
      "TENTACRUEL 2",
      "TOXICROAK 2",
      "URSARING 2",
      "WAILORD 2",
      "WEAVILE 2",
      "YANMEGA 2"
    ]
  },
  {
    "name": "AMORY",
    "trainerClass": "Lady",
    "pokemon": [
      "ABOMASNOW 2",
      "AERODACTYL 2",
      "ALAKAZAM 2",
      "ALTARIA 2",
      "AMPHAROS 2",
      "ARMALDO 2",
      "BASTIODON 2",
      "BRONZONG 2",
      "CLAYDOL 2",
      "CRADILY 2",
      "DONPHAN 2",
      "DRAPION 2",
      "DRIFBLIM 2",
      "EXEGGUTOR 2",
      "FLOATZEL 2",
      "GALLADE 2",
      "GARDEVOIR 2",
      "GENGAR 2",
      "GLISCOR 2",
      "GOLDUCK 2",
      "HERACROSS 2",
      "HONCHKROW 2",
      "HOUNDOOM 2",
      "LICKILICKY 2",
      "LUXRAY 2",
      "MACHAMP 2",
      "MILTANK 2",
      "MISMAGIUS 2",
      "MUK 2",
      "NIDOKING 2",
      "NIDOQUEEN 2",
      "NINETALES 2",
      "PINSIR 2",
      "POLITOED 2",
      "POLIWRATH 2",
      "PORYGON2 2",
      "RAMPARDOS 2",
      "RAPIDASH 2",
      "ROSERADE 2",
      "SCIZOR 2",
      "SHUCKLE 2",
      "SLOWKING 2",
      "STARMIE 2",
      "STEELIX 2",
      "TENTACRUEL 2",
      "TOXICROAK 2",
      "URSARING 2",
      "WAILORD 2",
      "WEAVILE 2",
      "YANMEGA 2"
    ]
  },
  {
    "name": "JULIANA",
    "trainerClass": "Lady",
    "pokemon": [
      "ABOMASNOW 2",
      "AERODACTYL 2",
      "ALAKAZAM 2",
      "ALTARIA 2",
      "AMPHAROS 2",
      "ARMALDO 2",
      "BASTIODON 2",
      "BRONZONG 2",
      "CLAYDOL 2",
      "CRADILY 2",
      "DONPHAN 2",
      "DRAPION 2",
      "DRIFBLIM 2",
      "EXEGGUTOR 2",
      "FLOATZEL 2",
      "GALLADE 2",
      "GARDEVOIR 2",
      "GENGAR 2",
      "GLISCOR 2",
      "GOLDUCK 2",
      "HERACROSS 2",
      "HONCHKROW 2",
      "HOUNDOOM 2",
      "LICKILICKY 2",
      "LUXRAY 2",
      "MACHAMP 2",
      "MILTANK 2",
      "MISMAGIUS 2",
      "MUK 2",
      "NIDOKING 2",
      "NIDOQUEEN 2",
      "NINETALES 2",
      "PINSIR 2",
      "POLITOED 2",
      "POLIWRATH 2",
      "PORYGON2 2",
      "RAMPARDOS 2",
      "RAPIDASH 2",
      "ROSERADE 2",
      "SCIZOR 2",
      "SHUCKLE 2",
      "SLOWKING 2",
      "STARMIE 2",
      "STEELIX 2",
      "TENTACRUEL 2",
      "TOXICROAK 2",
      "URSARING 2",
      "WAILORD 2",
      "WEAVILE 2",
      "YANMEGA 2"
    ]
  },
  {
    "name": "CAMUI",
    "trainerClass": "Bug Catcher",
    "pokemon": [
      "ABOMASNOW 2",
      "ARMALDO 2",
      "BRELOOM 2",
      "CRADILY 2",
      "EXEGGUTOR 2",
      "FORRETRESS 2",
      "HERACROSS 2",
      "LEAFEON 2",
      "LUDICOLO 2",
      "MEGANIUM 2",
      "PINSIR 2",
      "ROSERADE 2",
      "SCEPTILE 2",
      "SCIZOR 2",
      "SHIFTRY 2",
      "SHUCKLE 2",
      "TANGROWTH 2",
      "TORTERRA 2",
      "VENUSAUR 2",
      "VESPIQUEN 2",
      "VICTREEBEL 2",
      "VILEPLUME 2",
      "YANMEGA 2"
    ]
  },
  {
    "name": "ORLANDO",
    "trainerClass": "Bug Catcher",
    "pokemon": [
      "ABOMASNOW 2",
      "ARMALDO 2",
      "BRELOOM 2",
      "CRADILY 2",
      "EXEGGUTOR 2",
      "FORRETRESS 2",
      "HERACROSS 2",
      "LEAFEON 2",
      "LUDICOLO 2",
      "MEGANIUM 2",
      "PINSIR 2",
      "ROSERADE 2",
      "SCEPTILE 2",
      "SCIZOR 2",
      "SHIFTRY 2",
      "SHUCKLE 2",
      "TANGROWTH 2",
      "TORTERRA 2",
      "VENUSAUR 2",
      "VESPIQUEN 2",
      "VICTREEBEL 2",
      "VILEPLUME 2",
      "YANMEGA 2"
    ]
  },
  {
    "name": "ZACK",
    "trainerClass": "Ninja Boy",
    "pokemon": [
      "AGGRON 2",
      "ARCANINE 2",
      "BLISSEY 2",
      "CROBAT 2",
      "DRAGONITE 2",
      "DUSKNOIR 2",
      "ELECTIVIRE 2",
      "ESPEON 2",
      "FLAREON 2",
      "FLYGON 2",
      "GARCHOMP 2",
      "GLACEON 2",
      "GYARADOS 2",
      "HIPPOWDON 2",
      "JOLTEON 2",
      "KINGDRA 2",
      "LAPRAS 2",
      "LEAFEON 2",
      "LUCARIO 2",
      "MAGMORTAR 2",
      "MAGNEZONE 2",
      "MAMOSWINE 2",
      "METAGROSS 2",
      "MILOTIC 2",
      "PORYGON-Z 2",
      "PROBOPASS 2",
      "RHYPERIOR 2",
      "SALAMENCE 2",
      "SLAKING 2",
      "SNORLAX 2",
      "TANGROWTH 2",
      "TOGEKISS 2",
      "TYRANITAR 2",
      "UMBREON 2",
      "VAPOREON 2",
      "WALREIN 2"
    ]
  },
  {
    "name": "VANCE",
    "trainerClass": "Ninja Boy",
    "pokemon": [
      "AGGRON 2",
      "ARCANINE 2",
      "BLISSEY 2",
      "CROBAT 2",
      "DRAGONITE 2",
      "DUSKNOIR 2",
      "ELECTIVIRE 2",
      "ESPEON 2",
      "FLAREON 2",
      "FLYGON 2",
      "GARCHOMP 2",
      "GLACEON 2",
      "GYARADOS 2",
      "HIPPOWDON 2",
      "JOLTEON 2",
      "KINGDRA 2",
      "LAPRAS 2",
      "LEAFEON 2",
      "LUCARIO 2",
      "MAGMORTAR 2",
      "MAGNEZONE 2",
      "MAMOSWINE 2",
      "METAGROSS 2",
      "MILOTIC 2",
      "PORYGON-Z 2",
      "PROBOPASS 2",
      "RHYPERIOR 2",
      "SALAMENCE 2",
      "SLAKING 2",
      "SNORLAX 2",
      "TANGROWTH 2",
      "TOGEKISS 2",
      "TYRANITAR 2",
      "UMBREON 2",
      "VAPOREON 2",
      "WALREIN 2"
    ]
  },
  {
    "name": "KYLA",
    "trainerClass": "Poke Kid",
    "pokemon": [
      "AGGRON 2",
      "ARCANINE 2",
      "BLISSEY 2",
      "CROBAT 2",
      "DRAGONITE 2",
      "DUSKNOIR 2",
      "ELECTIVIRE 2",
      "ESPEON 2",
      "FLAREON 2",
      "FLYGON 2",
      "GARCHOMP 2",
      "GLACEON 2",
      "GYARADOS 2",
      "HIPPOWDON 2",
      "JOLTEON 2",
      "KINGDRA 2",
      "LAPRAS 2",
      "LEAFEON 2",
      "LUCARIO 2",
      "MAGMORTAR 2",
      "MAGNEZONE 2",
      "MAMOSWINE 2",
      "METAGROSS 2",
      "MILOTIC 2",
      "PORYGON-Z 2",
      "PROBOPASS 2",
      "RHYPERIOR 2",
      "SALAMENCE 2",
      "SLAKING 2",
      "SNORLAX 2",
      "TANGROWTH 2",
      "TOGEKISS 2",
      "TYRANITAR 2",
      "UMBREON 2",
      "VAPOREON 2",
      "WALREIN 2"
    ]
  },
  {
    "name": "RUBY",
    "trainerClass": "Poke Kid",
    "pokemon": [
      "AGGRON 2",
      "ARCANINE 2",
      "BLISSEY 2",
      "CROBAT 2",
      "DRAGONITE 2",
      "DUSKNOIR 2",
      "ELECTIVIRE 2",
      "ESPEON 2",
      "FLAREON 2",
      "FLYGON 2",
      "GARCHOMP 2",
      "GLACEON 2",
      "GYARADOS 2",
      "HIPPOWDON 2",
      "JOLTEON 2",
      "KINGDRA 2",
      "LAPRAS 2",
      "LEAFEON 2",
      "LUCARIO 2",
      "MAGMORTAR 2",
      "MAGNEZONE 2",
      "MAMOSWINE 2",
      "METAGROSS 2",
      "MILOTIC 2",
      "PORYGON-Z 2",
      "PROBOPASS 2",
      "RHYPERIOR 2",
      "SALAMENCE 2",
      "SLAKING 2",
      "SNORLAX 2",
      "TANGROWTH 2",
      "TOGEKISS 2",
      "TYRANITAR 2",
      "UMBREON 2",
      "VAPOREON 2",
      "WALREIN 2"
    ]
  },
  {
    "name": "KILEY",
    "trainerClass": "Idol",
    "pokemon": [
      "ABOMASNOW 2",
      "AMBIPOM 2",
      "BLISSEY 2",
      "BRELOOM 2",
      "CRADILY 2",
      "EXEGGUTOR 2",
      "EXPLOUD 2",
      "GRANBULL 2",
      "KANGASKHAN 2",
      "LEAFEON 2",
      "LICKILICKY 2",
      "LOPUNNY 2",
      "LUDICOLO 2",
      "MEGANIUM 2",
      "MILTANK 2",
      "PORYGON-Z 2",
      "PORYGON2 2",
      "ROSERADE 2",
      "SCEPTILE 2",
      "SHIFTRY 2",
      "SLAKING 2",
      "SNORLAX 2",
      "STARAPTOR 2",
      "TANGROWTH 2",
      "TAUROS 2",
      "TOGEKISS 2",
      "TORTERRA 2",
      "URSARING 2",
      "VENUSAUR 2",
      "VICTREEBEL 2",
      "VILEPLUME 2"
    ]
  },
  {
    "name": "UTAH",
    "trainerClass": "Idol",
    "pokemon": [
      "ABOMASNOW 2",
      "AMBIPOM 2",
      "BLISSEY 2",
      "BRELOOM 2",
      "CRADILY 2",
      "EXEGGUTOR 2",
      "EXPLOUD 2",
      "GRANBULL 2",
      "KANGASKHAN 2",
      "LEAFEON 2",
      "LICKILICKY 2",
      "LOPUNNY 2",
      "LUDICOLO 2",
      "MEGANIUM 2",
      "MILTANK 2",
      "PORYGON-Z 2",
      "PORYGON2 2",
      "ROSERADE 2",
      "SCEPTILE 2",
      "SHIFTRY 2",
      "SLAKING 2",
      "SNORLAX 2",
      "STARAPTOR 2",
      "TANGROWTH 2",
      "TAUROS 2",
      "TOGEKISS 2",
      "TORTERRA 2",
      "URSARING 2",
      "VENUSAUR 2",
      "VICTREEBEL 2",
      "VILEPLUME 2"
    ]
  },
  {
    "name": "COLT",
    "trainerClass": "Jogger",
    "pokemon": [
      "ABOMASNOW 3",
      "ABSOL 3",
      "ALAKAZAM 3",
      "ALTARIA 3",
      "AMBIPOM 3",
      "ARMALDO 3",
      "BASTIODON 3",
      "BLASTOISE 3",
      "BLAZIKEN 3",
      "BRELOOM 3",
      "CHARIZARD 3",
      "CRADILY 3",
      "DEWGONG 3",
      "DRIFBLIM 3",
      "DUGTRIO 3",
      "ELECTRODE 3",
      "EMPOLEON 3",
      "EXPLOUD 3",
      "FERALIGATR 3",
      "FLOATZEL 3",
      "FORRETRESS 3",
      "FROSLASS 3",
      "GASTRODON 3",
      "GLALIE 3",
      "GOLDUCK 3",
      "GOLEM 3",
      "GRANBULL 3",
      "HARIYAMA 3",
      "HYPNO 3",
      "INFERNAPE 3",
      "JYNX 3",
      "KANGASKHAN 3",
      "LANTURN 3",
      "LOPUNNY 3",
      "LUDICOLO 3",
      "MANECTRIC 3",
      "MAROWAK 3",
      "MEDICHAM 3",
      "MEGANIUM 3",
      "MILTANK 3",
      "MISMAGIUS 3",
      "MRMIME 3",
      "MUK 3",
      "NIDOKING 3",
      "NIDOQUEEN 3",
      "POLIWRATH 3",
      "QUAGSIRE 3",
      "RAICHU 3",
      "RAPIDASH 3",
      "RHYDON 3",
      "SCEPTILE 3",
      "SHIFTRY 3",
      "SKARMORY 3",
      "SKUNTANK 3",
      "SLOWBRO 3",
      "SLOWKING 3",
      "STARAPTOR 3",
      "SWAMPERT 3",
      "TAUROS 3",
      "TORTERRA 3",
      "TOXICROAK 3",
      "TYPHLOSION 3",
      "VENUSAUR 3",
      "VESPIQUEN 3",
      "VICTREEBEL 3",
      "VILEPLUME 3",
      "WEEZING 3",
      "WHISCASH 3"
    ]
  },
  {
    "name": "TORY",
    "trainerClass": "Jogger",
    "pokemon": [
      "ABOMASNOW 3",
      "ABSOL 3",
      "ALAKAZAM 3",
      "ALTARIA 3",
      "AMBIPOM 3",
      "ARMALDO 3",
      "BASTIODON 3",
      "BLASTOISE 3",
      "BLAZIKEN 3",
      "BRELOOM 3",
      "CHARIZARD 3",
      "CRADILY 3",
      "DEWGONG 3",
      "DRIFBLIM 3",
      "DUGTRIO 3",
      "ELECTRODE 3",
      "EMPOLEON 3",
      "EXPLOUD 3",
      "FERALIGATR 3",
      "FLOATZEL 3",
      "FORRETRESS 3",
      "FROSLASS 3",
      "GASTRODON 3",
      "GLALIE 3",
      "GOLDUCK 3",
      "GOLEM 3",
      "GRANBULL 3",
      "HARIYAMA 3",
      "HYPNO 3",
      "INFERNAPE 3",
      "JYNX 3",
      "KANGASKHAN 3",
      "LANTURN 3",
      "LOPUNNY 3",
      "LUDICOLO 3",
      "MANECTRIC 3",
      "MAROWAK 3",
      "MEDICHAM 3",
      "MEGANIUM 3",
      "MILTANK 3",
      "MISMAGIUS 3",
      "MRMIME 3",
      "MUK 3",
      "NIDOKING 3",
      "NIDOQUEEN 3",
      "POLIWRATH 3",
      "QUAGSIRE 3",
      "RAICHU 3",
      "RAPIDASH 3",
      "RHYDON 3",
      "SCEPTILE 3",
      "SHIFTRY 3",
      "SKARMORY 3",
      "SKUNTANK 3",
      "SLOWBRO 3",
      "SLOWKING 3",
      "STARAPTOR 3",
      "SWAMPERT 3",
      "TAUROS 3",
      "TORTERRA 3",
      "TOXICROAK 3",
      "TYPHLOSION 3",
      "VENUSAUR 3",
      "VESPIQUEN 3",
      "VICTREEBEL 3",
      "VILEPLUME 3",
      "WEEZING 3",
      "WHISCASH 3"
    ]
  },
  {
    "name": "FARLEY",
    "trainerClass": "Fisherman",
    "pokemon": [
      "BLASTOISE 3",
      "DEWGONG 3",
      "EMPOLEON 3",
      "FERALIGATR 3",
      "FLOATZEL 3",
      "GASTRODON 3",
      "GOLDUCK 3",
      "GYARADOS 3",
      "KINGDRA 3",
      "LANTURN 3",
      "LAPRAS 3",
      "LUDICOLO 3",
      "MILOTIC 3",
      "POLITOED 3",
      "POLIWRATH 3",
      "QUAGSIRE 3",
      "SLOWBRO 3",
      "SLOWKING 3",
      "STARMIE 3",
      "SWAMPERT 3",
      "TENTACRUEL 3",
      "VAPOREON 3",
      "WAILORD 3",
      "WALREIN 3",
      "WHISCASH 3"
    ]
  },
  {
    "name": "MARK",
    "trainerClass": "Fisherman",
    "pokemon": [
      "BLASTOISE 3",
      "DEWGONG 3",
      "EMPOLEON 3",
      "FERALIGATR 3",
      "FLOATZEL 3",
      "GASTRODON 3",
      "GOLDUCK 3",
      "GYARADOS 3",
      "KINGDRA 3",
      "LANTURN 3",
      "LAPRAS 3",
      "LUDICOLO 3",
      "MILOTIC 3",
      "POLITOED 3",
      "POLIWRATH 3",
      "QUAGSIRE 3",
      "SLOWBRO 3",
      "SLOWKING 3",
      "STARMIE 3",
      "SWAMPERT 3",
      "TENTACRUEL 3",
      "VAPOREON 3",
      "WAILORD 3",
      "WALREIN 3",
      "WHISCASH 3"
    ]
  },
  {
    "name": "SAMUEL",
    "trainerClass": "Ruin Maniac",
    "pokemon": [
      "AERODACTYL 3",
      "AGGRON 3",
      "ARMALDO 3",
      "BASTIODON 3",
      "BRONZONG 3",
      "CLAYDOL 3",
      "CRADILY 3",
      "DONPHAN 3",
      "DUGTRIO 3",
      "EMPOLEON 3",
      "FLYGON 3",
      "FORRETRESS 3",
      "GARCHOMP 3",
      "GASTRODON 3",
      "GLISCOR 3",
      "GOLEM 3",
      "HIPPOWDON 3",
      "LUCARIO 3",
      "MAGNEZONE 3",
      "MAMOSWINE 3",
      "MAROWAK 3",
      "METAGROSS 3",
      "NIDOKING 3",
      "NIDOQUEEN 3",
      "PROBOPASS 3",
      "QUAGSIRE 3",
      "RAMPARDOS 3",
      "RHYDON 3",
      "RHYPERIOR 3",
      "SCIZOR 3",
      "SHUCKLE 3",
      "SKARMORY 3",
      "STEELIX 3",
      "SWAMPERT 3",
      "TORTERRA 3",
      "TYRANITAR 3",
      "WHISCASH 3"
    ]
  },
  {
    "name": "PENN",
    "trainerClass": "Ruin Maniac",
    "pokemon": [
      "AERODACTYL 3",
      "AGGRON 3",
      "ARMALDO 3",
      "BASTIODON 3",
      "BRONZONG 3",
      "CLAYDOL 3",
      "CRADILY 3",
      "DONPHAN 3",
      "DUGTRIO 3",
      "EMPOLEON 3",
      "FLYGON 3",
      "FORRETRESS 3",
      "GARCHOMP 3",
      "GASTRODON 3",
      "GLISCOR 3",
      "GOLEM 3",
      "HIPPOWDON 3",
      "LUCARIO 3",
      "MAGNEZONE 3",
      "MAMOSWINE 3",
      "MAROWAK 3",
      "METAGROSS 3",
      "NIDOKING 3",
      "NIDOQUEEN 3",
      "PROBOPASS 3",
      "QUAGSIRE 3",
      "RAMPARDOS 3",
      "RHYDON 3",
      "RHYPERIOR 3",
      "SCIZOR 3",
      "SHUCKLE 3",
      "SKARMORY 3",
      "STEELIX 3",
      "SWAMPERT 3",
      "TORTERRA 3",
      "TYRANITAR 3",
      "WHISCASH 3"
    ]
  },
  {
    "name": "MARQUEZ",
    "trainerClass": "Collector",
    "pokemon": [
      "AERODACTYL 3",
      "AGGRON 3",
      "AMPHAROS 3",
      "ARCANINE 3",
      "BLISSEY 3",
      "BRONZONG 3",
      "CLAYDOL 3",
      "CROBAT 3",
      "DONPHAN 3",
      "DRAGONITE 3",
      "DRAPION 3",
      "DUSKNOIR 3",
      "ELECTIVIRE 3",
      "ESPEON 3",
      "EXEGGUTOR 3",
      "FLAREON 3",
      "FLYGON 3",
      "GALLADE 3",
      "GARCHOMP 3",
      "GARDEVOIR 3",
      "GENGAR 3",
      "GLACEON 3",
      "GLISCOR 3",
      "GYARADOS 3",
      "HERACROSS 3",
      "HIPPOWDON 3",
      "HONCHKROW 3",
      "HOUNDOOM 3",
      "JOLTEON 3",
      "KINGDRA 3",
      "LAPRAS 3",
      "LEAFEON 3",
      "LICKILICKY 3",
      "LUCARIO 3",
      "LUXRAY 3",
      "MACHAMP 3",
      "MAGMORTAR 3",
      "MAGNEZONE 3",
      "MAMOSWINE 3",
      "METAGROSS 3",
      "MILOTIC 3",
      "NINETALES 3",
      "PINSIR 3",
      "POLITOED 3",
      "PORYGON-Z 3",
      "PORYGON2 3",
      "PROBOPASS 3",
      "RAMPARDOS 3",
      "RHYPERIOR 3",
      "ROSERADE 3",
      "SALAMENCE 3",
      "SCIZOR 3",
      "SHUCKLE 3",
      "SLAKING 3",
      "SNORLAX 3",
      "STARMIE 3",
      "STEELIX 3",
      "TANGROWTH 3",
      "TENTACRUEL 3",
      "TOGEKISS 3",
      "TYRANITAR 3",
      "UMBREON 3",
      "URSARING 3",
      "VAPOREON 3",
      "WAILORD 3",
      "WALREIN 3",
      "WEAVILE 3",
      "YANMEGA 3"
    ]
  },
  {
    "name": "ARNOLD",
    "trainerClass": "Collector",
    "pokemon": [
      "AERODACTYL 3",
      "AGGRON 3",
      "AMPHAROS 3",
      "ARCANINE 3",
      "BLISSEY 3",
      "BRONZONG 3",
      "CLAYDOL 3",
      "CROBAT 3",
      "DONPHAN 3",
      "DRAGONITE 3",
      "DRAPION 3",
      "DUSKNOIR 3",
      "ELECTIVIRE 3",
      "ESPEON 3",
      "EXEGGUTOR 3",
      "FLAREON 3",
      "FLYGON 3",
      "GALLADE 3",
      "GARCHOMP 3",
      "GARDEVOIR 3",
      "GENGAR 3",
      "GLACEON 3",
      "GLISCOR 3",
      "GYARADOS 3",
      "HERACROSS 3",
      "HIPPOWDON 3",
      "HONCHKROW 3",
      "HOUNDOOM 3",
      "JOLTEON 3",
      "KINGDRA 3",
      "LAPRAS 3",
      "LEAFEON 3",
      "LICKILICKY 3",
      "LUCARIO 3",
      "LUXRAY 3",
      "MACHAMP 3",
      "MAGMORTAR 3",
      "MAGNEZONE 3",
      "MAMOSWINE 3",
      "METAGROSS 3",
      "MILOTIC 3",
      "NINETALES 3",
      "PINSIR 3",
      "POLITOED 3",
      "PORYGON-Z 3",
      "PORYGON2 3",
      "PROBOPASS 3",
      "RAMPARDOS 3",
      "RHYPERIOR 3",
      "ROSERADE 3",
      "SALAMENCE 3",
      "SCIZOR 3",
      "SHUCKLE 3",
      "SLAKING 3",
      "SNORLAX 3",
      "STARMIE 3",
      "STEELIX 3",
      "TANGROWTH 3",
      "TENTACRUEL 3",
      "TOGEKISS 3",
      "TYRANITAR 3",
      "UMBREON 3",
      "URSARING 3",
      "VAPOREON 3",
      "WAILORD 3",
      "WALREIN 3",
      "WEAVILE 3",
      "YANMEGA 3"
    ]
  },
  {
    "name": "FRED",
    "trainerClass": "Guitarist",
    "pokemon": [
      "ABSOL 3",
      "ALAKAZAM 3",
      "AMPHAROS 3",
      "BLAZIKEN 3",
      "BRELOOM 3",
      "BRONZONG 3",
      "CLAYDOL 3",
      "DRAPION 3",
      "DRIFBLIM 3",
      "DUSKNOIR 3",
      "ELECTIVIRE 3",
      "ELECTRODE 3",
      "ESPEON 3",
      "EXEGGUTOR 3",
      "FROSLASS 3",
      "GALLADE 3",
      "GARDEVOIR 3",
      "GENGAR 3",
      "HARIYAMA 3",
      "HERACROSS 3",
      "HONCHKROW 3",
      "HOUNDOOM 3",
      "HYPNO 3",
      "INFERNAPE 3",
      "JOLTEON 3",
      "JYNX 3",
      "LANTURN 3",
      "LUCARIO 3",
      "LUXRAY 3",
      "MACHAMP 3",
      "MAGNEZONE 3",
      "MANECTRIC 3",
      "MEDICHAM 3",
      "METAGROSS 3",
      "MISMAGIUS 3",
      "MRMIME 3",
      "POLIWRATH 3",
      "RAICHU 3",
      "SHIFTRY 3",
      "SKUNTANK 3",
      "SLOWBRO 3",
      "SLOWKING 3",
      "STARMIE 3",
      "TOXICROAK 3",
      "TYRANITAR 3",
      "UMBREON 3",
      "WEAVILE 3"
    ]
  },
  {
    "name": "CHASE",
    "trainerClass": "Guitarist",
    "pokemon": [
      "ABSOL 3",
      "ALAKAZAM 3",
      "AMPHAROS 3",
      "BLAZIKEN 3",
      "BRELOOM 3",
      "BRONZONG 3",
      "CLAYDOL 3",
      "DRAPION 3",
      "DRIFBLIM 3",
      "DUSKNOIR 3",
      "ELECTIVIRE 3",
      "ELECTRODE 3",
      "ESPEON 3",
      "EXEGGUTOR 3",
      "FROSLASS 3",
      "GALLADE 3",
      "GARDEVOIR 3",
      "GENGAR 3",
      "HARIYAMA 3",
      "HERACROSS 3",
      "HONCHKROW 3",
      "HOUNDOOM 3",
      "HYPNO 3",
      "INFERNAPE 3",
      "JOLTEON 3",
      "JYNX 3",
      "LANTURN 3",
      "LUCARIO 3",
      "LUXRAY 3",
      "MACHAMP 3",
      "MAGNEZONE 3",
      "MANECTRIC 3",
      "MEDICHAM 3",
      "METAGROSS 3",
      "MISMAGIUS 3",
      "MRMIME 3",
      "POLIWRATH 3",
      "RAICHU 3",
      "SHIFTRY 3",
      "SKUNTANK 3",
      "SLOWBRO 3",
      "SLOWKING 3",
      "STARMIE 3",
      "TOXICROAK 3",
      "TYRANITAR 3",
      "UMBREON 3",
      "WEAVILE 3"
    ]
  },
  {
    "name": "MCKENNA",
    "trainerClass": "Bird Keeper",
    "pokemon": [
      "AERODACTYL 3",
      "ALTARIA 3",
      "CHARIZARD 3",
      "CROBAT 3",
      "DRAGONITE 3",
      "DRIFBLIM 3",
      "FLYGON 3",
      "GLISCOR 3",
      "GYARADOS 3",
      "HONCHKROW 3",
      "PORYGON-Z 3",
      "PORYGON2 3",
      "SALAMENCE 3",
      "SKARMORY 3",
      "STARAPTOR 3",
      "TOGEKISS 3",
      "VESPIQUEN 3",
      "YANMEGA 3"
    ]
  },
  {
    "name": "SALLY",
    "trainerClass": "Bird Keeper",
    "pokemon": [
      "AERODACTYL 3",
      "ALTARIA 3",
      "CHARIZARD 3",
      "CROBAT 3",
      "DRAGONITE 3",
      "DRIFBLIM 3",
      "FLYGON 3",
      "GLISCOR 3",
      "GYARADOS 3",
      "HONCHKROW 3",
      "PORYGON-Z 3",
      "PORYGON2 3",
      "SALAMENCE 3",
      "SKARMORY 3",
      "STARAPTOR 3",
      "TOGEKISS 3",
      "VESPIQUEN 3",
      "YANMEGA 3"
    ]
  },
  {
    "name": "CASPER",
    "trainerClass": "Sailor",
    "pokemon": [
      "AMBIPOM 3",
      "BLASTOISE 3",
      "BLAZIKEN 3",
      "BLISSEY 3",
      "BRELOOM 3",
      "DEWGONG 3",
      "EMPOLEON 3",
      "EXPLOUD 3",
      "FERALIGATR 3",
      "FLOATZEL 3",
      "GALLADE 3",
      "GASTRODON 3",
      "GOLDUCK 3",
      "GRANBULL 3",
      "GYARADOS 3",
      "HARIYAMA 3",
      "HERACROSS 3",
      "INFERNAPE 3",
      "KANGASKHAN 3",
      "KINGDRA 3",
      "LANTURN 3",
      "LAPRAS 3",
      "LICKILICKY 3",
      "LOPUNNY 3",
      "LUCARIO 3",
      "LUDICOLO 3",
      "MACHAMP 3",
      "MEDICHAM 3",
      "MILOTIC 3",
      "MILTANK 3",
      "POLITOED 3",
      "POLIWRATH 3",
      "PORYGON-Z 3",
      "PORYGON2 3",
      "QUAGSIRE 3",
      "SLAKING 3",
      "SLOWBRO 3",
      "SLOWKING 3",
      "SNORLAX 3",
      "STARAPTOR 3",
      "STARMIE 3",
      "SWAMPERT 3",
      "TAUROS 3",
      "TENTACRUEL 3",
      "TOGEKISS 3",
      "TOXICROAK 3",
      "URSARING 3",
      "VAPOREON 3",
      "WAILORD 3",
      "WALREIN 3",
      "WHISCASH 3"
    ]
  },
  {
    "name": "DERRIAN",
    "trainerClass": "Sailor",
    "pokemon": [
      "AMBIPOM 3",
      "BLASTOISE 3",
      "BLAZIKEN 3",
      "BLISSEY 3",
      "BRELOOM 3",
      "DEWGONG 3",
      "EMPOLEON 3",
      "EXPLOUD 3",
      "FERALIGATR 3",
      "FLOATZEL 3",
      "GALLADE 3",
      "GASTRODON 3",
      "GOLDUCK 3",
      "GRANBULL 3",
      "GYARADOS 3",
      "HARIYAMA 3",
      "HERACROSS 3",
      "INFERNAPE 3",
      "KANGASKHAN 3",
      "KINGDRA 3",
      "LANTURN 3",
      "LAPRAS 3",
      "LICKILICKY 3",
      "LOPUNNY 3",
      "LUCARIO 3",
      "LUDICOLO 3",
      "MACHAMP 3",
      "MEDICHAM 3",
      "MILOTIC 3",
      "MILTANK 3",
      "POLITOED 3",
      "POLIWRATH 3",
      "PORYGON-Z 3",
      "PORYGON2 3",
      "QUAGSIRE 3",
      "SLAKING 3",
      "SLOWBRO 3",
      "SLOWKING 3",
      "SNORLAX 3",
      "STARAPTOR 3",
      "STARMIE 3",
      "SWAMPERT 3",
      "TAUROS 3",
      "TENTACRUEL 3",
      "TOGEKISS 3",
      "TOXICROAK 3",
      "URSARING 3",
      "VAPOREON 3",
      "WAILORD 3",
      "WALREIN 3",
      "WHISCASH 3"
    ]
  },
  {
    "name": "MONTY",
    "trainerClass": "Hiker",
    "pokemon": [
      "AERODACTYL 3",
      "AGGRON 3",
      "ARMALDO 3",
      "BASTIODON 3",
      "BLAZIKEN 3",
      "BRELOOM 3",
      "BRONZONG 3",
      "CLAYDOL 3",
      "CRADILY 3",
      "DONPHAN 3",
      "DUGTRIO 3",
      "FLYGON 3",
      "FORRETRESS 3",
      "GALLADE 3",
      "GARCHOMP 3",
      "GASTRODON 3",
      "GLISCOR 3",
      "GOLEM 3",
      "HARIYAMA 3",
      "HERACROSS 3",
      "HIPPOWDON 3",
      "INFERNAPE 3",
      "LUCARIO 3",
      "MACHAMP 3",
      "MAMOSWINE 3",
      "MAROWAK 3",
      "MEDICHAM 3",
      "METAGROSS 3",
      "NIDOKING 3",
      "NIDOQUEEN 3",
      "POLIWRATH 3",
      "PROBOPASS 3",
      "QUAGSIRE 3",
      "RAMPARDOS 3",
      "RHYDON 3",
      "RHYPERIOR 3",
      "SHUCKLE 3",
      "STEELIX 3",
      "SWAMPERT 3",
      "TORTERRA 3",
      "TOXICROAK 3",
      "TYRANITAR 3",
      "WHISCASH 3"
    ]
  },
  {
    "name": "ROCKY",
    "trainerClass": "Hiker",
    "pokemon": [
      "AERODACTYL 3",
      "AGGRON 3",
      "ARMALDO 3",
      "BASTIODON 3",
      "BLAZIKEN 3",
      "BRELOOM 3",
      "BRONZONG 3",
      "CLAYDOL 3",
      "CRADILY 3",
      "DONPHAN 3",
      "DUGTRIO 3",
      "FLYGON 3",
      "FORRETRESS 3",
      "GALLADE 3",
      "GARCHOMP 3",
      "GASTRODON 3",
      "GLISCOR 3",
      "GOLEM 3",
      "HARIYAMA 3",
      "HERACROSS 3",
      "HIPPOWDON 3",
      "INFERNAPE 3",
      "LUCARIO 3",
      "MACHAMP 3",
      "MAMOSWINE 3",
      "MAROWAK 3",
      "MEDICHAM 3",
      "METAGROSS 3",
      "NIDOKING 3",
      "NIDOQUEEN 3",
      "POLIWRATH 3",
      "PROBOPASS 3",
      "QUAGSIRE 3",
      "RAMPARDOS 3",
      "RHYDON 3",
      "RHYPERIOR 3",
      "SHUCKLE 3",
      "STEELIX 3",
      "SWAMPERT 3",
      "TORTERRA 3",
      "TOXICROAK 3",
      "TYRANITAR 3",
      "WHISCASH 3"
    ]
  },
  {
    "name": "REGGIE",
    "trainerClass": "Policeman",
    "pokemon": [
      "AGGRON 3",
      "AMBIPOM 3",
      "BASTIODON 3",
      "BLAZIKEN 3",
      "BLISSEY 3",
      "BRELOOM 3",
      "BRONZONG 3",
      "EMPOLEON 3",
      "EXPLOUD 3",
      "FORRETRESS 3",
      "GALLADE 3",
      "GRANBULL 3",
      "HARIYAMA 3",
      "HERACROSS 3",
      "INFERNAPE 3",
      "KANGASKHAN 3",
      "LICKILICKY 3",
      "LOPUNNY 3",
      "LUCARIO 3",
      "MACHAMP 3",
      "MAGNEZONE 3",
      "MEDICHAM 3",
      "METAGROSS 3",
      "MILTANK 3",
      "POLIWRATH 3",
      "PORYGON-Z 3",
      "PORYGON2 3",
      "PROBOPASS 3",
      "SCIZOR 3",
      "SKARMORY 3",
      "SLAKING 3",
      "SNORLAX 3",
      "STARAPTOR 3",
      "STEELIX 3",
      "TAUROS 3",
      "TOGEKISS 3",
      "TOXICROAK 3",
      "URSARING 3"
    ]
  },
  {
    "name": "QUINCY",
    "trainerClass": "Policeman",
    "pokemon": [
      "AGGRON 3",
      "AMBIPOM 3",
      "BASTIODON 3",
      "BLAZIKEN 3",
      "BLISSEY 3",
      "BRELOOM 3",
      "BRONZONG 3",
      "EMPOLEON 3",
      "EXPLOUD 3",
      "FORRETRESS 3",
      "GALLADE 3",
      "GRANBULL 3",
      "HARIYAMA 3",
      "HERACROSS 3",
      "INFERNAPE 3",
      "KANGASKHAN 3",
      "LICKILICKY 3",
      "LOPUNNY 3",
      "LUCARIO 3",
      "MACHAMP 3",
      "MAGNEZONE 3",
      "MEDICHAM 3",
      "METAGROSS 3",
      "MILTANK 3",
      "POLIWRATH 3",
      "PORYGON-Z 3",
      "PORYGON2 3",
      "PROBOPASS 3",
      "SCIZOR 3",
      "SKARMORY 3",
      "SLAKING 3",
      "SNORLAX 3",
      "STARAPTOR 3",
      "STEELIX 3",
      "TAUROS 3",
      "TOGEKISS 3",
      "TOXICROAK 3",
      "URSARING 3"
    ]
  },
  {
    "name": "NEIL",
    "trainerClass": "PI",
    "pokemon": [
      "DUGTRIO 3",
      "WHISCASH 3",
      "DEWGONG 3",
      "GASTRODON 3",
      "FROSLASS 3",
      "WEEZING 3",
      "BASTIODON 3",
      "MISMAGIUS 3",
      "DRIFBLIM 3",
      "RAPIDASH 3",
      "GLISCOR 3",
      "EXEGGUTOR 3",
      "HIPPOWDON 3",
      "PROBOPASS 3",
      "WALREIN 3",
      "MAMOSWINE 3",
      "RHYPERIOR 3"
    ]
  },
  {
    "name": "SERGEI",
    "trainerClass": "PI",
    "pokemon": [
      "DUGTRIO 3",
      "WHISCASH 3",
      "DEWGONG 3",
      "GASTRODON 3",
      "FROSLASS 3",
      "WEEZING 3",
      "BASTIODON 3",
      "MISMAGIUS 3",
      "DRIFBLIM 3",
      "RAPIDASH 3",
      "GLISCOR 3",
      "EXEGGUTOR 3",
      "HIPPOWDON 3",
      "PROBOPASS 3",
      "WALREIN 3",
      "MAMOSWINE 3",
      "RHYPERIOR 3"
    ]
  }
];

export const POKEMON_HGSS = [
  {
    "entry": 406,
    "name": "ABOMASNOW 1",
    "species": "Abomasnow",
    "instance": "1",
    "nature": "Calm",
    "item": "Lum Berry",
    "move1": "Giga Drain",
    "move2": "Ice Beam",
    "move3": "Water Pulse",
    "move4": "GrassWhistle",
    "speed": 80
  },
  {
    "entry": 542,
    "name": "ABOMASNOW 2",
    "species": "Abomasnow",
    "instance": "2",
    "nature": "Bold",
    "item": "Big Root",
    "move1": "Giga Drain",
    "move2": "Sheer Cold",
    "move3": "Ingrain",
    "move4": "Leech Seed",
    "speed": 80
  },
  {
    "entry": 678,
    "name": "ABOMASNOW 3",
    "species": "Abomasnow",
    "instance": "3",
    "nature": "Quiet",
    "item": "Occa Berry",
    "move1": "Energy Ball",
    "move2": "Blizzard",
    "move3": "Shadow Ball",
    "move4": "Focus Blast",
    "speed": 72
  },
  {
    "entry": 814,
    "name": "ABOMASNOW 4",
    "species": "Abomasnow",
    "instance": "4",
    "nature": "Brave",
    "item": "Shell Bell",
    "move1": "Wood Hammer",
    "move2": "Avalanche",
    "move3": "Earthquake",
    "move4": "Rock Slide",
    "speed": 72
  },
  {
    "entry": 374,
    "name": "ABSOL 1",
    "species": "Absol",
    "instance": "1",
    "nature": "Jolly",
    "item": "Chople Berry",
    "move1": "Sucker Punch",
    "move2": "Facade",
    "move3": "Double Team",
    "move4": "Taunt",
    "speed": 139
  },
  {
    "entry": 510,
    "name": "ABSOL 2",
    "species": "Absol",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Punishment",
    "move2": "Swagger",
    "move3": "Attract",
    "move4": "Thunder Wave",
    "speed": 95
  },
  {
    "entry": 646,
    "name": "ABSOL 3",
    "species": "Absol",
    "instance": "3",
    "nature": "Jolly",
    "item": "Razor Claw",
    "move1": "Night Slash",
    "move2": "Psycho Cut",
    "move3": "X-Scissor",
    "move4": "Aerial Ace",
    "speed": 139
  },
  {
    "entry": 782,
    "name": "ABSOL 4",
    "species": "Absol",
    "instance": "4",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Night Slash",
    "move2": "Superpower",
    "move3": "Giga Impact",
    "move4": "Zen Headbutt",
    "speed": 127
  },
  {
    "entry": 443,
    "name": "AERODACTYL 1",
    "species": "Aerodactyl",
    "instance": "1",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Rock Slide",
    "move2": "Aerial Ace",
    "move3": "Torment",
    "move4": "Taunt",
    "speed": 200
  },
  {
    "entry": 579,
    "name": "AERODACTYL 2",
    "species": "Aerodactyl",
    "instance": "2",
    "nature": "Jolly",
    "item": "Razor Fang",
    "move1": "Bite",
    "move2": "Fire Fang",
    "move3": "Thunder Fang",
    "move4": "Ice Fang",
    "speed": 200
  },
  {
    "entry": 715,
    "name": "AERODACTYL 3",
    "species": "Aerodactyl",
    "instance": "3",
    "nature": "Adamant",
    "item": "Yache Berry",
    "move1": "Giga Impact",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Crunch",
    "speed": 182
  },
  {
    "entry": 851,
    "name": "AERODACTYL 4",
    "species": "Aerodactyl",
    "instance": "4",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Stone Edge",
    "move2": "Aerial Ace",
    "move3": "Earthquake",
    "move4": "Dragon Claw",
    "speed": 182
  },
  {
    "entry": 463,
    "name": "AGGRON 1",
    "species": "Aggron",
    "instance": "1",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Iron Head",
    "move2": "Rock Slide",
    "move3": "Sandstorm",
    "move4": "Screech",
    "speed": 70
  },
  {
    "entry": 599,
    "name": "AGGRON 2",
    "species": "Aggron",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Metal Claw",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 70
  },
  {
    "entry": 735,
    "name": "AGGRON 3",
    "species": "Aggron",
    "instance": "3",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Iron Tail",
    "move2": "Dragon Rush",
    "move3": "Avalanche",
    "move4": "Aerial Ace",
    "speed": 70
  },
  {
    "entry": 871,
    "name": "AGGRON 4",
    "species": "Aggron",
    "instance": "4",
    "nature": "Adamant",
    "item": "Focus Sash",
    "move1": "Metal Burst",
    "move2": "Stone Edge",
    "move3": "Earthquake",
    "move4": "Shadow Claw",
    "speed": 70
  },
  {
    "entry": 401,
    "name": "ALAKAZAM 1",
    "species": "Alakazam",
    "instance": "1",
    "nature": "Timid",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Calm Mind",
    "move4": "Future Sight",
    "speed": 189
  },
  {
    "entry": 537,
    "name": "ALAKAZAM 2",
    "species": "Alakazam",
    "instance": "2",
    "nature": "Modest",
    "item": "Colbur Berry",
    "move1": "Psychic",
    "move2": "Focus Blast",
    "move3": "Charge Beam",
    "move4": "Recover",
    "speed": 172
  },
  {
    "entry": 673,
    "name": "ALAKAZAM 3",
    "species": "Alakazam",
    "instance": "3",
    "nature": "Timid",
    "item": "Wise Glasses",
    "move1": "Psychic",
    "move2": "Charge Beam",
    "move3": "Signal Beam",
    "move4": "Grass Knot",
    "speed": 189
  },
  {
    "entry": 809,
    "name": "ALAKAZAM 4",
    "species": "Alakazam",
    "instance": "4",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Energy Ball",
    "move4": "Focus Blast",
    "speed": 172
  },
  {
    "entry": 404,
    "name": "ALTARIA 1",
    "species": "Altaria",
    "instance": "1",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Dragon Claw",
    "move2": "Aerial Ace",
    "move3": "Dragon Dance",
    "move4": "Rest",
    "speed": 100
  },
  {
    "entry": 540,
    "name": "ALTARIA 2",
    "species": "Altaria",
    "instance": "2",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Dragon Pulse",
    "move2": "Ominous Wind",
    "move3": "Sing",
    "move4": "Perish Song",
    "speed": 100
  },
  {
    "entry": 676,
    "name": "ALTARIA 3",
    "species": "Altaria",
    "instance": "3",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Dragon Rush",
    "move2": "Sky Attack",
    "move3": "Earthquake",
    "move4": "Dragon Dance",
    "speed": 100
  },
  {
    "entry": 812,
    "name": "ALTARIA 4",
    "species": "Altaria",
    "instance": "4",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Draco Meteor",
    "move2": "Air Cutter",
    "move3": "Flamethrower",
    "move4": "Ice Beam",
    "speed": 132
  },
  {
    "entry": 393,
    "name": "AMBIPOM 1",
    "species": "Ambipom",
    "instance": "1",
    "nature": "Jolly",
    "item": "Muscle Band",
    "move1": "Double Hit",
    "move2": "Shadow Claw",
    "move3": "Brick Break",
    "move4": "Knock Off",
    "speed": 183
  },
  {
    "entry": 529,
    "name": "AMBIPOM 2",
    "species": "Ambipom",
    "instance": "2",
    "nature": "Jolly",
    "item": "Metronome",
    "move1": "Last Resort",
    "move2": "Thunder Wave",
    "move3": "Protect",
    "move4": "Fake Out",
    "speed": 183
  },
  {
    "entry": 665,
    "name": "AMBIPOM 3",
    "species": "Ambipom",
    "instance": "3",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Double Hit",
    "move2": "Gunk Shot",
    "move3": "Seed Bomb",
    "move4": "Aerial Ace",
    "speed": 167
  },
  {
    "entry": 801,
    "name": "AMBIPOM 4",
    "species": "Ambipom",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Double Hit",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 167
  },
  {
    "entry": 420,
    "name": "AMPHAROS 1",
    "species": "Ampharos",
    "instance": "1",
    "nature": "Modest",
    "item": "Shuca Berry",
    "move1": "Thunderbolt",
    "move2": "Power Gem",
    "move3": "Light Screen",
    "move4": "Thunder Wave",
    "speed": 75
  },
  {
    "entry": 556,
    "name": "AMPHAROS 2",
    "species": "Ampharos",
    "instance": "2",
    "nature": "Careful",
    "item": "Cheri Berry",
    "move1": "ThunderPunch",
    "move2": "Fire Punch",
    "move3": "Focus Punch",
    "move4": "Thunder Wave",
    "speed": 75
  },
  {
    "entry": 692,
    "name": "AMPHAROS 3",
    "species": "Ampharos",
    "instance": "3",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Charge Beam",
    "move2": "Hyper Beam",
    "move3": "Thunder Wave",
    "move4": "Rest",
    "speed": 75
  },
  {
    "entry": 828,
    "name": "AMPHAROS 4",
    "species": "Ampharos",
    "instance": "4",
    "nature": "Quiet",
    "item": "Zoom Lens",
    "move1": "Thunder",
    "move2": "Focus Blast",
    "move3": "Signal Beam",
    "move4": "Power Gem",
    "speed": 67
  },
  {
    "entry": 480,
    "name": "ARCANINE 1",
    "species": "Arcanine",
    "instance": "1",
    "nature": "Jolly",
    "item": "Lum Berry",
    "move1": "Fire Fang",
    "move2": "ExtremeSpeed",
    "move3": "Crunch",
    "move4": "Will-O-Wisp",
    "speed": 161
  },
  {
    "entry": 616,
    "name": "ARCANINE 2",
    "species": "Arcanine",
    "instance": "2",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Flare Blitz",
    "move2": "Thunder Fang",
    "move3": "Reversal",
    "move4": "Endure",
    "speed": 161
  },
  {
    "entry": 752,
    "name": "ARCANINE 3",
    "species": "Arcanine",
    "instance": "3",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "SolarBeam",
    "move3": "Dragon Pulse",
    "move4": "Sunny Day",
    "speed": 147
  },
  {
    "entry": 888,
    "name": "ARCANINE 4",
    "species": "Arcanine",
    "instance": "4",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Flare Blitz",
    "move2": "ExtremeSpeed",
    "move3": "Crunch",
    "move4": "Thunder Fang",
    "speed": 147
  },
  {
    "entry": 410,
    "name": "ARMALDO 1",
    "species": "Armaldo",
    "instance": "1",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "X-Scissor",
    "move2": "Rock Slide",
    "move3": "Earthquake",
    "move4": "Iron Defense",
    "speed": 65
  },
  {
    "entry": 546,
    "name": "ARMALDO 2",
    "species": "Armaldo",
    "instance": "2",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Crush Claw",
    "move2": "Aqua Tail",
    "move3": "Aerial Ace",
    "move4": "Swagger",
    "speed": 65
  },
  {
    "entry": 682,
    "name": "ARMALDO 3",
    "species": "Armaldo",
    "instance": "3",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Stone Edge",
    "move2": "Superpower",
    "move3": "Earthquake",
    "move4": "Giga Impact",
    "speed": 65
  },
  {
    "entry": 818,
    "name": "ARMALDO 4",
    "species": "Armaldo",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Stone Edge",
    "move2": "X-Scissor",
    "move3": "Earthquake",
    "move4": "Cross Poison",
    "speed": 65
  },
  {
    "entry": 895,
    "name": "ARTICUNO 1",
    "species": "Articuno",
    "instance": "1",
    "nature": "Quirky",
    "item": "Icy Rock",
    "move1": "Blizzard",
    "move2": "Fly",
    "move3": "Roost",
    "move4": "Hail",
    "speed": 105
  },
  {
    "entry": 909,
    "name": "ARTICUNO 2",
    "species": "Articuno",
    "instance": "2",
    "nature": "Brave",
    "item": "Wacan Berry",
    "move1": "Avalanche",
    "move2": "Aerial Ace",
    "move3": "Facade",
    "move4": "Reflect",
    "speed": 94
  },
  {
    "entry": 923,
    "name": "ARTICUNO 3",
    "species": "Articuno",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Ice Beam",
    "move2": "Signal Beam",
    "move3": "Ominous Wind",
    "move4": "Water Pulse",
    "speed": 105
  },
  {
    "entry": 937,
    "name": "ARTICUNO 4",
    "species": "Articuno",
    "instance": "4",
    "nature": "Modest",
    "item": "Charti Berry",
    "move1": "Ice Beam",
    "move2": "Air Cutter",
    "move3": "AncientPower",
    "move4": "Sheer Cold",
    "speed": 105
  },
  {
    "entry": 411,
    "name": "BASTIODON 1",
    "species": "Bastiodon",
    "instance": "1",
    "nature": "Impish",
    "item": "Focus Band",
    "move1": "Iron Head",
    "move2": "Stone Edge",
    "move3": "Swagger",
    "move4": "Taunt",
    "speed": 50
  },
  {
    "entry": 547,
    "name": "BASTIODON 2",
    "species": "Bastiodon",
    "instance": "2",
    "nature": "Modest",
    "item": "Persim Berry",
    "move1": "AncientPower",
    "move2": "Flamethrower",
    "move3": "Thunderbolt",
    "move4": "Ice Beam",
    "speed": 50
  },
  {
    "entry": 683,
    "name": "BASTIODON 3",
    "species": "Bastiodon",
    "instance": "3",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Iron Head",
    "move2": "Fissure",
    "move3": "Double Team",
    "move4": "Iron Defense",
    "speed": 50
  },
  {
    "entry": 819,
    "name": "BASTIODON 4",
    "species": "Bastiodon",
    "instance": "4",
    "nature": "Adamant",
    "item": "Focus Sash",
    "move1": "Metal Burst",
    "move2": "Stone Edge",
    "move3": "Avalanche",
    "move4": "Curse",
    "speed": 50
  },
  {
    "entry": 353,
    "name": "BLASTOISE 1",
    "species": "Blastoise",
    "instance": "1",
    "nature": "Modest",
    "item": "Mystic Water",
    "move1": "Hydro Pump",
    "move2": "Signal Beam",
    "move3": "Icy Wind",
    "move4": "Mirror Coat",
    "speed": 98
  },
  {
    "entry": 489,
    "name": "BLASTOISE 2",
    "species": "Blastoise",
    "instance": "2",
    "nature": "Adamant",
    "item": "Shell Bell",
    "move1": "Waterfall",
    "move2": "Focus Punch",
    "move3": "Double Team",
    "move4": "Aqua Ring",
    "speed": 98
  },
  {
    "entry": 625,
    "name": "BLASTOISE 3",
    "species": "Blastoise",
    "instance": "3",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Aqua Tail",
    "move2": "Earthquake",
    "move3": "Avalanche",
    "move4": "Zen Headbutt",
    "speed": 98
  },
  {
    "entry": 761,
    "name": "BLASTOISE 4",
    "species": "Blastoise",
    "instance": "4",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Hydro Cannon",
    "move2": "Ice Beam",
    "move3": "Hyper Beam",
    "move4": "Focus Blast",
    "speed": 98
  },
  {
    "entry": 358,
    "name": "BLAZIKEN 1",
    "species": "Blaziken",
    "instance": "1",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Blaze Kick",
    "move2": "Reversal",
    "move3": "Aerial Ace",
    "move4": "Endure",
    "speed": 132
  },
  {
    "entry": 494,
    "name": "BLAZIKEN 2",
    "species": "Blaziken",
    "instance": "2",
    "nature": "Timid",
    "item": "BrightPowder",
    "move1": "Blast Burn",
    "move2": "Focus Blast",
    "move3": "SolarBeam",
    "move4": "Sunny Day",
    "speed": 145
  },
  {
    "entry": 630,
    "name": "BLAZIKEN 3",
    "species": "Blaziken",
    "instance": "3",
    "nature": "Adamant",
    "item": "Passho Berry",
    "move1": "Blaze Kick",
    "move2": "Earthquake",
    "move3": "Shadow Claw",
    "move4": "Stone Edge",
    "speed": 132
  },
  {
    "entry": 766,
    "name": "BLAZIKEN 4",
    "species": "Blaziken",
    "instance": "4",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Flare Blitz",
    "move2": "Superpower",
    "move3": "ThunderPunch",
    "move4": "Night Slash",
    "speed": 132
  },
  {
    "entry": 475,
    "name": "BLISSEY 1",
    "species": "Blissey",
    "instance": "1",
    "nature": "Modest",
    "item": "Chople Berry",
    "move1": "Hyper Beam",
    "move2": "Shadow Ball",
    "move3": "Water Pulse",
    "move4": "Sing",
    "speed": 75
  },
  {
    "entry": 611,
    "name": "BLISSEY 2",
    "species": "Blissey",
    "instance": "2",
    "nature": "Calm",
    "item": "Chesto Berry",
    "move1": "Toxic",
    "move2": "Double Team",
    "move3": "Softboiled",
    "move4": "Counter",
    "speed": 75
  },
  {
    "entry": 747,
    "name": "BLISSEY 3",
    "species": "Blissey",
    "instance": "3",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Flamethrower",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Calm Mind",
    "speed": 75
  },
  {
    "entry": 883,
    "name": "BLISSEY 4",
    "species": "Blissey",
    "instance": "4",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Dream Eater",
    "move2": "Sing",
    "move3": "Softboiled",
    "move4": "Counter",
    "speed": 75
  },
  {
    "entry": 371,
    "name": "BRELOOM 1",
    "species": "Breloom",
    "instance": "1",
    "nature": "Impish",
    "item": "Focus Sash",
    "move1": "Seed Bomb",
    "move2": "Sky Uppercut",
    "move3": "Rock Slide",
    "move4": "Counter",
    "speed": 90
  },
  {
    "entry": 507,
    "name": "BRELOOM 2",
    "species": "Breloom",
    "instance": "2",
    "nature": "Brave",
    "item": "Big Root",
    "move1": "Drain Punch",
    "move2": "Giga Drain",
    "move3": "Synthesis",
    "move4": "Leech Seed",
    "speed": 81
  },
  {
    "entry": 643,
    "name": "BRELOOM 3",
    "species": "Breloom",
    "instance": "3",
    "nature": "Adamant",
    "item": "Toxic Orb",
    "move1": "DynamicPunch",
    "move2": "ThunderPunch",
    "move3": "Stone Edge",
    "move4": "Facade",
    "speed": 90
  },
  {
    "entry": 779,
    "name": "BRELOOM 4",
    "species": "Breloom",
    "instance": "4",
    "nature": "Adamant",
    "item": "Shell Bell",
    "move1": "Focus Punch",
    "move2": "Seed Bomb",
    "move3": "Giga Impact",
    "move4": "Spore",
    "speed": 90
  },
  {
    "entry": 431,
    "name": "BRONZONG 1",
    "species": "Bronzong",
    "instance": "1",
    "nature": "Impish",
    "item": "King's Rock",
    "move1": "Extrasensory",
    "move2": "Iron Head",
    "move3": "Rock Slide",
    "move4": "Trick Room",
    "speed": 53
  },
  {
    "entry": 567,
    "name": "BRONZONG 2",
    "species": "Bronzong",
    "instance": "2",
    "nature": "Calm",
    "item": "Lum Berry",
    "move1": "Dream Eater",
    "move2": "Hypnosis",
    "move3": "Signal Beam",
    "move4": "Trick Room",
    "speed": 53
  },
  {
    "entry": 703,
    "name": "BRONZONG 3",
    "species": "Bronzong",
    "instance": "3",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Charge Beam",
    "move4": "Signal Beam",
    "speed": 53
  },
  {
    "entry": 839,
    "name": "BRONZONG 4",
    "species": "Bronzong",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Zen Headbutt",
    "move2": "Iron Head",
    "move3": "Earthquake",
    "move4": "Explosion",
    "speed": 53
  },
  {
    "entry": 339,
    "name": "CACTURNE 2",
    "species": "Cacturne",
    "instance": "2",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Giga Drain",
    "move2": "Dark Pulse",
    "move3": "Acid",
    "move4": "Cotton Spore",
    "speed": 75
  },
  {
    "entry": 352,
    "name": "CHARIZARD 1",
    "species": "Charizard",
    "instance": "1",
    "nature": "Modest",
    "item": "Petaya Berry",
    "move1": "Flamethrower",
    "move2": "Air Slash",
    "move3": "SmokeScreen",
    "move4": "Scary Face",
    "speed": 152
  },
  {
    "entry": 488,
    "name": "CHARIZARD 2",
    "species": "Charizard",
    "instance": "2",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "SolarBeam",
    "move3": "Will-O-Wisp",
    "move4": "Sunny Day",
    "speed": 152
  },
  {
    "entry": 624,
    "name": "CHARIZARD 3",
    "species": "Charizard",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Flare Blitz",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Dragon Claw",
    "speed": 152
  },
  {
    "entry": 760,
    "name": "CHARIZARD 4",
    "species": "Charizard",
    "instance": "4",
    "nature": "Timid",
    "item": "BrightPowder",
    "move1": "Blast Burn",
    "move2": "Air Slash",
    "move3": "Focus Blast",
    "move4": "AncientPower",
    "speed": 167
  },
  {
    "entry": 429,
    "name": "CLAYDOL 1",
    "species": "Claydol",
    "instance": "1",
    "nature": "Brave",
    "item": "Kasib Berry",
    "move1": "Earthquake",
    "move2": "Zen Headbutt",
    "move3": "Grass Knot",
    "move4": "Trick Room",
    "speed": 85
  },
  {
    "entry": 565,
    "name": "CLAYDOL 2",
    "species": "Claydol",
    "instance": "2",
    "nature": "Modest",
    "item": "Rindo Berry",
    "move1": "Earth Power",
    "move2": "AncientPower",
    "move3": "Signal Beam",
    "move4": "Shadow Ball",
    "speed": 95
  },
  {
    "entry": 701,
    "name": "CLAYDOL 3",
    "species": "Claydol",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Earth Power",
    "move2": "Psychic",
    "move3": "Charge Beam",
    "move4": "Ice Beam",
    "speed": 95
  },
  {
    "entry": 837,
    "name": "CLAYDOL 4",
    "species": "Claydol",
    "instance": "4",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Earthquake",
    "move2": "Zen Headbutt",
    "move3": "Rock Slide",
    "move4": "Explosion",
    "speed": 95
  },
  {
    "entry": 409,
    "name": "CRADILY 1",
    "species": "Cradily",
    "instance": "1",
    "nature": "Impish",
    "item": "Razor Claw",
    "move1": "AncientPower",
    "move2": "Energy Ball",
    "move3": "Confuse Ray",
    "move4": "Sandstorm",
    "speed": 63
  },
  {
    "entry": 545,
    "name": "CRADILY 2",
    "species": "Cradily",
    "instance": "2",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Stockpile",
    "move3": "Double Team",
    "move4": "Ingrain",
    "speed": 63
  },
  {
    "entry": 681,
    "name": "CRADILY 3",
    "species": "Cradily",
    "instance": "3",
    "nature": "Calm",
    "item": "Big Root",
    "move1": "Giga Drain",
    "move2": "Sludge Bomb",
    "move3": "Recover",
    "move4": "Ingrain",
    "speed": 63
  },
  {
    "entry": 817,
    "name": "CRADILY 4",
    "species": "Cradily",
    "instance": "4",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Stone Edge",
    "move2": "Seed Bomb",
    "move3": "Earthquake",
    "move4": "Mirror Coat",
    "speed": 63
  },
  {
    "entry": 332,
    "name": "CRAWDAUNT 2",
    "species": "Crawdaunt",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Crabhammer",
    "move2": "Crunch",
    "move3": "X-Scissor",
    "move4": "Swords Dance",
    "speed": 75
  },
  {
    "entry": 907,
    "name": "CRESSELIA 1",
    "species": "Cresselia",
    "instance": "1",
    "nature": "Bold",
    "item": "Heat Rock",
    "move1": "Psychic",
    "move2": "SolarBeam",
    "move3": "Moonlight",
    "move4": "Sunny Day",
    "speed": 105
  },
  {
    "entry": 921,
    "name": "CRESSELIA 2",
    "species": "Cresselia",
    "instance": "2",
    "nature": "Bold",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Toxic",
    "move3": "Double Team",
    "move4": "Moonlight",
    "speed": 105
  },
  {
    "entry": 935,
    "name": "CRESSELIA 3",
    "species": "Cresselia",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Energy Ball",
    "move4": "Charge Beam",
    "speed": 105
  },
  {
    "entry": 949,
    "name": "CRESSELIA 4",
    "species": "Cresselia",
    "instance": "4",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Psychic",
    "move2": "Ice Beam",
    "move3": "Signal Beam",
    "move4": "Moonlight",
    "speed": 105
  },
  {
    "entry": 467,
    "name": "CROBAT 1",
    "species": "Crobat",
    "instance": "1",
    "nature": "Jolly",
    "item": "Payapa Berry",
    "move1": "Cross Poison",
    "move2": "Aerial Ace",
    "move3": "Roost",
    "move4": "Hypnosis",
    "speed": 200
  },
  {
    "entry": 603,
    "name": "CROBAT 2",
    "species": "Crobat",
    "instance": "2",
    "nature": "Docile",
    "item": "Razor Fang",
    "move1": "Air Slash",
    "move2": "Zen Headbutt",
    "move3": "Bite",
    "move4": "Twister",
    "speed": 182
  },
  {
    "entry": 739,
    "name": "CROBAT 3",
    "species": "Crobat",
    "instance": "3",
    "nature": "Modest",
    "item": "King's Rock",
    "move1": "Air Slash",
    "move2": "Sludge Bomb",
    "move3": "Heat Wave",
    "move4": "Dark Pulse",
    "speed": 182
  },
  {
    "entry": 875,
    "name": "CROBAT 4",
    "species": "Crobat",
    "instance": "4",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Cross Poison",
    "move2": "Brave Bird",
    "move3": "X-Scissor",
    "move4": "Zen Headbutt",
    "speed": 182
  },
  {
    "entry": 379,
    "name": "DEWGONG 1",
    "species": "Dewgong",
    "instance": "1",
    "nature": "Careful",
    "item": "Razor Fang",
    "move1": "Waterfall",
    "move2": "Avalanche",
    "move3": "Headbutt",
    "move4": "Fake Out",
    "speed": 90
  },
  {
    "entry": 515,
    "name": "DEWGONG 2",
    "species": "Dewgong",
    "instance": "2",
    "nature": "Calm",
    "item": "Wacan Berry",
    "move1": "Ice Beam",
    "move2": "Signal Beam",
    "move3": "Encore",
    "move4": "Disable",
    "speed": 90
  },
  {
    "entry": 651,
    "name": "DEWGONG 3",
    "species": "Dewgong",
    "instance": "3",
    "nature": "Calm",
    "item": "Salac Berry",
    "move1": "Sheer Cold",
    "move2": "Horn Drill",
    "move3": "Rest",
    "move4": "Sleep Talk",
    "speed": 90
  },
  {
    "entry": 787,
    "name": "DEWGONG 4",
    "species": "Dewgong",
    "instance": "4",
    "nature": "Calm",
    "item": "Chesto Berry",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Signal Beam",
    "move4": "Rest",
    "speed": 90
  },
  {
    "entry": 427,
    "name": "DONPHAN 1",
    "species": "Donphan",
    "instance": "1",
    "nature": "Impish",
    "item": "Razor Claw",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Poison Jab",
    "move4": "Sandstorm",
    "speed": 70
  },
  {
    "entry": 563,
    "name": "DONPHAN 2",
    "species": "Donphan",
    "instance": "2",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Earthquake",
    "move2": "Superpower",
    "move3": "Gunk Shot",
    "move4": "Counter",
    "speed": 70
  },
  {
    "entry": 699,
    "name": "DONPHAN 3",
    "species": "Donphan",
    "instance": "3",
    "nature": "Brave",
    "item": "Lax Incense",
    "move1": "Earthquake",
    "move2": "Gyro Ball",
    "move3": "Fire Fang",
    "move4": "Thunder Fang",
    "speed": 63
  },
  {
    "entry": 835,
    "name": "DONPHAN 4",
    "species": "Donphan",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Stone Edge",
    "move3": "Seed Bomb",
    "move4": "Fissure",
    "speed": 70
  },
  {
    "entry": 481,
    "name": "DRAGONITE 1",
    "species": "Dragonite",
    "instance": "1",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Dragon Claw",
    "move2": "Aerial Ace",
    "move3": "Thunder Wave",
    "move4": "Dragon Dance",
    "speed": 100
  },
  {
    "entry": 617,
    "name": "DRAGONITE 2",
    "species": "Dragonite",
    "instance": "2",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Dragon Rush",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 100
  },
  {
    "entry": 753,
    "name": "DRAGONITE 3",
    "species": "Dragonite",
    "instance": "3",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Draco Meteor",
    "move2": "Flamethrower",
    "move3": "Thunderbolt",
    "move4": "Surf",
    "speed": 100
  },
  {
    "entry": 889,
    "name": "DRAGONITE 4",
    "species": "Dragonite",
    "instance": "4",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Outrage",
    "move2": "Giga Impact",
    "move3": "Earthquake",
    "move4": "Superpower",
    "speed": 100
  },
  {
    "entry": 432,
    "name": "DRAPION 1",
    "species": "Drapion",
    "instance": "1",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Poison Jab",
    "move2": "Crunch",
    "move3": "Aqua Tail",
    "move4": "Acupressure",
    "speed": 115
  },
  {
    "entry": 568,
    "name": "DRAPION 2",
    "species": "Drapion",
    "instance": "2",
    "nature": "Adamant",
    "item": "Iron Ball",
    "move1": "Payback",
    "move2": "Poison Jab",
    "move3": "Fling",
    "move4": "Knock Off",
    "speed": 115
  },
  {
    "entry": 704,
    "name": "DRAPION 3",
    "species": "Drapion",
    "instance": "3",
    "nature": "Jolly",
    "item": "Scope Lens",
    "move1": "Cross Poison",
    "move2": "Fire Fang",
    "move3": "Thunder Fang",
    "move4": "Ice Fang",
    "speed": 161
  },
  {
    "entry": 840,
    "name": "DRAPION 4",
    "species": "Drapion",
    "instance": "4",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Cross Poison",
    "move2": "Night Slash",
    "move3": "Earthquake",
    "move4": "Aerial Ace",
    "speed": 147
  },
  {
    "entry": 414,
    "name": "DRIFBLIM 1",
    "species": "Drifblim",
    "instance": "1",
    "nature": "Modest",
    "item": "Salac Berry",
    "move1": "Ominous Wind",
    "move2": "Air Cutter",
    "move3": "Baton Pass",
    "move4": "Endure",
    "speed": 100
  },
  {
    "entry": 550,
    "name": "DRIFBLIM 2",
    "species": "Drifblim",
    "instance": "2",
    "nature": "Adamant",
    "item": "Black Sludge",
    "move1": "Payback",
    "move2": "Facade",
    "move3": "Will-O-Wisp",
    "move4": "Trick",
    "speed": 100
  },
  {
    "entry": 686,
    "name": "DRIFBLIM 3",
    "species": "Drifblim",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Icy Wind",
    "move4": "Destiny Bond",
    "speed": 100
  },
  {
    "entry": 822,
    "name": "DRIFBLIM 4",
    "species": "Drifblim",
    "instance": "4",
    "nature": "Quirky",
    "item": "Lax Incense",
    "move1": "Shadow Ball",
    "move2": "Air Cutter",
    "move3": "Silver Wind",
    "move4": "Explosion",
    "speed": 100
  },
  {
    "entry": 363,
    "name": "DUGTRIO 1",
    "species": "Dugtrio",
    "instance": "1",
    "nature": "Jolly",
    "item": "Grip Claw",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Astonish",
    "move4": "Sand Tomb",
    "speed": 189
  },
  {
    "entry": 499,
    "name": "DUGTRIO 2",
    "species": "Dugtrio",
    "instance": "2",
    "nature": "Modest",
    "item": "Lax Incense",
    "move1": "Earth Power",
    "move2": "Sludge Bomb",
    "move3": "Tri Attack",
    "move4": "Sandstorm",
    "speed": 172
  },
  {
    "entry": 635,
    "name": "DUGTRIO 3",
    "species": "Dugtrio",
    "instance": "3",
    "nature": "Jolly",
    "item": "Razor Claw",
    "move1": "Fissure",
    "move2": "Giga Impact",
    "move3": "Aerial Ace",
    "move4": "Night Slash",
    "speed": 189
  },
  {
    "entry": 771,
    "name": "DUGTRIO 4",
    "species": "Dugtrio",
    "instance": "4",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Earthquake",
    "move2": "Stone Edge",
    "move3": "Slash",
    "move4": "Shadow Claw",
    "speed": 172
  },
  {
    "entry": 462,
    "name": "DUSKNOIR 1",
    "species": "Dusknoir",
    "instance": "1",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Shadow Punch",
    "move2": "Fling",
    "move3": "Will-O-Wisp",
    "move4": "Trick Room",
    "speed": 58
  },
  {
    "entry": 598,
    "name": "DUSKNOIR 2",
    "species": "Dusknoir",
    "instance": "2",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Curse",
    "move2": "Pain Split",
    "move3": "Confuse Ray",
    "move4": "Attract",
    "speed": 65
  },
  {
    "entry": 734,
    "name": "DUSKNOIR 3",
    "species": "Dusknoir",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Shadow Punch",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 65
  },
  {
    "entry": 870,
    "name": "DUSKNOIR 4",
    "species": "Dusknoir",
    "instance": "4",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Shadow Punch",
    "move2": "Earthquake",
    "move3": "Brick Break",
    "move4": "Rock Slide",
    "speed": 65
  },
  {
    "entry": 477,
    "name": "ELECTIVIRE 1",
    "species": "Electivire",
    "instance": "1",
    "nature": "Jolly",
    "item": "Scope Lens",
    "move1": "ThunderPunch",
    "move2": "Cross Chop",
    "move3": "Thunder Wave",
    "move4": "Screech",
    "speed": 161
  },
  {
    "entry": 613,
    "name": "ELECTIVIRE 2",
    "species": "Electivire",
    "instance": "2",
    "nature": "Hardy",
    "item": "Wide Lens",
    "move1": "Thunder",
    "move2": "DynamicPunch",
    "move3": "Rock Slide",
    "move4": "Iron Tail",
    "speed": 115
  },
  {
    "entry": 749,
    "name": "ELECTIVIRE 3",
    "species": "Electivire",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Thunderbolt",
    "move2": "Psychic",
    "move3": "Focus Blast",
    "move4": "Signal Beam",
    "speed": 147
  },
  {
    "entry": 885,
    "name": "ELECTIVIRE 4",
    "species": "Electivire",
    "instance": "4",
    "nature": "Adamant",
    "item": "Shuca Berry",
    "move1": "ThunderPunch",
    "move2": "Fire Punch",
    "move3": "Ice Punch",
    "move4": "Earthquake",
    "speed": 147
  },
  {
    "entry": 386,
    "name": "ELECTRODE 1",
    "species": "Electrode",
    "instance": "1",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Thunderbolt",
    "move2": "Swift",
    "move3": "Thunder Wave",
    "move4": "Light Screen",
    "speed": 192
  },
  {
    "entry": 522,
    "name": "ELECTRODE 2",
    "species": "Electrode",
    "instance": "2",
    "nature": "Timid",
    "item": "BrightPowder",
    "move1": "Charge Beam",
    "move2": "Thunder Wave",
    "move3": "Flash",
    "move4": "Swagger",
    "speed": 211
  },
  {
    "entry": 658,
    "name": "ELECTRODE 3",
    "species": "Electrode",
    "instance": "3",
    "nature": "Timid",
    "item": "Damp Rock",
    "move1": "Thunder",
    "move2": "Hyper Beam",
    "move3": "Magnet Rise",
    "move4": "Rain Dance",
    "speed": 211
  },
  {
    "entry": 794,
    "name": "ELECTRODE 4",
    "species": "Electrode",
    "instance": "4",
    "nature": "Hardy",
    "item": "Focus Sash",
    "move1": "Thunderbolt",
    "move2": "Signal Beam",
    "move3": "Explosion",
    "move4": "Mirror Coat",
    "speed": 192
  },
  {
    "entry": 362,
    "name": "EMPOLEON 1",
    "species": "Empoleon",
    "instance": "1",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Waterfall",
    "move2": "Metal Claw",
    "move3": "Brick Break",
    "move4": "Knock Off",
    "speed": 80
  },
  {
    "entry": 498,
    "name": "EMPOLEON 2",
    "species": "Empoleon",
    "instance": "2",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Drill Peck",
    "move2": "Aqua Jet",
    "move3": "Shadow Claw",
    "move4": "Rock Slide",
    "speed": 80
  },
  {
    "entry": 634,
    "name": "EMPOLEON 3",
    "species": "Empoleon",
    "instance": "3",
    "nature": "Brave",
    "item": "Quick Claw",
    "move1": "Surf",
    "move2": "Earthquake",
    "move3": "Blizzard",
    "move4": "Signal Beam",
    "speed": 72
  },
  {
    "entry": 770,
    "name": "EMPOLEON 4",
    "species": "Empoleon",
    "instance": "4",
    "nature": "Brave",
    "item": "Quick Claw",
    "move1": "Hydro Cannon",
    "move2": "Flash Cannon",
    "move3": "Drill Peck",
    "move4": "Earthquake",
    "speed": 72
  },
  {
    "entry": 899,
    "name": "ENTEI 1",
    "species": "Entei",
    "instance": "1",
    "nature": "Jolly",
    "item": "Shuca Berry",
    "move1": "Fire Fang",
    "move2": "Return",
    "move3": "Roar",
    "move4": "Reflect",
    "speed": 167
  },
  {
    "entry": 913,
    "name": "ENTEI 2",
    "species": "Entei",
    "instance": "2",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Fire Fang",
    "move2": "Bite",
    "move3": "Iron Head",
    "move4": "Stone Edge",
    "speed": 167
  },
  {
    "entry": 927,
    "name": "ENTEI 3",
    "species": "Entei",
    "instance": "3",
    "nature": "Modest",
    "item": "Shuca Berry",
    "move1": "Fire Blast",
    "move2": "SolarBeam",
    "move3": "Hyper Beam",
    "move4": "Sunny Day",
    "speed": 152
  },
  {
    "entry": 941,
    "name": "ENTEI 4",
    "species": "Entei",
    "instance": "4",
    "nature": "Modest",
    "item": "Shuca Berry",
    "move1": "Overheat",
    "move2": "Extrasensory",
    "move3": "Shadow Ball",
    "move4": "Calm Mind",
    "speed": 152
  },
  {
    "entry": 455,
    "name": "ESPEON 1",
    "species": "Espeon",
    "instance": "1",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Reflect",
    "move3": "Calm Mind",
    "move4": "Baton Pass",
    "speed": 178
  },
  {
    "entry": 591,
    "name": "ESPEON 2",
    "species": "Espeon",
    "instance": "2",
    "nature": "Timid",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Swift",
    "move3": "Charm",
    "move4": "Attract",
    "speed": 178
  },
  {
    "entry": 727,
    "name": "ESPEON 3",
    "species": "Espeon",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Hyper Beam",
    "move4": "Grass Knot",
    "speed": 162
  },
  {
    "entry": 863,
    "name": "ESPEON 4",
    "species": "Espeon",
    "instance": "4",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Signal Beam",
    "move4": "Morning Sun",
    "speed": 162
  },
  {
    "entry": 449,
    "name": "EXEGGUTOR 1",
    "species": "Exeggutor",
    "instance": "1",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "SolarBeam",
    "move2": "Psychic",
    "move3": "Synthesis",
    "move4": "Sunny Day",
    "speed": 75
  },
  {
    "entry": 585,
    "name": "EXEGGUTOR 2",
    "species": "Exeggutor",
    "instance": "2",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Dream Eater",
    "move2": "Hypnosis",
    "move3": "Leech Seed",
    "move4": "Ingrain",
    "speed": 75
  },
  {
    "entry": 721,
    "name": "EXEGGUTOR 3",
    "species": "Exeggutor",
    "instance": "3",
    "nature": "Brave",
    "item": "Focus Sash",
    "move1": "Wood Hammer",
    "move2": "Zen Headbutt",
    "move3": "Trick Room",
    "move4": "Explosion",
    "speed": 67
  },
  {
    "entry": 857,
    "name": "EXEGGUTOR 4",
    "species": "Exeggutor",
    "instance": "4",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Leaf Storm",
    "move2": "Psychic",
    "move3": "Sludge Bomb",
    "move4": "AncientPower",
    "speed": 75
  },
  {
    "entry": 389,
    "name": "EXPLOUD 1",
    "species": "Exploud",
    "instance": "1",
    "nature": "Modest",
    "item": "Chople Berry",
    "move1": "Hyper Voice",
    "move2": "Extrasensory",
    "move3": "Water Pulse",
    "move4": "Torment",
    "speed": 88
  },
  {
    "entry": 525,
    "name": "EXPLOUD 2",
    "species": "Exploud",
    "instance": "2",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Facade",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 88
  },
  {
    "entry": 661,
    "name": "EXPLOUD 3",
    "species": "Exploud",
    "instance": "3",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Facade",
    "move2": "Earthquake",
    "move3": "Avalanche",
    "move4": "Crunch",
    "speed": 88
  },
  {
    "entry": 797,
    "name": "EXPLOUD 4",
    "species": "Exploud",
    "instance": "4",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Hyper Voice",
    "move2": "Overheat",
    "move3": "Surf",
    "move4": "Ice Beam",
    "speed": 88
  },
  {
    "entry": 356,
    "name": "FERALIGATR 1",
    "species": "Feraligatr",
    "instance": "1",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "Waterfall",
    "move2": "Ice Fang",
    "move3": "Rock Slide",
    "move4": "Scary Face",
    "speed": 98
  },
  {
    "entry": 492,
    "name": "FERALIGATR 2",
    "species": "Feraligatr",
    "instance": "2",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Aqua Tail",
    "move2": "Superpower",
    "move3": "Dragon Claw",
    "move4": "Shadow Claw",
    "speed": 98
  },
  {
    "entry": 628,
    "name": "FERALIGATR 3",
    "species": "Feraligatr",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Hydro Cannon",
    "move2": "Ice Beam",
    "move3": "Focus Blast",
    "move4": "AncientPower",
    "speed": 98
  },
  {
    "entry": 764,
    "name": "FERALIGATR 4",
    "species": "Feraligatr",
    "instance": "4",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Waterfall",
    "move2": "Earthquake",
    "move3": "Ice Fang",
    "move4": "Dragon Dance",
    "speed": 98
  },
  {
    "entry": 454,
    "name": "FLAREON 1",
    "species": "Flareon",
    "instance": "1",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Fire Fang",
    "move2": "Superpower",
    "move3": "Curse",
    "move4": "Baton Pass",
    "speed": 85
  },
  {
    "entry": 590,
    "name": "FLAREON 2",
    "species": "Flareon",
    "instance": "2",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Fire Fang",
    "move2": "Flail",
    "move3": "Endure",
    "move4": "Sand-Attack",
    "speed": 128
  },
  {
    "entry": 726,
    "name": "FLAREON 3",
    "species": "Flareon",
    "instance": "3",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Shadow Ball",
    "move3": "Mud-Slap",
    "move4": "Will-O-Wisp",
    "speed": 85
  },
  {
    "entry": 862,
    "name": "FLAREON 4",
    "species": "Flareon",
    "instance": "4",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Fire Fang",
    "move2": "Giga Impact",
    "move3": "Superpower",
    "move4": "Bite",
    "speed": 85
  },
  {
    "entry": 412,
    "name": "FLOATZEL 1",
    "species": "Floatzel",
    "instance": "1",
    "nature": "Jolly",
    "item": "Sitrus Berry",
    "move1": "Waterfall",
    "move2": "Ice Punch",
    "move3": "Quick Attack",
    "move4": "Rain Dance",
    "speed": 183
  },
  {
    "entry": 548,
    "name": "FLOATZEL 2",
    "species": "Floatzel",
    "instance": "2",
    "nature": "Jolly",
    "item": "Chesto Berry",
    "move1": "Waterfall",
    "move2": "Focus Punch",
    "move3": "Double Team",
    "move4": "Attract",
    "speed": 183
  },
  {
    "entry": 684,
    "name": "FLOATZEL 3",
    "species": "Floatzel",
    "instance": "3",
    "nature": "Modest",
    "item": "Wave Incense",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Focus Blast",
    "move4": "Rain Dance",
    "speed": 167
  },
  {
    "entry": 820,
    "name": "FLOATZEL 4",
    "species": "Floatzel",
    "instance": "4",
    "nature": "Adamant",
    "item": "Razor Fang",
    "move1": "Aqua Tail",
    "move2": "Ice Fang",
    "move3": "Crunch",
    "move4": "Brick Break",
    "speed": 167
  },
  {
    "entry": 451,
    "name": "FLYGON 1",
    "species": "Flygon",
    "instance": "1",
    "nature": "Adamant",
    "item": "Yache Berry",
    "move1": "Earthquake",
    "move2": "Dragon Claw",
    "move3": "Roost",
    "move4": "Sandstorm",
    "speed": 152
  },
  {
    "entry": 587,
    "name": "FLYGON 2",
    "species": "Flygon",
    "instance": "2",
    "nature": "Jolly",
    "item": "Razor Fang",
    "move1": "Fissure",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Aerial Ace",
    "speed": 167
  },
  {
    "entry": 723,
    "name": "FLYGON 3",
    "species": "Flygon",
    "instance": "3",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Draco Meteor",
    "move2": "Earth Power",
    "move3": "Flamethrower",
    "move4": "Giga Drain",
    "speed": 167
  },
  {
    "entry": 859,
    "name": "FLYGON 4",
    "species": "Flygon",
    "instance": "4",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Earthquake",
    "move2": "Outrage",
    "move3": "Crunch",
    "move4": "Stone Edge",
    "speed": 152
  },
  {
    "entry": 372,
    "name": "FORRETRESS 1",
    "species": "Forretress",
    "instance": "1",
    "nature": "Brave",
    "item": "Occa Berry",
    "move1": "Gyro Ball",
    "move2": "Bug Bite",
    "move3": "Revenge",
    "move4": "Counter",
    "speed": 54
  },
  {
    "entry": 508,
    "name": "FORRETRESS 2",
    "species": "Forretress",
    "instance": "2",
    "nature": "Brave",
    "item": "Sitrus Berry",
    "move1": "Payback",
    "move2": "Stealth Rock",
    "move3": "Toxic Spikes",
    "move4": "Spikes",
    "speed": 54
  },
  {
    "entry": 644,
    "name": "FORRETRESS 3",
    "species": "Forretress",
    "instance": "3",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Dig",
    "move2": "Swagger",
    "move3": "Toxic",
    "move4": "Double Team",
    "speed": 60
  },
  {
    "entry": 780,
    "name": "FORRETRESS 4",
    "species": "Forretress",
    "instance": "4",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Explosion",
    "move2": "Double-Edge",
    "move3": "Earthquake",
    "move4": "Rock Slide",
    "speed": 60
  },
  {
    "entry": 392,
    "name": "FROSLASS 1",
    "species": "Froslass",
    "instance": "1",
    "nature": "Timid",
    "item": "Cheri Berry",
    "move1": "Ice Beam",
    "move2": "Ominous Wind",
    "move3": "Confuse Ray",
    "move4": "Attract",
    "speed": 178
  },
  {
    "entry": 528,
    "name": "FROSLASS 2",
    "species": "Froslass",
    "instance": "2",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Ice Punch",
    "move2": "Sucker Punch",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed": 162
  },
  {
    "entry": 664,
    "name": "FROSLASS 3",
    "species": "Froslass",
    "instance": "3",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Ice Beam",
    "move2": "Thunderbolt",
    "move3": "Signal Beam",
    "move4": "Destiny Bond",
    "speed": 162
  },
  {
    "entry": 800,
    "name": "FROSLASS 4",
    "species": "Froslass",
    "instance": "4",
    "nature": "Modest",
    "item": "Lax Incense",
    "move1": "Blizzard",
    "move2": "Shadow Ball",
    "move3": "Psychic",
    "move4": "Hail",
    "speed": 162
  },
  {
    "entry": 448,
    "name": "GALLADE 1",
    "species": "Gallade",
    "instance": "1",
    "nature": "Careful",
    "item": "Kasib Berry",
    "move1": "Zen Headbutt",
    "move2": "Brick Break",
    "move3": "Thunder Wave",
    "move4": "Confuse Ray",
    "speed": 100
  },
  {
    "entry": 584,
    "name": "GALLADE 2",
    "species": "Gallade",
    "instance": "2",
    "nature": "Jolly",
    "item": "BrightPowder",
    "move1": "Drain Punch",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 145
  },
  {
    "entry": 720,
    "name": "GALLADE 3",
    "species": "Gallade",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Psycho Cut",
    "move2": "Stone Edge",
    "move3": "Aerial Ace",
    "move4": "X-Scissor",
    "speed": 100
  },
  {
    "entry": 856,
    "name": "GALLADE 4",
    "species": "Gallade",
    "instance": "4",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Psycho Cut",
    "move2": "Close Combat",
    "move3": "Leaf Blade",
    "move4": "Night Slash",
    "speed": 100
  },
  {
    "entry": 485,
    "name": "GARCHOMP 1",
    "species": "Garchomp",
    "instance": "1",
    "nature": "Jolly",
    "item": "BrightPowder",
    "move1": "Dragon Claw",
    "move2": "Earthquake",
    "move3": "Double Team",
    "move4": "Sandstorm",
    "speed": 169
  },
  {
    "entry": 621,
    "name": "GARCHOMP 2",
    "species": "Garchomp",
    "instance": "2",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Draco Meteor",
    "move2": "Earth Power",
    "move3": "Flamethrower",
    "move4": "Surf",
    "speed": 154
  },
  {
    "entry": 757,
    "name": "GARCHOMP 3",
    "species": "Garchomp",
    "instance": "3",
    "nature": "Adamant",
    "item": "Focus Sash",
    "move1": "Dragon Rush",
    "move2": "Stone Edge",
    "move3": "Aqua Tail",
    "move4": "Aerial Ace",
    "speed": 154
  },
  {
    "entry": 893,
    "name": "GARCHOMP 4",
    "species": "Garchomp",
    "instance": "4",
    "nature": "Adamant",
    "item": "Persim Berry",
    "move1": "Outrage",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Fire Fang",
    "speed": 154
  },
  {
    "entry": 447,
    "name": "GARDEVOIR 1",
    "species": "Gardevoir",
    "instance": "1",
    "nature": "Calm",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Thunder Wave",
    "move4": "Confuse Ray",
    "speed": 100
  },
  {
    "entry": 583,
    "name": "GARDEVOIR 2",
    "species": "Gardevoir",
    "instance": "2",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Calm Mind",
    "move4": "Rest",
    "speed": 100
  },
  {
    "entry": 719,
    "name": "GARDEVOIR 3",
    "species": "Gardevoir",
    "instance": "3",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Charge Beam",
    "move3": "Energy Ball",
    "move4": "Focus Blast",
    "speed": 100
  },
  {
    "entry": 855,
    "name": "GARDEVOIR 4",
    "species": "Gardevoir",
    "instance": "4",
    "nature": "Timid",
    "item": "Wise Glasses",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Shadow Ball",
    "move4": "Destiny Bond",
    "speed": 145
  },
  {
    "entry": 382,
    "name": "GASTRODON 1",
    "species": "Gastrodon",
    "instance": "1",
    "nature": "Careful",
    "item": "Focus Sash",
    "move1": "Waterfall",
    "move2": "Earthquake",
    "move3": "Recover",
    "move4": "Mirror Coat",
    "speed": 59
  },
  {
    "entry": 518,
    "name": "GASTRODON 2",
    "species": "Gastrodon",
    "instance": "2",
    "nature": "Sassy",
    "item": "Zoom Lens",
    "move1": "Muddy Water",
    "move2": "Mud Bomb",
    "move3": "Recover",
    "move4": "Yawn",
    "speed": 53
  },
  {
    "entry": 654,
    "name": "GASTRODON 3",
    "species": "Gastrodon",
    "instance": "3",
    "nature": "Adamant",
    "item": "Shell Bell",
    "move1": "Waterfall",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Fissure",
    "speed": 59
  },
  {
    "entry": 790,
    "name": "GASTRODON 4",
    "species": "Gastrodon",
    "instance": "4",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Surf",
    "move2": "Earth Power",
    "move3": "Ice Beam",
    "move4": "Sludge Bomb",
    "speed": 59
  },
  {
    "entry": 419,
    "name": "GENGAR 1",
    "species": "Gengar",
    "instance": "1",
    "nature": "Timid",
    "item": "Payapa Berry",
    "move1": "Shadow Ball",
    "move2": "Sludge Bomb",
    "move3": "Spite",
    "move4": "Confuse Ray",
    "speed": 178
  },
  {
    "entry": 555,
    "name": "GENGAR 2",
    "species": "Gengar",
    "instance": "2",
    "nature": "Modest",
    "item": "Life Orb",
    "move1": "Shadow Ball",
    "move2": "Dream Eater",
    "move3": "Hypnosis",
    "move4": "Substitute",
    "speed": 162
  },
  {
    "entry": 691,
    "name": "GENGAR 3",
    "species": "Gengar",
    "instance": "3",
    "nature": "Modest",
    "item": "Scope Lens",
    "move1": "Psychic",
    "move2": "Energy Ball",
    "move3": "Focus Blast",
    "move4": "Confuse Ray",
    "speed": 162
  },
  {
    "entry": 827,
    "name": "GENGAR 4",
    "species": "Gengar",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Shadow Ball",
    "move2": "Sludge Bomb",
    "move3": "Thunderbolt",
    "move4": "Destiny Bond",
    "speed": 162
  },
  {
    "entry": 316,
    "name": "GIRAFARIG 2",
    "species": "Girafarig",
    "instance": "2",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Zen Headbutt",
    "move2": "Double Hit",
    "move3": "Crunch",
    "move4": "Thunder Wave",
    "speed": 137
  },
  {
    "entry": 458,
    "name": "GLACEON 1",
    "species": "Glaceon",
    "instance": "1",
    "nature": "Calm",
    "item": "Lax Incense",
    "move1": "Ice Beam",
    "move2": "Water Pulse",
    "move3": "Double Team",
    "move4": "Baton Pass",
    "speed": 85
  },
  {
    "entry": 594,
    "name": "GLACEON 2",
    "species": "Glaceon",
    "instance": "2",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Ice Beam",
    "move2": "Double Team",
    "move3": "Yawn",
    "move4": "Hail",
    "speed": 85
  },
  {
    "entry": 730,
    "name": "GLACEON 3",
    "species": "Glaceon",
    "instance": "3",
    "nature": "Modest",
    "item": "Focus Sash",
    "move1": "Blizzard",
    "move2": "Hyper Beam",
    "move3": "Hail",
    "move4": "Mirror Coat",
    "speed": 85
  },
  {
    "entry": 866,
    "name": "GLACEON 4",
    "species": "Glaceon",
    "instance": "4",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Ice Beam",
    "move2": "Shadow Ball",
    "move3": "Signal Beam",
    "move4": "Water Pulse",
    "speed": 85
  },
  {
    "entry": 390,
    "name": "GLALIE 1",
    "species": "Glalie",
    "instance": "1",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Avalanche",
    "move2": "Payback",
    "move3": "Gyro Ball",
    "move4": "Ice Shard",
    "speed": 90
  },
  {
    "entry": 526,
    "name": "GLALIE 2",
    "species": "Glalie",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Ice Fang",
    "move2": "Crunch",
    "move3": "Earthquake",
    "move4": "Explosion",
    "speed": 100
  },
  {
    "entry": 662,
    "name": "GLALIE 3",
    "species": "Glalie",
    "instance": "3",
    "nature": "Modest",
    "item": "Scope Lens",
    "move1": "Ice Beam",
    "move2": "Shadow Ball",
    "move3": "Signal Beam",
    "move4": "Water Pulse",
    "speed": 100
  },
  {
    "entry": 798,
    "name": "GLALIE 4",
    "species": "Glalie",
    "instance": "4",
    "nature": "Modest",
    "item": "Lax Incense",
    "move1": "Blizzard",
    "move2": "Dark Pulse",
    "move3": "Sheer Cold",
    "move4": "Hail",
    "speed": 100
  },
  {
    "entry": 441,
    "name": "GLISCOR 1",
    "species": "Gliscor",
    "instance": "1",
    "nature": "Adamant",
    "item": "Yache Berry",
    "move1": "Earthquake",
    "move2": "Aerial Ace",
    "move3": "Swords Dance",
    "move4": "Baton Pass",
    "speed": 115
  },
  {
    "entry": 577,
    "name": "GLISCOR 2",
    "species": "Gliscor",
    "instance": "2",
    "nature": "Jolly",
    "item": "Razor Fang",
    "move1": "Earthquake",
    "move2": "Fire Fang",
    "move3": "Thunder Fang",
    "move4": "Ice Fang",
    "speed": 161
  },
  {
    "entry": 713,
    "name": "GLISCOR 3",
    "species": "Gliscor",
    "instance": "3",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Guillotine",
    "move2": "Earthquake",
    "move3": "U-turn",
    "move4": "Counter",
    "speed": 161
  },
  {
    "entry": 849,
    "name": "GLISCOR 4",
    "species": "Gliscor",
    "instance": "4",
    "nature": "Adamant",
    "item": "Expert Belt",
    "move1": "Earthquake",
    "move2": "Aerial Ace",
    "move3": "X-Scissor",
    "move4": "Stone Edge",
    "speed": 115
  },
  {
    "entry": 415,
    "name": "GOLDUCK 1",
    "species": "Golduck",
    "instance": "1",
    "nature": "Modest",
    "item": "Rindo Berry",
    "move1": "Surf",
    "move2": "Psychic",
    "move3": "Confuse Ray",
    "move4": "Calm Mind",
    "speed": 105
  },
  {
    "entry": 551,
    "name": "GOLDUCK 2",
    "species": "Golduck",
    "instance": "2",
    "nature": "Adamant",
    "item": "Shell Bell",
    "move1": "Waterfall",
    "move2": "Mud Bomb",
    "move3": "Shadow Claw",
    "move4": "Aerial Ace",
    "speed": 137
  },
  {
    "entry": 687,
    "name": "GOLDUCK 3",
    "species": "Golduck",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Aqua Tail",
    "move2": "Cross Chop",
    "move3": "Ice Punch",
    "move4": "Zen Headbutt",
    "speed": 105
  },
  {
    "entry": 823,
    "name": "GOLDUCK 4",
    "species": "Golduck",
    "instance": "4",
    "nature": "Modest",
    "item": "Wacan Berry",
    "move1": "Hydro Pump",
    "move2": "Psychic",
    "move3": "Ice Beam",
    "move4": "Signal Beam",
    "speed": 105
  },
  {
    "entry": 395,
    "name": "GOLEM 1",
    "species": "Golem",
    "instance": "1",
    "nature": "Impish",
    "item": "Focus Band",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Sucker Punch",
    "move4": "Sandstorm",
    "speed": 65
  },
  {
    "entry": 531,
    "name": "GOLEM 2",
    "species": "Golem",
    "instance": "2",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Earthquake",
    "move2": "Superpower",
    "move3": "Fire Punch",
    "move4": "ThunderPunch",
    "speed": 65
  },
  {
    "entry": 667,
    "name": "GOLEM 3",
    "species": "Golem",
    "instance": "3",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Gyro Ball",
    "move2": "Earthquake",
    "move3": "Hammer Arm",
    "move4": "Fling",
    "speed": 58
  },
  {
    "entry": 803,
    "name": "GOLEM 4",
    "species": "Golem",
    "instance": "4",
    "nature": "Brave",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Stone Edge",
    "move3": "Gyro Ball",
    "move4": "Explosion",
    "speed": 58
  },
  {
    "entry": 367,
    "name": "GRANBULL 1",
    "species": "Granbull",
    "instance": "1",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Return",
    "move2": "Rock Slide",
    "move3": "Crunch",
    "move4": "Thunder Wave",
    "speed": 65
  },
  {
    "entry": 503,
    "name": "GRANBULL 2",
    "species": "Granbull",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Facade",
    "move2": "Fire Fang",
    "move3": "Thunder Fang",
    "move4": "Ice Fang",
    "speed": 65
  },
  {
    "entry": 639,
    "name": "GRANBULL 3",
    "species": "Granbull",
    "instance": "3",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Fire Punch",
    "move2": "ThunderPunch",
    "move3": "Ice Punch",
    "move4": "Payback",
    "speed": 65
  },
  {
    "entry": 775,
    "name": "GRANBULL 4",
    "species": "Granbull",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Giga Impact",
    "move2": "Close Combat",
    "move3": "Earthquake",
    "move4": "Stone Edge",
    "speed": 65
  },
  {
    "entry": 472,
    "name": "GYARADOS 1",
    "species": "Gyarados",
    "instance": "1",
    "nature": "Careful",
    "item": "Razor Fang",
    "move1": "Aqua Tail",
    "move2": "Ice Fang",
    "move3": "Bite",
    "move4": "Rain Dance",
    "speed": 101
  },
  {
    "entry": 608,
    "name": "GYARADOS 2",
    "species": "Gyarados",
    "instance": "2",
    "nature": "Jolly",
    "item": "Lum Berry",
    "move1": "Waterfall",
    "move2": "Ice Fang",
    "move3": "Iron Head",
    "move4": "Dragon Dance",
    "speed": 146
  },
  {
    "entry": 744,
    "name": "GYARADOS 3",
    "species": "Gyarados",
    "instance": "3",
    "nature": "Adamant",
    "item": "Persim Berry",
    "move1": "Outrage",
    "move2": "Waterfall",
    "move3": "Stone Edge",
    "move4": "Giga Impact",
    "speed": 101
  },
  {
    "entry": 880,
    "name": "GYARADOS 4",
    "species": "Gyarados",
    "instance": "4",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Waterfall",
    "move2": "Earthquake",
    "move3": "Rest",
    "move4": "Dragon Dance",
    "speed": 133
  },
  {
    "entry": 376,
    "name": "HARIYAMA 1",
    "species": "Hariyama",
    "instance": "1",
    "nature": "Adamant",
    "item": "Persim Berry",
    "move1": "Arm Thrust",
    "move2": "Earthquake",
    "move3": "Facade",
    "move4": "Fake Out",
    "speed": 70
  },
  {
    "entry": 512,
    "name": "HARIYAMA 2",
    "species": "Hariyama",
    "instance": "2",
    "nature": "Adamant",
    "item": "Iron Ball",
    "move1": "Revenge",
    "move2": "Payback",
    "move3": "Fling",
    "move4": "Fake Out",
    "speed": 70
  },
  {
    "entry": 648,
    "name": "HARIYAMA 3",
    "species": "Hariyama",
    "instance": "3",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "DynamicPunch",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 70
  },
  {
    "entry": 784,
    "name": "HARIYAMA 4",
    "species": "Hariyama",
    "instance": "4",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Cross Chop",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Poison Jab",
    "speed": 70
  },
  {
    "entry": 906,
    "name": "HEATRAN 1",
    "species": "Heatran",
    "instance": "1",
    "nature": "Modest",
    "item": "Shuca Berry",
    "move1": "Heat Wave",
    "move2": "Flash Cannon",
    "move3": "AncientPower",
    "move4": "Scary Face",
    "speed": 97
  },
  {
    "entry": 920,
    "name": "HEATRAN 2",
    "species": "Heatran",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Iron Head",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Crunch",
    "speed": 97
  },
  {
    "entry": 934,
    "name": "HEATRAN 3",
    "species": "Heatran",
    "instance": "3",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Flamethrower",
    "move2": "Earth Power",
    "move3": "Dragon Pulse",
    "move4": "Dark Pulse",
    "speed": 97
  },
  {
    "entry": 948,
    "name": "HEATRAN 4",
    "species": "Heatran",
    "instance": "4",
    "nature": "Quiet",
    "item": "Focus Sash",
    "move1": "Magma Storm",
    "move2": "Flash Cannon",
    "move3": "Earth Power",
    "move4": "Explosion",
    "speed": 87
  },
  {
    "entry": 424,
    "name": "HERACROSS 1",
    "species": "Heracross",
    "instance": "1",
    "nature": "Jolly",
    "item": "Focus Band",
    "move1": "Megahorn",
    "move2": "Focus Punch",
    "move3": "Swagger",
    "move4": "Attract",
    "speed": 150
  },
  {
    "entry": 560,
    "name": "HERACROSS 2",
    "species": "Heracross",
    "instance": "2",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Close Combat",
    "move2": "Aerial Ace",
    "move3": "Night Slash",
    "move4": "Bulk Up",
    "speed": 105
  },
  {
    "entry": 696,
    "name": "HERACROSS 3",
    "species": "Heracross",
    "instance": "3",
    "nature": "Adamant",
    "item": "Coba Berry",
    "move1": "Megahorn",
    "move2": "Stone Edge",
    "move3": "Facade",
    "move4": "Shadow Claw",
    "speed": 137
  },
  {
    "entry": 832,
    "name": "HERACROSS 4",
    "species": "Heracross",
    "instance": "4",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Megahorn",
    "move2": "Earthquake",
    "move3": "Reversal",
    "move4": "Endure",
    "speed": 150
  },
  {
    "entry": 460,
    "name": "HIPPOWDON 1",
    "species": "Hippowdon",
    "instance": "1",
    "nature": "Impish",
    "item": "Persim Berry",
    "move1": "Earthquake",
    "move2": "Crunch",
    "move3": "Slack Off",
    "move4": "Curse",
    "speed": 67
  },
  {
    "entry": 596,
    "name": "HIPPOWDON 2",
    "species": "Hippowdon",
    "instance": "2",
    "nature": "Impish",
    "item": "Sitrus Berry",
    "move1": "Earthquake",
    "move2": "Swagger",
    "move3": "Sand Tomb",
    "move4": "Yawn",
    "speed": 67
  },
  {
    "entry": 732,
    "name": "HIPPOWDON 3",
    "species": "Hippowdon",
    "instance": "3",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Superpower",
    "move2": "Fire Fang",
    "move3": "Ice Fang",
    "move4": "Fissure",
    "speed": 67
  },
  {
    "entry": 868,
    "name": "HIPPOWDON 4",
    "species": "Hippowdon",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Stone Edge",
    "move3": "Crunch",
    "move4": "Thunder Fang",
    "speed": 67
  },
  {
    "entry": 315,
    "name": "HITMONCHAN 2",
    "species": "Hitmonchan",
    "instance": "2",
    "nature": "Adamant",
    "item": "King's Rock",
    "move1": "Sky Uppercut",
    "move2": "Mega Punch",
    "move3": "Bullet Punch",
    "move4": "Counter",
    "speed": 117
  },
  {
    "entry": 314,
    "name": "HITMONLEE 2",
    "species": "Hitmonlee",
    "instance": "2",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Hi Jump Kick",
    "move2": "Blaze Kick",
    "move3": "Mega Kick",
    "move4": "Endure",
    "speed": 128
  },
  {
    "entry": 317,
    "name": "HITMONTOP 2",
    "species": "Hitmontop",
    "instance": "2",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Triple Kick",
    "move2": "Bullet Punch",
    "move3": "Aerial Ace",
    "move4": "Counter",
    "speed": 90
  },
  {
    "entry": 438,
    "name": "HONCHKROW 1",
    "species": "Honchkrow",
    "instance": "1",
    "nature": "Adamant",
    "item": "Wacan Berry",
    "move1": "Night Slash",
    "move2": "Aerial Ace",
    "move3": "Torment",
    "move4": "Taunt",
    "speed": 91
  },
  {
    "entry": 574,
    "name": "HONCHKROW 2",
    "species": "Honchkrow",
    "instance": "2",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Superpower",
    "move2": "Pluck",
    "move3": "Confuse Ray",
    "move4": "Thunder Wave",
    "speed": 91
  },
  {
    "entry": 710,
    "name": "HONCHKROW 3",
    "species": "Honchkrow",
    "instance": "3",
    "nature": "Modest",
    "item": "Life Orb",
    "move1": "Dark Pulse",
    "move2": "Air Cutter",
    "move3": "Psychic",
    "move4": "Shadow Ball",
    "speed": 91
  },
  {
    "entry": 846,
    "name": "HONCHKROW 4",
    "species": "Honchkrow",
    "instance": "4",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Night Slash",
    "move2": "Drill Peck",
    "move3": "Sucker Punch",
    "move4": "Steel Wing",
    "speed": 91
  },
  {
    "entry": 426,
    "name": "HOUNDOOM 1",
    "species": "Houndoom",
    "instance": "1",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Fire Fang",
    "move2": "Crunch",
    "move3": "Roar",
    "move4": "Counter",
    "speed": 161
  },
  {
    "entry": 562,
    "name": "HOUNDOOM 2",
    "species": "Houndoom",
    "instance": "2",
    "nature": "Jolly",
    "item": "Focus Sash",
    "move1": "Fire Fang",
    "move2": "Thunder Fang",
    "move3": "Reversal",
    "move4": "Endure",
    "speed": 161
  },
  {
    "entry": 698,
    "name": "HOUNDOOM 3",
    "species": "Houndoom",
    "instance": "3",
    "nature": "Modest",
    "item": "Passho Berry",
    "move1": "Flamethrower",
    "move2": "Shadow Ball",
    "move3": "Sludge Bomb",
    "move4": "Will-O-Wisp",
    "speed": 147
  },
  {
    "entry": 834,
    "name": "HOUNDOOM 4",
    "species": "Houndoom",
    "instance": "4",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Dark Pulse",
    "move3": "SolarBeam",
    "move4": "Sunny Day",
    "speed": 161
  },
  {
    "entry": 394,
    "name": "HYPNO 1",
    "species": "Hypno",
    "instance": "1",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Psycho Cut",
    "move2": "Fling",
    "move3": "Hypnosis",
    "move4": "Trick Room",
    "speed": 78
  },
  {
    "entry": 530,
    "name": "HYPNO 2",
    "species": "Hypno",
    "instance": "2",
    "nature": "Hardy",
    "item": "Persim Berry",
    "move1": "Dream Eater",
    "move2": "Nightmare",
    "move3": "Drain Punch",
    "move4": "Hypnosis",
    "speed": 87
  },
  {
    "entry": 666,
    "name": "HYPNO 3",
    "species": "Hypno",
    "instance": "3",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Zen Headbutt",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 87
  },
  {
    "entry": 802,
    "name": "HYPNO 4",
    "species": "Hypno",
    "instance": "4",
    "nature": "Modest",
    "item": "Choice Specs",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Signal Beam",
    "move4": "Focus Blast",
    "speed": 87
  },
  {
    "entry": 361,
    "name": "INFERNAPE 1",
    "species": "Infernape",
    "instance": "1",
    "nature": "Jolly",
    "item": "Coba Berry",
    "move1": "Close Combat",
    "move2": "Fire Punch",
    "move3": "U-turn",
    "move4": "Fake Out",
    "speed": 176
  },
  {
    "entry": 497,
    "name": "INFERNAPE 2",
    "species": "Infernape",
    "instance": "2",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Blaze Kick",
    "move2": "Shadow Claw",
    "move3": "ThunderPunch",
    "move4": "Gunk Shot",
    "speed": 160
  },
  {
    "entry": 633,
    "name": "INFERNAPE 3",
    "species": "Infernape",
    "instance": "3",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Flamethrower",
    "move2": "Focus Blast",
    "move3": "SolarBeam",
    "move4": "Sunny Day",
    "speed": 160
  },
  {
    "entry": 769,
    "name": "INFERNAPE 4",
    "species": "Infernape",
    "instance": "4",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Flare Blitz",
    "move2": "Close Combat",
    "move3": "Earthquake",
    "move4": "ThunderPunch",
    "speed": 176
  },
  {
    "entry": 453,
    "name": "JOLTEON 1",
    "species": "Jolteon",
    "instance": "1",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "Thunderbolt",
    "move2": "Thunder Wave",
    "move3": "Agility",
    "move4": "Baton Pass",
    "speed": 200
  },
  {
    "entry": 589,
    "name": "JOLTEON 2",
    "species": "Jolteon",
    "instance": "2",
    "nature": "Docile",
    "item": "Razor Claw",
    "move1": "Discharge",
    "move2": "Double Kick",
    "move3": "Dig",
    "move4": "Thunder Wave",
    "speed": 150
  },
  {
    "entry": 725,
    "name": "JOLTEON 3",
    "species": "Jolteon",
    "instance": "3",
    "nature": "Timid",
    "item": "Lax Incense",
    "move1": "Thunder",
    "move2": "Shadow Ball",
    "move3": "Rain Dance",
    "move4": "Yawn",
    "speed": 200
  },
  {
    "entry": 861,
    "name": "JOLTEON 4",
    "species": "Jolteon",
    "instance": "4",
    "nature": "Modest",
    "item": "Razor Fang",
    "move1": "Thunderbolt",
    "move2": "Hyper Beam",
    "move3": "Shadow Ball",
    "move4": "Signal Beam",
    "speed": 182
  },
  {
    "entry": 368,
    "name": "JYNX 1",
    "species": "Jynx",
    "instance": "1",
    "nature": "Calm",
    "item": "Chesto Berry",
    "move1": "Psychic",
    "move2": "Ice Beam",
    "move3": "Lovely Kiss",
    "move4": "Fake Tears",
    "speed": 115
  },
  {
    "entry": 504,
    "name": "JYNX 2",
    "species": "Jynx",
    "instance": "2",
    "nature": "Calm",
    "item": "Lax Incense",
    "move1": "Dream Eater",
    "move2": "Lovely Kiss",
    "move3": "Perish Song",
    "move4": "Mean Look",
    "speed": 115
  },
  {
    "entry": 640,
    "name": "JYNX 3",
    "species": "Jynx",
    "instance": "3",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Blizzard",
    "move2": "Energy Ball",
    "move3": "Signal Beam",
    "move4": "Wring Out",
    "speed": 147
  },
  {
    "entry": 776,
    "name": "JYNX 4",
    "species": "Jynx",
    "instance": "4",
    "nature": "Modest",
    "item": "Choice Specs",
    "move1": "Ice Beam",
    "move2": "Psychic",
    "move3": "Focus Blast",
    "move4": "Shadow Ball",
    "speed": 147
  },
  {
    "entry": 348,
    "name": "KABUTOPS 2",
    "species": "Kabutops",
    "instance": "2",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Waterfall",
    "move2": "Rock Slide",
    "move3": "Slash",
    "move4": "Swords Dance",
    "speed": 100
  },
  {
    "entry": 399,
    "name": "KANGASKHAN 1",
    "species": "Kangaskhan",
    "instance": "1",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Double-Edge",
    "move2": "Crunch",
    "move3": "Reversal",
    "move4": "Endure",
    "speed": 156
  },
  {
    "entry": 535,
    "name": "KANGASKHAN 2",
    "species": "Kangaskhan",
    "instance": "2",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Dizzy Punch",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 110
  },
  {
    "entry": 671,
    "name": "KANGASKHAN 3",
    "species": "Kangaskhan",
    "instance": "3",
    "nature": "Jolly",
    "item": "Life Orb",
    "move1": "Double Hit",
    "move2": "Hammer Arm",
    "move3": "Shadow Claw",
    "move4": "Rock Slide",
    "speed": 156
  },
  {
    "entry": 807,
    "name": "KANGASKHAN 4",
    "species": "Kangaskhan",
    "instance": "4",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Giga Impact",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Outrage",
    "speed": 110
  },
  {
    "entry": 474,
    "name": "KINGDRA 1",
    "species": "Kingdra",
    "instance": "1",
    "nature": "Timid",
    "item": "Razor Fang",
    "move1": "Surf",
    "move2": "Dragon Pulse",
    "move3": "SmokeScreen",
    "move4": "Rain Dance",
    "speed": 150
  },
  {
    "entry": 610,
    "name": "KINGDRA 2",
    "species": "Kingdra",
    "instance": "2",
    "nature": "Timid",
    "item": "Shell Bell",
    "move1": "Brine",
    "move2": "Ice Beam",
    "move3": "Twister",
    "move4": "Yawn",
    "speed": 150
  },
  {
    "entry": 746,
    "name": "KINGDRA 3",
    "species": "Kingdra",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Waterfall",
    "move2": "Outrage",
    "move3": "Iron Head",
    "move4": "Dragon Dance",
    "speed": 105
  },
  {
    "entry": 882,
    "name": "KINGDRA 4",
    "species": "Kingdra",
    "instance": "4",
    "nature": "Modest",
    "item": "Wide Lens",
    "move1": "Hydro Pump",
    "move2": "Draco Meteor",
    "move3": "Blizzard",
    "move4": "Signal Beam",
    "speed": 105
  },
  {
    "entry": 338,
    "name": "KINGLER 2",
    "species": "Kingler",
    "instance": "2",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Crabhammer",
    "move2": "Guillotine",
    "move3": "Flail",
    "move4": "Endure",
    "speed": 139
  },
  {
    "entry": 291,
    "name": "LAIRON 2",
    "species": "Lairon",
    "instance": "2",
    "nature": "Impish",
    "item": "Sitrus Berry",
    "move1": "Iron Head",
    "move2": "Rock Slide",
    "move3": "Earthquake",
    "move4": "Roar",
    "speed": 60
  },
  {
    "entry": 370,
    "name": "LANTURN 1",
    "species": "Lanturn",
    "instance": "1",
    "nature": "Modest",
    "item": "Rindo Berry",
    "move1": "Surf",
    "move2": "Discharge",
    "move3": "Thunder Wave",
    "move4": "Aqua Ring",
    "speed": 87
  },
  {
    "entry": 506,
    "name": "LANTURN 2",
    "species": "Lanturn",
    "instance": "2",
    "nature": "Calm",
    "item": "Lum Berry",
    "move1": "Dive",
    "move2": "Confuse Ray",
    "move3": "Thunder Wave",
    "move4": "Attract",
    "speed": 87
  },
  {
    "entry": 642,
    "name": "LANTURN 3",
    "species": "Lanturn",
    "instance": "3",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Hydro Pump",
    "move2": "Thunder",
    "move3": "Blizzard",
    "move4": "Rain Dance",
    "speed": 87
  },
  {
    "entry": 778,
    "name": "LANTURN 4",
    "species": "Lanturn",
    "instance": "4",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Surf",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Signal Beam",
    "speed": 87
  },
  {
    "entry": 466,
    "name": "LAPRAS 1",
    "species": "Lapras",
    "instance": "1",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Aqua Tail",
    "move2": "Avalanche",
    "move3": "Ice Shard",
    "move4": "Curse",
    "speed": 80
  },
  {
    "entry": 602,
    "name": "LAPRAS 2",
    "species": "Lapras",
    "instance": "2",
    "nature": "Impish",
    "item": "Quick Claw",
    "move1": "Sheer Cold",
    "move2": "Perish Song",
    "move3": "Sing",
    "move4": "Confuse Ray",
    "speed": 80
  },
  {
    "entry": 738,
    "name": "LAPRAS 3",
    "species": "Lapras",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Waterfall",
    "move2": "Outrage",
    "move3": "Zen Headbutt",
    "move4": "Dragon Dance",
    "speed": 80
  },
  {
    "entry": 874,
    "name": "LAPRAS 4",
    "species": "Lapras",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Psychic",
    "move4": "Thunderbolt",
    "speed": 80
  },
  {
    "entry": 904,
    "name": "LATIAS 1",
    "species": "Latias",
    "instance": "1",
    "nature": "Calm",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Dragon Pulse",
    "move3": "Attract",
    "move4": "Calm Mind",
    "speed": 130
  },
  {
    "entry": 918,
    "name": "LATIAS 2",
    "species": "Latias",
    "instance": "2",
    "nature": "Adamant",
    "item": "Expert Belt",
    "move1": "Dragon Claw",
    "move2": "Zen Headbutt",
    "move3": "Earthquake",
    "move4": "Aerial Ace",
    "speed": 162
  },
  {
    "entry": 932,
    "name": "LATIAS 3",
    "species": "Latias",
    "instance": "3",
    "nature": "Timid",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Ice Beam",
    "move3": "Energy Ball",
    "move4": "Shadow Ball",
    "speed": 178
  },
  {
    "entry": 946,
    "name": "LATIAS 4",
    "species": "Latias",
    "instance": "4",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Mist Ball",
    "move2": "Draco Meteor",
    "move3": "Thunderbolt",
    "move4": "Surf",
    "speed": 162
  },
  {
    "entry": 905,
    "name": "LATIOS 1",
    "species": "Latios",
    "instance": "1",
    "nature": "Calm",
    "item": "Focus Band",
    "move1": "Psychic",
    "move2": "Dragon Pulse",
    "move3": "Thunder Wave",
    "move4": "Calm Mind",
    "speed": 130
  },
  {
    "entry": 919,
    "name": "LATIOS 2",
    "species": "Latios",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Dragon Claw",
    "move2": "Shadow Claw",
    "move3": "Earthquake",
    "move4": "Dragon Dance",
    "speed": 162
  },
  {
    "entry": 933,
    "name": "LATIOS 3",
    "species": "Latios",
    "instance": "3",
    "nature": "Timid",
    "item": "BrightPowder",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Ice Beam",
    "move4": "Energy Ball",
    "speed": 178
  },
  {
    "entry": 947,
    "name": "LATIOS 4",
    "species": "Latios",
    "instance": "4",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Luster Purge",
    "move2": "Draco Meteor",
    "move3": "Hyper Beam",
    "move4": "Surf",
    "speed": 162
  },
  {
    "entry": 457,
    "name": "LEAFEON 1",
    "species": "Leafeon",
    "instance": "1",
    "nature": "Jolly",
    "item": "Scope Lens",
    "move1": "Leaf Blade",
    "move2": "Aerial Ace",
    "move3": "Double Team",
    "move4": "Baton Pass",
    "speed": 161
  },
  {
    "entry": 593,
    "name": "LEAFEON 2",
    "species": "Leafeon",
    "instance": "2",
    "nature": "Jolly",
    "item": "BrightPowder",
    "move1": "Leaf Blade",
    "move2": "Last Resort",
    "move3": "Curse",
    "move4": "GrassWhistle",
    "speed": 161
  },
  {
    "entry": 729,
    "name": "LEAFEON 3",
    "species": "Leafeon",
    "instance": "3",
    "nature": "Adamant",
    "item": "Heat Rock",
    "move1": "Leaf Blade",
    "move2": "X-Scissor",
    "move3": "Synthesis",
    "move4": "Sunny Day",
    "speed": 115
  },
  {
    "entry": 865,
    "name": "LEAFEON 4",
    "species": "Leafeon",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Leaf Blade",
    "move2": "X-Scissor",
    "move3": "Aerial Ace",
    "move4": "Bite",
    "speed": 115
  },
  {
    "entry": 445,
    "name": "LICKILICKY 1",
    "species": "Lickilicky",
    "instance": "1",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Return",
    "move2": "Earthquake",
    "move3": "Belly Drum",
    "move4": "Rest",
    "speed": 70
  },
  {
    "entry": 581,
    "name": "LICKILICKY 2",
    "species": "Lickilicky",
    "instance": "2",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Thunderbolt",
    "move4": "Shadow Ball",
    "speed": 70
  },
  {
    "entry": 717,
    "name": "LICKILICKY 3",
    "species": "Lickilicky",
    "instance": "3",
    "nature": "Brave",
    "item": "Lum Berry",
    "move1": "Return",
    "move2": "Gyro Ball",
    "move3": "Curse",
    "move4": "Rest",
    "speed": 63
  },
  {
    "entry": 853,
    "name": "LICKILICKY 4",
    "species": "Lickilicky",
    "instance": "4",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Body Slam",
    "move2": "Power Whip",
    "move3": "Earthquake",
    "move4": "Explosion",
    "speed": 70
  },
  {
    "entry": 391,
    "name": "LOPUNNY 1",
    "species": "Lopunny",
    "instance": "1",
    "nature": "Jolly",
    "item": "Focus Band",
    "move1": "Return",
    "move2": "Drain Punch",
    "move3": "Charm",
    "move4": "Mirror Coat",
    "speed": 172
  },
  {
    "entry": 527,
    "name": "LOPUNNY 2",
    "species": "Lopunny",
    "instance": "2",
    "nature": "Jolly",
    "item": "BrightPowder",
    "move1": "Focus Punch",
    "move2": "Sweet Kiss",
    "move3": "Attract",
    "move4": "Thunder Wave",
    "speed": 172
  },
  {
    "entry": 663,
    "name": "LOPUNNY 3",
    "species": "Lopunny",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Charge Beam",
    "move2": "Ice Beam",
    "move3": "Shadow Ball",
    "move4": "Focus Blast",
    "speed": 157
  },
  {
    "entry": 799,
    "name": "LOPUNNY 4",
    "species": "Lopunny",
    "instance": "4",
    "nature": "Jolly",
    "item": "Muscle Band",
    "move1": "Dizzy Punch",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 172
  },
  {
    "entry": 459,
    "name": "LUCARIO 1",
    "species": "Lucario",
    "instance": "1",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Aura Sphere",
    "move2": "Flash Cannon",
    "move3": "Water Pulse",
    "move4": "Roar",
    "speed": 142
  },
  {
    "entry": 595,
    "name": "LUCARIO 2",
    "species": "Lucario",
    "instance": "2",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Cross Chop",
    "move2": "Stone Edge",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 142
  },
  {
    "entry": 731,
    "name": "LUCARIO 3",
    "species": "Lucario",
    "instance": "3",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Close Combat",
    "move2": "Earthquake",
    "move3": "Blaze Kick",
    "move4": "Shadow Claw",
    "speed": 142
  },
  {
    "entry": 867,
    "name": "LUCARIO 4",
    "species": "Lucario",
    "instance": "4",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Aura Sphere",
    "move2": "Psychic",
    "move3": "Shadow Ball",
    "move4": "Dragon Pulse",
    "speed": 142
  },
  {
    "entry": 387,
    "name": "LUDICOLO 1",
    "species": "Ludicolo",
    "instance": "1",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Waterfall",
    "move2": "Razor Leaf",
    "move3": "Drain Punch",
    "move4": "Swords Dance",
    "speed": 90
  },
  {
    "entry": 523,
    "name": "LUDICOLO 2",
    "species": "Ludicolo",
    "instance": "2",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Leech Seed",
    "move2": "Toxic",
    "move3": "Double Team",
    "move4": "Rain Dance",
    "speed": 90
  },
  {
    "entry": 659,
    "name": "LUDICOLO 3",
    "species": "Ludicolo",
    "instance": "3",
    "nature": "Modest",
    "item": "Wide Lens",
    "move1": "Hydro Pump",
    "move2": "Grass Knot",
    "move3": "Blizzard",
    "move4": "Focus Blast",
    "speed": 90
  },
  {
    "entry": 795,
    "name": "LUDICOLO 4",
    "species": "Ludicolo",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Giga Drain",
    "move3": "Ice Beam",
    "move4": "Rain Dance",
    "speed": 90
  },
  {
    "entry": 298,
    "name": "LUNATONE 2",
    "species": "Lunatone",
    "instance": "2",
    "nature": "Modest",
    "item": "Passho Berry",
    "move1": "Psychic",
    "move2": "AncientPower",
    "move3": "Shadow Ball",
    "move4": "Cosmic Power",
    "speed": 90
  },
  {
    "entry": 433,
    "name": "LUXRAY 1",
    "species": "Luxray",
    "instance": "1",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Thunder Fang",
    "move2": "Crunch",
    "move3": "Howl",
    "move4": "Charge",
    "speed": 90
  },
  {
    "entry": 569,
    "name": "LUXRAY 2",
    "species": "Luxray",
    "instance": "2",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Thunderbolt",
    "move2": "Signal Beam",
    "move3": "Thunder Wave",
    "move4": "Magnet Rise",
    "speed": 90
  },
  {
    "entry": 705,
    "name": "LUXRAY 3",
    "species": "Luxray",
    "instance": "3",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Thunder Fang",
    "move2": "Ice Fang",
    "move3": "Superpower",
    "move4": "Thunder Wave",
    "speed": 90
  },
  {
    "entry": 841,
    "name": "LUXRAY 4",
    "species": "Luxray",
    "instance": "4",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Thunder Fang",
    "move2": "Ice Fang",
    "move3": "Crunch",
    "move4": "Thunder Wave",
    "speed": 90
  },
  {
    "entry": 435,
    "name": "MACHAMP 1",
    "species": "Machamp",
    "instance": "1",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Cross Chop",
    "move2": "Earthquake",
    "move3": "Bullet Punch",
    "move4": "Foresight",
    "speed": 75
  },
  {
    "entry": 571,
    "name": "MACHAMP 2",
    "species": "Machamp",
    "instance": "2",
    "nature": "Adamant",
    "item": "Focus Sash",
    "move1": "Revenge",
    "move2": "Earthquake",
    "move3": "Payback",
    "move4": "Counter",
    "speed": 75
  },
  {
    "entry": 707,
    "name": "MACHAMP 3",
    "species": "Machamp",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "DynamicPunch",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Ice Punch",
    "speed": 75
  },
  {
    "entry": 843,
    "name": "MACHAMP 4",
    "species": "Machamp",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Cross Chop",
    "move2": "Earthquake",
    "move3": "ThunderPunch",
    "move4": "Fire Punch",
    "speed": 75
  },
  {
    "entry": 264,
    "name": "MAGCARGO 2",
    "species": "Magcargo",
    "instance": "2",
    "nature": "Quiet",
    "item": "Quick Claw",
    "move1": "Overheat",
    "move2": "Rock Slide",
    "move3": "Earthquake",
    "move4": "Body Slam",
    "speed": 45
  },
  {
    "entry": 478,
    "name": "MAGMORTAR 1",
    "species": "Magmortar",
    "instance": "1",
    "nature": "Modest",
    "item": "Heat Rock",
    "move1": "Fire Blast",
    "move2": "Focus Blast",
    "move3": "Will-O-Wisp",
    "move4": "Sunny Day",
    "speed": 135
  },
  {
    "entry": 614,
    "name": "MAGMORTAR 2",
    "species": "Magmortar",
    "instance": "2",
    "nature": "Adamant",
    "item": "Shuca Berry",
    "move1": "Fire Punch",
    "move2": "Focus Punch",
    "move3": "Confuse Ray",
    "move4": "SmokeScreen",
    "speed": 135
  },
  {
    "entry": 750,
    "name": "MAGMORTAR 3",
    "species": "Magmortar",
    "instance": "3",
    "nature": "Adamant",
    "item": "Passho Berry",
    "move1": "Flare Blitz",
    "move2": "ThunderPunch",
    "move3": "Earthquake",
    "move4": "Brick Break",
    "speed": 135
  },
  {
    "entry": 886,
    "name": "MAGMORTAR 4",
    "species": "Magmortar",
    "instance": "4",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Psychic",
    "move3": "Focus Blast",
    "move4": "Confuse Ray",
    "speed": 135
  },
  {
    "entry": 328,
    "name": "MAGNETON 2",
    "species": "Magneton",
    "instance": "2",
    "nature": "Modest",
    "item": "Shuca Berry",
    "move1": "Thunderbolt",
    "move2": "Mirror Shot",
    "move3": "Thunder Wave",
    "move4": "Magnet Rise",
    "speed": 90
  },
  {
    "entry": 468,
    "name": "MAGNEZONE 1",
    "species": "Magnezone",
    "instance": "1",
    "nature": "Bold",
    "item": "Light Clay",
    "move1": "Thunderbolt",
    "move2": "Mirror Shot",
    "move3": "Light Screen",
    "move4": "Reflect",
    "speed": 80
  },
  {
    "entry": 604,
    "name": "MAGNEZONE 2",
    "species": "Magnezone",
    "instance": "2",
    "nature": "Impish",
    "item": "Lum Berry",
    "move1": "Iron Head",
    "move2": "Explosion",
    "move3": "Swagger",
    "move4": "Psych Up",
    "speed": 80
  },
  {
    "entry": 740,
    "name": "MAGNEZONE 3",
    "species": "Magnezone",
    "instance": "3",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Charge Beam",
    "move2": "Flash Cannon",
    "move3": "Magnet Rise",
    "move4": "Thunder Wave",
    "speed": 80
  },
  {
    "entry": 876,
    "name": "MAGNEZONE 4",
    "species": "Magnezone",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Thunderbolt",
    "move2": "Flash Cannon",
    "move3": "Tri Attack",
    "move4": "Signal Beam",
    "speed": 80
  },
  {
    "entry": 465,
    "name": "MAMOSWINE 1",
    "species": "Mamoswine",
    "instance": "1",
    "nature": "Adamant",
    "item": "Icy Rock",
    "move1": "Earthquake",
    "move2": "Ice Fang",
    "move3": "Peck",
    "move4": "Hail",
    "speed": 100
  },
  {
    "entry": 601,
    "name": "MAMOSWINE 2",
    "species": "Mamoswine",
    "instance": "2",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Avalanche",
    "move2": "Earthquake",
    "move3": "Iron Head",
    "move4": "Curse",
    "speed": 100
  },
  {
    "entry": 737,
    "name": "MAMOSWINE 3",
    "species": "Mamoswine",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Earthquake",
    "move2": "Superpower",
    "move3": "Fissure",
    "move4": "Hail",
    "speed": 100
  },
  {
    "entry": 873,
    "name": "MAMOSWINE 4",
    "species": "Mamoswine",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Earthquake",
    "move2": "Ice Fang",
    "move3": "Stone Edge",
    "move4": "Double-Edge",
    "speed": 100
  },
  {
    "entry": 380,
    "name": "MANECTRIC 1",
    "species": "Manectric",
    "instance": "1",
    "nature": "Adamant",
    "item": "Shuca Berry",
    "move1": "Thunder Fang",
    "move2": "Crunch",
    "move3": "Roar",
    "move4": "Thunder Wave",
    "speed": 157
  },
  {
    "entry": 516,
    "name": "MANECTRIC 2",
    "species": "Manectric",
    "instance": "2",
    "nature": "Modest",
    "item": "Damp Rock",
    "move1": "Thunder",
    "move2": "Hyper Beam",
    "move3": "Thunder Wave",
    "move4": "Rain Dance",
    "speed": 157
  },
  {
    "entry": 652,
    "name": "MANECTRIC 3",
    "species": "Manectric",
    "instance": "3",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Thunder Fang",
    "move2": "Fire Fang",
    "move3": "Ice Fang",
    "move4": "Bite",
    "speed": 157
  },
  {
    "entry": 788,
    "name": "MANECTRIC 4",
    "species": "Manectric",
    "instance": "4",
    "nature": "Timid",
    "item": "BrightPowder",
    "move1": "Thunderbolt",
    "move2": "Flamethrower",
    "move3": "Signal Beam",
    "move4": "Swift",
    "speed": 172
  },
  {
    "entry": 364,
    "name": "MAROWAK 1",
    "species": "Marowak",
    "instance": "1",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Bone Rush",
    "move2": "Brick Break",
    "move3": "Iron Tail",
    "move4": "Sandstorm",
    "speed": 65
  },
  {
    "entry": 500,
    "name": "MAROWAK 2",
    "species": "Marowak",
    "instance": "2",
    "nature": "Adamant",
    "item": "Thick Club",
    "move1": "Bone Rush",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Rock Slide",
    "speed": 65
  },
  {
    "entry": 636,
    "name": "MAROWAK 3",
    "species": "Marowak",
    "instance": "3",
    "nature": "Adamant",
    "item": "Thick Club",
    "move1": "Earthquake",
    "move2": "Giga Impact",
    "move3": "Outrage",
    "move4": "Fire Punch",
    "speed": 65
  },
  {
    "entry": 772,
    "name": "MAROWAK 4",
    "species": "Marowak",
    "instance": "4",
    "nature": "Adamant",
    "item": "Thick Club",
    "move1": "Earthquake",
    "move2": "Stone Edge",
    "move3": "Iron Head",
    "move4": "ThunderPunch",
    "speed": 65
  },
  {
    "entry": 365,
    "name": "MEDICHAM 1",
    "species": "Medicham",
    "instance": "1",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "Zen Headbutt",
    "move2": "Reversal",
    "move3": "Endure",
    "move4": "Fake Out",
    "speed": 145
  },
  {
    "entry": 501,
    "name": "MEDICHAM 2",
    "species": "Medicham",
    "instance": "2",
    "nature": "Jolly",
    "item": "Cheri Berry",
    "move1": "Drain Punch",
    "move2": "Poison Jab",
    "move3": "Detect",
    "move4": "Recover",
    "speed": 145
  },
  {
    "entry": 637,
    "name": "MEDICHAM 3",
    "species": "Medicham",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Psychic",
    "move2": "Focus Blast",
    "move3": "Shadow Ball",
    "move4": "Calm Mind",
    "speed": 132
  },
  {
    "entry": 773,
    "name": "MEDICHAM 4",
    "species": "Medicham",
    "instance": "4",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Psycho Cut",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 132
  },
  {
    "entry": 354,
    "name": "MEGANIUM 1",
    "species": "Meganium",
    "instance": "1",
    "nature": "Modest",
    "item": "Heat Rock",
    "move1": "SolarBeam",
    "move2": "AncientPower",
    "move3": "Synthesis",
    "move4": "Sunny Day",
    "speed": 100
  },
  {
    "entry": 490,
    "name": "MEGANIUM 2",
    "species": "Meganium",
    "instance": "2",
    "nature": "Calm",
    "item": "Big Root",
    "move1": "Giga Drain",
    "move2": "Leech Seed",
    "move3": "Toxic",
    "move4": "Substitute",
    "speed": 100
  },
  {
    "entry": 626,
    "name": "MEGANIUM 3",
    "species": "Meganium",
    "instance": "3",
    "nature": "Bold",
    "item": "Light Clay",
    "move1": "Leaf Storm",
    "move2": "Wring Out",
    "move3": "Light Screen",
    "move4": "Reflect",
    "speed": 100
  },
  {
    "entry": 762,
    "name": "MEGANIUM 4",
    "species": "Meganium",
    "instance": "4",
    "nature": "Modest",
    "item": "Lax Incense",
    "move1": "Frenzy Plant",
    "move2": "AncientPower",
    "move3": "Hyper Beam",
    "move4": "Light Screen",
    "speed": 100
  },
  {
    "entry": 484,
    "name": "METAGROSS 1",
    "species": "Metagross",
    "instance": "1",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Zen Headbutt",
    "move2": "Bullet Punch",
    "move3": "Facade",
    "move4": "Light Screen",
    "speed": 90
  },
  {
    "entry": 620,
    "name": "METAGROSS 2",
    "species": "Metagross",
    "instance": "2",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Psychic",
    "move2": "Flash Cannon",
    "move3": "Shadow Ball",
    "move4": "Sludge Bomb",
    "speed": 90
  },
  {
    "entry": 756,
    "name": "METAGROSS 3",
    "species": "Metagross",
    "instance": "3",
    "nature": "Adamant",
    "item": "Occa Berry",
    "move1": "Hammer Arm",
    "move2": "ThunderPunch",
    "move3": "Ice Punch",
    "move4": "Aerial Ace",
    "speed": 90
  },
  {
    "entry": 892,
    "name": "METAGROSS 4",
    "species": "Metagross",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Meteor Mash",
    "move2": "Zen Headbutt",
    "move3": "Earthquake",
    "move4": "Explosion",
    "speed": 90
  },
  {
    "entry": 280,
    "name": "METANG 2",
    "species": "Metang",
    "instance": "2",
    "nature": "Adamant",
    "item": "Shuca Berry",
    "move1": "Meteor Mash",
    "move2": "Zen Headbutt",
    "move3": "Bullet Punch",
    "move4": "Scary Face",
    "speed": 70
  },
  {
    "entry": 276,
    "name": "MIGHTYENA 2",
    "species": "Mightyena",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chople Berry",
    "move1": "Crunch",
    "move2": "Take Down",
    "move3": "Sucker Punch",
    "move4": "Howl",
    "speed": 90
  },
  {
    "entry": 476,
    "name": "MILOTIC 1",
    "species": "Milotic",
    "instance": "1",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Attract",
    "move4": "Hypnosis",
    "speed": 101
  },
  {
    "entry": 612,
    "name": "MILOTIC 2",
    "species": "Milotic",
    "instance": "2",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Confuse Ray",
    "move3": "Double Team",
    "move4": "Aqua Ring",
    "speed": 101
  },
  {
    "entry": 748,
    "name": "MILOTIC 3",
    "species": "Milotic",
    "instance": "3",
    "nature": "Calm",
    "item": "Wide Lens",
    "move1": "Hydro Pump",
    "move2": "Blizzard",
    "move3": "Mirror Coat",
    "move4": "Recover",
    "speed": 101
  },
  {
    "entry": 884,
    "name": "MILOTIC 4",
    "species": "Milotic",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Dragon Pulse",
    "move4": "Recover",
    "speed": 101
  },
  {
    "entry": 403,
    "name": "MILTANK 1",
    "species": "Miltank",
    "instance": "1",
    "nature": "Impish",
    "item": "Cheri Berry",
    "move1": "Return",
    "move2": "Iron Head",
    "move3": "Thunder Wave",
    "move4": "Milk Drink",
    "speed": 120
  },
  {
    "entry": 539,
    "name": "MILTANK 2",
    "species": "Miltank",
    "instance": "2",
    "nature": "Adamant",
    "item": "Salac Berry",
    "move1": "Facade",
    "move2": "Zen Headbutt",
    "move3": "Reversal",
    "move4": "Endure",
    "speed": 152
  },
  {
    "entry": 675,
    "name": "MILTANK 3",
    "species": "Miltank",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Dizzy Punch",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 120
  },
  {
    "entry": 811,
    "name": "MILTANK 4",
    "species": "Miltank",
    "instance": "4",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Giga Impact",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Zen Headbutt",
    "speed": 152
  },
  {
    "entry": 413,
    "name": "MISMAGIUS 1",
    "species": "Mismagius",
    "instance": "1",
    "nature": "Modest",
    "item": "Kasib Berry",
    "move1": "Shadow Ball",
    "move2": "Power Gem",
    "move3": "Magical Leaf",
    "move4": "Memento",
    "speed": 157
  },
  {
    "entry": 549,
    "name": "MISMAGIUS 2",
    "species": "Mismagius",
    "instance": "2",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Shadow Ball",
    "move2": "Confuse Ray",
    "move3": "Perish Song",
    "move4": "Mean Look",
    "speed": 125
  },
  {
    "entry": 685,
    "name": "MISMAGIUS 3",
    "species": "Mismagius",
    "instance": "3",
    "nature": "Timid",
    "item": "Wise Glasses",
    "move1": "Shadow Ball",
    "move2": "Energy Ball",
    "move3": "Icy Wind",
    "move4": "Destiny Bond",
    "speed": 172
  },
  {
    "entry": 821,
    "name": "MISMAGIUS 4",
    "species": "Mismagius",
    "instance": "4",
    "nature": "Timid",
    "item": "Focus Sash",
    "move1": "Shadow Ball",
    "move2": "Psychic",
    "move3": "Thunderbolt",
    "move4": "Destiny Bond",
    "speed": 172
  },
  {
    "entry": 897,
    "name": "MOLTRES 1",
    "species": "Moltres",
    "instance": "1",
    "nature": "Timid",
    "item": "Passho Berry",
    "move1": "Flamethrower",
    "move2": "Air Slash",
    "move3": "AncientPower",
    "move4": "Roost",
    "speed": 156
  },
  {
    "entry": 911,
    "name": "MOLTRES 2",
    "species": "Moltres",
    "instance": "2",
    "nature": "Timid",
    "item": "Heat Rock",
    "move1": "Fire Blast",
    "move2": "SolarBeam",
    "move3": "Hyper Beam",
    "move4": "Sunny Day",
    "speed": 121
  },
  {
    "entry": 925,
    "name": "MOLTRES 3",
    "species": "Moltres",
    "instance": "3",
    "nature": "Adamant",
    "item": "Power Herb",
    "move1": "Sky Attack",
    "move2": "Return",
    "move3": "Steel Wing",
    "move4": "U-turn",
    "speed": 142
  },
  {
    "entry": 939,
    "name": "MOLTRES 4",
    "species": "Moltres",
    "instance": "4",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Air Slash",
    "move3": "AncientPower",
    "move4": "Ominous Wind",
    "speed": 142
  },
  {
    "entry": 369,
    "name": "MRMIME 1",
    "species": "Mr. Mime",
    "instance": "1",
    "nature": "Calm",
    "item": "Cheri Berry",
    "move1": "Psychic",
    "move2": "Signal Beam",
    "move3": "Copycat",
    "move4": "Mimic",
    "speed": 110
  },
  {
    "entry": 505,
    "name": "MRMIME 2",
    "species": "Mr. Mime",
    "instance": "2",
    "nature": "Calm",
    "item": "Light Clay",
    "move1": "Dream Eater",
    "move2": "Hypnosis",
    "move3": "Light Screen",
    "move4": "Reflect",
    "speed": 110
  },
  {
    "entry": 641,
    "name": "MRMIME 3",
    "species": "Mr. Mime",
    "instance": "3",
    "nature": "Modest",
    "item": "Kasib Berry",
    "move1": "Psychic",
    "move2": "Thunderbolt",
    "move3": "Energy Ball",
    "move4": "Hyper Beam",
    "speed": 110
  },
  {
    "entry": 777,
    "name": "MRMIME 4",
    "species": "Mr. Mime",
    "instance": "4",
    "nature": "Modest",
    "item": "Choice Specs",
    "move1": "Psychic",
    "move2": "Charge Beam",
    "move3": "Shadow Ball",
    "move4": "Focus Blast",
    "speed": 110
  },
  {
    "entry": 418,
    "name": "MUK 1",
    "species": "Muk",
    "instance": "1",
    "nature": "Adamant",
    "item": "Black Sludge",
    "move1": "Poison Jab",
    "move2": "Shadow Sneak",
    "move3": "Minimize",
    "move4": "Acid Armor",
    "speed": 70
  },
  {
    "entry": 554,
    "name": "MUK 2",
    "species": "Muk",
    "instance": "2",
    "nature": "Adamant",
    "item": "Expert Belt",
    "move1": "Poison Jab",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 70
  },
  {
    "entry": 690,
    "name": "MUK 3",
    "species": "Muk",
    "instance": "3",
    "nature": "Brave",
    "item": "Zoom Lens",
    "move1": "Gunk Shot",
    "move2": "Payback",
    "move3": "Shadow Sneak",
    "move4": "Curse",
    "speed": 63
  },
  {
    "entry": 826,
    "name": "MUK 4",
    "species": "Muk",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Gunk Shot",
    "move2": "Shadow Sneak",
    "move3": "Brick Break",
    "move4": "Explosion",
    "speed": 70
  },
  {
    "entry": 408,
    "name": "NIDOKING 1",
    "species": "Nidoking",
    "instance": "1",
    "nature": "Impish",
    "item": "Focus Band",
    "move1": "Earthquake",
    "move2": "Poison Jab",
    "move3": "Double Kick",
    "move4": "Counter",
    "speed": 105
  },
  {
    "entry": 544,
    "name": "NIDOKING 2",
    "species": "Nidoking",
    "instance": "2",
    "nature": "Careful",
    "item": "BrightPowder",
    "move1": "Focus Punch",
    "move2": "Dragon Pulse",
    "move3": "Horn Drill",
    "move4": "Substitute",
    "speed": 105
  },
  {
    "entry": 680,
    "name": "NIDOKING 3",
    "species": "Nidoking",
    "instance": "3",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Earth Power",
    "move2": "Sludge Bomb",
    "move3": "Ice Beam",
    "move4": "Shadow Ball",
    "speed": 137
  },
  {
    "entry": 816,
    "name": "NIDOKING 4",
    "species": "Nidoking",
    "instance": "4",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Earthquake",
    "move2": "Poison Jab",
    "move3": "Megahorn",
    "move4": "Outrage",
    "speed": 137
  },
  {
    "entry": 407,
    "name": "NIDOQUEEN 1",
    "species": "Nidoqueen",
    "instance": "1",
    "nature": "Adamant",
    "item": "Payapa Berry",
    "move1": "Earthquake",
    "move2": "Poison Fang",
    "move3": "Aerial Ace",
    "move4": "Charm",
    "speed": 96
  },
  {
    "entry": 543,
    "name": "NIDOQUEEN 2",
    "species": "Nidoqueen",
    "instance": "2",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Poison Jab",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 96
  },
  {
    "entry": 679,
    "name": "NIDOQUEEN 3",
    "species": "Nidoqueen",
    "instance": "3",
    "nature": "Modest",
    "item": "Black Sludge",
    "move1": "Sludge Bomb",
    "move2": "Earth Power",
    "move3": "Flamethrower",
    "move4": "Ice Beam",
    "speed": 96
  },
  {
    "entry": 815,
    "name": "NIDOQUEEN 4",
    "species": "Nidoqueen",
    "instance": "4",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Earthquake",
    "move2": "Poison Jab",
    "move3": "Superpower",
    "move4": "Crunch",
    "speed": 96
  },
  {
    "entry": 434,
    "name": "NINETALES 1",
    "species": "Ninetales",
    "instance": "1",
    "nature": "Timid",
    "item": "BrightPowder",
    "move1": "Fire Blast",
    "move2": "SolarBeam",
    "move3": "Attract",
    "move4": "Sunny Day",
    "speed": 167
  },
  {
    "entry": 570,
    "name": "NINETALES 2",
    "species": "Ninetales",
    "instance": "2",
    "nature": "Timid",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "Dark Pulse",
    "move3": "Nasty Plot",
    "move4": "Confuse Ray",
    "speed": 167
  },
  {
    "entry": 706,
    "name": "NINETALES 3",
    "species": "Ninetales",
    "instance": "3",
    "nature": "Timid",
    "item": "Wide Lens",
    "move1": "Heat Wave",
    "move2": "Ominous Wind",
    "move3": "Dream Eater",
    "move4": "Hypnosis",
    "speed": 167
  },
  {
    "entry": 842,
    "name": "NINETALES 4",
    "species": "Ninetales",
    "instance": "4",
    "nature": "Modest",
    "item": "Passho Berry",
    "move1": "Flamethrower",
    "move2": "Extrasensory",
    "move3": "Energy Ball",
    "move4": "Calm Mind",
    "speed": 152
  },
  {
    "entry": 347,
    "name": "OMASTAR 2",
    "species": "Omastar",
    "instance": "2",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Surf",
    "move2": "Stone Edge",
    "move3": "Ice Beam",
    "move4": "Toxic Spikes",
    "speed": 75
  },
  {
    "entry": 422,
    "name": "PINSIR 1",
    "species": "Pinsir",
    "instance": "1",
    "nature": "Adamant",
    "item": "Coba Berry",
    "move1": "X-Scissor",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Swords Dance",
    "speed": 105
  },
  {
    "entry": 558,
    "name": "PINSIR 2",
    "species": "Pinsir",
    "instance": "2",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "X-Scissor",
    "move2": "Revenge",
    "move3": "Flail",
    "move4": "Endure",
    "speed": 150
  },
  {
    "entry": 694,
    "name": "PINSIR 3",
    "species": "Pinsir",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "X-Scissor",
    "move2": "Superpower",
    "move3": "Stone Edge",
    "move4": "Giga Impact",
    "speed": 105
  },
  {
    "entry": 830,
    "name": "PINSIR 4",
    "species": "Pinsir",
    "instance": "4",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "X-Scissor",
    "move2": "Earthquake",
    "move3": "Close Combat",
    "move4": "Guillotine",
    "speed": 105
  },
  {
    "entry": 421,
    "name": "POLITOED 1",
    "species": "Politoed",
    "instance": "1",
    "nature": "Calm",
    "item": "Lax Incense",
    "move1": "Surf",
    "move2": "Hyper Voice",
    "move3": "Mud Bomb",
    "move4": "Swagger",
    "speed": 90
  },
  {
    "entry": 557,
    "name": "POLITOED 2",
    "species": "Politoed",
    "instance": "2",
    "nature": "Impish",
    "item": "Chesto Berry",
    "move1": "Dive",
    "move2": "Brick Break",
    "move3": "Hypnosis",
    "move4": "Perish Song",
    "speed": 90
  },
  {
    "entry": 693,
    "name": "POLITOED 3",
    "species": "Politoed",
    "instance": "3",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Waterfall",
    "move2": "Earthquake",
    "move3": "Belly Drum",
    "move4": "Rest",
    "speed": 90
  },
  {
    "entry": 829,
    "name": "POLITOED 4",
    "species": "Politoed",
    "instance": "4",
    "nature": "Modest",
    "item": "Wacan Berry",
    "move1": "Hydro Pump",
    "move2": "Ice Beam",
    "move3": "Psychic",
    "move4": "Hypnosis",
    "speed": 90
  },
  {
    "entry": 416,
    "name": "POLIWRATH 1",
    "species": "Poliwrath",
    "instance": "1",
    "nature": "Modest",
    "item": "Rindo Berry",
    "move1": "Surf",
    "move2": "Vacuum Wave",
    "move3": "Psychic",
    "move4": "Double Team",
    "speed": 90
  },
  {
    "entry": 552,
    "name": "POLIWRATH 2",
    "species": "Poliwrath",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Waterfall",
    "move2": "DynamicPunch",
    "move3": "Poison Jab",
    "move4": "Bulk Up",
    "speed": 90
  },
  {
    "entry": 688,
    "name": "POLIWRATH 3",
    "species": "Poliwrath",
    "instance": "3",
    "nature": "Modest",
    "item": "Wide Lens",
    "move1": "Hydro Pump",
    "move2": "Focus Blast",
    "move3": "Blizzard",
    "move4": "Mud Bomb",
    "speed": 90
  },
  {
    "entry": 824,
    "name": "POLIWRATH 4",
    "species": "Poliwrath",
    "instance": "4",
    "nature": "Adamant",
    "item": "Expert Belt",
    "move1": "Waterfall",
    "move2": "Focus Punch",
    "move3": "Earthquake",
    "move4": "Hypnosis",
    "speed": 90
  },
  {
    "entry": 444,
    "name": "PORYGON2 1",
    "species": "Porygon2",
    "instance": "1",
    "nature": "Modest",
    "item": "Cheri Berry",
    "move1": "Tri Attack",
    "move2": "Charge Beam",
    "move3": "Thunder Wave",
    "move4": "Recycle",
    "speed": 80
  },
  {
    "entry": 580,
    "name": "PORYGON2 2",
    "species": "Porygon2",
    "instance": "2",
    "nature": "Quiet",
    "item": "Iron Ball",
    "move1": "Tri Attack",
    "move2": "Thunderbolt",
    "move3": "Recover",
    "move4": "Trick Room",
    "speed": 72
  },
  {
    "entry": 716,
    "name": "PORYGON2 3",
    "species": "Porygon2",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Tri Attack",
    "move2": "Thunderbolt",
    "move3": "Psychic",
    "move4": "Ice Beam",
    "speed": 80
  },
  {
    "entry": 852,
    "name": "PORYGON2 4",
    "species": "Porygon2",
    "instance": "4",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Tri Attack",
    "move2": "Signal Beam",
    "move3": "Shadow Ball",
    "move4": "Ice Beam",
    "speed": 80
  },
  {
    "entry": 471,
    "name": "PORYGON-Z 1",
    "species": "Porygon-Z",
    "instance": "1",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Tri Attack",
    "move2": "Shadow Ball",
    "move3": "Recycle",
    "move4": "Conversion 2",
    "speed": 110
  },
  {
    "entry": 607,
    "name": "PORYGON-Z 2",
    "species": "Porygon-Z",
    "instance": "2",
    "nature": "Timid",
    "item": "Choice Scarf",
    "move1": "Tri Attack",
    "move2": "Thunder Wave",
    "move3": "Recover",
    "move4": "Trick",
    "speed": 156
  },
  {
    "entry": 743,
    "name": "PORYGON-Z 3",
    "species": "Porygon-Z",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Psychic",
    "move2": "Ice Beam",
    "move3": "Signal Beam",
    "move4": "Charge Beam",
    "speed": 110
  },
  {
    "entry": 879,
    "name": "PORYGON-Z 4",
    "species": "Porygon-Z",
    "instance": "4",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Tri Attack",
    "move2": "Shadow Ball",
    "move3": "Thunderbolt",
    "move4": "Recover",
    "speed": 142
  },
  {
    "entry": 313,
    "name": "PRIMEAPE 2",
    "species": "Primeape",
    "instance": "2",
    "nature": "Adamant",
    "item": "Expert Belt",
    "move1": "Cross Chop",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Swagger",
    "speed": 147
  },
  {
    "entry": 461,
    "name": "PROBOPASS 1",
    "species": "Probopass",
    "instance": "1",
    "nature": "Brave",
    "item": "Cheri Berry",
    "move1": "AncientPower",
    "move2": "Magnet Bomb",
    "move3": "Thunder Wave",
    "move4": "Protect",
    "speed": 54
  },
  {
    "entry": 597,
    "name": "PROBOPASS 2",
    "species": "Probopass",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chople Berry",
    "move1": "Iron Head",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 60
  },
  {
    "entry": 733,
    "name": "PROBOPASS 3",
    "species": "Probopass",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Stone Edge",
    "move2": "Iron Head",
    "move3": "Earthquake",
    "move4": "Explosion",
    "speed": 60
  },
  {
    "entry": 869,
    "name": "PROBOPASS 4",
    "species": "Probopass",
    "instance": "4",
    "nature": "Modest",
    "item": "Life Orb",
    "move1": "Flash Cannon",
    "move2": "Power Gem",
    "move3": "Earth Power",
    "move4": "Thunderbolt",
    "speed": 60
  },
  {
    "entry": 265,
    "name": "PUPITAR 2",
    "species": "Pupitar",
    "instance": "2",
    "nature": "Adamant",
    "item": "Soft Sand",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Crunch",
    "move4": "Scary Face",
    "speed": 71
  },
  {
    "entry": 366,
    "name": "QUAGSIRE 1",
    "species": "Quagsire",
    "instance": "1",
    "nature": "Adamant",
    "item": "Rindo Berry",
    "move1": "Earthquake",
    "move2": "Aqua Tail",
    "move3": "Brick Break",
    "move4": "Counter",
    "speed": 55
  },
  {
    "entry": 502,
    "name": "QUAGSIRE 2",
    "species": "Quagsire",
    "instance": "2",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Dive",
    "move2": "Yawn",
    "move3": "Curse",
    "move4": "Amnesia",
    "speed": 55
  },
  {
    "entry": 638,
    "name": "QUAGSIRE 3",
    "species": "Quagsire",
    "instance": "3",
    "nature": "Modest",
    "item": "Quick Claw",
    "move1": "Surf",
    "move2": "Earth Power",
    "move3": "Focus Blast",
    "move4": "Sludge Bomb",
    "speed": 55
  },
  {
    "entry": 774,
    "name": "QUAGSIRE 4",
    "species": "Quagsire",
    "instance": "4",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Earthquake",
    "move2": "Waterfall",
    "move3": "Stone Edge",
    "move4": "Ice Punch",
    "speed": 55
  },
  {
    "entry": 378,
    "name": "RAICHU 1",
    "species": "Raichu",
    "instance": "1",
    "nature": "Adamant",
    "item": "Wide Lens",
    "move1": "ThunderPunch",
    "move2": "Iron Tail",
    "move3": "Slam",
    "move4": "Quick Attack",
    "speed": 152
  },
  {
    "entry": 514,
    "name": "RAICHU 2",
    "species": "Raichu",
    "instance": "2",
    "nature": "Jolly",
    "item": "Focus Band",
    "move1": "ThunderPunch",
    "move2": "Focus Punch",
    "move3": "Sweet Kiss",
    "move4": "Thunder Wave",
    "speed": 167
  },
  {
    "entry": 650,
    "name": "RAICHU 3",
    "species": "Raichu",
    "instance": "3",
    "nature": "Timid",
    "item": "Petaya Berry",
    "move1": "Thunderbolt",
    "move2": "Focus Blast",
    "move3": "Signal Beam",
    "move4": "Nasty Plot",
    "speed": 167
  },
  {
    "entry": 786,
    "name": "RAICHU 4",
    "species": "Raichu",
    "instance": "4",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Volt Tackle",
    "move2": "Return",
    "move3": "Brick Break",
    "move4": "Thunder Wave",
    "speed": 152
  },
  {
    "entry": 898,
    "name": "RAIKOU 1",
    "species": "Raikou",
    "instance": "1",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Thunderbolt",
    "move2": "Shadow Ball",
    "move3": "Thunder Wave",
    "move4": "Light Screen",
    "speed": 183
  },
  {
    "entry": 912,
    "name": "RAIKOU 2",
    "species": "Raikou",
    "instance": "2",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Thunder Fang",
    "move2": "Crunch",
    "move3": "Iron Head",
    "move4": "Return",
    "speed": 183
  },
  {
    "entry": 926,
    "name": "RAIKOU 3",
    "species": "Raikou",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Thunder",
    "move2": "Extrasensory",
    "move3": "Signal Beam",
    "move4": "Rain Dance",
    "speed": 167
  },
  {
    "entry": 940,
    "name": "RAIKOU 4",
    "species": "Raikou",
    "instance": "4",
    "nature": "Modest",
    "item": "Shuca Berry",
    "move1": "Thunderbolt",
    "move2": "Extrasensory",
    "move3": "Shadow Ball",
    "move4": "Calm Mind",
    "speed": 167
  },
  {
    "entry": 430,
    "name": "RAMPARDOS 1",
    "species": "Rampardos",
    "instance": "1",
    "nature": "Adamant",
    "item": "Toxic Orb",
    "move1": "Rock Slide",
    "move2": "Facade",
    "move3": "Crunch",
    "move4": "Screech",
    "speed": 78
  },
  {
    "entry": 566,
    "name": "RAMPARDOS 2",
    "species": "Rampardos",
    "instance": "2",
    "nature": "Brave",
    "item": "Iron Ball",
    "move1": "Stone Edge",
    "move2": "Payback",
    "move3": "Avalanche",
    "move4": "Fling",
    "speed": 70
  },
  {
    "entry": 702,
    "name": "RAMPARDOS 3",
    "species": "Rampardos",
    "instance": "3",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Head Smash",
    "move2": "Zen Headbutt",
    "move3": "Fire Punch",
    "move4": "ThunderPunch",
    "speed": 78
  },
  {
    "entry": 838,
    "name": "RAMPARDOS 4",
    "species": "Rampardos",
    "instance": "4",
    "nature": "Jolly",
    "item": "Choice Scarf",
    "move1": "Head Smash",
    "move2": "Earthquake",
    "move3": "Giga Impact",
    "move4": "Superpower",
    "speed": 121
  },
  {
    "entry": 417,
    "name": "RAPIDASH 1",
    "species": "Rapidash",
    "instance": "1",
    "nature": "Modest",
    "item": "Chesto Berry",
    "move1": "Fire Blast",
    "move2": "SolarBeam",
    "move3": "Sunny Day",
    "move4": "Rest",
    "speed": 157
  },
  {
    "entry": 553,
    "name": "RAPIDASH 2",
    "species": "Rapidash",
    "instance": "2",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "SolarBeam",
    "move3": "Swift",
    "move4": "Sunny Day",
    "speed": 157
  },
  {
    "entry": 689,
    "name": "RAPIDASH 3",
    "species": "Rapidash",
    "instance": "3",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Flare Blitz",
    "move2": "Poison Jab",
    "move3": "Iron Tail",
    "move4": "Horn Drill",
    "speed": 157
  },
  {
    "entry": 825,
    "name": "RAPIDASH 4",
    "species": "Rapidash",
    "instance": "4",
    "nature": "Jolly",
    "item": "Chesto Berry",
    "move1": "Flare Blitz",
    "move2": "Megahorn",
    "move3": "Double-Edge",
    "move4": "Hypnosis",
    "speed": 172
  },
  {
    "entry": 902,
    "name": "REGICE 1",
    "species": "Regice",
    "instance": "1",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Ice Beam",
    "move2": "Signal Beam",
    "move3": "Charge Beam",
    "move4": "Amnesia",
    "speed": 70
  },
  {
    "entry": 916,
    "name": "REGICE 2",
    "species": "Regice",
    "instance": "2",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Avalanche",
    "move2": "Hammer Arm",
    "move3": "Double Team",
    "move4": "Curse",
    "speed": 70
  },
  {
    "entry": 930,
    "name": "REGICE 3",
    "species": "Regice",
    "instance": "3",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Ice Beam",
    "move2": "Flash Cannon",
    "move3": "AncientPower",
    "move4": "Rest",
    "speed": 70
  },
  {
    "entry": 944,
    "name": "REGICE 4",
    "species": "Regice",
    "instance": "4",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Ice Beam",
    "move2": "Thunderbolt",
    "move3": "Hyper Beam",
    "move4": "Focus Blast",
    "speed": 70
  },
  {
    "entry": 908,
    "name": "REGIGIGAS 1",
    "species": "Regigigas",
    "instance": "1",
    "nature": "Impish",
    "item": "Lax Incense",
    "move1": "Return",
    "move2": "Aerial Ace",
    "move3": "Thunder Wave",
    "move4": "Confuse Ray",
    "speed": 60
  },
  {
    "entry": 922,
    "name": "REGIGIGAS 2",
    "species": "Regigigas",
    "instance": "2",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Facade",
    "move2": "Zen Headbutt",
    "move3": "Double Team",
    "move4": "Substitute",
    "speed": 60
  },
  {
    "entry": 936,
    "name": "REGIGIGAS 3",
    "species": "Regigigas",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Earth Power",
    "move2": "Focus Blast",
    "move3": "Thunderbolt",
    "move4": "AncientPower",
    "speed": 60
  },
  {
    "entry": 950,
    "name": "REGIGIGAS 4",
    "species": "Regigigas",
    "instance": "4",
    "nature": "Adamant",
    "item": "BrightPowder",
    "move1": "Crush Grip",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Drain Punch",
    "speed": 60
  },
  {
    "entry": 901,
    "name": "REGIROCK 1",
    "species": "Regirock",
    "instance": "1",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Rock Slide",
    "move2": "Earthquake",
    "move3": "Brick Break",
    "move4": "Sandstorm",
    "speed": 70
  },
  {
    "entry": 915,
    "name": "REGIROCK 2",
    "species": "Regirock",
    "instance": "2",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Fire Punch",
    "move2": "ThunderPunch",
    "move3": "Ice Punch",
    "move4": "Drain Punch",
    "speed": 70
  },
  {
    "entry": 929,
    "name": "REGIROCK 3",
    "species": "Regirock",
    "instance": "3",
    "nature": "Careful",
    "item": "Chesto Berry",
    "move1": "Stone Edge",
    "move2": "Hammer Arm",
    "move3": "Rest",
    "move4": "Curse",
    "speed": 70
  },
  {
    "entry": 943,
    "name": "REGIROCK 4",
    "species": "Regirock",
    "instance": "4",
    "nature": "Careful",
    "item": "Quick Claw",
    "move1": "Stone Edge",
    "move2": "Earthquake",
    "move3": "Hammer Arm",
    "move4": "Explosion",
    "speed": 70
  },
  {
    "entry": 903,
    "name": "REGISTEEL 1",
    "species": "Registeel",
    "instance": "1",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Flash Cannon",
    "move2": "Thunderbolt",
    "move3": "Thunder Wave",
    "move4": "Amnesia",
    "speed": 70
  },
  {
    "entry": 917,
    "name": "REGISTEEL 2",
    "species": "Registeel",
    "instance": "2",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Iron Head",
    "move2": "Toxic",
    "move3": "Double Team",
    "move4": "Iron Defense",
    "speed": 70
  },
  {
    "entry": 931,
    "name": "REGISTEEL 3",
    "species": "Registeel",
    "instance": "3",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Shadow Claw",
    "move2": "Aerial Ace",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 70
  },
  {
    "entry": 945,
    "name": "REGISTEEL 4",
    "species": "Registeel",
    "instance": "4",
    "nature": "Adamant",
    "item": "Shell Bell",
    "move1": "Iron Head",
    "move2": "Hammer Arm",
    "move3": "Earthquake",
    "move4": "Curse",
    "speed": 70
  },
  {
    "entry": 344,
    "name": "RELICANTH 2",
    "species": "Relicanth",
    "instance": "2",
    "nature": "Impish",
    "item": "Chesto Berry",
    "move1": "Aqua Tail",
    "move2": "Rock Slide",
    "move3": "Rest",
    "move4": "Yawn",
    "speed": 75
  },
  {
    "entry": 396,
    "name": "RHYDON 1",
    "species": "Rhydon",
    "instance": "1",
    "nature": "Adamant",
    "item": "Passho Berry",
    "move1": "Earthquake",
    "move2": "Rock Slide",
    "move3": "Crunch",
    "move4": "Scary Face",
    "speed": 60
  },
  {
    "entry": 532,
    "name": "RHYDON 2",
    "species": "Rhydon",
    "instance": "2",
    "nature": "Adamant",
    "item": "Focus Sash",
    "move1": "Earthquake",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 60
  },
  {
    "entry": 668,
    "name": "RHYDON 3",
    "species": "Rhydon",
    "instance": "3",
    "nature": "Brave",
    "item": "Persim Berry",
    "move1": "Outrage",
    "move2": "Hammer Arm",
    "move3": "Shadow Claw",
    "move4": "Avalanche",
    "speed": 54
  },
  {
    "entry": 804,
    "name": "RHYDON 4",
    "species": "Rhydon",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Earthquake",
    "move2": "Stone Edge",
    "move3": "Megahorn",
    "move4": "Horn Drill",
    "speed": 60
  },
  {
    "entry": 469,
    "name": "RHYPERIOR 1",
    "species": "Rhyperior",
    "instance": "1",
    "nature": "Adamant",
    "item": "Focus Band",
    "move1": "Rock Wrecker",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Roar",
    "speed": 60
  },
  {
    "entry": 605,
    "name": "RHYPERIOR 2",
    "species": "Rhyperior",
    "instance": "2",
    "nature": "Adamant",
    "item": "Expert Belt",
    "move1": "Fire Punch",
    "move2": "ThunderPunch",
    "move3": "Ice Punch",
    "move4": "Aqua Tail",
    "speed": 60
  },
  {
    "entry": 741,
    "name": "RHYPERIOR 3",
    "species": "Rhyperior",
    "instance": "3",
    "nature": "Impish",
    "item": "Focus Sash",
    "move1": "Horn Drill",
    "move2": "Avalanche",
    "move3": "Payback",
    "move4": "Counter",
    "speed": 60
  },
  {
    "entry": 877,
    "name": "RHYPERIOR 4",
    "species": "Rhyperior",
    "instance": "4",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Rock Wrecker",
    "move2": "Earthquake",
    "move3": "Hammer Arm",
    "move4": "Megahorn",
    "speed": 60
  },
  {
    "entry": 437,
    "name": "ROSERADE 1",
    "species": "Roserade",
    "instance": "1",
    "nature": "Calm",
    "item": "Coba Berry",
    "move1": "Sludge Bomb",
    "move2": "Magical Leaf",
    "move3": "Stun Spore",
    "move4": "Mud-Slap",
    "speed": 110
  },
  {
    "entry": 573,
    "name": "ROSERADE 2",
    "species": "Roserade",
    "instance": "2",
    "nature": "Calm",
    "item": "Big Root",
    "move1": "Giga Drain",
    "move2": "Leech Seed",
    "move3": "Ingrain",
    "move4": "Synthesis",
    "speed": 110
  },
  {
    "entry": 709,
    "name": "ROSERADE 3",
    "species": "Roserade",
    "instance": "3",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Leaf Storm",
    "move2": "Sludge Bomb",
    "move3": "Hyper Beam",
    "move4": "GrassWhistle",
    "speed": 142
  },
  {
    "entry": 845,
    "name": "ROSERADE 4",
    "species": "Roserade",
    "instance": "4",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Leaf Storm",
    "move2": "Sludge Bomb",
    "move3": "Shadow Ball",
    "move4": "Weather Ball",
    "speed": 142
  },
  {
    "entry": 483,
    "name": "SALAMENCE 1",
    "species": "Salamence",
    "instance": "1",
    "nature": "Adamant",
    "item": "Cheri Berry",
    "move1": "Dragon Claw",
    "move2": "Aerial Ace",
    "move3": "Aqua Tail",
    "move4": "Scary Face",
    "speed": 152
  },
  {
    "entry": 619,
    "name": "SALAMENCE 2",
    "species": "Salamence",
    "instance": "2",
    "nature": "Jolly",
    "item": "Razor Fang",
    "move1": "Dragon Claw",
    "move2": "Fire Fang",
    "move3": "Thunder Fang",
    "move4": "Dragon Dance",
    "speed": 167
  },
  {
    "entry": 755,
    "name": "SALAMENCE 3",
    "species": "Salamence",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Draco Meteor",
    "move2": "Hydro Pump",
    "move3": "Flamethrower",
    "move4": "Ominous Wind",
    "speed": 152
  },
  {
    "entry": 891,
    "name": "SALAMENCE 4",
    "species": "Salamence",
    "instance": "4",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Outrage",
    "move2": "Crunch",
    "move3": "Earthquake",
    "move4": "Zen Headbutt",
    "speed": 152
  },
  {
    "entry": 357,
    "name": "SCEPTILE 1",
    "species": "Sceptile",
    "instance": "1",
    "nature": "Jolly",
    "item": "Liechi Berry",
    "move1": "Leaf Blade",
    "move2": "Crunch",
    "move3": "Quick Attack",
    "move4": "Screech",
    "speed": 189
  },
  {
    "entry": 493,
    "name": "SCEPTILE 2",
    "species": "Sceptile",
    "instance": "2",
    "nature": "Timid",
    "item": "Leftovers",
    "move1": "Giga Drain",
    "move2": "Leech Seed",
    "move3": "Toxic",
    "move4": "Double Team",
    "speed": 189
  },
  {
    "entry": 629,
    "name": "SCEPTILE 3",
    "species": "Sceptile",
    "instance": "3",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Leaf Blade",
    "move2": "X-Scissor",
    "move3": "Night Slash",
    "move4": "Aerial Ace",
    "speed": 172
  },
  {
    "entry": 765,
    "name": "SCEPTILE 4",
    "species": "Sceptile",
    "instance": "4",
    "nature": "Timid",
    "item": "Occa Berry",
    "move1": "Leaf Storm",
    "move2": "Dragon Pulse",
    "move3": "Focus Blast",
    "move4": "Hyper Beam",
    "speed": 189
  },
  {
    "entry": 423,
    "name": "SCIZOR 1",
    "species": "Scizor",
    "instance": "1",
    "nature": "Impish",
    "item": "BrightPowder",
    "move1": "X-Scissor",
    "move2": "Bullet Punch",
    "move3": "Swords Dance",
    "move4": "Baton Pass",
    "speed": 85
  },
  {
    "entry": 559,
    "name": "SCIZOR 2",
    "species": "Scizor",
    "instance": "2",
    "nature": "Careful",
    "item": "Sitrus Berry",
    "move1": "Metal Claw",
    "move2": "Night Slash",
    "move3": "Iron Defense",
    "move4": "Roost",
    "speed": 85
  },
  {
    "entry": 695,
    "name": "SCIZOR 3",
    "species": "Scizor",
    "instance": "3",
    "nature": "Jolly",
    "item": "Salac Berry",
    "move1": "X-Scissor",
    "move2": "Quick Attack",
    "move3": "Reversal",
    "move4": "Endure",
    "speed": 128
  },
  {
    "entry": 831,
    "name": "SCIZOR 4",
    "species": "Scizor",
    "instance": "4",
    "nature": "Adamant",
    "item": "Occa Berry",
    "move1": "X-Scissor",
    "move2": "Iron Head",
    "move3": "Aerial Ace",
    "move4": "Night Slash",
    "speed": 85
  },
  {
    "entry": 324,
    "name": "SHARPEDO 2",
    "species": "Sharpedo",
    "instance": "2",
    "nature": "Adamant",
    "item": "Wacan Berry",
    "move1": "Crunch",
    "move2": "Waterfall",
    "move3": "Ice Fang",
    "move4": "Swagger",
    "speed": 147
  },
  {
    "entry": 388,
    "name": "SHIFTRY 1",
    "species": "Shiftry",
    "instance": "1",
    "nature": "Jolly",
    "item": "Persim Berry",
    "move1": "Seed Bomb",
    "move2": "Faint Attack",
    "move3": "X-Scissor",
    "move4": "Fake Out",
    "speed": 145
  },
  {
    "entry": 524,
    "name": "SHIFTRY 2",
    "species": "Shiftry",
    "instance": "2",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Giga Drain",
    "move2": "Leech Seed",
    "move3": "Double Team",
    "move4": "Synthesis",
    "speed": 100
  },
  {
    "entry": 660,
    "name": "SHIFTRY 3",
    "species": "Shiftry",
    "instance": "3",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Leaf Storm",
    "move2": "Dark Pulse",
    "move3": "Focus Blast",
    "move4": "Shadow Ball",
    "speed": 100
  },
  {
    "entry": 796,
    "name": "SHIFTRY 4",
    "species": "Shiftry",
    "instance": "4",
    "nature": "Adamant",
    "item": "Cheri Berry",
    "move1": "Seed Bomb",
    "move2": "Sucker Punch",
    "move3": "Aerial Ace",
    "move4": "Explosion",
    "speed": 100
  },
  {
    "entry": 436,
    "name": "SHUCKLE 1",
    "species": "Shuckle",
    "instance": "1",
    "nature": "Impish",
    "item": "Lax Incense",
    "move1": "Stone Edge",
    "move2": "Bug Bite",
    "move3": "Swagger",
    "move4": "Power Trick",
    "speed": 25
  },
  {
    "entry": 572,
    "name": "SHUCKLE 2",
    "species": "Shuckle",
    "instance": "2",
    "nature": "Careful",
    "item": "Grip Claw",
    "move1": "Wrap",
    "move2": "Swagger",
    "move3": "Attract",
    "move4": "Toxic",
    "speed": 25
  },
  {
    "entry": 708,
    "name": "SHUCKLE 3",
    "species": "Shuckle",
    "instance": "3",
    "nature": "Impish",
    "item": "Lax Incense",
    "move1": "Gyro Ball",
    "move2": "Substitute",
    "move3": "Double Team",
    "move4": "Power Trick",
    "speed": 25
  },
  {
    "entry": 844,
    "name": "SHUCKLE 4",
    "species": "Shuckle",
    "instance": "4",
    "nature": "Calm",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Substitute",
    "move3": "Double Team",
    "move4": "Sandstorm",
    "speed": 25
  },
  {
    "entry": 373,
    "name": "SKARMORY 1",
    "species": "Skarmory",
    "instance": "1",
    "nature": "Impish",
    "item": "Occa Berry",
    "move1": "Drill Peck",
    "move2": "Steel Wing",
    "move3": "Spikes",
    "move4": "Roar",
    "speed": 90
  },
  {
    "entry": 509,
    "name": "SKARMORY 2",
    "species": "Skarmory",
    "instance": "2",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Fly",
    "move2": "Toxic",
    "move3": "Double Team",
    "move4": "Roost",
    "speed": 90
  },
  {
    "entry": 645,
    "name": "SKARMORY 3",
    "species": "Skarmory",
    "instance": "3",
    "nature": "Impish",
    "item": "Razor Claw",
    "move1": "Drill Peck",
    "move2": "Slash",
    "move3": "Payback",
    "move4": "Night Slash",
    "speed": 90
  },
  {
    "entry": 781,
    "name": "SKARMORY 4",
    "species": "Skarmory",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Brave Bird",
    "move2": "Steel Wing",
    "move3": "X-Scissor",
    "move4": "Rock Slide",
    "speed": 90
  },
  {
    "entry": 383,
    "name": "SKUNTANK 1",
    "species": "Skuntank",
    "instance": "1",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Sucker Punch",
    "move2": "Poison Jab",
    "move3": "Slash",
    "move4": "Screech",
    "speed": 104
  },
  {
    "entry": 519,
    "name": "SKUNTANK 2",
    "species": "Skuntank",
    "instance": "2",
    "nature": "Jolly",
    "item": "Chesto Berry",
    "move1": "Crunch",
    "move2": "Toxic",
    "move3": "Swagger",
    "move4": "Double Team",
    "speed": 149
  },
  {
    "entry": 655,
    "name": "SKUNTANK 3",
    "species": "Skuntank",
    "instance": "3",
    "nature": "Timid",
    "item": "Shuca Berry",
    "move1": "Sludge Bomb",
    "move2": "Dark Pulse",
    "move3": "Flamethrower",
    "move4": "Shadow Ball",
    "speed": 149
  },
  {
    "entry": 791,
    "name": "SKUNTANK 4",
    "species": "Skuntank",
    "instance": "4",
    "nature": "Jolly",
    "item": "Muscle Band",
    "move1": "Poison Jab",
    "move2": "Night Slash",
    "move3": "Crunch",
    "move4": "Explosion",
    "speed": 149
  },
  {
    "entry": 486,
    "name": "SLAKING 1",
    "species": "Slaking",
    "instance": "1",
    "nature": "Impish",
    "item": "Lax Incense",
    "move1": "Facade",
    "move2": "Shadow Claw",
    "move3": "Slack Off",
    "move4": "Yawn",
    "speed": 120
  },
  {
    "entry": 622,
    "name": "SLAKING 2",
    "species": "Slaking",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Crush Claw",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 120
  },
  {
    "entry": 758,
    "name": "SLAKING 3",
    "species": "Slaking",
    "instance": "3",
    "nature": "Jolly",
    "item": "Life Orb",
    "move1": "Return",
    "move2": "Night Slash",
    "move3": "Gunk Shot",
    "move4": "Aerial Ace",
    "speed": 167
  },
  {
    "entry": 894,
    "name": "SLAKING 4",
    "species": "Slaking",
    "instance": "4",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Giga Impact",
    "move2": "Earthquake",
    "move3": "Hammer Arm",
    "move4": "Shadow Claw",
    "speed": 120
  },
  {
    "entry": 397,
    "name": "SLOWBRO 1",
    "species": "Slowbro",
    "instance": "1",
    "nature": "Bold",
    "item": "Chesto Berry",
    "move1": "Psychic",
    "move2": "Surf",
    "move3": "Calm Mind",
    "move4": "Yawn",
    "speed": 50
  },
  {
    "entry": 533,
    "name": "SLOWBRO 2",
    "species": "Slowbro",
    "instance": "2",
    "nature": "Adamant",
    "item": "Expert Belt",
    "move1": "Zen Headbutt",
    "move2": "Aqua Tail",
    "move3": "Earthquake",
    "move4": "Avalanche",
    "speed": 50
  },
  {
    "entry": 669,
    "name": "SLOWBRO 3",
    "species": "Slowbro",
    "instance": "3",
    "nature": "Modest",
    "item": "Choice Specs",
    "move1": "Psychic",
    "move2": "Flamethrower",
    "move3": "Shadow Ball",
    "move4": "Signal Beam",
    "speed": 50
  },
  {
    "entry": 805,
    "name": "SLOWBRO 4",
    "species": "Slowbro",
    "instance": "4",
    "nature": "Quiet",
    "item": "Leftovers",
    "move1": "Psychic",
    "move2": "Surf",
    "move3": "Ice Beam",
    "move4": "Trick Room",
    "speed": 45
  },
  {
    "entry": 402,
    "name": "SLOWKING 1",
    "species": "Slowking",
    "instance": "1",
    "nature": "Quiet",
    "item": "Shell Bell",
    "move1": "Psychic",
    "move2": "Brine",
    "move3": "Yawn",
    "move4": "Trick Room",
    "speed": 45
  },
  {
    "entry": 538,
    "name": "SLOWKING 2",
    "species": "Slowking",
    "instance": "2",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Zen Headbutt",
    "move2": "Aqua Tail",
    "move3": "Earthquake",
    "move4": "Curse",
    "speed": 50
  },
  {
    "entry": 674,
    "name": "SLOWKING 3",
    "species": "Slowking",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Psychic",
    "move2": "Shadow Ball",
    "move3": "Signal Beam",
    "move4": "Focus Blast",
    "speed": 50
  },
  {
    "entry": 810,
    "name": "SLOWKING 4",
    "species": "Slowking",
    "instance": "4",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Psychic",
    "move2": "Surf",
    "move3": "Ice Beam",
    "move4": "Flamethrower",
    "speed": 50
  },
  {
    "entry": 473,
    "name": "SNORLAX 1",
    "species": "Snorlax",
    "instance": "1",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Return",
    "move2": "Rock Slide",
    "move3": "Curse",
    "move4": "Yawn",
    "speed": 50
  },
  {
    "entry": 609,
    "name": "SNORLAX 2",
    "species": "Snorlax",
    "instance": "2",
    "nature": "Adamant",
    "item": "Chesto Berry",
    "move1": "Fire Punch",
    "move2": "ThunderPunch",
    "move3": "Ice Punch",
    "move4": "Rest",
    "speed": 50
  },
  {
    "entry": 745,
    "name": "SNORLAX 3",
    "species": "Snorlax",
    "instance": "3",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Outrage",
    "move2": "Superpower",
    "move3": "Gunk Shot",
    "move4": "Seed Bomb",
    "speed": 50
  },
  {
    "entry": 881,
    "name": "SNORLAX 4",
    "species": "Snorlax",
    "instance": "4",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Double-Edge",
    "move2": "Earthquake",
    "move3": "Zen Headbutt",
    "move4": "Crunch",
    "speed": 50
  },
  {
    "entry": 299,
    "name": "SOLROCK 2",
    "species": "Solrock",
    "instance": "2",
    "nature": "Adamant",
    "item": "Passho Berry",
    "move1": "Zen Headbutt",
    "move2": "Rock Slide",
    "move3": "Will-O-Wisp",
    "move4": "Cosmic Power",
    "speed": 90
  },
  {
    "entry": 381,
    "name": "STARAPTOR 1",
    "species": "Staraptor",
    "instance": "1",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Return",
    "move2": "Aerial Ace",
    "move3": "Double Team",
    "move4": "Roost",
    "speed": 167
  },
  {
    "entry": 517,
    "name": "STARAPTOR 2",
    "species": "Staraptor",
    "instance": "2",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Endeavor",
    "move2": "Aerial Ace",
    "move3": "Endure",
    "move4": "Quick Attack",
    "speed": 167
  },
  {
    "entry": 653,
    "name": "STARAPTOR 3",
    "species": "Staraptor",
    "instance": "3",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Brave Bird",
    "move2": "Return",
    "move3": "Steel Wing",
    "move4": "Pursuit",
    "speed": 152
  },
  {
    "entry": 789,
    "name": "STARAPTOR 4",
    "species": "Staraptor",
    "instance": "4",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Brave Bird",
    "move2": "Giga Impact",
    "move3": "Close Combat",
    "move4": "U-turn",
    "speed": 152
  },
  {
    "entry": 450,
    "name": "STARMIE 1",
    "species": "Starmie",
    "instance": "1",
    "nature": "Timid",
    "item": "Lum Berry",
    "move1": "Surf",
    "move2": "Psychic",
    "move3": "Confuse Ray",
    "move4": "Thunder Wave",
    "speed": 183
  },
  {
    "entry": 586,
    "name": "STARMIE 2",
    "species": "Starmie",
    "instance": "2",
    "nature": "Timid",
    "item": "Wide Lens",
    "move1": "Hydro Pump",
    "move2": "Blizzard",
    "move3": "Thunder",
    "move4": "Recover",
    "speed": 183
  },
  {
    "entry": 722,
    "name": "STARMIE 3",
    "species": "Starmie",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Surf",
    "move2": "Psychic",
    "move3": "Power Gem",
    "move4": "Signal Beam",
    "speed": 167
  },
  {
    "entry": 858,
    "name": "STARMIE 4",
    "species": "Starmie",
    "instance": "4",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Surf",
    "move2": "Psychic",
    "move3": "Thunderbolt",
    "move4": "Ice Beam",
    "speed": 167
  },
  {
    "entry": 439,
    "name": "STEELIX 1",
    "species": "Steelix",
    "instance": "1",
    "nature": "Impish",
    "item": "Passho Berry",
    "move1": "Earthquake",
    "move2": "Iron Head",
    "move3": "Crunch",
    "move4": "Sandstorm",
    "speed": 50
  },
  {
    "entry": 575,
    "name": "STEELIX 2",
    "species": "Steelix",
    "instance": "2",
    "nature": "Adamant",
    "item": "Shuca Berry",
    "move1": "Earthquake",
    "move2": "Fire Fang",
    "move3": "Thunder Fang",
    "move4": "Ice Fang",
    "speed": 50
  },
  {
    "entry": 711,
    "name": "STEELIX 3",
    "species": "Steelix",
    "instance": "3",
    "nature": "Relaxed",
    "item": "Iron Ball",
    "move1": "Gyro Ball",
    "move2": "Payback",
    "move3": "Swagger",
    "move4": "Curse",
    "speed": 45
  },
  {
    "entry": 847,
    "name": "STEELIX 4",
    "species": "Steelix",
    "instance": "4",
    "nature": "Brave",
    "item": "Quick Claw",
    "move1": "Gyro Ball",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Explosion",
    "speed": 45
  },
  {
    "entry": 263,
    "name": "SUDOWOODO 2",
    "species": "Sudowoodo",
    "instance": "2",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Stone Edge",
    "move2": "Earthquake",
    "move3": "Mimic",
    "move4": "Selfdestruct",
    "speed": 50
  },
  {
    "entry": 900,
    "name": "SUICUNE 1",
    "species": "Suicune",
    "instance": "1",
    "nature": "Calm",
    "item": "Focus Sash",
    "move1": "Surf",
    "move2": "Icy Wind",
    "move3": "Ominous Wind",
    "move4": "Mirror Coat",
    "speed": 105
  },
  {
    "entry": 914,
    "name": "SUICUNE 2",
    "species": "Suicune",
    "instance": "2",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Waterfall",
    "move2": "Ice Fang",
    "move3": "Iron Head",
    "move4": "Bite",
    "speed": 150
  },
  {
    "entry": 928,
    "name": "SUICUNE 3",
    "species": "Suicune",
    "instance": "3",
    "nature": "Bold",
    "item": "Lum Berry",
    "move1": "Hydro Pump",
    "move2": "Blizzard",
    "move3": "Shadow Ball",
    "move4": "Hail",
    "speed": 105
  },
  {
    "entry": 942,
    "name": "SUICUNE 4",
    "species": "Suicune",
    "instance": "4",
    "nature": "Modest",
    "item": "Wacan Berry",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Extrasensory",
    "move4": "Calm Mind",
    "speed": 105
  },
  {
    "entry": 359,
    "name": "SWAMPERT 1",
    "species": "Swampert",
    "instance": "1",
    "nature": "Adamant",
    "item": "Shell Bell",
    "move1": "Waterfall",
    "move2": "Earthquake",
    "move3": "Ice Punch",
    "move4": "Protect",
    "speed": 80
  },
  {
    "entry": 495,
    "name": "SWAMPERT 2",
    "species": "Swampert",
    "instance": "2",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Aqua Tail",
    "move2": "Earthquake",
    "move3": "Hammer Arm",
    "move4": "Curse",
    "speed": 80
  },
  {
    "entry": 631,
    "name": "SWAMPERT 3",
    "species": "Swampert",
    "instance": "3",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Muddy Water",
    "move2": "Earth Power",
    "move3": "Ice Beam",
    "move4": "Counter",
    "speed": 80
  },
  {
    "entry": 767,
    "name": "SWAMPERT 4",
    "species": "Swampert",
    "instance": "4",
    "nature": "Adamant",
    "item": "Rindo Berry",
    "move1": "Earthquake",
    "move2": "Aqua Tail",
    "move3": "Avalanche",
    "move4": "Mirror Coat",
    "speed": 80
  },
  {
    "entry": 470,
    "name": "TANGROWTH 1",
    "species": "Tangrowth",
    "instance": "1",
    "nature": "Modest",
    "item": "Coba Berry",
    "move1": "Energy Ball",
    "move2": "Sludge Bomb",
    "move3": "Focus Blast",
    "move4": "Sleep Powder",
    "speed": 70
  },
  {
    "entry": 606,
    "name": "TANGROWTH 2",
    "species": "Tangrowth",
    "instance": "2",
    "nature": "Bold",
    "item": "Big Root",
    "move1": "Giga Drain",
    "move2": "Leech Seed",
    "move3": "Toxic",
    "move4": "Double Team",
    "speed": 70
  },
  {
    "entry": 742,
    "name": "TANGROWTH 3",
    "species": "Tangrowth",
    "instance": "3",
    "nature": "Modest",
    "item": "Heat Rock",
    "move1": "SolarBeam",
    "move2": "Wring Out",
    "move3": "Synthesis",
    "move4": "Sunny Day",
    "speed": 70
  },
  {
    "entry": 878,
    "name": "TANGROWTH 4",
    "species": "Tangrowth",
    "instance": "4",
    "nature": "Adamant",
    "item": "Lax Incense",
    "move1": "Power Whip",
    "move2": "Earthquake",
    "move3": "Aerial Ace",
    "move4": "Brick Break",
    "speed": 70
  },
  {
    "entry": 400,
    "name": "TAUROS 1",
    "species": "Tauros",
    "instance": "1",
    "nature": "Jolly",
    "item": "Persim Berry",
    "move1": "Thrash",
    "move2": "Zen Headbutt",
    "move3": "Pursuit",
    "move4": "Scary Face",
    "speed": 178
  },
  {
    "entry": 536,
    "name": "TAUROS 2",
    "species": "Tauros",
    "instance": "2",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Facade",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Payback",
    "speed": 162
  },
  {
    "entry": 672,
    "name": "TAUROS 3",
    "species": "Tauros",
    "instance": "3",
    "nature": "Jolly",
    "item": "Lum Berry",
    "move1": "Giga Impact",
    "move2": "Earthquake",
    "move3": "Outrage",
    "move4": "Iron Tail",
    "speed": 178
  },
  {
    "entry": 808,
    "name": "TAUROS 4",
    "species": "Tauros",
    "instance": "4",
    "nature": "Adamant",
    "item": "Choice Band",
    "move1": "Return",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Zen Headbutt",
    "speed": 162
  },
  {
    "entry": 442,
    "name": "TENTACRUEL 1",
    "species": "Tentacruel",
    "instance": "1",
    "nature": "Timid",
    "item": "Wacan Berry",
    "move1": "Surf",
    "move2": "Sludge Bomb",
    "move3": "Icy Wind",
    "move4": "Barrier",
    "speed": 167
  },
  {
    "entry": 578,
    "name": "TENTACRUEL 2",
    "species": "Tentacruel",
    "instance": "2",
    "nature": "Calm",
    "item": "Black Sludge",
    "move1": "Toxic",
    "move2": "Giga Drain",
    "move3": "Attract",
    "move4": "Confuse Ray",
    "speed": 120
  },
  {
    "entry": 714,
    "name": "TENTACRUEL 3",
    "species": "Tentacruel",
    "instance": "3",
    "nature": "Modest",
    "item": "Focus Sash",
    "move1": "Surf",
    "move2": "Sludge Bomb",
    "move3": "Giga Drain",
    "move4": "Mirror Coat",
    "speed": 120
  },
  {
    "entry": 850,
    "name": "TENTACRUEL 4",
    "species": "Tentacruel",
    "instance": "4",
    "nature": "Timid",
    "item": "Scope Lens",
    "move1": "Hydro Pump",
    "move2": "Sludge Bomb",
    "move3": "Ice Beam",
    "move4": "Wring Out",
    "speed": 167
  },
  {
    "entry": 479,
    "name": "TOGEKISS 1",
    "species": "Togekiss",
    "instance": "1",
    "nature": "Adamant",
    "item": "Power Herb",
    "move1": "Sky Attack",
    "move2": "ExtremeSpeed",
    "move3": "Drain Punch",
    "move4": "Roost",
    "speed": 100
  },
  {
    "entry": 615,
    "name": "TOGEKISS 2",
    "species": "Togekiss",
    "instance": "2",
    "nature": "Modest",
    "item": "Scope Lens",
    "move1": "Air Slash",
    "move2": "Ominous Wind",
    "move3": "Silver Wind",
    "move4": "AncientPower",
    "speed": 100
  },
  {
    "entry": 751,
    "name": "TOGEKISS 3",
    "species": "Togekiss",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Air Slash",
    "move2": "Heat Wave",
    "move3": "Signal Beam",
    "move4": "Magical Leaf",
    "speed": 132
  },
  {
    "entry": 887,
    "name": "TOGEKISS 4",
    "species": "Togekiss",
    "instance": "4",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Hyper Beam",
    "move2": "Air Slash",
    "move3": "Aura Sphere",
    "move4": "Psychic",
    "speed": 132
  },
  {
    "entry": 360,
    "name": "TORTERRA 1",
    "species": "Torterra",
    "instance": "1",
    "nature": "Adamant",
    "item": "Yache Berry",
    "move1": "Earthquake",
    "move2": "Grass Knot",
    "move3": "Rock Slide",
    "move4": "Curse",
    "speed": 76
  },
  {
    "entry": 496,
    "name": "TORTERRA 2",
    "species": "Torterra",
    "instance": "2",
    "nature": "Sassy",
    "item": "Leftovers",
    "move1": "Giga Drain",
    "move2": "Leech Seed",
    "move3": "Synthesis",
    "move4": "Amnesia",
    "speed": 68
  },
  {
    "entry": 632,
    "name": "TORTERRA 3",
    "species": "Torterra",
    "instance": "3",
    "nature": "Modest",
    "item": "Lax Incense",
    "move1": "Frenzy Plant",
    "move2": "Earth Power",
    "move3": "Hyper Beam",
    "move4": "Leech Seed",
    "speed": 76
  },
  {
    "entry": 768,
    "name": "TORTERRA 4",
    "species": "Torterra",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Wood Hammer",
    "move2": "Earthquake",
    "move3": "Stone Edge",
    "move4": "Crunch",
    "speed": 76
  },
  {
    "entry": 405,
    "name": "TOXICROAK 1",
    "species": "Toxicroak",
    "instance": "1",
    "nature": "Adamant",
    "item": "Black Sludge",
    "move1": "Poison Jab",
    "move2": "Brick Break",
    "move3": "X-Scissor",
    "move4": "Knock Off",
    "speed": 137
  },
  {
    "entry": 541,
    "name": "TOXICROAK 2",
    "species": "Toxicroak",
    "instance": "2",
    "nature": "Adamant",
    "item": "Wide Lens",
    "move1": "DynamicPunch",
    "move2": "Poison Jab",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 137
  },
  {
    "entry": 677,
    "name": "TOXICROAK 3",
    "species": "Toxicroak",
    "instance": "3",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Sludge Bomb",
    "move2": "Focus Blast",
    "move3": "Shadow Ball",
    "move4": "Dark Pulse",
    "speed": 137
  },
  {
    "entry": 813,
    "name": "TOXICROAK 4",
    "species": "Toxicroak",
    "instance": "4",
    "nature": "Adamant",
    "item": "Razor Claw",
    "move1": "Gunk Shot",
    "move2": "Cross Chop",
    "move3": "Earthquake",
    "move4": "Stone Edge",
    "speed": 137
  },
  {
    "entry": 355,
    "name": "TYPHLOSION 1",
    "species": "Typhlosion",
    "instance": "1",
    "nature": "Adamant",
    "item": "Scope Lens",
    "move1": "Fire Punch",
    "move2": "ThunderPunch",
    "move3": "Shadow Claw",
    "move4": "Quick Attack",
    "speed": 152
  },
  {
    "entry": 491,
    "name": "TYPHLOSION 2",
    "species": "Typhlosion",
    "instance": "2",
    "nature": "Serious",
    "item": "Salac Berry",
    "move1": "Blast Burn",
    "move2": "Earthquake",
    "move3": "Reversal",
    "move4": "Endure",
    "speed": 120
  },
  {
    "entry": 627,
    "name": "TYPHLOSION 3",
    "species": "Typhlosion",
    "instance": "3",
    "nature": "Adamant",
    "item": "Shuca Berry",
    "move1": "Flare Blitz",
    "move2": "Earthquake",
    "move3": "Shadow Claw",
    "move4": "Aerial Ace",
    "speed": 152
  },
  {
    "entry": 763,
    "name": "TYPHLOSION 4",
    "species": "Typhlosion",
    "instance": "4",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Overheat",
    "move2": "SolarBeam",
    "move3": "Focus Blast",
    "move4": "Sunny Day",
    "speed": 152
  },
  {
    "entry": 482,
    "name": "TYRANITAR 1",
    "species": "Tyranitar",
    "instance": "1",
    "nature": "Brave",
    "item": "Focus Band",
    "move1": "Rock Slide",
    "move2": "Payback",
    "move3": "Avalanche",
    "move4": "Curse",
    "speed": 72
  },
  {
    "entry": 618,
    "name": "TYRANITAR 2",
    "species": "Tyranitar",
    "instance": "2",
    "nature": "Jolly",
    "item": "Choice Scarf",
    "move1": "Fire Punch",
    "move2": "ThunderPunch",
    "move3": "Ice Punch",
    "move4": "Aerial Ace",
    "speed": 124
  },
  {
    "entry": 754,
    "name": "TYRANITAR 3",
    "species": "Tyranitar",
    "instance": "3",
    "nature": "Adamant",
    "item": "White Herb",
    "move1": "Superpower",
    "move2": "Dragon Claw",
    "move3": "Shadow Claw",
    "move4": "Aqua Tail",
    "speed": 81
  },
  {
    "entry": 890,
    "name": "TYRANITAR 4",
    "species": "Tyranitar",
    "instance": "4",
    "nature": "Adamant",
    "item": "Chople Berry",
    "move1": "Stone Edge",
    "move2": "Crunch",
    "move3": "Earthquake",
    "move4": "Dragon Dance",
    "speed": 81
  },
  {
    "entry": 456,
    "name": "UMBREON 1",
    "species": "Umbreon",
    "instance": "1",
    "nature": "Careful",
    "item": "Leftovers",
    "move1": "Payback",
    "move2": "Confuse Ray",
    "move3": "Curse",
    "move4": "Baton Pass",
    "speed": 85
  },
  {
    "entry": 592,
    "name": "UMBREON 2",
    "species": "Umbreon",
    "instance": "2",
    "nature": "Impish",
    "item": "Leftovers",
    "move1": "Toxic",
    "move2": "Mean Look",
    "move3": "Double Team",
    "move4": "Confuse Ray",
    "speed": 85
  },
  {
    "entry": 728,
    "name": "UMBREON 3",
    "species": "Umbreon",
    "instance": "3",
    "nature": "Impish",
    "item": "Lax Incense",
    "move1": "Faint Attack",
    "move2": "Swagger",
    "move3": "Psych Up",
    "move4": "Screech",
    "speed": 85
  },
  {
    "entry": 864,
    "name": "UMBREON 4",
    "species": "Umbreon",
    "instance": "4",
    "nature": "Impish",
    "item": "BrightPowder",
    "move1": "Payback",
    "move2": "Trump Card",
    "move3": "Curse",
    "move4": "Moonlight",
    "speed": 85
  },
  {
    "entry": 425,
    "name": "URSARING 1",
    "species": "Ursaring",
    "instance": "1",
    "nature": "Brave",
    "item": "Focus Sash",
    "move1": "Slash",
    "move2": "Payback",
    "move3": "Avalanche",
    "move4": "Counter",
    "speed": 67
  },
  {
    "entry": 561,
    "name": "URSARING 2",
    "species": "Ursaring",
    "instance": "2",
    "nature": "Adamant",
    "item": "Life Orb",
    "move1": "Hammer Arm",
    "move2": "Fire Punch",
    "move3": "ThunderPunch",
    "move4": "Ice Punch",
    "speed": 75
  },
  {
    "entry": 697,
    "name": "URSARING 3",
    "species": "Ursaring",
    "instance": "3",
    "nature": "Adamant",
    "item": "Toxic Orb",
    "move1": "Facade",
    "move2": "Superpower",
    "move3": "Crunch",
    "move4": "Protect",
    "speed": 75
  },
  {
    "entry": 833,
    "name": "URSARING 4",
    "species": "Ursaring",
    "instance": "4",
    "nature": "Adamant",
    "item": "Quick Claw",
    "move1": "Return",
    "move2": "Cross Chop",
    "move3": "Earthquake",
    "move4": "Aerial Ace",
    "speed": 75
  },
  {
    "entry": 452,
    "name": "VAPOREON 1",
    "species": "Vaporeon",
    "instance": "1",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Acid Armor",
    "move4": "Baton Pass",
    "speed": 85
  },
  {
    "entry": 588,
    "name": "VAPOREON 2",
    "species": "Vaporeon",
    "instance": "2",
    "nature": "Modest",
    "item": "Damp Rock",
    "move1": "Hydro Pump",
    "move2": "Ice Beam",
    "move3": "Acid Armor",
    "move4": "Rain Dance",
    "speed": 85
  },
  {
    "entry": 724,
    "name": "VAPOREON 3",
    "species": "Vaporeon",
    "instance": "3",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Muddy Water",
    "move2": "Blizzard",
    "move3": "Aqua Ring",
    "move4": "Yawn",
    "speed": 85
  },
  {
    "entry": 860,
    "name": "VAPOREON 4",
    "species": "Vaporeon",
    "instance": "4",
    "nature": "Modest",
    "item": "Expert Belt",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Shadow Ball",
    "move4": "Signal Beam",
    "speed": 85
  },
  {
    "entry": 351,
    "name": "VENUSAUR 1",
    "species": "Venusaur",
    "instance": "1",
    "nature": "Modest",
    "item": "White Herb",
    "move1": "Leaf Storm",
    "move2": "Sludge Bomb",
    "move3": "Amnesia",
    "move4": "Sleep Powder",
    "speed": 100
  },
  {
    "entry": 487,
    "name": "VENUSAUR 2",
    "species": "Venusaur",
    "instance": "2",
    "nature": "Bold",
    "item": "Big Root",
    "move1": "Giga Drain",
    "move2": "Ingrain",
    "move3": "Leech Seed",
    "move4": "Sleep Powder",
    "speed": 100
  },
  {
    "entry": 623,
    "name": "VENUSAUR 3",
    "species": "Venusaur",
    "instance": "3",
    "nature": "Adamant",
    "item": "Black Sludge",
    "move1": "Seed Bomb",
    "move2": "Earthquake",
    "move3": "Outrage",
    "move4": "Curse",
    "speed": 100
  },
  {
    "entry": 759,
    "name": "VENUSAUR 4",
    "species": "Venusaur",
    "instance": "4",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Frenzy Plant",
    "move2": "Sludge Bomb",
    "move3": "Hyper Beam",
    "move4": "Synthesis",
    "speed": 100
  },
  {
    "entry": 377,
    "name": "VESPIQUEN 1",
    "species": "Vespiquen",
    "instance": "1",
    "nature": "Modest",
    "item": "Scope Lens",
    "move1": "Silver Wind",
    "move2": "Air Cutter",
    "move3": "Ominous Wind",
    "move4": "Swagger",
    "speed": 60
  },
  {
    "entry": 513,
    "name": "VESPIQUEN 2",
    "species": "Vespiquen",
    "instance": "2",
    "nature": "Careful",
    "item": "Persim Berry",
    "move1": "X-Scissor",
    "move2": "Toxic",
    "move3": "Heal Order",
    "move4": "Destiny Bond",
    "speed": 60
  },
  {
    "entry": 649,
    "name": "VESPIQUEN 3",
    "species": "Vespiquen",
    "instance": "3",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "X-Scissor",
    "move2": "Aerial Ace",
    "move3": "Pursuit",
    "move4": "U-turn",
    "speed": 60
  },
  {
    "entry": 785,
    "name": "VESPIQUEN 4",
    "species": "Vespiquen",
    "instance": "4",
    "nature": "Adamant",
    "item": "Shell Bell",
    "move1": "Attack Order",
    "move2": "Defend Order",
    "move3": "Heal Order",
    "move4": "Confuse Ray",
    "speed": 60
  },
  {
    "entry": 385,
    "name": "VICTREEBEL 1",
    "species": "Victreebel",
    "instance": "1",
    "nature": "Modest",
    "item": "Payapa Berry",
    "move1": "Leaf Storm",
    "move2": "Sludge Bomb",
    "move3": "Sleep Powder",
    "move4": "Gastro Acid",
    "speed": 90
  },
  {
    "entry": 521,
    "name": "VICTREEBEL 2",
    "species": "Victreebel",
    "instance": "2",
    "nature": "Adamant",
    "item": "Black Sludge",
    "move1": "Seed Bomb",
    "move2": "Spit Up",
    "move3": "Swallow",
    "move4": "Stockpile",
    "speed": 90
  },
  {
    "entry": 657,
    "name": "VICTREEBEL 3",
    "species": "Victreebel",
    "instance": "3",
    "nature": "Modest",
    "item": "Power Herb",
    "move1": "Sludge Bomb",
    "move2": "SolarBeam",
    "move3": "Hyper Beam",
    "move4": "Synthesis",
    "speed": 90
  },
  {
    "entry": 793,
    "name": "VICTREEBEL 4",
    "species": "Victreebel",
    "instance": "4",
    "nature": "Modest",
    "item": "Focus Band",
    "move1": "SolarBeam",
    "move2": "Sludge Bomb",
    "move3": "Wring Out",
    "move4": "Sunny Day",
    "speed": 90
  },
  {
    "entry": 384,
    "name": "VILEPLUME 1",
    "species": "Vileplume",
    "instance": "1",
    "nature": "Modest",
    "item": "Big Root",
    "move1": "Giga Drain",
    "move2": "Sludge Bomb",
    "move3": "Sleep Powder",
    "move4": "Ingrain",
    "speed": 70
  },
  {
    "entry": 520,
    "name": "VILEPLUME 2",
    "species": "Vileplume",
    "instance": "2",
    "nature": "Bold",
    "item": "Black Sludge",
    "move1": "Toxic",
    "move2": "Grass Knot",
    "move3": "Double Team",
    "move4": "Attract",
    "speed": 70
  },
  {
    "entry": 656,
    "name": "VILEPLUME 3",
    "species": "Vileplume",
    "instance": "3",
    "nature": "Adamant",
    "item": "Lum Berry",
    "move1": "Seed Bomb",
    "move2": "Drain Punch",
    "move3": "Frustration",
    "move4": "Swords Dance",
    "speed": 70
  },
  {
    "entry": 792,
    "name": "VILEPLUME 4",
    "species": "Vileplume",
    "instance": "4",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Sludge Bomb",
    "move2": "Energy Ball",
    "move3": "Hyper Beam",
    "move4": "Synthesis",
    "speed": 70
  },
  {
    "entry": 428,
    "name": "WAILORD 1",
    "species": "Wailord",
    "instance": "1",
    "nature": "Modest",
    "item": "Sitrus Berry",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Attract",
    "move4": "Double Team",
    "speed": 80
  },
  {
    "entry": 564,
    "name": "WAILORD 2",
    "species": "Wailord",
    "instance": "2",
    "nature": "Impish",
    "item": "Chesto Berry",
    "move1": "Whirlpool",
    "move2": "Toxic",
    "move3": "Amnesia",
    "move4": "Rest",
    "speed": 80
  },
  {
    "entry": 700,
    "name": "WAILORD 3",
    "species": "Wailord",
    "instance": "3",
    "nature": "Adamant",
    "item": "Leftovers",
    "move1": "Waterfall",
    "move2": "Avalanche",
    "move3": "Earthquake",
    "move4": "Curse",
    "speed": 80
  },
  {
    "entry": 836,
    "name": "WAILORD 4",
    "species": "Wailord",
    "instance": "4",
    "nature": "Modest",
    "item": "Quick Claw",
    "move1": "Hydro Pump",
    "move2": "Blizzard",
    "move3": "Hyper Beam",
    "move4": "Fissure",
    "speed": 80
  },
  {
    "entry": 464,
    "name": "WALREIN 1",
    "species": "Walrein",
    "instance": "1",
    "nature": "Adamant",
    "item": "Chople Berry",
    "move1": "Ice Fang",
    "move2": "Aqua Tail",
    "move3": "Swagger",
    "move4": "Encore",
    "speed": 85
  },
  {
    "entry": 600,
    "name": "WALREIN 2",
    "species": "Walrein",
    "instance": "2",
    "nature": "Brave",
    "item": "Life Orb",
    "move1": "Avalanche",
    "move2": "Earthquake",
    "move3": "Crunch",
    "move4": "Curse",
    "speed": 76
  },
  {
    "entry": 736,
    "name": "WALREIN 3",
    "species": "Walrein",
    "instance": "3",
    "nature": "Bold",
    "item": "Lax Incense",
    "move1": "Sheer Cold",
    "move2": "Fissure",
    "move3": "Rest",
    "move4": "Sleep Talk",
    "speed": 85
  },
  {
    "entry": 872,
    "name": "WALREIN 4",
    "species": "Walrein",
    "instance": "4",
    "nature": "Modest",
    "item": "Leftovers",
    "move1": "Surf",
    "move2": "Ice Beam",
    "move3": "Signal Beam",
    "move4": "Hail",
    "speed": 85
  },
  {
    "entry": 440,
    "name": "WEAVILE 1",
    "species": "Weavile",
    "instance": "1",
    "nature": "Adamant",
    "item": "Chople Berry",
    "move1": "Night Slash",
    "move2": "Ice Punch",
    "move3": "Screech",
    "move4": "Fake Out",
    "speed": 177
  },
  {
    "entry": 576,
    "name": "WEAVILE 2",
    "species": "Weavile",
    "instance": "2",
    "nature": "Jolly",
    "item": "BrightPowder",
    "move1": "Night Slash",
    "move2": "Attract",
    "move3": "Double Team",
    "move4": "Hail",
    "speed": 194
  },
  {
    "entry": 712,
    "name": "WEAVILE 3",
    "species": "Weavile",
    "instance": "3",
    "nature": "Adamant",
    "item": "Focus Sash",
    "move1": "Night Slash",
    "move2": "X-Scissor",
    "move3": "Metal Claw",
    "move4": "Counter",
    "speed": 177
  },
  {
    "entry": 848,
    "name": "WEAVILE 4",
    "species": "Weavile",
    "instance": "4",
    "nature": "Jolly",
    "item": "Razor Claw",
    "move1": "Night Slash",
    "move2": "Ice Punch",
    "move3": "Aerial Ace",
    "move4": "Brick Break",
    "speed": 194
  },
  {
    "entry": 398,
    "name": "WEEZING 1",
    "species": "Weezing",
    "instance": "1",
    "nature": "Bold",
    "item": "Payapa Berry",
    "move1": "Sludge Bomb",
    "move2": "Dark Pulse",
    "move3": "Shock Wave",
    "move4": "Grudge",
    "speed": 80
  },
  {
    "entry": 534,
    "name": "WEEZING 2",
    "species": "Weezing",
    "instance": "2",
    "nature": "Adamant",
    "item": "Sitrus Berry",
    "move1": "Double Hit",
    "move2": "Payback",
    "move3": "Toxic",
    "move4": "Swagger",
    "speed": 80
  },
  {
    "entry": 670,
    "name": "WEEZING 3",
    "species": "Weezing",
    "instance": "3",
    "nature": "Sassy",
    "item": "Lax Incense",
    "move1": "Sludge Bomb",
    "move2": "Thunderbolt",
    "move3": "Dark Pulse",
    "move4": "Explosion",
    "speed": 72
  },
  {
    "entry": 806,
    "name": "WEEZING 4",
    "species": "Weezing",
    "instance": "4",
    "nature": "Modest",
    "item": "Quick Claw",
    "move1": "Sludge Bomb",
    "move2": "Flamethrower",
    "move3": "Shadow Ball",
    "move4": "Destiny Bond",
    "speed": 80
  },
  {
    "entry": 375,
    "name": "WHISCASH 1",
    "species": "Whiscash",
    "instance": "1",
    "nature": "Modest",
    "item": "Shell Bell",
    "move1": "Surf",
    "move2": "Earth Power",
    "move3": "Icy Wind",
    "move4": "Amnesia",
    "speed": 80
  },
  {
    "entry": 511,
    "name": "WHISCASH 2",
    "species": "Whiscash",
    "instance": "2",
    "nature": "Adamant",
    "item": "Persim Berry",
    "move1": "Aqua Tail",
    "move2": "Earthquake",
    "move3": "Rock Slide",
    "move4": "Thrash",
    "speed": 80
  },
  {
    "entry": 647,
    "name": "WHISCASH 3",
    "species": "Whiscash",
    "instance": "3",
    "nature": "Modest",
    "item": "Zoom Lens",
    "move1": "Hydro Pump",
    "move2": "Earth Power",
    "move3": "Blizzard",
    "move4": "Fissure",
    "speed": 80
  },
  {
    "entry": 783,
    "name": "WHISCASH 4",
    "species": "Whiscash",
    "instance": "4",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Earthquake",
    "move2": "Aqua Tail",
    "move3": "Zen Headbutt",
    "move4": "Stone Edge",
    "speed": 80
  },
  {
    "entry": 334,
    "name": "XATU 2",
    "species": "Xatu",
    "instance": "2",
    "nature": "Modest",
    "item": "Colbur Berry",
    "move1": "Psychic",
    "move2": "Air Cutter",
    "move3": "Ominous Wind",
    "move4": "Confuse Ray",
    "speed": 147
  },
  {
    "entry": 446,
    "name": "YANMEGA 1",
    "species": "Yanmega",
    "instance": "1",
    "nature": "Timid",
    "item": "Coba Berry",
    "move1": "Signal Beam",
    "move2": "Air Cutter",
    "move3": "Detect",
    "move4": "Double Team",
    "speed": 161
  },
  {
    "entry": 582,
    "name": "YANMEGA 2",
    "species": "Yanmega",
    "instance": "2",
    "nature": "Adamant",
    "item": "Muscle Band",
    "move1": "Aerial Ace",
    "move2": "U-turn",
    "move3": "Night Slash",
    "move4": "Steel Wing",
    "speed": 147
  },
  {
    "entry": 718,
    "name": "YANMEGA 3",
    "species": "Yanmega",
    "instance": "3",
    "nature": "Modest",
    "item": "Lum Berry",
    "move1": "Silver Wind",
    "move2": "AncientPower",
    "move3": "Ominous Wind",
    "move4": "Giga Drain",
    "speed": 147
  },
  {
    "entry": 854,
    "name": "YANMEGA 4",
    "species": "Yanmega",
    "instance": "4",
    "nature": "Modest",
    "item": "Wise Glasses",
    "move1": "Bug Buzz",
    "move2": "Air Slash",
    "move3": "Psychic",
    "move4": "Shadow Ball",
    "speed": 147
  },
  {
    "entry": 896,
    "name": "ZAPDOS 1",
    "species": "Zapdos",
    "instance": "1",
    "nature": "Serious",
    "item": "Yache Berry",
    "move1": "Thunder",
    "move2": "Drill Peck",
    "move3": "Thunder Wave",
    "move4": "Rain Dance",
    "speed": 152
  },
  {
    "entry": 910,
    "name": "ZAPDOS 2",
    "species": "Zapdos",
    "instance": "2",
    "nature": "Timid",
    "item": "Focus Band",
    "move1": "Thunderbolt",
    "move2": "AncientPower",
    "move3": "Ominous Wind",
    "move4": "Light Screen",
    "speed": 167
  },
  {
    "entry": 924,
    "name": "ZAPDOS 3",
    "species": "Zapdos",
    "instance": "3",
    "nature": "Jolly",
    "item": "King's Rock",
    "move1": "Drill Peck",
    "move2": "Twister",
    "move3": "Steel Wing",
    "move4": "U-turn",
    "speed": 167
  },
  {
    "entry": 938,
    "name": "ZAPDOS 4",
    "species": "Zapdos",
    "instance": "4",
    "nature": "Modest",
    "item": "BrightPowder",
    "move1": "Thunderbolt",
    "move2": "Air Cutter",
    "move3": "Heat Wave",
    "move4": "Signal Beam",
    "speed": 152
  }
];
